import * as Q1 from "react";
import t, { useRef as f1, useState as c1, useEffect as y1, useCallback as n1, useId as H1, useMemo as z1, forwardRef as T4, useImperativeHandle as ue, createContext as a5, useContext as i5, useLayoutEffect as a3 } from "react";
import y, { css as k, useTheme as l5, keyframes as i3, createGlobalStyle as de } from "styled-components";
import W4 from "react-is";
import { motion as P1, AnimatePresence as R4 } from "framer-motion";
import * as fe from "react-dom";
import c5 from "react-dom";
function J1(...e) {
  return (r) => e.some((n) => (n == null || n(r), r == null ? void 0 : r.defaultPrevented));
}
function G(e, r) {
  return typeof r == "number" ? `${e}: ${r}rem;` : Array.isArray(r) ? `${e}: ${r[0]}rem ${r[1]}rem;` : `${e}: ${r};`;
}
function N1(...e) {
  return (r) => {
    e.forEach((n) => {
      if (n) {
        if (typeof n == "function") {
          n(r);
          return;
        }
        n.current = r;
      }
    });
  };
}
const oi = () => {
}, me = /(\d)(?=(\d{3})+(?!\d))/g;
function J2(e) {
  if (e == null)
    return "";
  const [r, n] = e.split(".");
  let a = r.search(/[1-9]/);
  a = a === -1 ? r.length : a;
  const o = r.substring(0, a) + r.substring(a, r.length).replace(me, "$1,");
  return n == null ? o : `${o}.${n}`;
}
const z = t.forwardRef(
  ({
    width: e,
    height: r,
    mx: n,
    my: a,
    mt: o,
    mr: i,
    mb: l,
    ml: c,
    px: C,
    py: s,
    pt: u,
    pr: f,
    pb: h,
    pl: d,
    relative: v,
    absolute: m,
    flex: g,
    flexInline: L,
    flexBasis: E,
    flexGrow: V,
    flexShrink: O,
    flexRow: D,
    flexColumn: H,
    flexWrap: F,
    alignItems: _,
    justifyContent: Y,
    rowGap: W,
    columnGap: A,
    alignSelf: N,
    children: j,
    backgroundColor: J,
    ...X
  }, B) => /* @__PURE__ */ t.createElement(
    be,
    {
      ref: B,
      $width: e,
      $height: r,
      $mx: n,
      $my: a,
      $mt: o,
      $mr: i,
      $mb: l,
      $ml: c,
      $px: C,
      $py: s,
      $pt: u,
      $pr: f,
      $pb: h,
      $pl: d,
      $relative: v,
      $absolute: m,
      $flex: g,
      $flexInline: L,
      $flexBasis: E,
      $flexGrow: V,
      $flexShrink: O,
      $flexRow: D,
      $flexColumn: H,
      $flexWrap: F,
      $alignItems: _,
      $alignSelf: N,
      $justifyContent: Y,
      $rowGap: W,
      $columnGap: A,
      $backgroundColor: J,
      ...X
    },
    j
  )
);
z.displayName = "Box";
const he = k`
  ${({ $width: e }) => e && G("width", e)};
  ${({ $height: e }) => e && G("height", e)};
`, ve = k`
  ${({ $mx: e }) => e && G("margin-inline", e)};
  ${({ $my: e }) => e && G("margin-block", e)};
  ${({ $mt: e }) => e && G("margin-top", e)};
  ${({ $mr: e }) => e && G("margin-right", e)};
  ${({ $mb: e }) => e && G("margin-bottom", e)};
  ${({ $ml: e }) => e && G("margin-left", e)};
`, ge = k`
  ${({ $px: e }) => e && G("padding-inline", e)};
  ${({ $py: e }) => e && G("padding-block", e)};
  ${({ $pt: e }) => e && G("padding-top", e)};
  ${({ $pr: e }) => e && G("padding-right", e)};
  ${({ $pb: e }) => e && G("padding-bottom", e)};
  ${({ $pl: e }) => e && G("padding-left", e)};
`, pe = k`
  ${({ $relative: e }) => e && G("position", "relative")};
  ${({ $absolute: e }) => e && G("position", "absolute")};
`, ye = k`
  ${({ $flex: e }) => e && G("display", "flex")};
  ${({ $flexInline: e }) => e && G("display", "inline-flex")};
  ${({ $flexBasis: e }) => e && G("flex-basis", e)};
  ${({ $flexGrow: e }) => e && G("flex-grow", e)};
  ${({ $flexShrink: e }) => e && G("flex-shrink", e)};
  ${({ $flexRow: e }) => e && G("flex-direction", "row")};
  ${({ $flexColumn: e }) => e && G("flex-direction", "column")};
  ${({ $flexWrap: e }) => e && G("flex-wrap", "wrap")};
  ${({ $alignItems: e }) => e && G("align-items", e)};
  ${({ $alignSelf: e }) => e && G("align-self", e)};
  ${({ $justifyContent: e }) => e && G("justify-content", e)};
  ${({ $rowGap: e }) => e && G("row-gap", e)};
  ${({ $columnGap: e }) => e && G("column-gap", e)};
`, we = k`
  ${({ $backgroundColor: e, theme: r }) => e && G("background-color", r.colors[e])}
`, be = y.div`
  ${he}
  ${ve}
  ${ge}
  ${pe}
  ${ye}
  ${we}
`, Ee = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 6V4M12 6C11.4696 6 10.9609 6.21071 10.5858 6.58579C10.2107 6.96086 10 7.46957 10 8C10 8.53043 10.2107 9.03914 10.5858 9.41421C10.9609 9.78929 11.4696 10 12 10M12 6C12.5304 6 13.0391 6.21071 13.4142 6.58579C13.7893 6.96086 14 7.46957 14 8C14 8.53043 13.7893 9.03914 13.4142 9.41421C13.0391 9.78929 12.5304 10 12 10M12 10V20M6 18C6.53043 18 7.03914 17.7893 7.41421 17.4142C7.78929 17.0391 8 16.5304 8 16C8 15.4696 7.78929 14.9609 7.41421 14.5858C7.03914 14.2107 6.53043 14 6 14M6 18C5.46957 18 4.96086 17.7893 4.58579 17.4142C4.21071 17.0391 4 16.5304 4 16C4 15.4696 4.21071 14.9609 4.58579 14.5858C4.96086 14.2107 5.46957 14 6 14M6 18V20M6 14V4M18 18C18.5304 18 19.0391 17.7893 19.4142 17.4142C19.7893 17.0391 20 16.5304 20 16C20 15.4696 19.7893 14.9609 19.4142 14.5858C19.0391 14.2107 18.5304 14 18 14M18 18C17.4696 18 16.9609 17.7893 16.5858 17.4142C16.2107 17.0391 16 16.5304 16 16C16 15.4696 16.2107 14.9609 16.5858 14.5858C16.9609 14.2107 17.4696 14 18 14M18 18V20M18 14V4",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), ke = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5 8H19M5 8C4.46957 8 3.96086 7.78929 3.58579 7.41421C3.21071 7.03914 3 6.53043 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6C21 6.53043 20.7893 7.03914 20.4142 7.41421C20.0391 7.78929 19.5304 8 19 8M5 8V18C5 18.5304 5.21071 19.0391 5.58579 19.4142C5.96086 19.7893 6.46957 20 7 20H17C17.5304 20 18.0391 19.7893 18.4142 19.4142C18.7893 19.0391 19 18.5304 19 18V8M10 12H14",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Le = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M19 14L12 21M12 21L5 14M12 21V3",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), xe = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M10 19L3 12M3 12L10 5M3 12H21",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), He = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14 5L21 12M21 12L14 19M21 12H3",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Me = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5 10L12 3M12 3L19 10M12 3V21",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Ve = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M20 20H16M4 8V4V8ZM4 4H8H4ZM4 4L9 9L4 4ZM20 8V4V8ZM20 4H16H20ZM20 4L15 9L20 4ZM4 16V20V16ZM4 20H8H4ZM4 20L9 15L4 20ZM20 20L15 15L20 20ZM20 20V16V20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), $e = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16 12C16 10.9391 15.5786 9.92172 14.8284 9.17158C14.0783 8.42143 13.0609 8 12 8C10.9391 8 9.92172 8.42143 9.17158 9.17158C8.42143 9.92172 8 10.9391 8 12C8 13.0609 8.42143 14.0783 9.17158 14.8284C9.92172 15.5786 10.9391 16 12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12ZM16 12V13.5C16 14.163 16.2634 14.7989 16.7322 15.2678C17.2011 15.7366 17.837 16 18.5 16C19.163 16 19.7989 15.7366 20.2678 15.2678C20.7366 14.7989 21 14.163 21 13.5V12C21 10.22 20.4722 8.47991 19.4832 6.99987C18.4943 5.51983 17.0887 4.36628 15.4442 3.68509C13.7996 3.0039 11.99 2.82567 10.2442 3.17294C8.49836 3.5202 6.89472 4.37737 5.63604 5.63604C4.37737 6.89472 3.5202 8.49836 3.17294 10.2442C2.82567 11.99 3.0039 13.7996 3.68509 15.4442C4.36628 17.0887 5.51983 18.4943 6.99987 19.4832C8.47991 20.4722 10.22 21 12 21C13.5802 21.0016 15.1327 20.5862 16.5 19.794",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Oe = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M18.364 18.364C20.0518 16.6762 21 14.387 21 12C21 9.61303 20.0518 7.32383 18.364 5.63599C16.6762 3.94816 14.387 2.99994 12 2.99994C9.61303 2.99994 7.32383 3.94816 5.63599 5.63599M18.364 18.364L5.63599 5.63599M18.364 18.364C16.6762 20.0518 14.387 21 12 21C9.61303 21 7.32383 20.0518 5.63599 18.364C3.94816 16.6762 2.99994 14.387 2.99994 12C2.99994 9.61303 3.94816 7.32383 5.63599 5.63599",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Se = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1723 17.868C14.7855 18.8538 13.0945 19.3165 11.399 19.1743C9.70354 19.032 8.11323 18.294 6.91007 17.091C5.70691 15.888 4.96866 14.2977 4.82621 12.6023C4.68377 10.9068 5.14634 9.21573 6.1319 7.82882L16.1723 17.8704V17.868ZM17.8691 16.1712L7.8287 6.13202C9.21555 5.14564 10.907 4.68239 12.6029 4.82447C14.2988 4.96655 15.8896 5.70477 17.093 6.90816C18.2964 8.11156 19.0346 9.70232 19.1767 11.3982C19.3187 13.0942 18.8555 14.7856 17.8691 16.1724V16.1712ZM21.5999 12C21.5999 14.5461 20.5885 16.9879 18.7881 18.7882C16.9878 20.5886 14.546 21.6 11.9999 21.6C9.45382 21.6 7.01203 20.5886 5.21168 18.7882C3.41133 16.9879 2.3999 14.5461 2.3999 12C2.3999 9.45395 3.41133 7.01215 5.21168 5.2118C7.01203 3.41145 9.45382 2.40002 11.9999 2.40002C14.546 2.40002 16.9878 3.41145 18.7881 5.2118C20.5885 7.01215 21.5999 9.45395 21.5999 12Z",
    fill: e.color
  }
)), Ze = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15 17H20L18.595 15.595C18.4063 15.4063 18.2567 15.1822 18.1546 14.9357C18.0525 14.6891 18 14.4249 18 14.158V11C18.0002 9.75894 17.6156 8.54834 16.8992 7.53489C16.1829 6.52144 15.17 5.75496 14 5.341V5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3C11.4696 3 10.9609 3.21071 10.5858 3.58579C10.2107 3.96086 10 4.46957 10 5V5.341C7.67 6.165 6 8.388 6 11V14.159C6 14.697 5.786 15.214 5.405 15.595L4 17H9M15 17H9M15 17V18C15 18.7956 14.6839 19.5587 14.1213 20.1213C13.5587 20.6839 12.7956 21 12 21C11.2044 21 10.4413 20.6839 9.87868 20.1213C9.31607 19.5587 9 18.7956 9 18V17",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), De = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z" })), _e = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 6.253V19.253M12 6.253C10.832 5.477 9.246 5 7.5 5C5.754 5 4.168 5.477 3 6.253V19.253C4.168 18.477 5.754 18 7.5 18C9.246 18 10.832 18.477 12 19.253M12 6.253C13.168 5.477 14.754 5 16.5 5C18.247 5 19.832 5.477 21 6.253V19.253C19.832 18.477 18.247 18 16.5 18C14.754 18 13.168 18.477 12 19.253",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Be = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V21L12 17.5L19 21V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Te = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M21 13.255C18.1405 14.4112 15.0844 15.0038 12 15C8.817 15 5.78 14.38 3 13.255M12 12H12.01M16 6V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V6H16ZM5 20H19C19.5304 20 20.0391 19.7893 20.4142 19.4142C20.7893 19.0391 21 18.5304 21 18V8C21 7.46957 20.7893 6.96086 20.4142 6.58579C20.0391 6.21071 19.5304 6 19 6H5C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21071 6.96086 3 7.46957 3 8V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), We = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 7H15M15 17V14M12 17H12.01M9 17H9.01M9 14H9.01M12 14H12.01M15 11H15.01M12 11H12.01M9 11H9.01M7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Re = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8 7V3M16 7V3M7 11H17M5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), je = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3.58579 7.58579C3.21071 7.96086 3 8.46957 3 9V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H19C19.5304 20 20.0391 19.7893 20.4142 19.4142C20.7893 19.0391 21 18.5304 21 18V9C21 8.46957 20.7893 7.96086 20.4142 7.58579C20.0391 7.21071 19.5304 7 19 7H18.07C17.7408 7.00005 17.4167 6.91884 17.1264 6.76359C16.8362 6.60834 16.5887 6.38383 16.406 6.11L15.594 4.89C15.4113 4.61617 15.1638 4.39166 14.8736 4.23641C14.5833 4.08116 14.2592 3.99995 13.93 4H10.07C9.74082 3.99995 9.41671 4.08116 9.12643 4.23641C8.83616 4.39166 8.5887 4.61617 8.406 4.89L7.594 6.11C7.4113 6.38383 7.16384 6.60834 6.87357 6.76359C6.58329 6.91884 6.25918 7.00005 5.93 7H5C4.46957 7 3.96086 7.21071 3.58579 7.58579Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.1213 15.1213C14.6839 14.5587 15 13.7956 15 13C15 12.2044 14.6839 11.4413 14.1213 10.8787C13.5587 10.3161 12.7956 10 12 10C11.2044 10 10.4413 10.3161 9.87868 10.8787C9.31607 11.4413 9 12.2044 9 13C9 13.7956 9.31607 14.5587 9.87868 15.1213C10.4413 15.6839 11.2044 16 12 16C12.7956 16 13.5587 15.6839 14.1213 15.1213Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Ae = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 8H19C19.5304 8 20.0391 8.21071 20.4142 8.58579C20.7893 8.96086 21 9.46957 21 10V16C21 16.5304 20.7893 17.0391 20.4142 17.4142C20.0391 17.7893 19.5304 18 19 18H17V22L13 18H9C8.73733 18.0003 8.47719 17.9486 8.23453 17.8481C7.99187 17.7475 7.77148 17.6 7.586 17.414M7.586 17.414L11 14H15C15.5304 14 16.0391 13.7893 16.4142 13.4142C16.7893 13.0391 17 12.5304 17 12V6C17 5.46957 16.7893 4.96086 16.4142 4.58579C16.0391 4.21071 15.5304 4 15 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V12C3 12.5304 3.21071 13.0391 3.58579 13.4142C3.96086 13.7893 4.46957 14 5 14H7V18L7.586 17.414Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Ie = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8 12L11 15L16 10M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Ne = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.6C17.302 21.6 21.6 17.302 21.6 12C21.6 6.69809 17.302 2.40002 12 2.40002C6.69809 2.40002 2.40002 6.69809 2.40002 12C2.40002 17.302 6.69809 21.6 12 21.6ZM10.8 16.6971L17.6485 9.84853L15.9514 8.15148L10.8 13.3029L8.6485 11.1515L6.95144 12.8485L10.8 16.6971Z",
    fill: e.color
  }
)), Fe = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5 13L9 17L19 7",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Pe = (e) => /* @__PURE__ */ t.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...e }, /* @__PURE__ */ t.createElement("g", { clipPath: "url(#clip0_43194_153438)" }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 0C1.49238 0 0 1.49238 0 3.33333V16.6667C0 18.5076 1.49238 20 3.33333 20H16.6667C18.5076 20 20 18.5076 20 16.6667V3.33333C20 1.49238 18.5076 0 16.6667 0H3.33333ZM8.49999 14.4142L15.2071 7.70709L13.7929 6.29288L8.49999 11.5858L6.2071 9.29288L4.79289 10.7071L8.49999 14.4142Z",
    fill: "#5E47F6"
  }
)), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement("clipPath", { id: "clip0_43194_153438" }, /* @__PURE__ */ t.createElement("rect", { width: 20, height: 20, fill: "white" })))), Ge = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M19 9L12 16L5 9",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), ze = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15 19L8 12L15 5",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Ye = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 5L16 12L9 19",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Ue = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5 15L12 8L19 15",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), qe = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15M9 5C9 5.53043 9.21071 6.03914 9.58579 6.41421C9.96086 6.78929 10.4696 7 11 7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5M9 5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5M9 14L11 16L15 12",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Xe = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8 5H6C5.46957 5 4.96086 5.21071 4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V18M8 5C8 5.53043 8.21071 6.03914 8.58579 6.41421C8.96086 6.78929 9.46957 7 10 7H12C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5M8 5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H12C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5M14 5H16C16.5304 5 17.0391 5.21071 17.4142 5.58579C17.7893 5.96086 18 6.46957 18 7V10M20 14H10M10 14L13 11M10 14L13 17",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Ke = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15M9 5C9 5.53043 9.21071 6.03914 9.58579 6.41421C9.96086 6.78929 10.4696 7 11 7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5M9 5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5M12 12H15M12 16H15M9 12H9.01M9 16H9.01",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Je = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15M9 5C9 5.53043 9.21071 6.03914 9.58579 6.41421C9.96086 6.78929 10.4696 7 11 7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5M9 5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Qe = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 8V12L15 15M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), e8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C14.546 21.6 16.9878 20.5886 18.7881 18.7882C20.5885 16.9879 21.5999 14.5461 21.5999 12C21.5999 9.45395 20.5885 7.01215 18.7881 5.2118C16.9878 3.41145 14.546 2.40002 11.9999 2.40002C9.45382 2.40002 7.01203 3.41145 5.21168 5.2118C3.41133 7.01215 2.3999 9.45395 2.3999 12C2.3999 14.5461 3.41133 16.9879 5.21168 18.7882C7.01203 20.5886 9.45382 21.6 11.9999 21.6ZM13.1999 7.20002C13.1999 6.88176 13.0735 6.57654 12.8484 6.3515C12.6234 6.12645 12.3182 6.00002 11.9999 6.00002C11.6816 6.00002 11.3764 6.12645 11.1514 6.3515C10.9263 6.57654 10.7999 6.88176 10.7999 7.20002V12C10.8 12.3183 10.9264 12.6234 11.1515 12.8484L14.5451 16.2432C14.6566 16.3547 14.789 16.4432 14.9346 16.5035C15.0803 16.5638 15.2364 16.5949 15.3941 16.5949C15.5518 16.5949 15.7079 16.5638 15.8536 16.5035C15.9993 16.4432 16.1316 16.3547 16.2431 16.2432C16.3546 16.1317 16.443 15.9994 16.5034 15.8537C16.5637 15.708 16.5948 15.5519 16.5948 15.3942C16.5948 15.2366 16.5637 15.0804 16.5034 14.9347C16.443 14.7891 16.3546 14.6567 16.2431 14.5452L13.1999 11.5032V7.20002Z",
    fill: e.color
  }
)), t8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M7.00001 16C6.01503 16.0011 5.06427 15.6388 4.32988 14.9823C3.5955 14.3259 3.12913 13.4216 3.02012 12.4427C2.91112 11.4638 3.16714 10.479 3.73915 9.67714C4.31115 8.87526 5.15891 8.31263 6.12001 8.09703C5.84193 6.80012 6.09044 5.44586 6.81086 4.33218C7.53128 3.21849 8.6646 2.43661 9.96151 2.15853C11.2584 1.88045 12.6127 2.12895 13.7264 2.84937C14.84 3.56979 15.6219 4.70312 15.9 6.00003H16C17.24 5.99878 18.4361 6.45831 19.3563 7.2894C20.2765 8.12049 20.8551 9.26386 20.9797 10.4975C21.1043 11.7312 20.7661 12.9672 20.0307 13.9655C19.2953 14.9638 18.2152 15.6533 17 15.9M9.00001 19L12 22M12 22L15 19M12 22V10",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), r8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4.17157 17.8284C3.42143 17.0783 3 16.0608 3 15C2.99995 14.0919 3.30881 13.2108 3.87581 12.5015C4.44281 11.7922 5.23422 11.2969 6.12 11.097C5.96791 10.4495 5.94648 9.77816 6.05696 9.12228C6.16745 8.4664 6.40763 7.83914 6.76345 7.27721C7.11927 6.71527 7.58359 6.22995 8.12924 5.84962C8.6749 5.4693 9.29092 5.20161 9.94127 5.06223C10.5916 4.92285 11.2632 4.91458 11.9168 5.03789C12.5704 5.1612 13.1928 5.41362 13.7477 5.78038C14.3026 6.14714 14.7787 6.62088 15.1483 7.17388C15.5178 7.72687 15.7734 8.34802 15.9 9.00098C16.5607 8.98776 17.2174 9.10564 17.8323 9.3478C18.4471 9.58996 19.0079 9.9516 19.4821 10.4118C19.9563 10.872 20.3346 11.4217 20.5951 12.029C20.8556 12.6363 20.9931 13.2892 20.9997 13.95C21.0064 14.6108 20.8819 15.2663 20.6336 15.8787C20.3853 16.4911 20.0181 17.0482 19.5532 17.5178C19.0882 17.9874 18.5348 18.3602 17.925 18.6146C17.3151 18.869 16.6608 19 16 19H7C5.93913 19 4.92172 18.5785 4.17157 17.8284Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), n8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M7.00001 16C6.01503 16.0011 5.06427 15.6388 4.32988 14.9823C3.5955 14.3259 3.12913 13.4216 3.02012 12.4427C2.91112 11.4638 3.16714 10.479 3.73915 9.67714C4.31115 8.87526 5.15891 8.31263 6.12001 8.09703C5.84193 6.80012 6.09044 5.44586 6.81086 4.33218C7.53128 3.21849 8.6646 2.43661 9.96151 2.15853C11.2584 1.88045 12.6127 2.12895 13.7264 2.84937C14.84 3.56979 15.6219 4.70312 15.9 6.00003H16C17.24 5.99878 18.4361 6.45831 19.3563 7.2894C20.2765 8.12049 20.8551 9.26386 20.9797 10.4975C21.1043 11.7312 20.7661 12.9672 20.0307 13.9655C19.2953 14.9638 18.2152 15.6533 17 15.9M15 13L12 10M12 10L9.00001 13M12 10V22",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), o8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M13.675 4.317C13.249 2.561 10.751 2.561 10.325 4.317C10.049 5.452 8.749 5.99 7.753 5.382C6.209 4.442 4.443 6.209 5.383 7.752C5.5243 7.98375 5.60889 8.24559 5.62987 8.51621C5.65085 8.78683 5.60764 9.05859 5.50375 9.30935C5.39985 9.56011 5.23822 9.7828 5.032 9.95929C4.82578 10.1358 4.5808 10.2611 4.317 10.325C2.561 10.751 2.561 13.249 4.317 13.675C4.58056 13.7391 4.82529 13.8645 5.03127 14.0409C5.23726 14.2174 5.3987 14.44 5.50247 14.6906C5.60624 14.9412 5.64942 15.2128 5.62848 15.4832C5.60755 15.7537 5.5231 16.0153 5.382 16.247C4.442 17.791 6.209 19.557 7.752 18.617C7.98375 18.4757 8.24559 18.3911 8.51621 18.3701C8.78683 18.3491 9.05859 18.3924 9.30935 18.4963C9.56011 18.6001 9.7828 18.7618 9.95929 18.968C10.1358 19.1742 10.2611 19.4192 10.325 19.683C10.751 21.439 13.249 21.439 13.675 19.683C13.7391 19.4194 13.8645 19.1747 14.0409 18.9687C14.2174 18.7627 14.44 18.6013 14.6906 18.4975C14.9412 18.3938 15.2128 18.3506 15.4832 18.3715C15.7537 18.3924 16.0153 18.4769 16.247 18.618C17.791 19.558 19.557 17.791 18.617 16.248C18.4757 16.0162 18.3911 15.7544 18.3701 15.4838C18.3491 15.2132 18.3924 14.9414 18.4963 14.6907C18.6001 14.4399 18.7618 14.2172 18.968 14.0407C19.1742 13.8642 19.4192 13.7389 19.683 13.675C21.439 13.249 21.439 10.751 19.683 10.325C19.4194 10.2609 19.1747 10.1355 18.9687 9.95905C18.7627 9.78258 18.6013 9.55999 18.4975 9.30938C18.3938 9.05877 18.3506 8.78721 18.3715 8.51677C18.3924 8.24634 18.4769 7.98466 18.618 7.753C19.558 6.209 17.791 4.443 16.248 5.383C16.0162 5.5243 15.7544 5.60889 15.4838 5.62987C15.2132 5.65085 14.9414 5.60764 14.6907 5.50375C14.4399 5.39985 14.2172 5.23822 14.0407 5.032C13.8642 4.82578 13.7389 4.5808 13.675 4.317Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), a8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3 10H21M7 15H8M12 15H13M6 19H18C18.7956 19 19.5587 18.6839 20.1213 18.1213C20.6839 17.5587 21 16.7956 21 16V8C21 7.20435 20.6839 6.44129 20.1213 5.87868C19.5587 5.31607 18.7956 5 18 5H6C5.20435 5 4.44129 5.31607 3.87868 5.87868C3.31607 6.44129 3 7.20435 3 8V16C3 16.7956 3.31607 17.5587 3.87868 18.1213C4.44129 18.6839 5.20435 19 6 19Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), i8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15 15L13 20L8.99998 9.00001L20 13L15 15ZM15 15L20 20M7.18798 2.23901L7.96498 5.13601M5.13598 7.96501L2.23798 7.18801M13.95 4.05001L11.828 6.17201M6.17098 11.828L4.05098 13.95",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), l8 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z" })), c8 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 3C12.5523 3 13 3.44772 13 4L12.9998 11.9998C13.8355 11.372 14.8743 11 16 11C18.7614 11 21 13.2386 21 16C21 18.7614 18.7614 21 16 21C14.9681 21 14.0092 20.6874 13.2129 20.1518L13 20C13 20.5523 12.5523 21 12 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H12ZM11 5H7V19H11V5ZM19 15H13V17H19V15Z" })), C8 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 5C20.5523 5 21 5.44772 21 6V12C21 12.5523 20.5523 13 20 13C20.628 13.8355 21 14.8743 21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16C11 14.8743 11.372 13.8355 11.9998 12.9998L4 13C3.44772 13 3 12.5523 3 12V6C3 5.44772 3.44772 5 4 5H20ZM13 15V17H19V15H13ZM19 7H5V11H19V7Z" })), s8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M10 5L14 12L12 15.5L10 19",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), u8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 13H15M12 10V16M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H12.586C12.8512 3.00006 13.1055 3.10545 13.293 3.293L18.707 8.707C18.8946 8.89449 18.9999 9.1488 19 9.414V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), d8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 10V16M12 16L9 13M12 16L15 13M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H12.586C12.8512 3.00006 13.1055 3.10545 13.293 3.293L18.707 8.707C18.8946 8.89449 18.9999 9.1488 19 9.414V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), f8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8 7V15C8 15.5304 8.21071 16.0391 8.58579 16.4142C8.96086 16.7893 9.46957 17 10 17H16M8 7V5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H14.586C14.8512 3.00006 15.1055 3.10545 15.293 3.293L19.707 7.707C19.8946 7.89449 19.9999 8.1488 20 8.414V15C20 15.5304 19.7893 16.0391 19.4142 16.4142C19.0391 16.7893 18.5304 17 18 17H16M8 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H14C14.5304 21 15.0391 20.7893 15.4142 20.4142C15.7893 20.0391 16 19.5304 16 19V17",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), m8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H12.586C12.8512 3.00006 13.1055 3.10545 13.293 3.293L18.707 8.707C18.8946 8.89449 18.9999 9.1488 19 9.414V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), h8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 13H15M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H12.586C12.8512 3.00006 13.1055 3.10545 13.293 3.293L18.707 8.707C18.8946 8.89449 18.9999 9.1488 19 9.414V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), v8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M10 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V9.414C18.9999 9.1488 18.8946 8.89449 18.707 8.707L13.293 3.293C13.1055 3.10545 12.8512 3.00006 12.586 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V16M5 21L9.879 16.121M9.879 16.121C10.1567 16.4033 10.4876 16.6279 10.8525 16.7817C11.2174 16.9355 11.6092 17.0156 12.0052 17.0173C12.4012 17.0189 12.7936 16.9421 13.1599 16.7914C13.5261 16.6406 13.8588 16.4188 14.1388 16.1388C14.4189 15.8588 14.6408 15.5262 14.7916 15.16C14.9425 14.7938 15.0193 14.4014 15.0177 14.0054C15.0162 13.6094 14.9362 13.2176 14.7825 12.8526C14.6287 12.4877 14.4043 12.1568 14.122 11.879C13.5579 11.3239 12.7973 11.0142 12.0059 11.0173C11.2145 11.0204 10.4564 11.3362 9.8967 11.8957C9.33702 12.4553 9.02111 13.2133 9.0178 14.0047C9.01448 14.7961 9.32402 15.5568 9.879 16.121Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), g8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 12H15M9 16H15M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H12.586C12.8512 3.00006 13.1055 3.10545 13.293 3.293L18.707 8.707C18.8946 8.89449 18.9999 9.1488 19 9.414V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), p8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C14.546 21.6 16.9878 20.5886 18.7881 18.7882C20.5885 16.9879 21.5999 14.5461 21.5999 12C21.5999 9.45395 20.5885 7.01215 18.7881 5.2118C16.9878 3.41145 14.546 2.40002 11.9999 2.40002C9.45382 2.40002 7.01203 3.41145 5.21168 5.2118C3.41133 7.01215 2.3999 9.45395 2.3999 12C2.3999 14.5461 3.41133 16.9879 5.21168 18.7882C7.01203 20.5886 9.45382 21.6 11.9999 21.6ZM8.3999 12C8.3999 11.3373 7.86264 10.8 7.1999 10.8C6.53716 10.8 5.9999 11.3373 5.9999 12C5.9999 12.6628 6.53716 13.2 7.1999 13.2C7.86264 13.2 8.3999 12.6628 8.3999 12ZM17.9999 12C17.9999 11.3373 17.4626 10.8 16.7999 10.8C16.1372 10.8 15.5999 11.3373 15.5999 12C15.5999 12.6628 16.1372 13.2 16.7999 13.2C17.4626 13.2 17.9999 12.6628 17.9999 12ZM10.7999 12C10.7999 11.3373 11.3372 10.8 11.9999 10.8C12.6626 10.8 13.1999 11.3373 13.1999 12C13.1999 12.6628 12.6626 13.2 11.9999 13.2C11.3372 13.2 10.7999 12.6628 10.7999 12Z",
    fill: e.color
  }
)), y8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5 12H5.01M12 12H12.01M19 12H19.01M6 12C6 12.2652 5.89464 12.5196 5.70711 12.7071C5.51957 12.8946 5.26522 13 5 13C4.73478 13 4.48043 12.8946 4.29289 12.7071C4.10536 12.5196 4 12.2652 4 12C4 11.7348 4.10536 11.4804 4.29289 11.2929C4.48043 11.1054 4.73478 11 5 11C5.26522 11 5.51957 11.1054 5.70711 11.2929C5.89464 11.4804 6 11.7348 6 12ZM13 12C13 12.2652 12.8946 12.5196 12.7071 12.7071C12.5196 12.8946 12.2652 13 12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11C12.2652 11 12.5196 11.1054 12.7071 11.2929C12.8946 11.4804 13 11.7348 13 12ZM20 12C20 12.2652 19.8946 12.5196 19.7071 12.7071C19.5196 12.8946 19.2652 13 19 13C18.7348 13 18.4804 12.8946 18.2929 12.7071C18.1054 12.5196 18 12.2652 18 12C18 11.7348 18.1054 11.4804 18.2929 11.2929C18.4804 11.1054 18.7348 11 19 11C19.2652 11 19.5196 11.1054 19.7071 11.2929C19.8946 11.4804 20 11.7348 20 12Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), w8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 5V5.01M12 12V12.01M12 19V19.01M12 6C11.7348 6 11.4804 5.89464 11.2929 5.70711C11.1054 5.51957 11 5.26522 11 5C11 4.73478 11.1054 4.48043 11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4C12.2652 4 12.5196 4.10536 12.7071 4.29289C12.8946 4.48043 13 4.73478 13 5C13 5.26522 12.8946 5.51957 12.7071 5.70711C12.5196 5.89464 12.2652 6 12 6ZM12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11C12.2652 11 12.5196 11.1054 12.7071 11.2929C12.8946 11.4804 13 11.7348 13 12C13 12.2652 12.8946 12.5196 12.7071 12.7071C12.5196 12.8946 12.2652 13 12 13ZM12 20C11.7348 20 11.4804 19.8946 11.2929 19.7071C11.1054 19.5196 11 19.2652 11 19C11 18.7348 11.1054 18.4804 11.2929 18.2929C11.4804 18.1054 11.7348 18 12 18C12.2652 18 12.5196 18.1054 12.7071 18.2929C12.8946 18.4804 13 18.7348 13 19C13 19.2652 12.8946 19.5196 12.7071 19.7071C12.5196 19.8946 12.2652 20 12 20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), b8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4 16V17C4 17.7956 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V16M16 12L12 16M12 16L8 12M12 16V4",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), E8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M18 9.20002C18 9.41669 17.9258 9.60419 17.7773 9.76252L12.5273 15.3625C12.3789 15.5209 12.2031 15.6 12 15.6C11.7969 15.6 11.6211 15.5209 11.4727 15.3625L6.22266 9.76252C6.07422 9.60419 6 9.41669 6 9.20002C6 8.98336 6.07422 8.79586 6.22266 8.63752C6.37109 8.47919 6.54688 8.40002 6.75 8.40002H17.25C17.4531 8.40002 17.6289 8.47919 17.7773 8.63752C17.9258 8.79586 18 8.98336 18 9.20002Z",
    fill: e.color
  }
)), k8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8 16H6C5.46957 16 4.96086 15.7893 4.58579 15.4142C4.21071 15.0391 4 14.5304 4 14V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H14C14.5304 4 15.0391 4.21071 15.4142 4.58579C15.7893 4.96086 16 5.46957 16 6V8M10 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V10C20 9.46957 19.7893 8.96086 19.4142 8.58579C19.0391 8.21071 18.5304 8 18 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V18C8 18.5304 8.21071 19.0391 8.58579 19.4142C8.96086 19.7893 9.46957 20 10 20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), L8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M11 4.99992H6C5.46957 4.99992 4.96086 5.21063 4.58579 5.5857C4.21071 5.96078 4 6.46948 4 6.99992V17.9999C4 18.5304 4.21071 19.0391 4.58579 19.4141C4.96086 19.7892 5.46957 19.9999 6 19.9999H17C17.5304 19.9999 18.0391 19.7892 18.4142 19.4141C18.7893 19.0391 19 18.5304 19 17.9999V12.9999M17.586 3.58592C17.7705 3.3949 17.9912 3.24253 18.2352 3.13772C18.4792 3.0329 18.7416 2.97772 19.0072 2.97542C19.2728 2.97311 19.5361 3.02371 19.7819 3.12427C20.0277 3.22484 20.251 3.37334 20.4388 3.56113C20.6266 3.74891 20.7751 3.97222 20.8756 4.21801C20.9762 4.4638 21.0268 4.72716 21.0245 4.99272C21.0222 5.25828 20.967 5.52072 20.8622 5.76473C20.7574 6.00874 20.605 6.22942 20.414 6.41392L11.828 14.9999H9V12.1719L17.586 3.58592Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), x8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.6C17.302 21.6 21.6 17.302 21.6 12C21.6 6.69809 17.302 2.40002 12 2.40002C6.69809 2.40002 2.40002 6.69809 2.40002 12C2.40002 17.302 6.69809 21.6 12 21.6ZM13.0248 13.3711H10.9043V6.90002H13.0248V13.3711ZM13.1408 15.7688C13.1408 16.4069 12.6123 16.9289 11.9678 16.9289C11.3297 16.9289 10.8012 16.4069 10.8012 15.7688C10.8012 15.1178 11.3297 14.5957 11.9678 14.5957C12.6123 14.5957 13.1408 15.1178 13.1408 15.7688Z",
    fill: e.color
  }
)), H8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0917 4.91882C13.1749 3.28682 10.8265 3.28682 9.90846 4.91882L3.21246 16.8228C2.31246 18.4236 3.46806 20.3988 5.30406 20.3988H18.6973C20.5321 20.3988 21.6877 18.4236 20.7877 16.8228L14.0917 4.91882ZM10.9032 14.8711H13.0237V8.40002H10.9032V14.8711ZM11.9667 18.4289C12.6112 18.4289 13.1397 17.9069 13.1397 17.2688C13.1397 16.6178 12.6112 16.0957 11.9667 16.0957C11.3286 16.0957 10.8 16.6178 10.8 17.2688C10.8 17.9069 11.3286 18.4289 11.9667 18.4289Z",
    fill: e.color
  }
)), M8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M10 6H6C5.46957 6 4.96086 6.21071 4.58579 6.58579C4.21071 6.96086 4 7.46957 4 8V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V14M14 4H20M20 4V10M20 4L10 14",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), V8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M13.5718 18.0667C13.0536 18.1706 12.5274 18.2226 12 18.2222C8.24604 18.2222 5.06885 15.6062 4 12C4.28777 11.0294 4.731 10.1186 5.31028 9.30756M10.2211 10.1147C10.6928 9.61453 11.3325 9.33355 11.9996 9.33355C12.6666 9.33355 13.3064 9.61453 13.7781 10.1147C14.2497 10.6148 14.5147 11.2931 14.5147 12.0004C14.5147 12.7077 14.2497 13.3861 13.7781 13.8862M10.2211 10.1147L13.7781 13.8862M10.2211 10.1147L13.7772 13.8844M13.7781 13.8862L16.5369 16.8107M10.2228 10.1156L7.46474 7.19111M7.46474 7.19111L4.4552 4M7.46474 7.19111C8.81639 6.26628 10.3914 5.77547 12 5.77778C15.754 5.77778 18.9312 8.39378 20 12C19.4099 13.9826 18.1845 15.6841 16.5361 16.8098M7.46474 7.19111L16.5361 16.8098M16.5361 16.8098L19.5448 20",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), $8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34008 3.89518C5.14642 3.70362 4.88704 3.59762 4.61781 3.60002C4.34858 3.60241 4.09104 3.71301 3.90065 3.90799C3.71027 4.10296 3.60228 4.36672 3.59994 4.64245C3.5976 4.91818 3.7011 5.18382 3.88814 5.38216L18.2637 20.1048C18.4574 20.2963 18.7168 20.4023 18.986 20.3999C19.2552 20.3975 19.5128 20.2869 19.7032 20.092C19.8935 19.897 20.0015 19.6332 20.0039 19.3575C20.0062 19.0818 19.9027 18.8161 19.7157 18.6178L18.2032 17.0688C19.8025 15.7628 20.9851 13.998 21.5999 12C20.2917 7.73357 16.4 4.63867 11.8019 4.63867C10.1923 4.63643 8.60488 5.02341 7.16886 5.7681L5.34111 3.89518H5.34008ZM9.71539 8.37506L11.27 9.96825C11.6182 9.87356 11.9846 9.87418 12.3324 9.97007C12.6803 10.066 12.9975 10.2537 13.2522 10.5146C13.507 10.7755 13.6903 11.1004 13.784 11.4566C13.8776 11.8129 13.8782 12.1881 13.7857 12.5447L15.3404 14.1369C15.8034 13.3334 15.9926 12.3952 15.8781 11.4696C15.7635 10.5441 15.3518 9.68379 14.7077 9.02409C14.0635 8.3644 13.2235 7.94273 12.3198 7.82543C11.416 7.70813 10.4999 7.90184 9.71539 8.37611V8.37506Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.3999 18.886L11.695 16.0829C10.7224 16.0198 9.8054 15.5911 9.1162 14.8773C8.427 14.1635 8.01295 13.2138 7.95175 12.2062L4.27753 8.39998C3.43246 9.44248 2.79438 10.6476 2.3999 11.9461C3.67433 16.1502 7.46659 19.2 11.9451 19.2C12.7924 19.2 13.6146 19.0912 14.3999 18.886Z",
    fill: e.color
  }
)), O8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4 12C5.06812 8.52257 8.24649 6 12 6C15.7543 6 18.9319 8.52257 20 12C18.9319 15.4774 15.7543 18 12 18C8.24649 18 5.06812 15.4774 4 12Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), S8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M11.9999 14.4C12.6364 14.4 13.2469 14.1471 13.697 13.697C14.147 13.247 14.3999 12.6365 14.3999 12C14.3999 11.3635 14.147 10.753 13.697 10.3029C13.2469 9.85285 12.6364 9.59999 11.9999 9.59999C11.3634 9.59999 10.7529 9.85285 10.3028 10.3029C9.85276 10.753 9.5999 11.3635 9.5999 12C9.5999 12.6365 9.85276 13.247 10.3028 13.697C10.7529 14.1471 11.3634 14.4 11.9999 14.4Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 12C3.68165 7.82707 7.49468 4.79999 11.9999 4.79999C16.5051 4.79999 20.3182 7.82707 21.5999 12C20.3182 16.1729 16.5051 19.2 11.9999 19.2C7.49468 19.2 3.68165 16.1729 2.3999 12ZM16.0242 12C16.0242 13.0912 15.6002 14.1376 14.8455 14.9092C14.0908 15.6808 13.0672 16.1143 11.9999 16.1143C10.9326 16.1143 9.90899 15.6808 9.15428 14.9092C8.39958 14.1376 7.97559 13.0912 7.97559 12C7.97559 10.9088 8.39958 9.86233 9.15428 9.09075C9.90899 8.31917 10.9326 7.8857 11.9999 7.8857C13.0672 7.8857 14.0908 8.31917 14.8455 9.09075C15.6002 9.86233 16.0242 10.9088 16.0242 12Z",
    fill: e.color
  }
)), Z8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V6.586C3.00006 6.85119 3.10545 7.10551 3.293 7.293L9.707 13.707C9.89455 13.8945 9.99994 14.1488 10 14.414V21L14 17V14.414C14.0001 14.1488 14.1055 13.8945 14.293 13.707L20.707 7.293C20.8946 7.10551 20.9999 6.85119 21 6.586V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), D8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 11C12 14.517 10.991 17.799 9.247 20.571M5.807 18.531L5.861 18.441C7.26352 16.2129 8.00523 13.6327 8 11C8 9.9391 8.42143 8.92168 9.17157 8.17154C9.92172 7.42139 10.9391 6.99997 12 6.99997C13.0609 6.99997 14.0783 7.42139 14.8284 8.17154C15.5786 8.92168 16 9.9391 16 11C16 12.017 15.93 13.019 15.797 14M13.679 20.844C14.2962 19.6125 14.7958 18.3254 15.171 17M19.01 18.132C19.655 15.866 20 13.473 20 11C20.0003 9.59552 19.6309 8.21574 18.9289 6.99934C18.2269 5.78293 17.217 4.77277 16.0008 4.07041C14.7846 3.36806 13.4049 2.99825 12.0004 2.99817C10.596 2.99809 9.21629 3.36774 8 4.06997M3 15.364C3.64 14.045 4 12.564 4 11C4 9.54297 4.39 8.17697 5.07 6.99997",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), _8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 13H15M12 10V16M3 17V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H11L13 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), B8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 10V16M12 16L9 13M12 16L15 13M3 17V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H11L13 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), T8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5 19C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H9L11 7H15C15.5304 7 16.0391 7.21071 16.4142 7.58579C16.7893 7.96086 17 8.46957 17 9V10M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V12C21 11.4696 20.7893 10.9609 20.4142 10.5858C20.0391 10.2107 19.5304 10 19 10H9C8.46957 10 7.96086 10.2107 7.58579 10.5858C7.21071 10.9609 7 11.4696 7 12V17C7 17.5304 6.78929 18.0391 6.41421 18.4142C6.03914 18.7893 5.53043 19 5 19Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), W8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3 17V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H11L13 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), R8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 13H15M3 17V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H11L13 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), j8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement("g", { clipPath: "url(#clip0_984_3112)" }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5 3.625H19C19.7548 3.625 20.375 4.24518 20.375 5V14.7411L14.7411 20.375H5C4.24518 20.375 3.625 19.7548 3.625 19V5C3.625 4.24518 4.24518 3.625 5 3.625Z",
    stroke: e.color,
    strokeWidth: 1.25
  }
), /* @__PURE__ */ t.createElement("path", { d: "M20.5 14.5H14.5V20", stroke: e.color, strokeWidth: 1.25 }), /* @__PURE__ */ t.createElement("path", { d: "M7.5 8.5H16.5", stroke: e.color, strokeWidth: 1.25 }), /* @__PURE__ */ t.createElement("path", { d: "M7.5 12.5H12", stroke: e.color, strokeWidth: 1.25 })), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement("clipPath", { id: "clip0_984_3112" }, /* @__PURE__ */ t.createElement("rect", { width: 24, height: 24, fill: "white" })))), A8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21M21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3M21 12H3M12 21C9.61305 21 7.32387 20.0518 5.63604 18.364C3.94821 16.6761 3 14.3869 3 12M12 21C13.657 21 15 16.97 15 12C15 7.03 13.657 3 12 3M12 21C10.343 21 9 16.97 9 12C9 7.03 10.343 3 12 3M12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), I8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3.055 11H5C5.53043 11 6.03914 11.2107 6.41421 11.5858C6.78929 11.9609 7 12.4696 7 13V14C7 14.5304 7.21071 15.0391 7.58579 15.4142C7.96086 15.7893 8.46957 16 9 16C9.53043 16 10.0391 16.2107 10.4142 16.5858C10.7893 16.9609 11 17.4696 11 18V20.945M8 3.935V5.5C8 6.16304 8.26339 6.79893 8.73223 7.26777C9.20107 7.73661 9.83696 8 10.5 8H11C11.5304 8 12.0391 8.21071 12.4142 8.58579C12.7893 8.96086 13 9.46957 13 10C13 10.5304 13.2107 11.0391 13.5858 11.4142C13.9609 11.7893 14.4696 12 15 12C15.5304 12 16.0391 11.7893 16.4142 11.4142C16.7893 11.0391 17 10.5304 17 10C17 9.46957 17.2107 8.96086 17.5858 8.58579C17.9609 8.21071 18.4696 8 19 8H20.064M15 20.488V18C15 17.4696 15.2107 16.9609 15.5858 16.5858C15.9609 16.2107 16.4696 16 17 16H20.064M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), N8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M7 11.5V14M7 11.5V5.5C7 5.10218 7.15804 4.72064 7.43934 4.43934C7.72064 4.15804 8.10218 4 8.5 4C8.89782 4 9.27936 4.15804 9.56066 4.43934C9.84196 4.72064 10 5.10218 10 5.5M7 11.5C7 11.1022 6.84196 10.7206 6.56066 10.4393C6.27936 10.158 5.89782 10 5.5 10C5.10218 10 4.72064 10.158 4.43934 10.4393C4.15804 10.7206 4 11.1022 4 11.5V13.5C4 15.4891 4.79018 17.3968 6.1967 18.8033C7.60322 20.2098 9.51088 21 11.5 21C13.4891 21 15.3968 20.2098 16.8033 18.8033C18.2098 17.3968 19 15.4891 19 13.5V8.5C19 8.10218 18.842 7.72064 18.5607 7.43934C18.2794 7.15804 17.8978 7 17.5 7C17.1022 7 16.7206 7.15804 16.4393 7.43934C16.158 7.72064 16 8.10218 16 8.5M10 5.5V11M10 5.5V4.5C10 4.10218 10.158 3.72064 10.4393 3.43934C10.7206 3.15804 11.1022 3 11.5 3C11.8978 3 12.2794 3.15804 12.5607 3.43934C12.842 3.72064 13 4.10218 13 4.5V5.5M16 8.5V5.5C16 5.10218 15.842 4.72064 15.5607 4.43934C15.2794 4.15804 14.8978 4 14.5 4C14.1022 4 13.7206 4.15804 13.4393 4.43934C13.158 4.72064 13 5.10218 13 5.5M16 8.5V11M13 5.5V11",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), F8 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 11V4H19V21H17V13H7V21H5V4H7V11H17Z" })), P8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3.3425 7.77795C3.56865 7.23198 3.90012 6.7359 4.31799 6.31804C4.73586 5.90017 5.23194 5.5687 5.7779 5.34255C6.32387 5.1164 6.90904 5 7.49999 5C8.09095 5 8.67611 5.1164 9.22208 5.34255C9.76805 5.5687 10.2641 5.90017 10.682 6.31804L12 7.63604L13.318 6.31804C14.1619 5.47412 15.3065 5.00001 16.5 5.00001C17.6935 5.00001 18.8381 5.47412 19.682 6.31804C20.5259 7.16196 21 8.30656 21 9.50004C21 10.6935 20.5259 11.8381 19.682 12.682L12 20.364L4.31799 12.682C3.90012 12.2642 3.56865 11.7681 3.3425 11.2221C3.11635 10.6762 2.99995 10.091 2.99995 9.50004C2.99995 8.90909 3.11635 8.32392 3.3425 7.77795Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), G8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H9M19 10L21 12M19 10V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H15M9 21C9.26522 21 9.51957 20.8946 9.70711 20.7071C9.89464 20.5196 10 20.2652 10 20V16C10 15.7348 10.1054 15.4804 10.2929 15.2929C10.4804 15.1054 10.7348 15 11 15H13C13.2652 15 13.5196 15.1054 13.7071 15.2929C13.8946 15.4804 14 15.7348 14 16V20C14 20.2652 14.1054 20.5196 14.2929 20.7071C14.4804 20.8946 14.7348 21 15 21M9 21H15",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), z8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M10 6H5C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21071 6.96086 3 7.46957 3 8V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V8C21 7.46957 20.7893 6.96086 20.4142 6.58579C20.0391 6.21071 19.5304 6 19 6H14M10 6V5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5V6M10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6M9 14C9.53043 14 10.0391 13.7893 10.4142 13.4142C10.7893 13.0391 11 12.5304 11 12C11 11.4696 10.7893 10.9609 10.4142 10.5858C10.0391 10.2107 9.53043 10 9 10C8.46957 10 7.96086 10.2107 7.58579 10.5858C7.21071 10.9609 7 11.4696 7 12C7 12.5304 7.21071 13.0391 7.58579 13.4142C7.96086 13.7893 8.46957 14 9 14ZM9 14C10.306 14 11.417 14.835 11.83 16M9 14C8.37938 13.9998 7.77397 14.1921 7.26715 14.5502C6.76032 14.9084 6.37701 15.4149 6.17 16M15 11H18M15 15H17",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Y8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H16M12 3V11M12 11L15 8M12 11L9 8M4 13H6.586C6.85119 13.0001 7.10551 13.1055 7.293 13.293L9.707 15.707C9.89449 15.8945 10.1488 15.9999 10.414 16H13.586C13.8512 15.9999 14.1055 15.8945 14.293 15.707L16.707 13.293C16.8945 13.1055 17.1488 13.0001 17.414 13H20",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), U8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M20 13V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V13M20 13V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H6C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18V13M20 13H17.414C17.1488 13.0001 16.8945 13.1055 16.707 13.293L14.293 15.707C14.1055 15.8945 13.8512 15.9999 13.586 16H10.414C10.1488 15.9999 9.89449 15.8945 9.707 15.707L7.293 13.293C7.10551 13.1055 6.85119 13.0001 6.586 13H4",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), q8 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C17.3018 21.6 21.5999 17.302 21.5999 12C21.5999 6.69809 17.3018 2.40002 11.9999 2.40002C6.69797 2.40002 2.3999 6.69809 2.3999 12C2.3999 17.302 6.69797 21.6 11.9999 21.6ZM13.1999 8.28003C13.1999 8.94277 12.6626 9.48003 11.9999 9.48003C11.3372 9.48003 10.7999 8.94277 10.7999 8.28003C10.7999 7.61728 11.3372 7.08003 11.9999 7.08003C12.6626 7.08003 13.1999 7.61728 13.1999 8.28003ZM13.0799 15.96V10.62L10.1999 10.62V11.82H10.9199V15.96H10.1999V17.16H13.7999V15.96H13.0799Z",
    fill: e.color
  }
)), X8 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V4C13 3.44772 13.4477 3 14 3H20ZM19 5H15V19H19V5ZM6 7C8.76142 7 11 9.23858 11 12C11 14.7614 8.76142 17 6 17C3.23858 17 1 14.7614 1 12C1 9.23858 3.23858 7 6 7ZM7 9H5V10.999L3 11V13L5 12.999V15H7V12.999L9 13V11L7 10.999V9Z" })), K8 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M10 3C10.5523 3 11 3.44772 11 4V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM9 5H5V19H9V5ZM18 7C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17C15.2386 17 13 14.7614 13 12C13 9.23858 15.2386 7 18 7ZM19 9H17V10.999L15 11V13L17 12.999V15H19V12.999L21 13V11L19 10.999V9Z" })), J8 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 13C14.7614 13 17 15.2386 17 18C17 20.7614 14.7614 23 12 23C9.23858 23 7 20.7614 7 18C7 15.2386 9.23858 13 12 13ZM13 15H11V16.999L9 17V19L11 18.999V21H13V18.999L15 19V17L13 16.999V15ZM20 3C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V4C3 3.44772 3.44772 3 4 3H20ZM5 5V9H19V5H5Z" })), Q8 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M20 13C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13H20ZM19 15H5V19H19V15ZM12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1ZM13 3H11V4.999L9 5V7L11 6.999V9H13V6.999L15 7V5L13 4.999V3Z" })), e6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z" })), t6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9.663 17H14.336M12 3V4M18.364 5.636L17.657 6.343M21 12H20M4 12H3M6.343 6.343L5.636 5.636M8.464 15.536C7.76487 14.8367 7.2888 13.9458 7.09598 12.9759C6.90316 12.006 7.00225 11.0008 7.38073 10.0872C7.75921 9.17366 8.40007 8.39284 9.22229 7.84349C10.0445 7.29414 11.0111 7.00093 12 7.00093C12.9889 7.00093 13.9555 7.29414 14.7777 7.84349C15.5999 8.39284 16.2408 9.17366 16.6193 10.0872C16.9977 11.0008 17.0968 12.006 16.904 12.9759C16.7112 13.9458 16.2351 14.8367 15.536 15.536L14.988 16.083C14.6747 16.3963 14.4262 16.7683 14.2567 17.1777C14.0872 17.5871 13.9999 18.0259 14 18.469V19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19V18.469C10 17.574 9.644 16.715 9.012 16.083L8.464 15.536Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), r6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M13 3V10H20L11 21V14H4L13 3Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), n6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M13.828 10.172C13.0779 9.42216 12.0607 9.0009 11 9.0009C9.93936 9.0009 8.92213 9.42216 8.17202 10.172L4.17202 14.172C3.78998 14.541 3.48525 14.9824 3.27561 15.4704C3.06598 15.9584 2.95563 16.4833 2.95102 17.0144C2.9464 17.5456 3.04761 18.0723 3.24873 18.5639C3.44986 19.0554 3.74687 19.5021 4.12244 19.8776C4.49801 20.2532 4.94462 20.5502 5.4362 20.7513C5.92779 20.9525 6.45451 21.0537 6.98562 21.049C7.51674 21.0444 8.04162 20.9341 8.52964 20.7244C9.01765 20.5148 9.45903 20.2101 9.82802 19.828L10.93 18.727M10.172 13.828C10.9221 14.5779 11.9394 14.9992 13 14.9992C14.0607 14.9992 15.0779 14.5779 15.828 13.828L19.828 9.82804C20.5567 9.07363 20.9598 8.06322 20.9507 7.01444C20.9416 5.96565 20.5209 4.9624 19.7793 4.22077C19.0377 3.47913 18.0344 3.05846 16.9856 3.04935C15.9368 3.04023 14.9264 3.44341 14.172 4.17204L13.072 5.27204",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), o6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17 17H22V19H19V22H17V17ZM7 7H2V5H5V2H7V7ZM18.364 15.5355L16.9497 14.1213L18.364 12.7071C20.3166 10.7545 20.3166 7.58866 18.364 5.63604C16.4113 3.68342 13.2455 3.68342 11.2929 5.63604L9.87868 7.05025L8.46447 5.63604L9.87868 4.22183C12.6123 1.48816 17.0445 1.48816 19.7782 4.22183C22.5118 6.9555 22.5118 11.3877 19.7782 14.1213L18.364 15.5355ZM15.5355 18.364L14.1213 19.7782C11.3877 22.5118 6.9555 22.5118 4.22183 19.7782C1.48816 17.0445 1.48816 12.6123 4.22183 9.87868L5.63604 8.46447L7.05025 9.87868L5.63604 11.2929C3.68342 13.2455 3.68342 16.4113 5.63604 18.364C7.58866 20.3166 10.7545 20.3166 12.7071 18.364L14.1213 16.9497L15.5355 18.364ZM14.8284 7.75736L16.2426 9.17157L9.17157 16.2426L7.75736 14.8284L14.8284 7.75736Z" })), a6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M17.657 14.8284L16.2428 13.4142L17.657 12C19.2191 10.4379 19.2191 7.90526 17.657 6.34316C16.0949 4.78106 13.5622 4.78106 12.0001 6.34316L10.5859 7.75737L9.17171 6.34316L10.5859 4.92895C12.9291 2.5858 16.7281 2.5858 19.0712 4.92895C21.4143 7.27209 21.4143 11.0711 19.0712 13.4142L17.657 14.8284ZM14.8286 17.6569L13.4143 19.0711C11.0712 21.4142 7.27221 21.4142 4.92907 19.0711C2.58592 16.7279 2.58592 12.9289 4.92907 10.5858L6.34328 9.17159L7.75749 10.5858L6.34328 12C4.78118 13.5621 4.78118 16.0948 6.34328 17.6569C7.90538 19.219 10.438 19.219 12.0001 17.6569L13.4143 16.2427L14.8286 17.6569ZM14.8286 7.75737L16.2428 9.17159L9.17171 16.2427L7.75749 14.8284L14.8286 7.75737ZM5.77539 2.29291L7.70724 1.77527L8.74252 5.63897L6.81067 6.15661L5.77539 2.29291ZM15.2578 18.3611L17.1896 17.8434L18.2249 21.7071L16.293 22.2248L15.2578 18.3611ZM2.29303 5.77527L6.15673 6.81054L5.63909 8.7424L1.77539 7.70712L2.29303 5.77527ZM18.3612 15.2576L22.2249 16.2929L21.7072 18.2248L17.8435 17.1895L18.3612 15.2576Z" })), i6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M5.75024 3.5H4.71733L3.25 3.89317V5.44582L4.25002 5.17782L4.25018 8.5H3V10H7V8.5H5.75024V3.5ZM10 4H21V6H10V4ZM10 11H21V13H10V11ZM10 18H21V20H10V18ZM2.875 15.625C2.875 14.4514 3.82639 13.5 5 13.5C6.17361 13.5 7.125 14.4514 7.125 15.625C7.125 16.1106 6.96183 16.5587 6.68747 16.9167L6.68271 16.9229L5.31587 18.5H7V20H3.00012L2.99959 18.8786L5.4717 16.035C5.5673 15.9252 5.625 15.7821 5.625 15.625C5.625 15.2798 5.34518 15 5 15C4.67378 15 4.40573 15.2501 4.37747 15.5688L4.3651 15.875H2.875V15.625Z" })), l6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M8 4H21V6H8V4ZM4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5C6 5.82843 5.32843 6.5 4.5 6.5ZM4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12C6 12.8284 5.32843 13.5 4.5 13.5ZM4.5 20.4C3.67157 20.4 3 19.7284 3 18.9C3 18.0716 3.67157 17.4 4.5 17.4C5.32843 17.4 6 18.0716 6 18.9C6 19.7284 5.32843 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" })), c6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17.657 16.657L13.414 20.9C13.2284 21.0857 13.0081 21.233 12.7656 21.3336C12.523 21.4341 12.2631 21.4859 12.0005 21.4859C11.738 21.4859 11.478 21.4341 11.2354 21.3336C10.9929 21.233 10.7726 21.0857 10.587 20.9L6.343 16.657C5.22422 15.5381 4.46234 14.1127 4.15369 12.5608C3.84504 11.009 4.00349 9.40047 4.60901 7.93868C5.21452 6.4769 6.2399 5.22749 7.55548 4.34846C8.87107 3.46943 10.4178 3.00024 12 3.00024C13.5822 3.00024 15.1289 3.46943 16.4445 4.34846C17.7601 5.22749 18.7855 6.4769 19.391 7.93868C19.9965 9.40047 20.155 11.009 19.8463 12.5608C19.5377 14.1127 18.7758 15.5381 17.657 16.657Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.1213 13.1213C14.6839 12.5587 15 11.7956 15 11C15 10.2043 14.6839 9.44124 14.1213 8.87863C13.5587 8.31602 12.7957 7.99995 12 7.99995C11.2044 7.99995 10.4413 8.31602 9.87868 8.87863C9.31607 9.44124 9 10.2043 9 11C9 11.7956 9.31607 12.5587 9.87868 13.1213C10.4413 13.6839 11.2044 14 12 14C12.7957 14 13.5587 13.6839 14.1213 13.1213Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), C6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 15V17M6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V13C20 12.4696 19.7893 11.9609 19.4142 11.5858C19.0391 11.2107 18.5304 11 18 11H6C5.46957 11 4.96086 11.2107 4.58579 11.5858C4.21071 11.9609 4 12.4696 4 13V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21ZM16 11V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V11H16Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), s6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8 11V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7M12 15V17M6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V13C20 12.4696 19.7893 11.9609 19.4142 11.5858C19.0391 11.2107 18.5304 11 18 11H6C5.46957 11 4.96086 11.2107 4.58579 11.5858C4.21071 11.9609 4 12.4696 4 13V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), u6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M11 16L7 12M7 12L11 8M7 12H21M16 16V17C16 17.7956 15.6839 18.5587 15.1213 19.1213C14.5587 19.6839 13.7956 20 13 20H6C5.20435 20 4.44129 19.6839 3.87868 19.1213C3.31607 18.5587 3 17.7956 3 17V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H13C13.7956 4 14.5587 4.31607 15.1213 4.87868C15.6839 5.44129 16 6.20435 16 7V8",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), d6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 16L21 12M21 12L17 8M21 12H7M13 16V17C13 17.7956 12.6839 18.5587 12.1213 19.1213C11.5587 19.6839 10.7956 20 10 20H6C5.20435 20 4.44129 19.6839 3.87868 19.1213C3.31607 18.5587 3 17.7956 3 17V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H10C10.7956 4 11.5587 4.31607 12.1213 4.87868C12.6839 5.44129 13 6.20435 13 7V8",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), f6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3 19.0001V10.0701C2.99995 9.74092 3.08116 9.41682 3.23641 9.12654C3.39166 8.83627 3.61617 8.58881 3.89 8.40611L10.89 3.74011C11.2187 3.52083 11.6049 3.40381 12 3.40381C12.3951 3.40381 12.7813 3.52083 13.11 3.74011L20.11 8.40611C20.3838 8.58881 20.6083 8.83627 20.7636 9.12654C20.9188 9.41682 21 9.74092 21 10.0701V19.0001M3 19.0001C3 19.5305 3.21071 20.0392 3.58579 20.4143C3.96086 20.7894 4.46957 21.0001 5 21.0001H19C19.5304 21.0001 20.0391 20.7894 20.4142 20.4143C20.7893 20.0392 21 19.5305 21 19.0001M3 19.0001L9.75 14.5001M21 19.0001L14.25 14.5001M9.75 14.5001L3 10.0001M9.75 14.5001L10.89 15.2601C11.2187 15.4794 11.6049 15.5964 12 15.5964C12.3951 15.5964 12.7813 15.4794 13.11 15.2601L14.25 14.5001M14.25 14.5001L21 10.0001",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), m6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), h6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 20L3.553 17.276C3.38692 17.193 3.24722 17.0654 3.14955 16.9075C3.05188 16.7496 3.0001 16.5677 3 16.382V5.618C3.00009 5.44761 3.04372 5.28007 3.12674 5.13127C3.20977 4.98248 3.32944 4.85736 3.47439 4.76781C3.61935 4.67825 3.78479 4.62721 3.95501 4.61955C4.12522 4.61188 4.29458 4.64784 4.447 4.724L9 7M9 20V7M9 20L15 17M9 7L15 4M15 17L19.553 19.276C19.7054 19.3522 19.8748 19.3881 20.045 19.3805C20.2152 19.3728 20.3806 19.3218 20.5256 19.2322C20.6706 19.1426 20.7902 19.0175 20.8733 18.8687C20.9563 18.7199 20.9999 18.5524 21 18.382V7.618C20.9999 7.43234 20.9481 7.25037 20.8504 7.09247C20.7528 6.93458 20.6131 6.80699 20.447 6.724L15 4M15 17V4",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), v6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4 18H11M4 6H20H4ZM4 12H20H4Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), g6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15 12H9M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), p6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C14.546 21.6 16.9878 20.5886 18.7881 18.7882C20.5885 16.9879 21.5999 14.5461 21.5999 12C21.5999 9.45395 20.5885 7.01215 18.7881 5.2118C16.9878 3.41145 14.546 2.40002 11.9999 2.40002C9.45382 2.40002 7.01203 3.41145 5.21168 5.2118C3.41133 7.01215 2.3999 9.45395 2.3999 12C2.3999 14.5461 3.41133 16.9879 5.21168 18.7882C7.01203 20.5886 9.45382 21.6 11.9999 21.6ZM8.3999 10.8C8.08164 10.8 7.77642 10.9265 7.55137 11.1515C7.32633 11.3765 7.1999 11.6818 7.1999 12C7.1999 12.3183 7.32633 12.6235 7.55137 12.8486C7.77642 13.0736 8.08164 13.2 8.3999 13.2H15.5999C15.9182 13.2 16.2234 13.0736 16.4484 12.8486C16.6735 12.6235 16.7999 12.3183 16.7999 12C16.7999 11.6818 16.6735 11.3765 16.4484 11.1515C16.2234 10.9265 15.9182 10.8 15.5999 10.8H8.3999Z",
    fill: e.color
  }
)), y6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M18 12H6",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), w6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5 9H5.01M12 9H12.01M19 9H19.01M5 15H5.01M12 15H12.01M19 15H19.01M6 9C6 9.26522 5.89464 9.51957 5.70711 9.70711C5.51957 9.89464 5.26522 10 5 10C4.73478 10 4.48043 9.89464 4.29289 9.70711C4.10536 9.51957 4 9.26522 4 9C4 8.73478 4.10536 8.48043 4.29289 8.29289C4.48043 8.10536 4.73478 8 5 8C5.26522 8 5.51957 8.10536 5.70711 8.29289C5.89464 8.48043 6 8.73478 6 9ZM13 9C13 9.26522 12.8946 9.51957 12.7071 9.70711C12.5196 9.89464 12.2652 10 12 10C11.7348 10 11.4804 9.89464 11.2929 9.70711C11.1054 9.51957 11 9.26522 11 9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9ZM20 9C20 9.26522 19.8946 9.51957 19.7071 9.70711C19.5196 9.89464 19.2652 10 19 10C18.7348 10 18.4804 9.89464 18.2929 9.70711C18.1054 9.51957 18 9.26522 18 9C18 8.73478 18.1054 8.48043 18.2929 8.29289C18.4804 8.10536 18.7348 8 19 8C19.2652 8 19.5196 8.10536 19.7071 8.29289C19.8946 8.48043 20 8.73478 20 9ZM6 15C6 15.2652 5.89464 15.5196 5.70711 15.7071C5.51957 15.8947 5.26522 16 5 16C4.73478 16 4.48043 15.8947 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15C4 14.7348 4.10536 14.4804 4.29289 14.2929C4.48043 14.1054 4.73478 14 5 14C5.26522 14 5.51957 14.1054 5.70711 14.2929C5.89464 14.4804 6 14.7348 6 15ZM13 15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8947 12.2652 16 12 16C11.7348 16 11.4804 15.8947 11.2929 15.7071C11.1054 15.5196 11 15.2652 11 15C11 14.7348 11.1054 14.4804 11.2929 14.2929C11.4804 14.1054 11.7348 14 12 14C12.2652 14 12.5196 14.1054 12.7071 14.2929C12.8946 14.4804 13 14.7348 13 15ZM20 15C20 15.2652 19.8946 15.5196 19.7071 15.7071C19.5196 15.8947 19.2652 16 19 16C18.7348 16 18.4804 15.8947 18.2929 15.7071C18.1054 15.5196 18 15.2652 18 15C18 14.7348 18.1054 14.4804 18.2929 14.2929C18.4804 14.1054 18.7348 14 19 14C19.2652 14 19.5196 14.1054 19.7071 14.2929C19.8946 14.4804 20 14.7348 20 15Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), b6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8.39999 7.8H15.6M8.39999 11.8H12M19.2 10.2V5.4C19.2 4.07452 18.1255 3 16.8 3H7.19999C5.8745 3 4.79999 4.07452 4.79999 5.4V18.6C4.79999 19.9255 5.8745 21 7.19999 21H8.69999M17.9895 13.4895C18.1279 13.3462 18.2934 13.232 18.4764 13.1534C18.6594 13.0747 18.8562 13.0334 19.0554 13.0316C19.2546 13.0299 19.4521 13.0679 19.6364 13.1433C19.8208 13.2187 19.9882 13.3301 20.1291 13.4709C20.2699 13.6118 20.3813 13.7792 20.4567 13.9636C20.5321 14.1479 20.5701 14.3454 20.5684 14.5446C20.5666 14.7438 20.5253 14.9406 20.4466 15.1236C20.368 15.3066 20.2538 15.4721 20.1105 15.6105L13.671 22.05H11.55V19.929L17.9895 13.4895Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), E6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M19 20H5C4.46957 20 3.96086 19.7893 3.58579 19.4142C3.21071 19.0391 3 18.5304 3 18V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H15C15.5304 4 16.0391 4.21071 16.4142 4.58579C16.7893 4.96086 17 5.46957 17 6V7M19 20C18.4696 20 17.9609 19.7893 17.5858 19.4142C17.2107 19.0391 17 18.5304 17 18V7M19 20C19.5304 20 20.0391 19.7893 20.4142 19.4142C20.7893 19.0391 21 18.5304 21 18V9C21 8.46957 20.7893 7.96086 20.4142 7.58579C20.0391 7.21071 19.5304 7 19 7H17M13 4H9M7 16H13M7 8H13V12H7V8Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), k6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M19 21V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V21M19 21H5M19 21H21M19 21H14M5 21H3M5 21H10M14 21V16C14 15.7348 13.8946 15.4804 13.7071 15.2929C13.5196 15.1054 13.2652 15 13 15H11C10.7348 15 10.4804 15.1054 10.2929 15.2929C10.1054 15.4804 10 15.7348 10 16V21M14 21H10M9 7H10M9 11H10M14 7H15M14 11H15",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), L6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M20.1 21.5478V22.1728C20.4452 22.1728 20.725 21.893 20.725 21.5478H20.1ZM12.3 21.5478H11.675C11.675 21.893 11.9548 22.1728 12.3 22.1728V21.5478ZM8.39999 7.175C8.05481 7.175 7.77499 7.45482 7.77499 7.8C7.77499 8.14518 8.05481 8.425 8.39999 8.425V7.175ZM15.6 8.425C15.9452 8.425 16.225 8.14518 16.225 7.8C16.225 7.45482 15.9452 7.175 15.6 7.175V8.425ZM8.39999 11.175C8.05481 11.175 7.77499 11.4548 7.77499 11.8C7.77499 12.1452 8.05481 12.425 8.39999 12.425V11.175ZM12 12.425C12.3452 12.425 12.625 12.1452 12.625 11.8C12.625 11.4548 12.3452 11.175 12 11.175V12.425ZM18.575 10.2C18.575 10.5452 18.8548 10.825 19.2 10.825C19.5452 10.825 19.825 10.5452 19.825 10.2H18.575ZM8.69999 21.625C9.04517 21.625 9.32499 21.3452 9.32499 21C9.32499 20.6548 9.04517 20.375 8.69999 20.375V21.625ZM17.375 14.0609C17.375 14.6407 16.8754 15.1576 16.2 15.1576V16.4076C17.5128 16.4076 18.625 15.3828 18.625 14.0609H17.375ZM16.2 15.1576C15.5246 15.1576 15.025 14.6407 15.025 14.0609H13.775C13.775 15.3828 14.8872 16.4076 16.2 16.4076V15.1576ZM15.025 14.0609C15.025 13.4811 15.5246 12.9641 16.2 12.9641V11.7141C14.8872 11.7141 13.775 12.7389 13.775 14.0609H15.025ZM16.2 12.9641C16.8754 12.9641 17.375 13.4811 17.375 14.0609H18.625C18.625 12.7389 17.5128 11.7141 16.2 11.7141V12.9641ZM14.7 18.1554H17.7V16.9054H14.7V18.1554ZM19.475 19.9304V21.5478H20.725V19.9304H19.475ZM20.1 20.9228H12.3V22.1728H20.1V20.9228ZM12.925 21.5478V19.9304H11.675V21.5478H12.925ZM17.7 18.1554C18.6803 18.1554 19.475 18.9501 19.475 19.9304H20.725C20.725 18.2598 19.3707 16.9054 17.7 16.9054V18.1554ZM14.7 16.9054C13.0293 16.9054 11.675 18.2598 11.675 19.9304H12.925C12.925 18.9501 13.7197 18.1554 14.7 18.1554V16.9054ZM8.39999 8.425H15.6V7.175H8.39999V8.425ZM8.39999 12.425H12V11.175H8.39999V12.425ZM7.19999 3.625H16.8V2.375H7.19999V3.625ZM5.42499 18.6V5.4H4.17499V18.6H5.42499ZM7.19999 20.375C6.21968 20.375 5.42499 19.5803 5.42499 18.6H4.17499C4.17499 20.2707 5.52933 21.625 7.19999 21.625V20.375ZM16.8 3.625C17.7803 3.625 18.575 4.41969 18.575 5.4H19.825C19.825 3.72934 18.4706 2.375 16.8 2.375V3.625ZM7.19999 2.375C5.52933 2.375 4.17499 3.72934 4.17499 5.4H5.42499C5.42499 4.41969 6.21968 3.625 7.19999 3.625V2.375ZM18.575 5.4V10.2H19.825V5.4H18.575ZM7.19999 21.625H8.69999V20.375H7.19999V21.625Z",
    fill: e.color
  }
)), x6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15.172 6.99992L8.58602 13.5859C8.395 13.7704 8.24264 13.9911 8.13782 14.2351C8.033 14.4791 7.97783 14.7416 7.97552 15.0071C7.97321 15.2727 8.02381 15.536 8.12438 15.7818C8.22494 16.0276 8.37344 16.2509 8.56123 16.4387C8.74902 16.6265 8.97232 16.775 9.21811 16.8756C9.4639 16.9761 9.72726 17.0267 9.99282 17.0244C10.2584 17.0221 10.5208 16.9669 10.7648 16.8621C11.0088 16.7573 11.2295 16.6049 11.414 16.4139L17.828 9.82792C18.5567 9.07351 18.9598 8.0631 18.9507 7.01431C18.9416 5.96553 18.5209 4.96228 17.7793 4.22065C17.0377 3.47901 16.0344 3.05834 14.9856 3.04922C13.9368 3.04011 12.9264 3.44329 12.172 4.17192L5.75702 10.7569C4.63171 11.8822 3.99951 13.4085 3.99951 14.9999C3.99951 16.5914 4.63171 18.1176 5.75702 19.2429C6.88233 20.3682 8.40859 21.0004 10 21.0004C11.5915 21.0004 13.1177 20.3682 14.243 19.2429L20.5 12.9999",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), H6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M20.8968 3.1032C20.4468 2.65327 19.8364 2.40051 19.2 2.40051C18.5636 2.40051 17.9533 2.65327 17.5032 3.1032L8.40002 12.2064V15.6H11.7936L20.8968 6.4968C21.3468 6.04673 21.5995 5.43639 21.5995 4.8C21.5995 4.16361 21.3468 3.55327 20.8968 3.1032Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40002 7.2C2.40002 6.56348 2.65288 5.95303 3.10297 5.50294C3.55306 5.05286 4.1635 4.8 4.80002 4.8H9.60002C9.91828 4.8 10.2235 4.92643 10.4486 5.15147C10.6736 5.37652 10.8 5.68174 10.8 6C10.8 6.31826 10.6736 6.62348 10.4486 6.84853C10.2235 7.07357 9.91828 7.2 9.60002 7.2H4.80002V19.2H16.8V14.4C16.8 14.0817 16.9265 13.7765 17.1515 13.5515C17.3765 13.3264 17.6818 13.2 18 13.2C18.3183 13.2 18.6235 13.3264 18.8486 13.5515C19.0736 13.7765 19.2 14.0817 19.2 14.4V19.2C19.2 19.8365 18.9472 20.447 18.4971 20.8971C18.047 21.3471 17.4365 21.6 16.8 21.6H4.80002C4.1635 21.6 3.55306 21.3471 3.10297 20.8971C2.65288 20.447 2.40002 19.8365 2.40002 19.2V7.2Z",
    fill: e.color
  }
)), M6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15.232 5.23209L18.768 8.76809M16.732 3.73209C17.2009 3.26318 17.8369 2.99976 18.5 2.99976C19.1631 2.99976 19.7991 3.26318 20.268 3.73209C20.7369 4.20099 21.0003 4.83696 21.0003 5.50009C21.0003 6.16321 20.7369 6.79918 20.268 7.26809L6.5 21.0361H3V17.4641L16.732 3.73209Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), V6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V6C3 14.284 9.716 21 18 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V15.721C21.0001 15.511 20.934 15.3064 20.8112 15.136C20.6885 14.9657 20.5152 14.8383 20.316 14.772L15.823 13.274C15.5947 13.1981 15.3466 13.2071 15.1244 13.2993C14.9021 13.3915 14.7205 13.5607 14.613 13.776L13.483 16.033C11.0345 14.9267 9.07332 12.9655 7.967 10.517L10.224 9.387C10.4393 9.27945 10.6085 9.0979 10.7007 8.87564C10.7929 8.65339 10.8019 8.40534 10.726 8.177L9.228 3.684C9.16171 3.48496 9.03449 3.3118 8.86436 3.18905C8.69422 3.0663 8.48979 3.00016 8.28 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), $6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4 16L8.586 11.414C8.96106 11.0391 9.46967 10.8284 10 10.8284C10.5303 10.8284 11.0389 11.0391 11.414 11.414L16 16M14 14L15.586 12.414C15.9611 12.0391 16.4697 11.8284 17 11.8284C17.5303 11.8284 18.0389 12.0391 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), O6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C14.546 21.6 16.9878 20.5886 18.7881 18.7882C20.5885 16.9879 21.5999 14.5461 21.5999 12C21.5999 9.45395 20.5885 7.01215 18.7881 5.2118C16.9878 3.41145 14.546 2.40002 11.9999 2.40002C9.45382 2.40002 7.01203 3.41145 5.21168 5.2118C3.41133 7.01215 2.3999 9.45395 2.3999 12C2.3999 14.5461 3.41133 16.9879 5.21168 18.7882C7.01203 20.5886 9.45382 21.6 11.9999 21.6ZM11.4659 8.60162C11.2852 8.48105 11.0751 8.4118 10.8581 8.40126C10.6411 8.39072 10.4253 8.43928 10.2338 8.54178C10.0422 8.64427 9.88209 8.79684 9.77045 8.98321C9.65882 9.16959 9.59987 9.38277 9.5999 9.60002V14.4C9.59987 14.6173 9.65882 14.8305 9.77045 15.0168C9.88209 15.2032 10.0422 15.3558 10.2338 15.4583C10.4253 15.5608 10.6411 15.6093 10.8581 15.5988C11.0751 15.5883 11.2852 15.519 11.4659 15.3984L15.0659 12.9984C15.2303 12.8888 15.365 12.7404 15.4582 12.5662C15.5514 12.392 15.6002 12.1976 15.6002 12C15.6002 11.8025 15.5514 11.608 15.4582 11.4338C15.365 11.2597 15.2303 11.1112 15.0659 11.0016L11.4659 8.60162Z",
    fill: e.color
  }
)), S6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 9V12M12 12V15M12 12H15M12 12H9M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Z6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C14.546 21.6 16.9878 20.5886 18.7881 18.7882C20.5885 16.9879 21.5999 14.5461 21.5999 12C21.5999 9.45395 20.5885 7.01215 18.7881 5.2118C16.9878 3.41145 14.546 2.40002 11.9999 2.40002C9.45382 2.40002 7.01203 3.41145 5.21168 5.2118C3.41133 7.01215 2.3999 9.45395 2.3999 12C2.3999 14.5461 3.41133 16.9879 5.21168 18.7882C7.01203 20.5886 9.45382 21.6 11.9999 21.6ZM13.1999 8.40002C13.1999 8.08176 13.0735 7.77654 12.8484 7.5515C12.6234 7.32645 12.3182 7.20002 11.9999 7.20002C11.6816 7.20002 11.3764 7.32645 11.1514 7.5515C10.9263 7.77654 10.7999 8.08176 10.7999 8.40002V10.8H8.3999C8.08164 10.8 7.77642 10.9265 7.55137 11.1515C7.32633 11.3765 7.1999 11.6818 7.1999 12C7.1999 12.3183 7.32633 12.6235 7.55137 12.8486C7.77642 13.0736 8.08164 13.2 8.3999 13.2H10.7999V15.6C10.7999 15.9183 10.9263 16.2235 11.1514 16.4486C11.3764 16.6736 11.6816 16.8 11.9999 16.8C12.3182 16.8 12.6234 16.6736 12.8484 16.4486C13.0735 16.2235 13.1999 15.9183 13.1999 15.6V13.2H15.5999C15.9182 13.2 16.2234 13.0736 16.4484 12.8486C16.6735 12.6235 16.7999 12.3183 16.7999 12C16.7999 11.6818 16.6735 11.3765 16.4484 11.1515C16.2234 10.9265 15.9182 10.8 15.5999 10.8H13.1999V8.40002Z",
    fill: e.color
  }
)), D6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 6V12M12 12V18M12 12H18M12 12H6",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), _6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 17H19C19.5304 17 20.0391 16.7893 20.4142 16.4142C20.7893 16.0391 21 15.5304 21 15V11C21 10.4696 20.7893 9.96086 20.4142 9.58579C20.0391 9.21071 19.5304 9 19 9H5C4.46957 9 3.96086 9.21071 3.58579 9.58579C3.21071 9.96086 3 10.4696 3 11V15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17H7M9 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V15C17 14.4696 16.7893 13.9609 16.4142 13.5858C16.0391 13.2107 15.5304 13 15 13H9C8.46957 13 7.96086 13.2107 7.58579 13.5858C7.21071 13.9609 7 14.4696 7 15V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21ZM17 9V5C17 4.46957 16.7893 3.96086 16.4142 3.58579C16.0391 3.21071 15.5304 3 15 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V9H17Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), B6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C17.3018 21.6 21.5999 17.302 21.5999 12C21.5999 6.69809 17.3018 2.40002 11.9999 2.40002C6.69797 2.40002 2.3999 6.69809 2.3999 12C2.3999 17.302 6.69797 21.6 11.9999 21.6ZM12.8792 12.6125V13.6789H11.1615V11.4992C12.3417 11.4992 13.3232 11.2707 13.3232 10.1398C13.3232 9.34294 12.7389 8.95623 12.0204 8.95623C11.1908 8.95623 10.6825 9.46599 10.6766 10.216H8.9999C8.9999 8.55193 10.2326 7.38005 12.0145 7.38005C13.6854 7.38005 14.9999 8.40544 14.9999 10.1222C14.9999 11.8332 13.7789 12.4308 12.8792 12.6125ZM13.1129 15.5597C13.1129 16.1457 12.6396 16.6144 12.0612 16.6144C11.4712 16.6144 10.998 16.1457 10.998 15.5597C10.998 14.9679 11.4712 14.4933 12.0612 14.4933C12.6396 14.4933 13.1129 14.9679 13.1129 15.5597Z",
    fill: e.color
  }
)), T6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M9 8H15M9 12H15M19 21V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V21L8.5 19L12 21L15.5 19L19 21Z",
    stroke: "#656C73",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), W6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18.1716 6.99955H11C7.68629 6.99955 5 9.68584 5 12.9996C5 16.3133 7.68629 18.9996 11 18.9996H20V20.9996H11C6.58172 20.9996 3 17.4178 3 12.9996C3 8.58127 6.58172 4.99955 11 4.99955H18.1716L15.636 2.46402L17.0503 1.0498L22 5.99955L17.0503 10.9493L15.636 9.53509L18.1716 6.99955Z" })), R6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4 4.00005V9.00005H4.582M4.582 9.00005C5.24585 7.35818 6.43568 5.98296 7.96503 5.08991C9.49438 4.19686 11.2768 3.83646 13.033 4.06519C14.7891 4.29392 16.4198 5.09884 17.6694 6.35383C18.919 7.60881 19.7168 9.24291 19.938 11M4.582 9.00005H9M20 20V15H19.419M19.419 15C18.7542 16.641 17.564 18.0151 16.0348 18.9073C14.5056 19.7996 12.7237 20.1596 10.9681 19.9309C9.21246 19.7023 7.5822 18.8979 6.33253 17.6438C5.08287 16.3896 4.28435 14.7565 4.062 13M19.419 15H15",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), j6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79998 2.40002C5.11824 2.40002 5.42346 2.52645 5.6485 2.7515C5.87355 2.97654 5.99998 3.28176 5.99998 3.60002V6.12122C6.99842 5.10275 8.23969 4.35519 9.60687 3.94896C10.974 3.54274 12.4221 3.49121 13.8147 3.79923C15.2073 4.10725 16.4986 4.76469 17.5669 5.70962C18.6352 6.65455 19.4454 7.85587 19.9212 9.20042C19.9789 9.35013 20.006 9.5099 20.0009 9.67027C19.9958 9.83064 19.9586 9.98836 19.8915 10.1341C19.8244 10.2798 19.7287 10.4106 19.6101 10.5188C19.4916 10.6269 19.3526 10.7101 19.2013 10.7636C19.05 10.817 18.8895 10.8396 18.7294 10.83C18.5692 10.8203 18.4126 10.7786 18.2688 10.7074C18.125 10.6362 17.997 10.5368 17.8923 10.4153C17.7876 10.2937 17.7083 10.1524 17.6592 9.99962C17.2969 8.9758 16.6637 8.06944 15.827 7.37712C14.9903 6.68479 13.9814 6.23245 12.9078 6.06828C11.8343 5.90412 10.7364 6.03429 9.73097 6.44491C8.72558 6.85554 7.85043 7.53125 7.19878 8.40002H10.8C11.1182 8.40002 11.4235 8.52645 11.6485 8.7515C11.8735 8.97654 12 9.28176 12 9.60002C12 9.91828 11.8735 10.2235 11.6485 10.4486C11.4235 10.6736 11.1182 10.8 10.8 10.8H4.79998C4.48172 10.8 4.17649 10.6736 3.95145 10.4486C3.7264 10.2235 3.59998 9.91828 3.59998 9.60002V3.60002C3.59998 3.28176 3.7264 2.97654 3.95145 2.7515C4.17649 2.52645 4.48172 2.40002 4.79998 2.40002ZM4.80958 13.2684C4.95818 13.2159 5.11567 13.1932 5.27304 13.2016C5.43042 13.21 5.5846 13.2493 5.72679 13.3173C5.86898 13.3852 5.99639 13.4806 6.10173 13.5978C6.20708 13.715 6.28831 13.8518 6.34078 14.0004C6.70301 15.0242 7.33623 15.9306 8.17296 16.6229C9.00968 17.3153 10.0186 17.7676 11.0921 17.9318C12.1656 18.0959 13.2636 17.9658 14.269 17.5551C15.2744 17.1445 16.1495 16.4688 16.8012 15.6H13.2C12.8817 15.6 12.5765 15.4736 12.3514 15.2486C12.1264 15.0235 12 14.7183 12 14.4C12 14.0818 12.1264 13.7765 12.3514 13.5515C12.5765 13.3265 12.8817 13.2 13.2 13.2H19.2C19.5182 13.2 19.8235 13.3265 20.0485 13.5515C20.2735 13.7765 20.4 14.0818 20.4 14.4V20.4C20.4 20.7183 20.2735 21.0235 20.0485 21.2486C19.8235 21.4736 19.5182 21.6 19.2 21.6C18.8817 21.6 18.5765 21.4736 18.3514 21.2486C18.1264 21.0235 18 20.7183 18 20.4V17.8788C17.0015 18.8973 15.7603 19.6449 14.3931 20.0511C13.0259 20.4573 11.5778 20.5088 10.1852 20.2008C8.79265 19.8928 7.50138 19.2354 6.43307 18.2904C5.36475 17.3455 4.55455 16.1442 4.07878 14.7996C4.02629 14.651 4.00359 14.4935 4.01197 14.3362C4.02035 14.1788 4.05965 14.0246 4.12762 13.8824C4.1956 13.7402 4.29091 13.6128 4.40813 13.5075C4.52535 13.4021 4.66216 13.3209 4.81078 13.2684H4.80958Z",
    fill: e.color
  }
)), A6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M21 21L15 15M17 10C17 10.9193 16.8189 11.8295 16.4672 12.6788C16.1154 13.5281 15.5998 14.2997 14.9497 14.9497C14.2997 15.5998 13.5281 16.1154 12.6788 16.4672C11.8295 16.8189 10.9193 17 10 17C9.08075 17 8.1705 16.8189 7.32122 16.4672C6.47194 16.1154 5.70026 15.5998 5.05025 14.9497C4.40024 14.2997 3.88463 13.5281 3.53284 12.6788C3.18106 11.8295 3 10.9193 3 10C3 8.14348 3.7375 6.36301 5.05025 5.05025C6.36301 3.7375 8.14348 3 10 3C11.8565 3 13.637 3.7375 14.9497 5.05025C16.2625 6.36301 17 8.14348 17 10Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), I6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M8 9L12 5L16 9M16 15L12 19L8 15",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), N6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M11.5991 13.2848L13.8683 11.0156C14.1124 10.7715 14.1124 10.3758 13.8683 10.1317C13.6242 9.88764 13.2285 9.88764 12.9844 10.1317L10.7152 12.4009L3.91295 10.4574C3.54563 10.3525 3.52403 9.84004 3.88122 9.70456L19.8349 3.65316C20.1549 3.53179 20.4682 3.84513 20.3468 4.1651L14.2954 20.1188C14.16 20.476 13.6475 20.4544 13.5426 20.0871L11.5991 13.2848Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), F6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18.3638 15.5355L16.9496 14.1213L18.3638 12.7071C20.3164 10.7545 20.3164 7.58866 18.3638 5.63604C16.4112 3.68341 13.2453 3.68341 11.2927 5.63604L9.87849 7.05025L8.46428 5.63604L9.87849 4.22182C12.6122 1.48815 17.0443 1.48815 19.778 4.22182C22.5117 6.95549 22.5117 11.3876 19.778 14.1213L18.3638 15.5355ZM15.5353 18.364L14.1211 19.7782C11.3875 22.5118 6.95531 22.5118 4.22164 19.7782C1.48797 17.0445 1.48797 12.6123 4.22164 9.87868L5.63585 8.46446L7.05007 9.87868L5.63585 11.2929C3.68323 13.2455 3.68323 16.4113 5.63585 18.364C7.58847 20.3166 10.7543 20.3166 12.7069 18.364L14.1211 16.9497L15.5353 18.364ZM14.8282 7.75736L16.2425 9.17157L9.17139 16.2426L7.75717 14.8284L14.8282 7.75736Z" })), P6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 8V20M3 4H16H3ZM3 8H12H3ZM3 12H9H3ZM13 12L17 8L13 12ZM17 8L21 12L17 8Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), G6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 20L21 16M3 4H16H3ZM3 8H12H3ZM3 12H12H3ZM17 8V20V8ZM17 20L13 16L17 20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), z6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12.951 2.92708C12.652 2.00608 11.349 2.00608 11.049 2.92708L9.52997 7.60108C9.46455 7.80173 9.33732 7.97654 9.1665 8.10048C8.99568 8.22442 8.79002 8.29113 8.57897 8.29108H3.66497C2.69697 8.29108 2.29297 9.53108 3.07697 10.1011L7.05297 12.9891C7.22377 13.1132 7.35087 13.2883 7.41608 13.4891C7.48129 13.6899 7.48125 13.9063 7.41597 14.1071L5.89797 18.7811C5.59797 19.7021 6.65297 20.4691 7.43597 19.8991L11.412 17.0111C11.5829 16.8869 11.7887 16.8199 12 16.8199C12.2112 16.8199 12.4171 16.8869 12.588 17.0111L16.564 19.8991C17.347 20.4691 18.402 19.7031 18.102 18.7811L16.584 14.1071C16.5187 13.9063 16.5187 13.6899 16.5839 13.4891C16.6491 13.2883 16.7762 13.1132 16.947 12.9891L20.923 10.1011C21.706 9.53108 21.304 8.29108 20.335 8.29108H15.42C15.2091 8.29092 15.0037 8.22411 14.833 8.10018C14.6624 7.97626 14.5353 7.80157 14.47 7.60108L12.951 2.92708Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Y6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M5.59567 4L10.5 9.92831L15.4043 4H18L11.7978 11.4971L18 18.9943V19H15.4091L10.5 13.0659L5.59092 19H3V18.9943L9.20216 11.4971L3 4H5.59567ZM21.8 16C21.8 15.5582 21.4418 15.2 21 15.2C20.5582 15.2 20.2 15.5582 20.2 16C20.2 16.0762 20.2107 16.15 20.2306 16.2198L19.0765 16.5496C19.0267 16.375 19 16.1906 19 16C19 14.8954 19.8954 14 21 14C22.1046 14 23 14.8954 23 16C23 16.5727 22.7593 17.0892 22.3735 17.4538L20.7441 19H23V20H19V19L21.5507 16.5803C21.7042 16.4345 21.8 16.2284 21.8 16Z" })), U6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M5.59567 5L10.5 10.9283L15.4043 5H18L11.7978 12.4971L18 19.9943V20H15.4091L10.5 14.0659L5.59092 20H3V19.9943L9.20216 12.4971L3 5H5.59567ZM21.5507 6.5803C21.7042 6.43453 21.8 6.22845 21.8 6C21.8 5.55817 21.4418 5.2 21 5.2C20.5582 5.2 20.2 5.55817 20.2 6C20.2 6.07624 20.2107 6.14999 20.2306 6.21983L19.0765 6.54958C19.0267 6.37497 19 6.1906 19 6C19 4.89543 19.8954 4 21 4C22.1046 4 23 4.89543 23 6C23 6.57273 22.7593 7.08923 22.3735 7.45384L20.7441 9H23V10H19V9L21.5507 6.5803V6.5803Z" })), q6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M18.364 5.636L14.828 9.172M18.364 5.636C16.6762 3.94817 14.3869 3 12 3C9.61305 3 7.32383 3.94817 5.636 5.636M18.364 5.636C20.0518 7.32383 21 9.61305 21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5283 18.364 18.364M14.828 9.172C14.0779 8.42185 13.0609 8 12 8C10.9391 8 9.92215 8.42185 9.172 9.172M14.828 9.172C15.5781 9.92215 16 10.9391 16 12C16 13.0609 15.5781 14.0779 14.828 14.828M14.828 14.828L18.364 18.364M14.828 14.828C14.0779 15.5781 13.0609 16 12 16C10.9391 16 9.92215 15.5781 9.172 14.828M18.364 18.364C17.5283 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47173 19.1997 5.636 18.364M9.172 9.172L5.636 5.636M9.172 9.172C8.42185 9.92215 8 10.9391 8 12C8 13.0609 8.42185 14.0779 9.172 14.828M5.636 5.636C3.94817 7.32383 3 9.61305 3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80027 17.5283 5.636 18.364M9.172 14.828L5.636 18.364",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), X6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 20L13 16M7 16V4V16ZM7 4L3 8L7 4ZM7 4L11 8L7 4ZM17 8V20V8ZM17 20L21 16L17 20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), K6 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M4 8H20V5H4V8ZM14 19V10H10V19H14ZM16 19H20V10H16V19ZM8 19V10H4V19H8ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3Z" })), J6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8H19C19.2652 8 19.5196 7.89464 19.7071 7.70711C19.8946 7.51957 20 7.26522 20 7V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H5C4.73478 4 4.48043 4.10536 4.29289 4.29289Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4.29289 12.2929C4.10536 12.4804 4 12.7348 4 13V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H11C11.2652 20 11.5196 19.8946 11.7071 19.7071C11.8946 19.5196 12 19.2652 12 19V13C12 12.7348 11.8946 12.4804 11.7071 12.2929C11.5196 12.1054 11.2652 12 11 12H5C4.73478 12 4.48043 12.1054 4.29289 12.2929Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16.2929 12.2929C16.1054 12.4804 16 12.7348 16 13V19C16 19.2652 16.1054 19.5196 16.2929 19.7071C16.4804 19.8946 16.7348 20 17 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V13C20 12.7348 19.8946 12.4804 19.7071 12.2929C19.5196 12.1054 19.2652 12 19 12H17C16.7348 12 16.4804 12.1054 16.2929 12.2929Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), Q6 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16.999 4L13.239 3.06C13.0804 3.02025 12.9175 3.0001 12.754 3H8.73602C8.36452 3.00001 8.00037 3.10349 7.68439 3.29884C7.36841 3.49419 7.11307 3.77369 6.94702 4.106L3.44702 11.106C3.29465 11.4109 3.22274 11.7497 3.23812 12.0902C3.2535 12.4308 3.35566 12.7617 3.53489 13.0516C3.71412 13.3416 3.96449 13.5809 4.26221 13.7469C4.55994 13.9129 4.89515 14 5.23602 14H10H12M16.999 4L17 13L13.608 18.088C13.211 18.683 13 19.381 13 20.096C13 20.595 12.595 21 12.095 21H11.999C11.4686 21 10.9599 20.7893 10.5848 20.4142C10.2097 20.0391 9.99902 19.5304 9.99902 19V14M16.999 4H19C19.5304 4 20.0392 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V12C21 12.5304 20.7893 13.0391 20.4142 13.4142C20.0392 13.7893 19.5304 14 19 14H16.5",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), e7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14 10H18.764C19.1049 10 19.4401 10.0871 19.7378 10.2531C20.0355 10.4191 20.2859 10.6584 20.4651 10.9484C20.6444 11.2383 20.7465 11.5692 20.7619 11.9098C20.7773 12.2503 20.7054 12.5891 20.553 12.894L17.053 19.894C16.8869 20.2265 16.6314 20.5061 16.3152 20.7014C15.999 20.8968 15.6347 21.0002 15.263 21H11.246C11.083 21 10.92 20.98 10.761 20.94L7 20M14 10V5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3H11.905C11.405 3 11 3.405 11 3.905C11 4.619 10.789 5.317 10.392 5.911L7 11V20M14 10H12M7 20H5C4.46957 20 3.96086 19.7893 3.58579 19.4142C3.21071 19.0391 3 18.5304 3 18V12C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10H7.5",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), t7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M3 5H15M9 3V5M10.048 14.5C8.5081 12.9059 7.27548 11.0413 6.412 9M12.5 18H19.5M11 21L16 11L21 21M12.751 5C11.783 10.77 8.07 15.61 3 18.129",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), r7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M10 11V17M14 11V17M4 7H20M19 7L18.133 19.142C18.0971 19.6466 17.8713 20.1188 17.5011 20.4636C17.1309 20.8083 16.6439 21 16.138 21H7.862C7.35614 21 6.86907 20.8083 6.49889 20.4636C6.1287 20.1188 5.90292 19.6466 5.867 19.142L5 7H19ZM15 7V4C15 3.73478 14.8946 3.48043 14.7071 3.29289C14.5196 3.10536 14.2652 3 14 3H10C9.73478 3 9.48043 3.10536 9.29289 3.29289C9.10536 3.48043 9 3.73478 9 4V7H15Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), n7 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z" })), o7 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M5.82843 6.99955L8.36396 9.53509L6.94975 10.9493L2 5.99955L6.94975 1.0498L8.36396 2.46402L5.82843 4.99955H13C17.4183 4.99955 21 8.58127 21 12.9996C21 17.4178 17.4183 20.9996 13 20.9996H4V18.9996H13C16.3137 18.9996 19 16.3133 19 12.9996C19 9.68584 16.3137 6.99955 13 6.99955H5.82843Z" })), a7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4 16V17C4 17.7956 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V16M16 8L12 4M12 4L8 8M12 4V16",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), i7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M18 9V12V9ZM18 12V15V12ZM18 12H21H18ZM18 12H15H18ZM13 7C13 8.06087 12.5786 9.07828 11.8284 9.82843C11.0783 10.5786 10.0609 11 9 11C7.93913 11 6.92172 10.5786 6.17157 9.82843C5.42143 9.07828 5 8.06087 5 7C5 5.93913 5.42143 4.92172 6.17157 4.17157C6.92172 3.42143 7.93913 3 9 3C10.0609 3 11.0783 3.42143 11.8284 4.17157C12.5786 4.92172 13 5.93913 13 7V7ZM3 20C3 18.4087 3.63214 16.8826 4.75736 15.7574C5.88258 14.6321 7.4087 14 9 14C10.5913 14 12.1174 14.6321 13.2426 15.7574C14.3679 16.8826 15 18.4087 15 20V21H3V20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), l7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5.121 17.804C7.21942 16.6179 9.58958 15.9963 12 16C14.5 16 16.847 16.655 18.879 17.804M15 10C15 10.7956 14.6839 11.5587 14.1213 12.1213C13.5587 12.6839 12.7956 13 12 13C11.2044 13 10.4413 12.6839 9.87868 12.1213C9.31607 11.5587 9 10.7956 9 10C9 9.20435 9.31607 8.44129 9.87868 7.87868C10.4413 7.31607 11.2044 7 12 7C12.7956 7 13.5587 7.31607 14.1213 7.87868C14.6839 8.44129 15 9.20435 15 10ZM21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), c7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 20H22V18C22 17.3765 21.8057 16.7686 21.4441 16.2606C21.0826 15.7527 20.5718 15.37 19.9827 15.1658C19.3937 14.9615 18.7556 14.9459 18.1573 15.121C17.5589 15.2962 17.03 15.6534 16.644 16.143M17 20H7M17 20V18C17 17.344 16.874 16.717 16.644 16.143M16.644 16.143C16.2726 15.215 15.6318 14.4195 14.804 13.8591C13.9762 13.2988 12.9996 12.9993 12 12.9993C11.0004 12.9993 10.0238 13.2988 9.196 13.8591C8.36825 14.4195 7.72736 15.215 7.356 16.143M7 20H2V18C2.00005 17.3765 2.19434 16.7686 2.55586 16.2606C2.91739 15.7527 3.42819 15.37 4.01725 15.1658C4.60632 14.9615 5.24438 14.9459 5.84274 15.121C6.4411 15.2962 6.97003 15.6534 7.356 16.143M7 20V18C7 17.344 7.126 16.717 7.356 16.143M15 7C15 7.79565 14.6839 8.55871 14.1213 9.12132C13.5587 9.68393 12.7956 10 12 10C11.2044 10 10.4413 9.68393 9.87868 9.12132C9.31607 8.55871 9 7.79565 9 7C9 6.20435 9.31607 5.44129 9.87868 4.87868C10.4413 4.31607 11.2044 4 12 4C12.7956 4 13.5587 4.31607 14.1213 4.87868C14.6839 5.44129 15 6.20435 15 7ZM21 10C21 10.5304 20.7893 11.0391 20.4142 11.4142C20.0391 11.7893 19.5304 12 19 12C18.4696 12 17.9609 11.7893 17.5858 11.4142C17.2107 11.0391 17 10.5304 17 10C17 9.46957 17.2107 8.96086 17.5858 8.58579C17.9609 8.21071 18.4696 8 19 8C19.5304 8 20.0391 8.21071 20.4142 8.58579C20.7893 8.96086 21 9.46957 21 10ZM7 10C7 10.5304 6.78929 11.0391 6.41421 11.4142C6.03914 11.7893 5.53043 12 5 12C4.46957 12 3.96086 11.7893 3.58579 11.4142C3.21071 11.0391 3 10.5304 3 10C3 9.46957 3.21071 8.96086 3.58579 8.58579C3.96086 8.21071 4.46957 8 5 8C5.53043 8 6.03914 8.21071 6.41421 8.58579C6.78929 8.96086 7 9.46957 7 10Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), C7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M7.05025 16.0503C8.36301 14.7375 10.1435 14 12 14C13.8565 14 15.637 14.7375 16.9497 16.0503C18.2625 17.363 19 19.1435 19 21H5C5 19.1435 5.7375 17.363 7.05025 16.0503Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), s7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M21 12H15M13 7C13 8.06087 12.5786 9.07828 11.8284 9.82843C11.0783 10.5786 10.0609 11 9 11C7.93913 11 6.92172 10.5786 6.17157 9.82843C5.42143 9.07828 5 8.06087 5 7C5 5.93913 5.42143 4.92172 6.17157 4.17157C6.92172 3.42143 7.93913 3 9 3C10.0609 3 11.0783 3.42143 11.8284 4.17157C12.5786 4.92172 13 5.93913 13 7ZM9 14C7.4087 14 5.88258 14.6321 4.75736 15.7574C3.63214 16.8826 3 18.4087 3 20V21H15V20C15 18.4087 14.3679 16.8826 13.2426 15.7574C12.1174 14.6321 10.5913 14 9 14Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), u7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12 4.354C12.5374 3.7447 13.2477 3.31351 14.0362 3.11779C14.8247 2.92208 15.6542 2.97112 16.4142 3.2584C17.1741 3.54568 17.8286 4.05757 18.2905 4.72596C18.7524 5.39435 18.9998 6.18754 18.9998 7C18.9998 7.81246 18.7524 8.60565 18.2905 9.27404C17.8286 9.94243 17.1741 10.4543 16.4142 10.7416C15.6542 11.0289 14.8247 11.0779 14.0362 10.8822C13.2477 10.6865 12.5374 10.2553 12 9.646M15 21H3V20C3 18.4087 3.63214 16.8826 4.75736 15.7574C5.88258 14.6321 7.4087 14 9 14C10.5913 14 12.1174 14.6321 13.2426 15.7574C14.3679 16.8826 15 18.4087 15 20V21ZM15 21H21V20C21.0001 18.9467 20.723 17.9119 20.1965 16.9997C19.6699 16.0875 18.9125 15.3299 18.0004 14.8032C17.0882 14.2765 16.0535 13.9992 15.0002 13.9992C13.9469 13.9991 12.9122 14.2764 12 14.803M13 7C13 8.06087 12.5786 9.07828 11.8284 9.82843C11.0783 10.5786 10.0609 11 9 11C7.93913 11 6.92172 10.5786 6.17157 9.82843C5.42143 9.07828 5 8.06087 5 7C5 5.93913 5.42143 4.92172 6.17157 4.17157C6.92172 3.42143 7.93913 3 9 3C10.0609 3 11.0783 3.42143 11.8284 4.17157C12.5786 4.92172 13 5.93913 13 7Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), d7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15 10L19.553 7.724C19.7054 7.64784 19.8748 7.61188 20.045 7.61955C20.2152 7.62721 20.3806 7.67825 20.5256 7.76781C20.6706 7.85736 20.7902 7.98248 20.8733 8.13127C20.9563 8.28007 20.9999 8.44761 21 8.618V15.382C20.9999 15.5524 20.9563 15.7199 20.8733 15.8687C20.7902 16.0175 20.6706 16.1426 20.5256 16.2322C20.3806 16.3218 20.2152 16.3728 20.045 16.3805C19.8748 16.3881 19.7054 16.3522 19.553 16.276L15 14V10ZM5 18H13C13.5304 18 14.0391 17.7893 14.4142 17.4142C14.7893 17.0391 15 16.5304 15 16V8C15 7.46957 14.7893 6.96086 14.4142 6.58579C14.0391 6.21071 13.5304 6 13 6H5C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21071 6.96086 3 7.46957 3 8V16C3 16.5304 3.21071 17.0391 3.58579 17.4142C3.96086 17.7893 4.46957 18 5 18Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), f7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7999 5.99998C4.16338 5.99998 3.55293 6.25283 3.10285 6.70292C2.65276 7.15301 2.3999 7.76346 2.3999 8.39998V18C2.3999 18.6365 2.65276 19.2469 3.10285 19.697C3.55293 20.1471 4.16338 20.4 4.7999 20.4H19.1999C19.8364 20.4 20.4469 20.1471 20.897 19.697C21.347 19.2469 21.5999 18.6365 21.5999 18V8.39998C21.5999 7.76346 21.347 7.15301 20.897 6.70292C20.4469 6.25283 19.8364 5.99998 19.1999 5.99998H17.2967C16.9785 5.99991 16.6733 5.87343 16.4483 5.64838L15.1031 4.30318C14.6531 3.85306 14.0428 3.60011 13.4063 3.59998H10.5935C9.95704 3.60011 9.34669 3.85306 8.8967 4.30318L7.5515 5.64838C7.32651 5.87343 7.02134 5.99991 6.7031 5.99998H4.7999ZM11.9999 16.8C12.4727 16.8 12.9408 16.7069 13.3776 16.5259C13.8143 16.345 14.2112 16.0799 14.5455 15.7456C14.8798 15.4113 15.145 15.0144 15.3259 14.5776C15.5068 14.1409 15.5999 13.6727 15.5999 13.2C15.5999 12.7272 15.5068 12.2591 15.3259 11.8223C15.145 11.3855 14.8798 10.9887 14.5455 10.6544C14.2112 10.3201 13.8143 10.0549 13.3776 9.87401C12.9408 9.69309 12.4727 9.59998 11.9999 9.59998C11.0451 9.59998 10.1294 9.97926 9.45432 10.6544C8.77919 11.3295 8.3999 12.2452 8.3999 13.2C8.3999 14.1548 8.77919 15.0704 9.45432 15.7456C10.1294 16.4207 11.0451 16.8 11.9999 16.8Z",
    fill: e.color
  }
)), m7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M17 14V20M14 17H20M6 10H8C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8V6C10 5.46957 9.78929 4.96086 9.41421 4.58579C9.03914 4.21071 8.53043 4 8 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V8C4 8.53043 4.21071 9.03914 4.58579 9.41421C4.96086 9.78929 5.46957 10 6 10ZM16 10H18C18.5304 10 19.0391 9.78929 19.4142 9.41421C19.7893 9.03914 20 8.53043 20 8V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H16C15.4696 4 14.9609 4.21071 14.5858 4.58579C14.2107 4.96086 14 5.46957 14 6V8C14 8.53043 14.2107 9.03914 14.5858 9.41421C14.9609 9.78929 15.4696 10 16 10ZM6 20H8C8.53043 20 9.03914 19.7893 9.41421 19.4142C9.78929 19.0391 10 18.5304 10 18V16C10 15.4696 9.78929 14.9609 9.41421 14.5858C9.03914 14.2107 8.53043 14 8 14H6C5.46957 14 4.96086 14.2107 4.58579 14.5858C4.21071 14.9609 4 15.4696 4 16V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), h7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V8C4 8.53043 4.21071 9.03914 4.58579 9.41421C4.96086 9.78929 5.46957 10 6 10H8C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8V6C10 5.46957 9.78929 4.96086 9.41421 4.58579C9.03914 4.21071 8.53043 4 8 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.5858 4.58579C14.2107 4.96086 14 5.46957 14 6V8C14 8.53043 14.2107 9.03914 14.5858 9.41421C14.9609 9.78929 15.4696 10 16 10H18C18.5304 10 19.0391 9.78929 19.4142 9.41421C19.7893 9.03914 20 8.53043 20 8V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H16C15.4696 4 14.9609 4.21071 14.5858 4.58579Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4.58579 14.5858C4.21071 14.9609 4 15.4696 4 16V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H8C8.53043 20 9.03914 19.7893 9.41421 19.4142C9.78929 19.0391 10 18.5304 10 18V16C10 15.4696 9.78929 14.9609 9.41421 14.5858C9.03914 14.2107 8.53043 14 8 14H6C5.46957 14 4.96086 14.2107 4.58579 14.5858Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.5858 14.5858C14.2107 14.9609 14 15.4696 14 16V18C14 18.5304 14.2107 19.0391 14.5858 19.4142C14.9609 19.7893 15.4696 20 16 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V16C20 15.4696 19.7893 14.9609 19.4142 14.5858C19.0391 14.2107 18.5304 14 18 14H16C15.4696 14 14.9609 14.2107 14.5858 14.5858Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), v7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4 18H20M4 6H20H4ZM4 10H20H4ZM4 14H20H4Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), g7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.6C14.5461 21.6 16.9879 20.5886 18.7882 18.7882C20.5886 16.9879 21.6 14.5461 21.6 12C21.6 9.45395 20.5886 7.01215 18.7882 5.2118C16.9879 3.41145 14.5461 2.40002 12 2.40002C9.45395 2.40002 7.01215 3.41145 5.2118 5.2118C3.41145 7.01215 2.40002 9.45395 2.40002 12C2.40002 14.5461 3.41145 16.9879 5.2118 18.7882C7.01215 20.5886 9.45395 21.6 12 21.6ZM10.4484 8.75163C10.2221 8.53304 9.91898 8.41208 9.60434 8.41482C9.28971 8.41755 8.98873 8.54375 8.76624 8.76624C8.54375 8.98873 8.41755 9.28971 8.41482 9.60434C8.41208 9.91898 8.53304 10.2221 8.75163 10.4484L10.3032 12L8.75163 13.5516C8.63701 13.6623 8.54559 13.7947 8.4827 13.9411C8.41981 14.0875 8.38671 14.245 8.38532 14.4043C8.38394 14.5637 8.4143 14.7217 8.47464 14.8692C8.53498 15.0166 8.62408 15.1506 8.73675 15.2633C8.84942 15.376 8.9834 15.4651 9.13088 15.5254C9.27836 15.5857 9.43637 15.6161 9.59571 15.6147C9.75504 15.6133 9.91251 15.5802 10.0589 15.5173C10.2053 15.4545 10.3377 15.363 10.4484 15.2484L12 13.6968L13.5516 15.2484C13.7779 15.467 14.0811 15.588 14.3957 15.5852C14.7103 15.5825 15.0113 15.4563 15.2338 15.2338C15.4563 15.0113 15.5825 14.7103 15.5852 14.3957C15.588 14.0811 15.467 13.7779 15.2484 13.5516L13.6968 12L15.2484 10.4484C15.467 10.2221 15.588 9.91898 15.5852 9.60434C15.5825 9.28971 15.4563 8.98873 15.2338 8.76624C15.0113 8.54375 14.7103 8.41755 14.3957 8.41482C14.0811 8.41208 13.7779 8.53304 13.5516 8.75163L12 10.3032L10.4484 8.75163Z",
    fill: e.color
  }
)), p7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M6 6L18 18M6 18L18 6L6 18Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), y7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M10 10H7M21 21L15 15L21 21ZM17 10C17 10.9193 16.8189 11.8295 16.4672 12.6788C16.1154 13.5281 15.5998 14.2997 14.9497 14.9497C14.2997 15.5998 13.5281 16.1154 12.6788 16.4672C11.8295 16.8189 10.9193 17 10 17C9.08075 17 8.1705 16.8189 7.32122 16.4672C6.47194 16.1154 5.70026 15.5998 5.05025 14.9497C4.40024 14.2997 3.88463 13.5281 3.53284 12.6788C3.18106 11.8295 3 10.9193 3 10C3 8.14348 3.7375 6.36301 5.05025 5.05025C6.36301 3.7375 8.14348 3 10 3C11.8565 3 13.637 3.7375 14.9497 5.05025C16.2625 6.36301 17 8.14348 17 10ZM10 7V10V7ZM10 10V13V10ZM10 10H13H10Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), w7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M13 10H7M21 21L15 15L21 21ZM17 10C17 10.9193 16.8189 11.8295 16.4672 12.6788C16.1154 13.5281 15.5998 14.2997 14.9497 14.9497C14.2997 15.5998 13.5281 16.1154 12.6788 16.4672C11.8295 16.8189 10.9193 17 10 17C9.08075 17 8.1705 16.8189 7.32122 16.4672C6.47194 16.1154 5.70026 15.5998 5.05025 14.9497C4.40024 14.2997 3.88463 13.5281 3.53284 12.6788C3.18106 11.8295 3 10.9193 3 10C3 8.14348 3.7375 6.36301 5.05025 5.05025C6.36301 3.7375 8.14348 3 10 3C11.8565 3 13.637 3.7375 14.9497 5.05025C16.2625 6.36301 17 8.14348 17 10Z",
    stroke: e.color,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
)), b7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 96, height: 40, viewBox: "0 0 96 40", fill: "none", ...e }, /* @__PURE__ */ t.createElement("g", { clipPath: "url(#clip0_23711_66943)" }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M33.5642 26.0991H29.4115L28.7243 28.086H26.5283L30.2782 17.6445H32.7132L36.4631 28.086H34.2521L33.5649 26.0991H33.5642ZM32.9963 24.426L31.4875 20.0638L29.9788 24.426H32.9963Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M40.6824 20.0567C41.1556 19.8025 41.6959 19.6758 42.3034 19.6758C43.0107 19.6758 43.6502 19.8502 44.2232 20.1985C44.7956 20.5475 45.2487 21.0426 45.5826 21.6846C45.9158 22.3272 46.0828 23.0715 46.0828 23.9181C46.0828 24.7647 45.9158 25.514 45.5826 26.1661C45.2487 26.8187 44.7956 27.3239 44.2232 27.6823C43.6502 28.0406 43.0107 28.2201 42.3034 28.2201C41.6959 28.2201 41.1606 28.0952 40.6974 27.8467C40.2343 27.5982 39.8583 27.2844 39.5696 26.9053V32.0294H37.4785V19.8101H39.5696V21.005C39.8383 20.6265 40.2092 20.3102 40.6824 20.0567ZM43.6402 22.626C43.4362 22.2626 43.167 21.9865 42.8337 21.797C42.4999 21.6081 42.139 21.5133 41.7505 21.5133C41.362 21.5133 41.0162 21.6106 40.6824 21.8045C40.3485 21.9984 40.0799 22.2802 39.8759 22.6486C39.6719 23.0169 39.5696 23.4506 39.5696 23.9482C39.5696 24.4459 39.6719 24.8796 39.8759 25.2479C40.0799 25.6163 40.3491 25.8975 40.6824 26.092C41.0156 26.2859 41.3721 26.3832 41.7505 26.3832C42.129 26.3832 42.4999 26.284 42.8337 26.0845C43.167 25.8855 43.4362 25.6019 43.6402 25.2329C43.8442 24.8645 43.9465 24.4265 43.9465 23.9181C43.9465 23.4098 43.8442 22.99 43.6402 22.626Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M50.4216 20.0567C50.8948 19.8025 51.4352 19.6758 52.0427 19.6758C52.75 19.6758 53.3895 19.8502 53.9625 20.1985C54.5348 20.5475 54.988 21.0426 55.3218 21.6846C55.6551 22.3272 55.822 23.0715 55.822 23.9181C55.822 24.7647 55.6551 25.514 55.3218 26.1661C54.988 26.8187 54.5348 27.3239 53.9625 27.6823C53.3895 28.0406 52.75 28.2201 52.0427 28.2201C51.4352 28.2201 50.8998 28.0952 50.4367 27.8467C49.9735 27.5982 49.5976 27.2844 49.3089 26.9053V32.0294H47.2178V19.8101H49.3089V21.005C49.5775 20.6265 49.9484 20.3102 50.4216 20.0567ZM53.3801 22.626C53.1761 22.2626 52.9069 21.9865 52.5736 21.797C52.2397 21.6081 51.8789 21.5133 51.4904 21.5133C51.1019 21.5133 50.7561 21.6106 50.4222 21.8045C50.0884 21.9984 49.8198 22.2802 49.6158 22.6486C49.4118 23.0169 49.3095 23.4506 49.3095 23.9482C49.3095 24.4459 49.4118 24.8796 49.6158 25.2479C49.8198 25.6163 50.089 25.8975 50.4222 26.092C50.7555 26.2859 51.112 26.3832 51.4904 26.3832C51.8688 26.3832 52.2397 26.284 52.5736 26.0845C52.9069 25.8855 53.1761 25.6019 53.3801 25.2329C53.584 24.8645 53.6863 24.4265 53.6863 23.9181C53.6863 23.4098 53.584 22.99 53.3801 22.626Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement("path", { d: "M59.0491 17.0312V28.0852H56.958V17.0312H59.0491Z", fill: e.color }), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M68.6397 19.8092L63.5155 31.9984H61.2894L63.0818 27.8753L59.7656 19.8086H62.1109L64.2472 25.5897L66.4131 19.8086H68.6391L68.6397 19.8092Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M71.0073 27.8163C70.4249 27.5678 69.9642 27.2088 69.6253 26.7406C69.2864 26.2725 69.1126 25.7202 69.1025 25.0826H71.343C71.3732 25.5112 71.5244 25.8495 71.7987 26.0986C72.0723 26.3478 72.4482 26.472 72.9264 26.472C73.4047 26.472 73.7975 26.3553 74.0768 26.1212C74.3555 25.8871 74.4948 25.5809 74.4948 25.2025C74.4948 24.8937 74.4 24.6402 74.2111 24.4406C74.0216 24.2417 73.7856 24.0848 73.5013 23.9699C73.2177 23.8557 72.8267 23.7283 72.3284 23.589C71.6512 23.3901 71.1008 23.193 70.6778 22.9991C70.2542 22.8052 69.8908 22.5115 69.587 22.118C69.2833 21.7245 69.1314 21.1992 69.1314 20.5422C69.1314 19.9246 69.2858 19.3868 69.5946 18.9287C69.9033 18.4706 70.3364 18.1198 70.8943 17.8756C71.4522 17.6315 72.0892 17.5098 72.8066 17.5098C73.8823 17.5098 74.7559 17.7715 75.428 18.2942C76.1002 18.817 76.4711 19.5468 76.5407 20.4825H74.24C74.2199 20.1242 74.068 19.828 73.7844 19.5939C73.5007 19.3598 73.1248 19.2431 72.6566 19.2431C72.248 19.2431 71.9223 19.3479 71.6782 19.5569C71.434 19.7659 71.3123 20.0696 71.3123 20.4681C71.3123 20.7468 71.4045 20.9783 71.5884 21.1628C71.7723 21.3473 72.0014 21.4967 72.2756 21.6109C72.5493 21.7258 72.9352 21.8575 73.4335 22.0069C74.1107 22.2065 74.6636 22.4054 75.0916 22.6043C75.5196 22.8039 75.888 23.1026 76.1968 23.5005C76.5056 23.899 76.66 24.4218 76.66 25.0688C76.66 25.6267 76.5156 26.1444 76.2269 26.6226C75.9382 27.1009 75.5146 27.4818 74.9573 27.7654C74.3994 28.0491 73.7373 28.1909 72.9704 28.1909C72.243 28.1909 71.5884 28.0667 71.006 27.8175L71.0073 27.8163Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M85.3409 20.7962C85.1018 20.3582 84.7729 20.0243 84.355 19.7952C83.9364 19.5662 83.4487 19.4513 82.8908 19.4513C82.2733 19.4513 81.7254 19.5906 81.2478 19.8699C80.7696 20.1485 80.3961 20.547 80.1275 21.0648C79.8589 21.5825 79.724 22.18 79.724 22.8571C79.724 23.5343 79.8608 24.1618 80.1351 24.6796C80.4087 25.1973 80.7896 25.5958 81.2779 25.8745C81.7655 26.1531 82.3335 26.293 82.9812 26.293C83.7776 26.293 84.4303 26.0816 84.938 25.6579C85.4457 25.235 85.7796 24.6444 85.939 23.8876H82.3536V22.2892H88.0006V24.1116C87.8613 24.839 87.5626 25.5111 87.1044 26.128C86.6463 26.7455 86.0564 27.2407 85.334 27.6141C84.6117 27.9875 83.8027 28.1745 82.9065 28.1745C81.9005 28.1745 80.9917 27.9479 80.1802 27.4948C79.3681 27.0417 78.7311 26.4117 78.268 25.6052C77.8048 24.7988 77.5732 23.8826 77.5732 22.8565C77.5732 21.8304 77.8048 20.9123 78.268 20.1002C78.7311 19.2888 79.3681 18.6562 80.1802 18.2031C80.9917 17.75 81.8955 17.5234 82.8914 17.5234C84.0663 17.5234 85.0874 17.8096 85.9541 18.3826C86.8208 18.9555 87.4182 19.7595 87.7465 20.7949H85.3415L85.3409 20.7962Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16.7861 8H5.59559C2.50534 8 0 10.5052 0 13.5954V24.7855C0 27.8756 2.50534 30.3803 5.59559 30.3803H16.7861C19.8764 30.3803 22.3817 27.875 22.3817 24.7849V13.5954C22.3817 10.5052 19.8764 8 16.7861 8ZM11.916 26.8C11.0613 27.6547 9.67869 27.6547 8.82391 26.8L3.28355 21.2598C2.71433 20.6906 2.71433 19.7687 3.28355 19.1995L7.26184 15.2214C7.83106 14.6541 8.75299 14.6541 9.32222 15.2214L10.2398 16.1414C10.3107 16.2123 10.4268 16.2123 10.4977 16.1414L14.7402 11.8991C15.0258 11.6135 15.4864 11.6135 15.772 11.8991L16.8947 13.0218C17.1784 13.3054 17.1784 13.768 16.8947 14.0516L10.5705 20.3756C10.4462 20.4584 10.2812 20.4566 10.1588 20.3656L9.30402 19.5108L9.81613 18.9987C10.0013 18.8136 9.87136 18.5023 9.61342 18.5023H6.74596C6.64366 18.5023 6.56082 18.5852 6.56082 18.6874V21.5548C6.56082 21.8127 6.87211 21.9445 7.05725 21.7594L7.57313 21.2416L9.85567 23.5241C10.1218 23.7902 10.5448 23.8059 10.8303 23.573C10.8498 23.5574 10.868 23.5417 10.8855 23.5241L15.4845 18.9253C15.5655 19.465 15.8115 19.9633 16.2056 20.3574C16.5979 20.7496 17.0962 20.9994 17.6378 21.0785L11.916 26.8ZM19.0812 19.6307C18.7838 19.9263 18.3959 20.0756 18.0056 20.0756C17.6152 20.0756 17.2292 19.9256 16.9324 19.6307C16.3393 19.0376 16.3393 18.0749 16.9324 17.4819C17.2298 17.1863 17.6177 17.0369 18.0056 17.0369C18.3934 17.0369 18.7838 17.1863 19.0812 17.4819C19.6743 18.0749 19.6743 19.0376 19.0812 19.6307Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M35.4636 10.8468C35.2665 10.6447 35.0293 10.4859 34.7519 10.3705C34.4745 10.2556 34.1676 10.1979 33.8306 10.1979C33.4936 10.1979 33.1861 10.255 32.9074 10.3692C32.6288 10.4834 32.3909 10.6416 32.1926 10.8455C31.9943 11.0489 31.8405 11.2899 31.732 11.5679C31.6228 11.8465 31.5688 12.149 31.5688 12.4753C31.5688 12.8017 31.6234 13.1048 31.732 13.3828C31.8405 13.6614 31.9943 13.9024 32.1926 14.1051C32.3909 14.3084 32.6288 14.4672 32.9074 14.5814C33.1861 14.6957 33.4936 14.7528 33.8306 14.7528C34.1676 14.7528 34.4745 14.6957 34.7519 14.5814C35.0293 14.4672 35.2665 14.3084 35.4636 14.1051C35.6607 13.9018 35.8138 13.6608 35.923 13.3828C36.0316 13.1042 36.0862 12.8023 36.0862 12.4753C36.0862 12.1484 36.0316 11.8465 35.923 11.5679C35.8138 11.2892 35.6607 11.0495 35.4636 10.8468ZM35.1385 13.133C35.0739 13.3269 34.9804 13.4914 34.8592 13.6263C34.7381 13.7606 34.5906 13.8641 34.4168 13.9357C34.2429 14.0072 34.0471 14.0436 33.83 14.0436C33.6128 14.0436 33.4158 14.0078 33.2413 13.9357C33.0668 13.8641 32.9181 13.7606 32.7964 13.6263C32.674 13.4914 32.5798 13.3276 32.5146 13.133C32.4493 12.9385 32.416 12.7195 32.416 12.4753C32.416 12.2312 32.4487 12.0116 32.5146 11.8176C32.5805 11.6237 32.674 11.4587 32.7964 11.3231C32.9187 11.1876 33.0668 11.084 33.2413 11.0118C33.4158 10.9403 33.6122 10.9039 33.83 10.9039C34.0478 10.9039 34.2436 10.9397 34.4168 11.0118C34.5906 11.084 34.7375 11.1876 34.8592 11.3231C34.9804 11.4587 35.0733 11.6237 35.1385 11.8176C35.2032 12.0116 35.2352 12.2312 35.2352 12.4753C35.2352 12.7195 35.2032 12.9391 35.1385 13.133ZM29.2473 12.9378C29.2473 12.9811 29.263 13.0175 29.2938 13.047C29.3245 13.0765 29.3666 13.0916 29.4199 13.0916H29.9778V13.9018C29.8523 13.9614 29.7205 14.0085 29.5818 14.0417C29.4431 14.0756 29.2806 14.0926 29.0936 14.0926C28.8814 14.0926 28.6869 14.0562 28.508 13.9834C28.3292 13.9106 28.1754 13.8051 28.0461 13.6677C27.9168 13.5303 27.8158 13.3608 27.7443 13.1606C27.6721 12.9604 27.6363 12.7314 27.6363 12.4747C27.6363 12.2362 27.6702 12.021 27.738 11.8277C27.8058 11.6344 27.9024 11.4693 28.0279 11.3313C28.1528 11.1938 28.3047 11.0878 28.4823 11.0137C28.6599 10.9397 28.8589 10.9026 29.0785 10.9026C29.2141 10.9026 29.3339 10.9121 29.4375 10.9303C29.541 10.9491 29.6346 10.9723 29.718 11.0012C29.8015 11.03 29.8774 11.0639 29.9458 11.1028C30.0149 11.1418 30.082 11.1807 30.1479 11.2202C30.1994 11.2528 30.2496 11.2698 30.2992 11.2698C30.377 11.2698 30.4398 11.2315 30.4868 11.1556L30.7272 10.7796C30.542 10.6071 30.3167 10.4665 30.0506 10.3592C29.7845 10.2512 29.4701 10.1973 29.1061 10.1973C28.7421 10.1973 28.4302 10.2525 28.1447 10.3636C27.8591 10.4746 27.6162 10.6303 27.416 10.8317C27.2158 11.0332 27.0614 11.2735 26.9522 11.5528C26.843 11.8321 26.7891 12.1396 26.7891 12.4741C26.7891 12.8086 26.8449 13.1098 26.9573 13.3891C27.069 13.6683 27.2252 13.9087 27.4242 14.1101C27.6231 14.3116 27.8597 14.4685 28.1327 14.5814C28.4057 14.6944 28.7051 14.7509 29.0296 14.7509C29.2122 14.7509 29.3829 14.7408 29.541 14.7214C29.6992 14.7019 29.8479 14.6724 29.986 14.6335C30.1247 14.5946 30.2552 14.545 30.3776 14.4842C30.5 14.4233 30.6174 14.3524 30.7303 14.2695V12.4672H29.248V12.9353L29.2473 12.9378ZM39.9415 10.3058C39.8944 10.3447 39.8611 10.388 39.8429 10.4351L38.7986 13.1531C38.7283 13.3338 38.67 13.5422 38.6229 13.7788C38.594 13.6621 38.5639 13.5503 38.5319 13.4443C38.4999 13.3389 38.4666 13.2416 38.4315 13.1531L37.3834 10.4351C37.3608 10.3793 37.3269 10.3341 37.2817 10.2996C37.2366 10.265 37.1782 10.2475 37.106 10.2475H36.437L38.2369 14.7038H38.9856L40.7856 10.2475H40.1172C40.0469 10.2475 39.9885 10.2669 39.9415 10.3058ZM50.3626 11.3256C50.4894 11.1901 50.64 11.0859 50.8157 11.0131C50.9914 10.9403 51.1841 10.9039 51.3937 10.9039C51.5726 10.9039 51.7201 10.9221 51.8362 10.9591C51.9523 10.9962 52.0483 11.0363 52.1242 11.0796C52.2002 11.1229 52.2629 11.1631 52.3125 11.1995C52.3621 11.2365 52.4098 11.2553 52.4575 11.2553C52.5052 11.2553 52.5384 11.2459 52.5635 11.2277C52.5893 11.2089 52.6106 11.1876 52.6269 11.1631L52.9043 10.7778C52.7274 10.6033 52.5152 10.4627 52.268 10.3567C52.0207 10.2512 51.7314 10.1979 51.4006 10.1979C51.0699 10.1979 50.7517 10.2537 50.4712 10.3655C50.1906 10.4778 49.9496 10.6341 49.7488 10.8355C49.5474 11.0369 49.3911 11.2767 49.28 11.5553C49.1689 11.834 49.1137 12.1402 49.1137 12.4753C49.1137 12.8104 49.1633 13.1111 49.2631 13.3903C49.3628 13.6696 49.5059 13.9099 49.693 14.1114C49.88 14.3128 50.1053 14.4697 50.3695 14.5827C50.6337 14.6957 50.9306 14.7521 51.2613 14.7521C51.631 14.7521 51.9479 14.6925 52.2121 14.5733C52.4763 14.454 52.6985 14.2827 52.8792 14.0587L52.5529 13.7041C52.5202 13.669 52.4813 13.652 52.4361 13.652C52.4092 13.652 52.3847 13.6577 52.3621 13.669C52.3395 13.6803 52.3175 13.6953 52.2975 13.7135C52.2297 13.775 52.1613 13.8271 52.0929 13.8692C52.0238 13.9112 51.951 13.9457 51.8738 13.9727C51.7966 13.9991 51.7125 14.0185 51.6209 14.0311C51.5293 14.0436 51.427 14.0499 51.314 14.0499C51.1251 14.0499 50.9481 14.0141 50.7837 13.9432C50.6193 13.8723 50.4768 13.7706 50.3557 13.6363C50.2346 13.5027 50.1385 13.3382 50.0676 13.1437C49.9967 12.9485 49.9609 12.7257 49.9609 12.4747C49.9609 12.2237 49.9967 12.0141 50.0676 11.8202C50.1385 11.6262 50.2371 11.4612 50.3632 11.3256H50.3626ZM56.737 10.2475V12.1641H54.6478V10.2475H53.8125V14.7038H54.6478V12.7559H56.737V14.7038H57.5723V10.2475H56.737ZM45.5345 14.7032H48.3455V14.0405H46.3699V12.7803H47.9263V12.1421H46.3699V10.9064H48.3455V10.2468H45.5345V14.7032ZM41.1835 10.9284H42.5303V14.7038H43.3593V10.9284H44.6999V10.2475H41.1835V10.9284Z",
    fill: e.color
  }
)), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement("clipPath", { id: "clip0_23711_66943" }, /* @__PURE__ */ t.createElement("rect", { width: 88, height: 24, fill: "white", transform: "translate(0 8)" })))), E7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 88, height: 44, viewBox: "0 0 88 44", fill: "none", ...e }, /* @__PURE__ */ t.createElement("g", { clipPath: "url(#clip0_23713_68073)" }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M33.5642 28.0991H29.4115L28.7243 30.086H26.5283L30.2782 19.6445H32.7132L36.4631 30.086H34.2521L33.5649 28.0991H33.5642ZM32.9963 26.426L31.4875 22.0638L29.9788 26.426H32.9963Z",
    fill: "#2A2A2A"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M40.6824 22.0567C41.1556 21.8025 41.6959 21.6758 42.3034 21.6758C43.0107 21.6758 43.6502 21.8502 44.2232 22.1985C44.7956 22.5475 45.2487 23.0426 45.5826 23.6846C45.9158 24.3272 46.0828 25.0715 46.0828 25.9181C46.0828 26.7647 45.9158 27.514 45.5826 28.1661C45.2487 28.8187 44.7956 29.3239 44.2232 29.6823C43.6502 30.0406 43.0107 30.2201 42.3034 30.2201C41.6959 30.2201 41.1606 30.0952 40.6974 29.8467C40.2343 29.5982 39.8583 29.2844 39.5696 28.9053V34.0294H37.4785V21.8101H39.5696V23.005C39.8383 22.6265 40.2092 22.3102 40.6824 22.0567ZM43.6402 24.626C43.4362 24.2626 43.167 23.9865 42.8337 23.797C42.4999 23.6081 42.139 23.5133 41.7505 23.5133C41.362 23.5133 41.0162 23.6106 40.6824 23.8045C40.3485 23.9984 40.0799 24.2802 39.8759 24.6486C39.6719 25.0169 39.5696 25.4506 39.5696 25.9482C39.5696 26.4459 39.6719 26.8796 39.8759 27.2479C40.0799 27.6163 40.3491 27.8975 40.6824 28.092C41.0156 28.2859 41.3721 28.3832 41.7505 28.3832C42.129 28.3832 42.4999 28.284 42.8337 28.0845C43.167 27.8855 43.4362 27.6019 43.6402 27.2329C43.8442 26.8645 43.9465 26.4265 43.9465 25.9181C43.9465 25.4098 43.8442 24.99 43.6402 24.626Z",
    fill: "#2A2A2A"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M50.4216 22.0567C50.8948 21.8025 51.4352 21.6758 52.0427 21.6758C52.75 21.6758 53.3895 21.8502 53.9625 22.1985C54.5348 22.5475 54.988 23.0426 55.3218 23.6846C55.6551 24.3272 55.822 25.0715 55.822 25.9181C55.822 26.7647 55.6551 27.514 55.3218 28.1661C54.988 28.8187 54.5348 29.3239 53.9625 29.6823C53.3895 30.0406 52.75 30.2201 52.0427 30.2201C51.4352 30.2201 50.8998 30.0952 50.4367 29.8467C49.9735 29.5982 49.5976 29.2844 49.3089 28.9053V34.0294H47.2178V21.8101H49.3089V23.005C49.5775 22.6265 49.9484 22.3102 50.4216 22.0567ZM53.3801 24.626C53.1761 24.2626 52.9069 23.9865 52.5736 23.797C52.2397 23.6081 51.8789 23.5133 51.4904 23.5133C51.1019 23.5133 50.7561 23.6106 50.4222 23.8045C50.0884 23.9984 49.8198 24.2802 49.6158 24.6486C49.4118 25.0169 49.3095 25.4506 49.3095 25.9482C49.3095 26.4459 49.4118 26.8796 49.6158 27.2479C49.8198 27.6163 50.089 27.8975 50.4222 28.092C50.7555 28.2859 51.112 28.3832 51.4904 28.3832C51.8688 28.3832 52.2397 28.284 52.5736 28.0845C52.9069 27.8855 53.1761 27.6019 53.3801 27.2329C53.584 26.8645 53.6863 26.4265 53.6863 25.9181C53.6863 25.4098 53.584 24.99 53.3801 24.626Z",
    fill: "#2A2A2A"
  }
), /* @__PURE__ */ t.createElement("path", { d: "M59.0501 19.0312V30.0852H56.959V19.0312H59.0501Z", fill: "#2A2A2A" }), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M68.6397 21.8092L63.5155 33.9984H61.2894L63.0818 29.8753L59.7656 21.8086H62.1109L64.2472 27.5897L66.4131 21.8086H68.6391L68.6397 21.8092Z",
    fill: "#2A2A2A"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M71.0073 29.8163C70.4249 29.5678 69.9642 29.2088 69.6253 28.7406C69.2864 28.2725 69.1126 27.7202 69.1025 27.0826H71.343C71.3732 27.5112 71.5244 27.8495 71.7987 28.0986C72.0723 28.3478 72.4482 28.472 72.9264 28.472C73.4047 28.472 73.7975 28.3553 74.0768 28.1212C74.3555 27.8871 74.4948 27.5809 74.4948 27.2025C74.4948 26.8937 74.4 26.6402 74.2111 26.4406C74.0216 26.2417 73.7856 26.0848 73.5013 25.9699C73.2177 25.8557 72.8267 25.7283 72.3284 25.589C71.6512 25.3901 71.1008 25.193 70.6778 24.9991C70.2542 24.8052 69.8908 24.5115 69.587 24.118C69.2833 23.7245 69.1314 23.1992 69.1314 22.5422C69.1314 21.9246 69.2858 21.3868 69.5946 20.9287C69.9033 20.4706 70.3364 20.1198 70.8943 19.8756C71.4522 19.6315 72.0892 19.5098 72.8066 19.5098C73.8823 19.5098 74.7559 19.7715 75.428 20.2942C76.1002 20.817 76.4711 21.5468 76.5407 22.4825H74.24C74.2199 22.1242 74.068 21.828 73.7844 21.5939C73.5007 21.3598 73.1248 21.2431 72.6566 21.2431C72.248 21.2431 71.9223 21.3479 71.6782 21.5569C71.434 21.7659 71.3123 22.0696 71.3123 22.4681C71.3123 22.7468 71.4045 22.9783 71.5884 23.1628C71.7723 23.3473 72.0014 23.4967 72.2756 23.6109C72.5493 23.7258 72.9352 23.8575 73.4335 24.0069C74.1107 24.2065 74.6636 24.4054 75.0916 24.6043C75.5196 24.8039 75.888 25.1026 76.1968 25.5005C76.5056 25.899 76.66 26.4218 76.66 27.0688C76.66 27.6267 76.5156 28.1444 76.2269 28.6226C75.9382 29.1009 75.5146 29.4818 74.9573 29.7654C74.3994 30.0491 73.7373 30.1909 72.9704 30.1909C72.243 30.1909 71.5884 30.0667 71.006 29.8175L71.0073 29.8163Z",
    fill: "#2A2A2A"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M85.3409 22.7962C85.1018 22.3582 84.7729 22.0243 84.355 21.7952C83.9364 21.5662 83.4487 21.4513 82.8908 21.4513C82.2733 21.4513 81.7254 21.5906 81.2478 21.8699C80.7696 22.1485 80.3961 22.547 80.1275 23.0648C79.8589 23.5825 79.724 24.18 79.724 24.8571C79.724 25.5343 79.8608 26.1618 80.1351 26.6796C80.4087 27.1973 80.7896 27.5958 81.2779 27.8745C81.7655 28.1531 82.3335 28.293 82.9812 28.293C83.7776 28.293 84.4303 28.0816 84.938 27.6579C85.4457 27.235 85.7796 26.6444 85.939 25.8876H82.3536V24.2892H88.0006V26.1116C87.8613 26.839 87.5626 27.5111 87.1044 28.128C86.6463 28.7455 86.0564 29.2407 85.334 29.6141C84.6117 29.9875 83.8027 30.1745 82.9065 30.1745C81.9005 30.1745 80.9917 29.9479 80.1802 29.4948C79.3681 29.0417 78.7311 28.4117 78.268 27.6052C77.8048 26.7988 77.5732 25.8826 77.5732 24.8565C77.5732 23.8304 77.8048 22.9123 78.268 22.1002C78.7311 21.2888 79.3681 20.6562 80.1802 20.2031C80.9917 19.75 81.8955 19.5234 82.8914 19.5234C84.0663 19.5234 85.0874 19.8096 85.9541 20.3826C86.8208 20.9555 87.4182 21.7595 87.7465 22.7949H85.3415L85.3409 22.7962Z",
    fill: "#2A2A2A"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16.7859 10.0645H5.59533C2.53478 10.0645 0.0537109 12.5454 0.0537109 15.6059V26.796C0.0537109 29.8564 2.53478 32.3374 5.59533 32.3374H16.7859C19.8464 32.3374 22.3275 29.8564 22.3275 26.796V15.6059C22.3275 12.5454 19.8464 10.0645 16.7859 10.0645Z",
    fill: "url(#paint0_linear_23713_68073)"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16.7861 10.1177C19.8118 10.1177 22.2738 12.5796 22.2738 15.6051V26.7953C22.2738 29.8208 19.8118 32.2827 16.7861 32.2827H5.59559C2.56998 32.2827 0.107945 29.8208 0.107945 26.7953V15.6051C0.107945 12.579 2.56935 10.1177 5.59559 10.1177H16.7861ZM16.7861 10.0098H5.59559C2.50534 10.0098 0 12.515 0 15.6051V26.7953C0 29.8854 2.50534 32.39 5.59559 32.39H16.7861C19.8764 32.39 22.3817 29.8848 22.3817 26.7946V15.6051C22.3817 12.515 19.8764 10.0098 16.7861 10.0098Z",
    fill: "#EBEBEB"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16.2054 22.3678C16.5977 22.76 17.096 23.0098 17.6376 23.0889L11.9159 28.8104C11.0611 29.6651 9.6785 29.6651 8.82373 28.8104L3.28336 23.2702C2.71414 22.701 2.71414 21.7791 3.28336 21.2099L7.26165 17.2318C7.83088 16.6645 8.75281 16.6645 9.32203 17.2318L10.2396 18.1518C10.3105 18.2227 10.4266 18.2227 10.4975 18.1518L14.74 13.9095C15.0256 13.6239 15.4862 13.6239 15.7718 13.9095L16.8945 15.0322C17.1782 15.3158 17.1782 15.7784 16.8945 16.062L10.5703 22.386C10.446 22.4688 10.281 22.467 10.1586 22.376L9.30383 21.5212L9.81595 21.0091C10.0011 20.824 9.87117 20.5127 9.61323 20.5127H6.74578C6.64348 20.5127 6.56064 20.5956 6.56064 20.6978V23.5652C6.56064 23.8231 6.87192 23.9549 7.05706 23.7698L7.57294 23.252L9.85548 25.5345C10.1216 25.8006 10.5446 25.8163 10.8301 25.5834C10.8496 25.5678 10.8678 25.5521 10.8854 25.5345L15.4843 20.9357C15.5653 21.4754 15.8113 21.9737 16.2054 22.3678ZM19.0811 19.4923C18.7836 19.1967 18.3957 19.0474 18.0054 19.0474C17.615 19.0474 17.229 19.1967 16.9322 19.4923C16.3391 20.0853 16.3391 21.048 16.9322 21.6411C17.2297 21.9367 17.6175 22.086 18.0054 22.086C18.3932 22.086 18.7836 21.936 19.0811 21.6411C19.6741 21.048 19.6741 20.0853 19.0811 19.4923Z",
    fill: "url(#paint1_linear_23713_68073)"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M35.464 12.8468C35.2669 12.6447 35.0297 12.4859 34.7523 12.3705C34.4749 12.2556 34.168 12.1979 33.831 12.1979C33.494 12.1979 33.1864 12.255 32.9078 12.3692C32.6291 12.4834 32.3913 12.6416 32.193 12.8455C31.9946 13.0489 31.8409 13.2899 31.7323 13.5679C31.6231 13.8465 31.5691 14.149 31.5691 14.4753C31.5691 14.8017 31.6237 15.1048 31.7323 15.3828C31.8409 15.6614 31.9946 15.9024 32.193 16.1051C32.3913 16.3084 32.6291 16.4672 32.9078 16.5814C33.1864 16.6957 33.494 16.7528 33.831 16.7528C34.168 16.7528 34.4749 16.6957 34.7523 16.5814C35.0297 16.4672 35.2669 16.3084 35.464 16.1051C35.661 15.9018 35.8142 15.6608 35.9234 15.3828C36.0319 15.1042 36.0865 14.8023 36.0865 14.4753C36.0865 14.1484 36.0319 13.8465 35.9234 13.5679C35.8142 13.2892 35.661 13.0495 35.464 12.8468ZM35.1389 15.133C35.0742 15.3269 34.9813 15.4914 34.8596 15.6263C34.7385 15.7606 34.591 15.8641 34.4171 15.9357C34.2433 16.0072 34.0475 16.0436 33.8303 16.0436C33.6132 16.0436 33.4161 16.0078 33.2417 15.9357C33.0672 15.8641 32.9185 15.7606 32.7967 15.6263C32.6743 15.4914 32.5802 15.3276 32.5149 15.133C32.4496 14.9385 32.4164 14.7195 32.4164 14.4753C32.4164 14.2312 32.449 14.0116 32.5149 13.8176C32.5808 13.6237 32.6743 13.4587 32.7967 13.3231C32.9191 13.1876 33.0672 13.084 33.2417 13.0118C33.4161 12.9403 33.6126 12.9039 33.8303 12.9039C34.0481 12.9039 34.2439 12.9397 34.4171 13.0118C34.591 13.084 34.7378 13.1876 34.8596 13.3231C34.9807 13.4587 35.0736 13.6237 35.1389 13.8176C35.2035 14.0116 35.2355 14.2312 35.2355 14.4753C35.2355 14.7195 35.2035 14.9391 35.1389 15.133ZM29.2477 14.9378C29.2477 14.9811 29.2634 15.0175 29.2941 15.047C29.3249 15.0765 29.3669 15.0916 29.4203 15.0916H29.9782V15.9018C29.8527 15.9614 29.7209 16.0085 29.5822 16.0417C29.4435 16.0756 29.2809 16.0926 29.0939 16.0926C28.8818 16.0926 28.6872 16.0562 28.5084 15.9834C28.3295 15.9106 28.1758 15.8051 28.0465 15.6677C27.9172 15.5303 27.8161 15.3608 27.7446 15.1606C27.6724 14.9604 27.6367 14.7314 27.6367 14.4747C27.6367 14.2362 27.6705 14.021 27.7383 13.8277C27.8061 13.6344 27.9028 13.4693 28.0283 13.3313C28.1532 13.1938 28.305 13.0878 28.4826 13.0137C28.6603 12.9397 28.8592 12.9026 29.0789 12.9026C29.2144 12.9026 29.3343 12.9121 29.4378 12.9303C29.5414 12.9491 29.6349 12.9723 29.7184 13.0012C29.8018 13.03 29.8778 13.0639 29.9462 13.1028C30.0152 13.1418 30.0824 13.1807 30.1483 13.2202C30.1997 13.2528 30.2499 13.2698 30.2995 13.2698C30.3773 13.2698 30.4401 13.2315 30.4878 13.1556L30.7282 12.7796C30.543 12.6071 30.3177 12.4665 30.0516 12.3592C29.7855 12.2512 29.4711 12.1973 29.1071 12.1973C28.7431 12.1973 28.4312 12.2525 28.1456 12.3636C27.8601 12.4746 27.6172 12.6303 27.417 12.8317C27.2168 13.0332 27.0624 13.2735 26.9532 13.5528C26.844 13.8321 26.79 14.1396 26.79 14.4741C26.79 14.8086 26.8459 15.1098 26.9582 15.3891C27.0699 15.6683 27.2262 15.9087 27.4252 16.1101C27.6241 16.3116 27.8607 16.4685 28.1337 16.5814C28.4067 16.6944 28.7061 16.7509 29.0305 16.7509C29.2132 16.7509 29.3839 16.7408 29.542 16.7214C29.7002 16.7019 29.8489 16.6724 29.987 16.6335C30.1257 16.5946 30.2562 16.545 30.3786 16.4842C30.501 16.4233 30.6183 16.3524 30.7313 16.2695V14.4672H29.2489V14.9353L29.2477 14.9378ZM39.9418 12.3058C39.8947 12.3447 39.8615 12.388 39.8433 12.4351L38.799 15.1531C38.7287 15.3338 38.6703 15.5422 38.6232 15.7788C38.5944 15.6621 38.5642 15.5503 38.5322 15.4443C38.5002 15.3389 38.467 15.2416 38.4318 15.1531L37.3838 12.4351C37.3612 12.3793 37.3273 12.3341 37.2821 12.2996C37.2369 12.265 37.1785 12.2475 37.1064 12.2475H36.4374L38.2373 16.7038H38.986L40.7859 12.2475H40.1175C40.0472 12.2475 39.9889 12.2669 39.9418 12.3058ZM45.5349 16.7032H48.3459V16.0405H46.3702V14.7803H47.9266V14.1421H46.3702V12.9064H48.3459V12.2468H45.5349V16.7032ZM41.1838 12.9284H42.5306V16.7038H43.3597V12.9284H44.7002V12.2475H41.1838V12.9284ZM56.7374 12.2475V14.1641H54.6481V12.2475H53.8128V16.7038H54.6481V14.7559H56.7374V16.7038H57.5727V12.2475H56.7374ZM50.3629 13.3256C50.4897 13.1901 50.6403 13.0859 50.8161 13.0131C50.9918 12.9403 51.1845 12.9039 51.3941 12.9039C51.5729 12.9039 51.7204 12.9221 51.8365 12.9591C51.9526 12.9962 52.0486 13.0363 52.1246 13.0796C52.2005 13.1229 52.2633 13.1631 52.3122 13.1995C52.3618 13.2365 52.4095 13.2553 52.4572 13.2553C52.5049 13.2553 52.5382 13.2459 52.5633 13.2277C52.589 13.2089 52.6103 13.1876 52.6267 13.1631L52.904 12.7778C52.7271 12.6033 52.5149 12.4627 52.2677 12.3567C52.0204 12.2512 51.7311 12.1979 51.4003 12.1979C51.0696 12.1979 50.7514 12.2537 50.4709 12.3655C50.1904 12.4778 49.9494 12.6341 49.7485 12.8355C49.5471 13.0369 49.3908 13.2767 49.2797 13.5553C49.1686 13.834 49.1134 14.1402 49.1134 14.4753C49.1134 14.8104 49.163 15.1111 49.2628 15.3903C49.3626 15.6696 49.5056 15.9099 49.6927 16.1114C49.8797 16.3128 50.105 16.4697 50.3692 16.5827C50.6334 16.6957 50.9303 16.7521 51.261 16.7521C51.6307 16.7521 51.9476 16.6925 52.2118 16.5733C52.476 16.454 52.6982 16.2827 52.8789 16.0587L52.5526 15.7041C52.52 15.669 52.4811 15.652 52.4359 15.652C52.4089 15.652 52.3844 15.6577 52.3618 15.669C52.3392 15.6803 52.3173 15.6953 52.2972 15.7135C52.2294 15.775 52.161 15.8271 52.0926 15.8692C52.0235 15.9112 51.9507 15.9457 51.8735 15.9727C51.7964 15.9991 51.7123 16.0185 51.6206 16.0311C51.529 16.0436 51.4267 16.0499 51.3137 16.0499C51.1248 16.0499 50.9479 16.0141 50.7834 15.9432C50.619 15.8723 50.4765 15.7706 50.3554 15.6363C50.2343 15.5027 50.1383 15.3382 50.0673 15.1437C49.9964 14.9485 49.9607 14.7257 49.9607 14.4747C49.9607 14.2237 49.9964 14.0141 50.0673 13.8202C50.1383 13.6262 50.2368 13.4612 50.3629 13.3256Z",
    fill: "url(#paint2_linear_23713_68073)"
  }
)), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement(
  "linearGradient",
  {
    id: "paint0_linear_23713_68073",
    x1: 0.545114,
    y1: 10.5558,
    x2: 21.3019,
    y2: 31.3134,
    gradientUnits: "userSpaceOnUse"
  },
  /* @__PURE__ */ t.createElement("stop", { stopColor: "#EBEBEB" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.5, stopColor: "white" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 1, stopColor: "#EBEBEB" })
), /* @__PURE__ */ t.createElement(
  "linearGradient",
  {
    id: "paint1_linear_23713_68073",
    x1: 5.97384,
    y1: 26.6352,
    x2: 16.1335,
    y2: 16.4752,
    gradientUnits: "userSpaceOnUse"
  },
  /* @__PURE__ */ t.createElement("stop", { stopColor: "#ED1C24" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.27, stopColor: "#B94197" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.79, stopColor: "#0078BF" })
), /* @__PURE__ */ t.createElement(
  "linearGradient",
  {
    id: "paint2_linear_23713_68073",
    x1: 27.031,
    y1: 11.6513,
    x2: 57.4678,
    y2: 17.0186,
    gradientUnits: "userSpaceOnUse"
  },
  /* @__PURE__ */ t.createElement("stop", { stopColor: "#4D90CD" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.3, stopColor: "#705CA8" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.6, stopColor: "#B94197" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.8, stopColor: "#ED2986" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 1, stopColor: "#EF383A" })
), /* @__PURE__ */ t.createElement("clipPath", { id: "clip0_23713_68073" }, /* @__PURE__ */ t.createElement("rect", { width: 88, height: 24, fill: "white", transform: "translate(0 10)" })))), k7 = (e) => /* @__PURE__ */ t.createElement("svg", { id: "applysg-icon", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 500 500", ...e }, /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement(
  "linearGradient",
  {
    id: "applysg-icon-bg-gradient",
    x1: 12.19,
    y1: 12.19,
    x2: 475.91,
    y2: 475.91,
    gradientUnits: "userSpaceOnUse"
  },
  /* @__PURE__ */ t.createElement("stop", { offset: 0, stopColor: "#ebebeb" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.5, stopColor: "#fff" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 1, stopColor: "#ebebeb" })
), /* @__PURE__ */ t.createElement(
  "linearGradient",
  {
    id: "applysg-icon-shape-gradient",
    x1: 133.47,
    y1: 371.41,
    x2: 360.43,
    y2: 144.44,
    gradientUnits: "userSpaceOnUse"
  },
  /* @__PURE__ */ t.createElement("stop", { offset: 0, stopColor: "#d30027" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.27, stopColor: "#ba2fa2" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.79, stopColor: "#1c75c1" })
)), /* @__PURE__ */ t.createElement("g", null, /* @__PURE__ */ t.createElement(
  "rect",
  {
    fill: "url(#applysg-icon-bg-gradient)",
    x: 1.2,
    y: 1.2,
    width: 497.59,
    height: 497.59,
    rx: 123.8,
    ry: 123.8
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fill: "#ebebeb",
    d: "M375,2.41c32.75,0,63.53,12.75,86.69,35.91,23.16,23.15,35.91,53.94,35.91,86.69v250c0,32.75-12.75,63.53-35.91,86.69-23.15,23.15-53.94,35.91-86.69,35.91H125c-32.75,0-63.53-12.75-86.69-35.91-23.16-23.15-35.91-53.94-35.91-86.69V125c0-32.75,12.75-63.53,35.91-86.69C61.47,15.16,92.25,2.41,125,2.41h250ZM375,0H125C55.96,0,0,55.96,0,125v250C0,444.04,55.96,500,125,500h250c69.04,0,125-55.96,125-125V125C500,55.96,444.04,0,375,0h0Z"
  }
)), /* @__PURE__ */ t.createElement(
  "path",
  {
    fill: "url(#applysg-icon-shape-gradient)",
    d: "M362.03,276.08c8.76,8.76,19.89,14.35,31.99,16.1l-127.82,127.82c-19.1,19.1-49.98,19.1-69.08,0l-123.77-123.77c-12.72-12.72-12.72-33.31,0-46.02l88.88-88.88c12.72-12.67,33.31-12.67,46.02,0l20.5,20.55c1.58,1.58,4.18,1.58,5.76,0l94.78-94.78c6.38-6.38,16.68-6.38,23.06,0l25.08,25.08c6.34,6.34,6.34,16.68,0,23.01l-141.28,141.29c-2.77,1.85-6.47,1.8-9.2-.22l-19.1-19.1,11.44-11.44c4.14-4.14,1.23-11.09-4.53-11.09h-64.06c-2.29,0-4.14,1.85-4.14,4.14v64.06c0,5.76,6.95,8.71,11.09,4.58l11.53-11.57,51,51c5.94,5.94,15.4,6.29,21.78,1.1.44-.35.84-.7,1.23-1.1l102.74-102.74c1.8,12.06,7.3,23.19,16.1,31.99ZM426.27,211.84c-6.64-6.6-15.31-9.94-24.02-9.94s-17.34,3.34-23.98,9.94c-13.24,13.25-13.24,34.76,0,48.01,6.64,6.6,15.31,9.95,23.98,9.95s17.38-3.35,24.02-9.95c13.24-13.24,13.24-34.76,0-48.01Z"
  }
)), L7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 88, height: 44, viewBox: "0 0 88 44", fill: "none", ...e }, /* @__PURE__ */ t.createElement("g", { clipPath: "url(#clip0_23711_66404)" }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M33.5642 28.0991H29.4115L28.7243 30.086H26.5283L30.2782 19.6445H32.7132L36.4631 30.086H34.2521L33.5649 28.0991H33.5642ZM32.9963 26.426L31.4875 22.0638L29.9788 26.426H32.9963Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M40.6824 22.0567C41.1556 21.8025 41.6959 21.6758 42.3034 21.6758C43.0107 21.6758 43.6502 21.8502 44.2232 22.1985C44.7956 22.5475 45.2487 23.0426 45.5826 23.6846C45.9158 24.3272 46.0828 25.0715 46.0828 25.9181C46.0828 26.7647 45.9158 27.514 45.5826 28.1661C45.2487 28.8187 44.7956 29.3239 44.2232 29.6823C43.6502 30.0406 43.0107 30.2201 42.3034 30.2201C41.6959 30.2201 41.1606 30.0952 40.6974 29.8467C40.2343 29.5982 39.8583 29.2844 39.5696 28.9053V34.0294H37.4785V21.8101H39.5696V23.005C39.8383 22.6265 40.2092 22.3102 40.6824 22.0567ZM43.6402 24.626C43.4362 24.2626 43.167 23.9865 42.8337 23.797C42.4999 23.6081 42.139 23.5133 41.7505 23.5133C41.362 23.5133 41.0162 23.6106 40.6824 23.8045C40.3485 23.9984 40.0799 24.2802 39.8759 24.6486C39.6719 25.0169 39.5696 25.4506 39.5696 25.9482C39.5696 26.4459 39.6719 26.8796 39.8759 27.2479C40.0799 27.6163 40.3491 27.8975 40.6824 28.092C41.0156 28.2859 41.3721 28.3832 41.7505 28.3832C42.129 28.3832 42.4999 28.284 42.8337 28.0845C43.167 27.8855 43.4362 27.6019 43.6402 27.2329C43.8442 26.8645 43.9465 26.4265 43.9465 25.9181C43.9465 25.4098 43.8442 24.99 43.6402 24.626Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M50.4216 22.0567C50.8948 21.8025 51.4352 21.6758 52.0427 21.6758C52.75 21.6758 53.3895 21.8502 53.9625 22.1985C54.5348 22.5475 54.988 23.0426 55.3218 23.6846C55.6551 24.3272 55.822 25.0715 55.822 25.9181C55.822 26.7647 55.6551 27.514 55.3218 28.1661C54.988 28.8187 54.5348 29.3239 53.9625 29.6823C53.3895 30.0406 52.75 30.2201 52.0427 30.2201C51.4352 30.2201 50.8998 30.0952 50.4367 29.8467C49.9735 29.5982 49.5976 29.2844 49.3089 28.9053V34.0294H47.2178V21.8101H49.3089V23.005C49.5775 22.6265 49.9484 22.3102 50.4216 22.0567ZM53.3801 24.626C53.1761 24.2626 52.9069 23.9865 52.5736 23.797C52.2397 23.6081 51.8789 23.5133 51.4904 23.5133C51.1019 23.5133 50.7561 23.6106 50.4222 23.8045C50.0884 23.9984 49.8198 24.2802 49.6158 24.6486C49.4118 25.0169 49.3095 25.4506 49.3095 25.9482C49.3095 26.4459 49.4118 26.8796 49.6158 27.2479C49.8198 27.6163 50.089 27.8975 50.4222 28.092C50.7555 28.2859 51.112 28.3832 51.4904 28.3832C51.8688 28.3832 52.2397 28.284 52.5736 28.0845C52.9069 27.8855 53.1761 27.6019 53.3801 27.2329C53.584 26.8645 53.6863 26.4265 53.6863 25.9181C53.6863 25.4098 53.584 24.99 53.3801 24.626Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement("path", { d: "M59.0491 19.0312V30.0852H56.958V19.0312H59.0491Z", fill: "white" }), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M68.6397 21.8092L63.5155 33.9984H61.2894L63.0818 29.8753L59.7656 21.8086H62.1109L64.2472 27.5897L66.4131 21.8086H68.6391L68.6397 21.8092Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M71.0073 29.8163C70.4249 29.5678 69.9642 29.2088 69.6253 28.7406C69.2864 28.2725 69.1126 27.7202 69.1025 27.0826H71.343C71.3732 27.5112 71.5244 27.8495 71.7987 28.0986C72.0723 28.3478 72.4482 28.472 72.9264 28.472C73.4047 28.472 73.7975 28.3553 74.0768 28.1212C74.3555 27.8871 74.4948 27.5809 74.4948 27.2025C74.4948 26.8937 74.4 26.6402 74.2111 26.4406C74.0216 26.2417 73.7856 26.0848 73.5013 25.9699C73.2177 25.8557 72.8267 25.7283 72.3284 25.589C71.6512 25.3901 71.1008 25.193 70.6778 24.9991C70.2542 24.8052 69.8908 24.5115 69.587 24.118C69.2833 23.7245 69.1314 23.1992 69.1314 22.5422C69.1314 21.9246 69.2858 21.3868 69.5946 20.9287C69.9033 20.4706 70.3364 20.1198 70.8943 19.8756C71.4522 19.6315 72.0892 19.5098 72.8066 19.5098C73.8823 19.5098 74.7559 19.7715 75.428 20.2942C76.1002 20.817 76.4711 21.5468 76.5407 22.4825H74.24C74.2199 22.1242 74.068 21.828 73.7844 21.5939C73.5007 21.3598 73.1248 21.2431 72.6566 21.2431C72.248 21.2431 71.9223 21.3479 71.6782 21.5569C71.434 21.7659 71.3123 22.0696 71.3123 22.4681C71.3123 22.7468 71.4045 22.9783 71.5884 23.1628C71.7723 23.3473 72.0014 23.4967 72.2756 23.6109C72.5493 23.7258 72.9352 23.8575 73.4335 24.0069C74.1107 24.2065 74.6636 24.4054 75.0916 24.6043C75.5196 24.8039 75.888 25.1026 76.1968 25.5005C76.5056 25.899 76.66 26.4218 76.66 27.0688C76.66 27.6267 76.5156 28.1444 76.2269 28.6226C75.9382 29.1009 75.5146 29.4818 74.9573 29.7654C74.3994 30.0491 73.7373 30.1909 72.9704 30.1909C72.243 30.1909 71.5884 30.0667 71.006 29.8175L71.0073 29.8163Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M85.3409 22.7962C85.1018 22.3582 84.7729 22.0243 84.355 21.7952C83.9364 21.5662 83.4487 21.4513 82.8908 21.4513C82.2733 21.4513 81.7254 21.5906 81.2478 21.8699C80.7696 22.1485 80.3961 22.547 80.1275 23.0648C79.8589 23.5825 79.724 24.18 79.724 24.8571C79.724 25.5343 79.8608 26.1618 80.1351 26.6796C80.4087 27.1973 80.7896 27.5958 81.2779 27.8745C81.7655 28.1531 82.3335 28.293 82.9812 28.293C83.7776 28.293 84.4303 28.0816 84.938 27.6579C85.4457 27.235 85.7796 26.6444 85.939 25.8876H82.3536V24.2892H88.0006V26.1116C87.8613 26.839 87.5626 27.5111 87.1044 28.128C86.6463 28.7455 86.0564 29.2407 85.334 29.6141C84.6117 29.9875 83.8027 30.1745 82.9065 30.1745C81.9005 30.1745 80.9917 29.9479 80.1802 29.4948C79.3681 29.0417 78.7311 28.4117 78.268 27.6052C77.8048 26.7988 77.5732 25.8826 77.5732 24.8565C77.5732 23.8304 77.8048 22.9123 78.268 22.1002C78.7311 21.2888 79.3681 20.6562 80.1802 20.2031C80.9917 19.75 81.8955 19.5234 82.8914 19.5234C84.0663 19.5234 85.0874 19.8096 85.9541 20.3826C86.8208 20.9555 87.4182 21.7595 87.7465 22.7949H85.3415L85.3409 22.7962Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M5.59533 10.0645H16.7859C19.8441 10.0645 22.3275 12.5477 22.3275 15.6059V26.796C22.3275 29.8541 19.8441 32.3374 16.7859 32.3374H5.59533C2.53708 32.3374 0.0537109 29.8541 0.0537109 26.796V15.6059C0.0537109 12.5471 2.53646 10.0645 5.59533 10.0645Z",
    fill: "url(#paint0_linear_23711_66404)"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16.7861 10.1177C19.8118 10.1177 22.2738 12.5796 22.2738 15.6051V26.7953C22.2738 29.8208 19.8118 32.2827 16.7861 32.2827H5.59559C2.56998 32.2827 0.107945 29.8208 0.107945 26.7953V15.6051C0.107945 12.579 2.56935 10.1177 5.59559 10.1177H16.7861ZM16.7861 10.0098H5.59559C2.50534 10.0098 0 12.515 0 15.6051V26.7953C0 29.8854 2.50534 32.39 5.59559 32.39H16.7861C19.8764 32.39 22.3817 29.8848 22.3817 26.7946V15.6051C22.3817 12.515 19.8764 10.0098 16.7861 10.0098Z",
    fill: "#EBEBEB"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M16.2054 22.3678C16.5977 22.76 17.096 23.0098 17.6376 23.0889L11.9159 28.8104C11.0611 29.6651 9.6785 29.6651 8.82373 28.8104L3.28336 23.2702C2.71414 22.701 2.71414 21.7791 3.28336 21.2099L7.26165 17.2318C7.83088 16.6645 8.75281 16.6645 9.32203 17.2318L10.2396 18.1518C10.3105 18.2227 10.4266 18.2227 10.4975 18.1518L14.74 13.9095C15.0256 13.6239 15.4862 13.6239 15.7718 13.9095L16.8945 15.0322C17.1782 15.3158 17.1782 15.7784 16.8945 16.062L10.5703 22.386C10.446 22.4688 10.281 22.467 10.1586 22.376L9.30383 21.5212L9.81595 21.0091C10.0011 20.824 9.87117 20.5127 9.61323 20.5127H6.74578C6.64348 20.5127 6.56064 20.5956 6.56064 20.6978V23.5652C6.56064 23.8231 6.87192 23.9549 7.05706 23.7698L7.57294 23.252L9.85548 25.5345C10.1216 25.8006 10.5446 25.8163 10.8301 25.5834C10.8496 25.5678 10.8678 25.5521 10.8854 25.5345L15.4843 20.9357C15.5653 21.4754 15.8113 21.9737 16.2054 22.3678ZM19.0811 19.4923C18.7836 19.1967 18.3957 19.0474 18.0054 19.0474C17.615 19.0474 17.229 19.1967 16.9322 19.4923C16.3391 20.0853 16.3391 21.048 16.9322 21.6411C17.2297 21.9367 17.6175 22.086 18.0054 22.086C18.3932 22.086 18.7836 21.936 19.0811 21.6411C19.6741 21.048 19.6741 20.0853 19.0811 19.4923Z",
    fill: "url(#paint1_linear_23711_66404)"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M35.4636 12.8468C35.2665 12.6447 35.0293 12.4859 34.7519 12.3705C34.4745 12.2556 34.1676 12.1979 33.8306 12.1979C33.4936 12.1979 33.1861 12.255 32.9074 12.3692C32.6288 12.4834 32.3909 12.6416 32.1926 12.8455C31.9943 13.0489 31.8405 13.2899 31.732 13.5679C31.6228 13.8465 31.5688 14.149 31.5688 14.4753C31.5688 14.8017 31.6234 15.1048 31.732 15.3828C31.8405 15.6614 31.9943 15.9024 32.1926 16.1051C32.3909 16.3084 32.6288 16.4672 32.9074 16.5814C33.1861 16.6957 33.4936 16.7528 33.8306 16.7528C34.1676 16.7528 34.4745 16.6957 34.7519 16.5814C35.0293 16.4672 35.2665 16.3084 35.4636 16.1051C35.6607 15.9018 35.8138 15.6608 35.923 15.3828C36.0316 15.1042 36.0862 14.8023 36.0862 14.4753C36.0862 14.1484 36.0316 13.8465 35.923 13.5679C35.8138 13.2892 35.6607 13.0495 35.4636 12.8468ZM35.1385 15.133C35.0739 15.3269 34.9804 15.4914 34.8592 15.6263C34.7381 15.7606 34.5906 15.8641 34.4168 15.9357C34.2429 16.0072 34.0471 16.0436 33.83 16.0436C33.6128 16.0436 33.4158 16.0078 33.2413 15.9357C33.0668 15.8641 32.9181 15.7606 32.7964 15.6263C32.674 15.4914 32.5798 15.3276 32.5146 15.133C32.4493 14.9385 32.416 14.7195 32.416 14.4753C32.416 14.2312 32.4487 14.0116 32.5146 13.8176C32.5805 13.6237 32.674 13.4587 32.7964 13.3231C32.9187 13.1876 33.0668 13.084 33.2413 13.0118C33.4158 12.9403 33.6122 12.9039 33.83 12.9039C34.0478 12.9039 34.2436 12.9397 34.4168 13.0118C34.5906 13.084 34.7375 13.1876 34.8592 13.3231C34.9804 13.4587 35.0733 13.6237 35.1385 13.8176C35.2032 14.0116 35.2352 14.2312 35.2352 14.4753C35.2352 14.7195 35.2032 14.9391 35.1385 15.133ZM39.9415 12.3058C39.8944 12.3447 39.8611 12.388 39.8429 12.4351L38.7986 15.1531C38.7283 15.3338 38.67 15.5422 38.6229 15.7788C38.594 15.6621 38.5639 15.5503 38.5319 15.4443C38.4999 15.3389 38.4666 15.2416 38.4315 15.1531L37.3834 12.4351C37.3608 12.3793 37.3269 12.3341 37.2817 12.2996C37.2366 12.265 37.1782 12.2475 37.106 12.2475H36.437L38.2369 16.7038H38.9856L40.7856 12.2475H40.1172C40.0469 12.2475 39.9885 12.2669 39.9415 12.3058ZM29.2473 14.9378C29.2473 14.9811 29.263 15.0175 29.2938 15.047C29.3245 15.0765 29.3666 15.0916 29.4199 15.0916H29.9778V15.9018C29.8523 15.9614 29.7205 16.0085 29.5818 16.0417C29.4431 16.0756 29.2806 16.0926 29.0936 16.0926C28.8814 16.0926 28.6869 16.0562 28.508 15.9834C28.3292 15.9106 28.1754 15.8051 28.0461 15.6677C27.9168 15.5303 27.8158 15.3608 27.7443 15.1606C27.6721 14.9604 27.6363 14.7314 27.6363 14.4747C27.6363 14.2362 27.6702 14.021 27.738 13.8277C27.8058 13.6344 27.9024 13.4693 28.0279 13.3313C28.1528 13.1938 28.3047 13.0878 28.4823 13.0137C28.6599 12.9397 28.8589 12.9026 29.0785 12.9026C29.2141 12.9026 29.3339 12.9121 29.4375 12.9303C29.541 12.9491 29.6346 12.9723 29.718 13.0012C29.8015 13.03 29.8774 13.0639 29.9458 13.1028C30.0149 13.1418 30.082 13.1807 30.1479 13.2202C30.1994 13.2528 30.2496 13.2698 30.2992 13.2698C30.377 13.2698 30.4398 13.2315 30.4868 13.1556L30.7272 12.7796C30.542 12.6071 30.3167 12.4665 30.0506 12.3592C29.7845 12.2512 29.4701 12.1973 29.1061 12.1973C28.7421 12.1973 28.4302 12.2525 28.1447 12.3636C27.8591 12.4746 27.6162 12.6303 27.416 12.8317C27.2158 13.0332 27.0614 13.2735 26.9522 13.5528C26.843 13.8321 26.7891 14.1396 26.7891 14.4741C26.7891 14.8086 26.8449 15.1098 26.9573 15.3891C27.069 15.6683 27.2252 15.9087 27.4242 16.1101C27.6231 16.3116 27.8597 16.4685 28.1327 16.5814C28.4057 16.6944 28.7051 16.7509 29.0296 16.7509C29.2122 16.7509 29.3829 16.7408 29.541 16.7214C29.6992 16.7019 29.8479 16.6724 29.986 16.6335C30.1247 16.5946 30.2552 16.545 30.3776 16.4842C30.5 16.4233 30.6174 16.3524 30.7303 16.2695V14.4672H29.248V14.9353L29.2473 14.9378ZM56.737 12.2475V14.1641H54.6478V12.2475H53.8125V16.7038H54.6478V14.7559H56.737V16.7038H57.5723V12.2475H56.737ZM50.3626 13.3256C50.4894 13.1901 50.64 13.0859 50.8157 13.0131C50.9914 12.9403 51.1841 12.9039 51.3937 12.9039C51.5726 12.9039 51.7201 12.9221 51.8362 12.9591C51.9523 12.9962 52.0483 13.0363 52.1242 13.0796C52.2002 13.1229 52.2629 13.1631 52.3119 13.1995C52.3615 13.2365 52.4092 13.2553 52.4569 13.2553C52.5046 13.2553 52.5378 13.2459 52.5629 13.2277C52.5887 13.2089 52.61 13.1876 52.6263 13.1631L52.9037 12.7778C52.7267 12.6033 52.5146 12.4627 52.2673 12.3567C52.0201 12.2512 51.7307 12.1979 51.4 12.1979C51.0693 12.1979 50.7511 12.2537 50.4705 12.3655C50.19 12.4778 49.949 12.6341 49.7482 12.8355C49.5467 13.0369 49.3905 13.2767 49.2794 13.5553C49.1683 13.834 49.1131 14.1402 49.1131 14.4753C49.1131 14.8104 49.1626 15.1111 49.2624 15.3903C49.3622 15.6696 49.5053 15.9099 49.6923 16.1114C49.8793 16.3128 50.1047 16.4697 50.3689 16.5827C50.6331 16.6957 50.9299 16.7521 51.2607 16.7521C51.6303 16.7521 51.9473 16.6925 52.2115 16.5733C52.4757 16.454 52.6979 16.2827 52.8786 16.0587L52.5523 15.7041C52.5196 15.669 52.4807 15.652 52.4355 15.652C52.4085 15.652 52.3841 15.6577 52.3615 15.669C52.3389 15.6803 52.3169 15.6953 52.2968 15.7135C52.229 15.775 52.1606 15.8271 52.0922 15.8692C52.0232 15.9112 51.9504 15.9457 51.8732 15.9727C51.796 15.9991 51.7119 16.0185 51.6203 16.0311C51.5287 16.0436 51.4264 16.0499 51.3134 16.0499C51.1245 16.0499 50.9475 16.0141 50.7831 15.9432C50.6186 15.8723 50.4762 15.7706 50.3551 15.6363C50.2339 15.5027 50.1379 15.3382 50.067 15.1437C49.9961 14.9485 49.9603 14.7257 49.9603 14.4747C49.9603 14.2237 49.9961 14.0141 50.067 13.8202C50.1379 13.6262 50.2364 13.4612 50.3626 13.3256ZM41.1835 12.9284H42.5303V16.7038H43.3593V12.9284H44.6999V12.2475H41.1835V12.9284ZM45.5345 16.7032H48.3455V16.0405H46.3699V14.7803H47.9263V14.1421H46.3699V12.9064H48.3455V12.2468H45.5345V16.7032Z",
    fill: "white"
  }
)), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement(
  "linearGradient",
  {
    id: "paint0_linear_23711_66404",
    x1: 0.545114,
    y1: 10.5558,
    x2: 21.3019,
    y2: 31.3134,
    gradientUnits: "userSpaceOnUse"
  },
  /* @__PURE__ */ t.createElement("stop", { stopColor: "#EBEBEB" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.5, stopColor: "white" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 1, stopColor: "#EBEBEB" })
), /* @__PURE__ */ t.createElement(
  "linearGradient",
  {
    id: "paint1_linear_23711_66404",
    x1: 5.97384,
    y1: 26.6352,
    x2: 16.1335,
    y2: 16.4752,
    gradientUnits: "userSpaceOnUse"
  },
  /* @__PURE__ */ t.createElement("stop", { stopColor: "#ED1C24" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.27, stopColor: "#B94197" }),
  /* @__PURE__ */ t.createElement("stop", { offset: 0.79, stopColor: "#0078BF" })
), /* @__PURE__ */ t.createElement("clipPath", { id: "clip0_23711_66404" }, /* @__PURE__ */ t.createElement("rect", { width: 88, height: 24, fill: "white", transform: "translate(0 10)" })))), x7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 88, height: 44, viewBox: "0 0 88 44", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2107 5.07122C65.9789 6.84224 66.8845 9.00202 66.8414 11.5506C66.8414 14.4447 65.9358 16.6908 63.9951 18.3323C62.0545 19.9737 59.5101 20.7944 56.2326 20.7944H54.0764V32.2844H49.3326V21.8311C49.2464 22.3926 49.117 22.911 48.9445 23.4293C48.5132 24.9844 47.6507 26.453 46.4432 27.7921C43.7263 30.859 40.3195 32.3276 36.1363 32.3276C32.0826 32.3276 28.5895 30.9022 25.657 27.9649C24.4926 26.8418 23.587 25.5891 22.8969 24.25C22.8107 26.4098 21.9482 28.2672 20.3957 29.7359C19.4469 30.7294 18.2826 31.4205 17.0319 31.8093C15.6951 32.198 13.9701 32.3708 11.9001 32.3708H5.00005V2.47949H9.52818C11.5982 2.47949 13.1938 2.65227 14.4013 2.95464C15.6951 3.25701 16.6438 3.77536 17.5063 4.50968C18.3257 5.2872 18.9726 6.19431 19.4901 7.36059C20.0076 8.52687 20.2232 9.69315 20.2232 10.8594C20.2232 12.976 19.4038 14.8334 17.7651 16.3021C19.3176 16.8204 20.5251 17.7275 21.4307 18.9802C21.3876 18.5482 21.3876 18.0731 21.3876 17.5547C21.3876 13.3648 22.8107 9.82273 25.7863 6.88544C28.6757 3.94814 32.2982 2.47949 36.5245 2.47949C38.767 2.47949 40.8801 2.95464 42.9501 3.94814C44.8476 4.85525 46.702 6.3239 48.5132 8.39728L45.3651 11.3778C42.9932 8.2245 40.1038 6.66946 36.6538 6.66946C33.5488 6.66946 31.0045 7.70615 28.9345 9.82273C26.8213 11.8961 25.7863 14.4447 25.7863 17.5547C25.7863 20.7512 26.9507 23.3861 29.2795 25.4595C31.4357 27.3169 33.8076 28.3104 36.3088 28.3104C38.4651 28.3104 40.4488 27.5761 42.1307 26.1506C43.8126 24.7252 44.7614 22.911 44.977 20.924H37.732V16.6476H49.3326V2.47949H54.7232C57.3539 2.47949 59.2945 2.65227 60.6745 2.99784C61.9682 3.42979 63.1757 4.03453 64.2107 5.07122ZM55.5463 37.6341H54.2257V41.0814H53.5853V37.6341H52.2247V37.0729H55.5463V37.6341ZM8.12153 40.52C8.16155 40.3997 8.20157 40.2394 8.20157 40.079C8.20157 39.8385 8.12153 39.598 8.00147 39.4377C7.8414 39.2773 7.68132 39.1571 7.4412 39.0769C7.6413 38.9567 7.76136 38.8364 7.88141 38.6761C8.00147 38.4756 8.04149 38.3153 8.04149 38.1149C8.04149 37.9946 8.00147 37.8744 7.96145 37.7541C7.92143 37.6339 7.84139 37.5136 7.76136 37.4334C7.69326 37.3311 7.62516 37.2868 7.53242 37.2265C7.5162 37.216 7.49908 37.2048 7.48122 37.1929C7.36116 37.1528 7.2411 37.1128 7.08102 37.1128H5V41.1213H6.92094C7.08102 41.1213 7.2411 41.0812 7.40118 41.0411C7.56126 41.001 7.68132 40.9208 7.80138 40.8407C7.87981 40.7883 7.94117 40.7188 8.00776 40.6434C8.0431 40.6034 8.07991 40.5617 8.12153 40.52ZM5.63978 38.8373V37.6347H6.80035C6.92041 37.6347 7.08049 37.6748 7.16053 37.795C7.28059 37.9153 7.32061 38.0756 7.32061 38.236C7.32061 38.3162 7.32061 38.3963 7.28059 38.4765C7.24057 38.5567 7.20055 38.6368 7.16053 38.6769C7.12051 38.717 7.08049 38.7571 7.00045 38.7972C6.96043 38.8373 6.88039 38.8373 6.80035 38.8373H5.63978ZM7.5207 39.9594C7.5207 39.8792 7.5207 39.799 7.48068 39.7189C7.44066 39.6387 7.40064 39.5585 7.36062 39.5184C7.32061 39.4784 7.24057 39.3982 7.20055 39.3982C7.12051 39.3581 7.04047 39.3581 6.96043 39.3581H5.63978V40.6007H6.92041C7.00045 40.6007 7.08049 40.6007 7.16053 40.5606C7.20055 40.5406 7.23056 40.5206 7.26058 40.5005C7.29059 40.4805 7.3206 40.4604 7.36062 40.4404C7.40064 40.4003 7.44066 40.3201 7.48068 40.24C7.5207 40.1197 7.5207 40.0395 7.5207 39.9594ZM11.204 40.4398C11.0839 40.52 10.8838 40.5601 10.6837 40.5601C10.4836 40.5601 10.2835 40.52 10.2035 40.4398C10.0434 40.3596 9.92336 40.2394 9.84332 40.1191C9.72326 39.9989 9.68324 39.8385 9.64322 39.6782C9.6032 39.5179 9.6032 39.3575 9.6032 39.1571V37.1128H8.96289V39.1571C8.96289 39.4377 8.96289 39.6782 9.04293 39.9187C9.08295 40.1592 9.20301 40.3596 9.32307 40.5601C9.44313 40.7204 9.6032 40.8807 9.84332 41.001C10.0434 41.1213 10.3236 41.1613 10.6437 41.1613C10.9639 41.1613 11.204 41.1213 11.4441 41.001C11.6842 40.8807 11.8443 40.7605 12.0044 40.5601C12.1645 40.3596 12.2445 40.1592 12.3245 39.9187C12.3646 39.6782 12.4046 39.4377 12.4046 39.1571V37.1128H11.7643V39.1571C11.7643 39.3174 11.7643 39.5179 11.7242 39.6782C11.6842 39.8385 11.6042 39.9989 11.5241 40.1191C11.4441 40.2394 11.3641 40.3596 11.204 40.4398ZM15.7649 38.0347C15.7249 37.9946 15.6849 37.9545 15.6048 37.9145L15.3647 37.7942C15.2847 37.7541 15.1646 37.714 15.0445 37.6739C14.9245 37.6339 14.8044 37.6339 14.6844 37.6339C14.4442 37.6339 14.2441 37.6739 14.1241 37.7942C14.004 37.8744 13.924 38.0347 13.924 38.1951C13.924 38.2752 13.964 38.3554 14.004 38.4356C14.044 38.5157 14.1241 38.5558 14.2041 38.5959C14.2842 38.636 14.4042 38.6761 14.5243 38.7162C14.6443 38.7562 14.8044 38.7963 14.9645 38.8364C15.0645 38.8565 15.1546 38.8865 15.2446 38.9166C15.3347 38.9466 15.4247 38.9767 15.5248 38.9968C15.6849 39.0368 15.8449 39.117 15.965 39.1972C16.0851 39.2773 16.1651 39.3976 16.2451 39.5179C16.3252 39.6381 16.3252 39.7985 16.3252 39.9989C16.3252 40.1993 16.2851 40.3997 16.2051 40.52C16.1251 40.6803 16.005 40.8006 15.885 40.8807C15.7649 40.9609 15.6048 41.0411 15.4047 41.0812C15.2446 41.1213 15.0445 41.1613 14.8444 41.1613C14.5243 41.1613 14.2441 41.1213 13.964 41.0411C13.6839 40.9609 13.4037 40.8006 13.2036 40.6402L13.4838 40.079C13.5238 40.1191 13.6038 40.1993 13.6839 40.2394C13.7639 40.3196 13.884 40.3596 14.004 40.3997C14.1241 40.4398 14.2441 40.4799 14.4042 40.52C14.5643 40.5601 14.7244 40.5601 14.8444 40.5601C15.0846 40.5601 15.2847 40.52 15.4047 40.4398C15.5248 40.3596 15.6048 40.2394 15.6048 40.039C15.6048 39.9187 15.5648 39.8385 15.5248 39.7985C15.4848 39.7183 15.4047 39.6782 15.3247 39.6381C15.2446 39.598 15.1246 39.5579 14.9645 39.5179C14.8444 39.4778 14.6844 39.4377 14.4843 39.3976C14.3691 39.3745 14.2672 39.3382 14.1709 39.3038C14.0999 39.2785 14.032 39.2543 13.964 39.2373C13.8039 39.1972 13.6839 39.117 13.6038 39.0368C13.5638 38.9968 13.5238 38.9466 13.4838 38.8965C13.4438 38.8464 13.4037 38.7963 13.3637 38.7562C13.3237 38.636 13.2837 38.5157 13.2837 38.3554C13.2837 38.155 13.3237 37.9946 13.4037 37.8343C13.4838 37.6739 13.5638 37.5537 13.7239 37.4334C13.8439 37.3132 14.004 37.233 14.2041 37.1929C14.3642 37.1528 14.5643 37.1128 14.7644 37.1128C15.0445 37.1128 15.2847 37.1528 15.5248 37.233C15.7649 37.3132 15.965 37.4334 16.1251 37.5537C16.045 37.5136 15.7649 38.0347 15.7649 38.0347ZM17.2065 37.1128V41.1213H17.8468V37.1128H17.2065ZM19.6483 38.2752V41.1213H19.008V37.1128H19.4882L21.8093 39.9989V37.1128H22.4497V41.1213H21.9294L19.6483 38.2752ZM26.3302 41.1213V40.6002H24.2092V39.3575H26.0101V38.8364H24.2092V37.6739H26.2902V37.1128H23.5689V41.1213H26.3302ZM29.573 38.0347C29.533 37.9946 29.493 37.9545 29.4129 37.9145L29.1728 37.7942C29.0928 37.7541 28.9727 37.714 28.8527 37.6739C28.7326 37.6339 28.6125 37.6339 28.4925 37.6339C28.2524 37.6339 28.0523 37.6739 27.9322 37.7942C27.8121 37.8744 27.7321 38.0347 27.7321 38.1951C27.7321 38.2752 27.7721 38.3554 27.8121 38.4356C27.8522 38.5157 27.9322 38.5558 28.0122 38.5959C28.0923 38.636 28.2123 38.6761 28.3324 38.7162C28.4525 38.7562 28.6125 38.7963 28.7726 38.8364C28.8727 38.8565 28.9627 38.8865 29.0527 38.9166C29.1428 38.9466 29.2328 38.9767 29.3329 38.9968C29.493 39.0368 29.653 39.117 29.7731 39.1972C29.8932 39.2773 29.9732 39.3976 30.0532 39.5179C30.1333 39.6381 30.1333 39.7985 30.1333 39.9989C30.1333 40.1993 30.0933 40.3997 30.0132 40.52C29.9332 40.6803 29.8131 40.8006 29.6931 40.8807C29.573 40.9609 29.4129 41.0411 29.2128 41.0812C29.0528 41.1213 28.8527 41.1613 28.6526 41.1613C28.3324 41.1613 28.0523 41.1213 27.7721 41.0411C27.492 40.9609 27.2119 40.8006 27.0118 40.6402L27.2919 40.079C27.3319 40.1191 27.4119 40.1993 27.492 40.2394C27.572 40.3196 27.6921 40.3596 27.8121 40.3997C27.9322 40.4398 28.0523 40.4799 28.2123 40.52C28.3724 40.5601 28.5325 40.5601 28.6526 40.5601C28.8927 40.5601 29.0928 40.52 29.2128 40.4398C29.3329 40.3596 29.4129 40.2394 29.4129 40.039C29.4129 39.9187 29.3729 39.8385 29.3329 39.7985C29.2929 39.7584 29.2128 39.6782 29.1328 39.6381C29.0528 39.598 28.9327 39.5579 28.7726 39.5179C28.7193 39.5045 28.6703 39.4911 28.6214 39.4778C28.5236 39.451 28.4258 39.4243 28.2924 39.3976C28.1772 39.3745 28.0753 39.3382 27.979 39.3038C27.908 39.2785 27.8401 39.2543 27.7721 39.2373C27.612 39.1972 27.492 39.117 27.4119 39.0368C27.3719 38.9968 27.3319 38.9466 27.2919 38.8965C27.2519 38.8464 27.2119 38.7963 27.1718 38.7562C27.1318 38.636 27.0918 38.5157 27.0918 38.3554C27.0918 38.155 27.1318 37.9946 27.2119 37.8343C27.2919 37.6739 27.3719 37.5537 27.532 37.4334C27.6521 37.3132 27.8121 37.233 28.0122 37.1929C28.1723 37.1528 28.3724 37.1128 28.5725 37.1128C28.8527 37.1128 29.0928 37.1528 29.3329 37.233C29.573 37.3132 29.7731 37.4334 29.9332 37.5537L29.573 38.0347ZM33.1339 37.9145C33.2139 37.9545 33.2539 37.9946 33.294 38.0347L33.6541 37.5537C33.4941 37.4334 33.294 37.3132 33.0539 37.233C32.8137 37.1528 32.5736 37.1128 32.2935 37.1128C32.0934 37.1128 31.8933 37.1528 31.7332 37.1929C31.5331 37.233 31.373 37.3132 31.253 37.4334C31.0929 37.5537 31.0128 37.6739 30.9328 37.8343C30.8528 37.9946 30.8127 38.155 30.8127 38.3554C30.8127 38.5157 30.8528 38.636 30.8928 38.7562C30.9328 38.7963 30.9728 38.8464 31.0129 38.8965C31.0529 38.9466 31.0929 38.9968 31.1329 39.0368C31.2129 39.117 31.333 39.1972 31.4931 39.2373C31.561 39.2543 31.629 39.2785 31.7 39.3038C31.7963 39.3382 31.8982 39.3745 32.0133 39.3976C32.1467 39.4243 32.2446 39.451 32.3424 39.4778C32.3913 39.4911 32.4402 39.5045 32.4936 39.5179C32.6537 39.5579 32.7737 39.598 32.8538 39.6381C32.9338 39.6782 33.0138 39.7584 33.0539 39.7985C33.0939 39.8385 33.1339 39.9187 33.1339 40.039C33.1339 40.2394 33.0539 40.3596 32.9338 40.4398C32.8137 40.52 32.6136 40.5601 32.3735 40.5601C32.2535 40.5601 32.0934 40.5601 31.9333 40.52C31.7732 40.4799 31.6532 40.4398 31.5331 40.3997C31.413 40.3596 31.293 40.3196 31.2129 40.2394C31.1329 40.1993 31.0529 40.1191 31.0128 40.079L30.7327 40.6402C30.9328 40.8006 31.2129 40.9609 31.4931 41.0411C31.7732 41.1213 32.0534 41.1613 32.3735 41.1613C32.5736 41.1613 32.7737 41.1213 32.9338 41.0812C33.1339 41.0411 33.294 40.9609 33.414 40.8807C33.5341 40.8006 33.6541 40.6803 33.7342 40.52C33.8142 40.3997 33.8542 40.1993 33.8542 39.9989C33.8542 39.7985 33.8542 39.6381 33.7742 39.5179C33.6942 39.3976 33.6141 39.2773 33.4941 39.1972C33.374 39.117 33.2139 39.0368 33.0539 38.9968C32.9538 38.9767 32.8638 38.9466 32.7737 38.9166C32.6837 38.8865 32.5936 38.8565 32.4936 38.8364C32.3335 38.7963 32.1734 38.7562 32.0534 38.7162C31.9333 38.6761 31.8132 38.636 31.7332 38.5959C31.6532 38.5558 31.5731 38.5157 31.5331 38.4356C31.4931 38.3554 31.4531 38.2752 31.4531 38.1951C31.4531 38.0347 31.5331 37.8744 31.6532 37.7942C31.7732 37.6739 31.9733 37.6339 32.2134 37.6339C32.3335 37.6339 32.4536 37.6339 32.5736 37.6739C32.6937 37.714 32.8137 37.7541 32.8938 37.7942L33.1339 37.9145ZM38.5769 40.6008C38.2168 40.9615 37.8566 41.1619 37.4164 41.1619C37.1362 41.1619 36.8961 41.1219 36.696 41.0016C36.4959 40.8813 36.2558 40.721 36.0957 40.5607C35.9356 40.3602 35.7756 40.1598 35.6955 39.9193C35.6155 39.6788 35.5354 39.3982 35.5354 39.1577C35.5354 38.8771 35.5755 38.6366 35.6955 38.3961C35.7756 38.1556 35.9356 37.9551 36.0957 37.7547C36.2558 37.5543 36.4559 37.434 36.696 37.3138C36.9361 37.1935 37.1762 37.1534 37.4564 37.1534C37.8166 37.1534 38.1367 37.2336 38.4169 37.3939C38.657 37.5543 38.8571 37.7547 39.0172 38.0353L38.5369 38.3961C38.4169 38.1956 38.2968 37.9952 38.0967 37.9151C37.8966 37.7948 37.6965 37.7547 37.4564 37.7547C37.2563 37.7547 37.0962 37.7948 36.9361 37.875C36.7761 37.9551 36.656 38.0754 36.5359 38.1956C36.4159 38.3159 36.3358 38.4762 36.2958 38.6767C36.2558 38.837 36.2158 39.0374 36.2158 39.2379C36.2158 39.4383 36.2558 39.6387 36.2958 39.7991C36.3759 39.9594 36.4559 40.1197 36.576 40.2801C36.696 40.4003 36.8161 40.5206 36.9761 40.6008C37.1362 40.6809 37.2963 40.721 37.4964 40.721C37.8966 40.721 38.2568 40.5206 38.617 40.1197V39.5585H37.7765V39.0775H39.1372V41.1219H38.617L38.5769 40.6008ZM40.178 37.1128V41.1213H40.8184V39.7183H41.7388L42.6192 41.1213H43.3796L42.4191 39.598C42.5392 39.5579 42.6593 39.5179 42.7393 39.4377C42.8193 39.3575 42.8994 39.2773 42.9794 39.1571C43.0594 39.0369 43.0995 38.9166 43.1395 38.7964C43.1795 38.6761 43.1795 38.5157 43.1795 38.3955C43.1795 38.2351 43.1795 38.0748 43.0995 37.9145C43.0595 37.7942 42.9794 37.6339 42.8594 37.5136C42.7393 37.3933 42.6192 37.3132 42.4592 37.233C42.2991 37.1528 42.139 37.1128 41.9389 37.1128H40.178ZM40.8179 39.1587H41.9385C42.0185 39.1587 42.0986 39.1587 42.1786 39.1186C42.2586 39.0786 42.2987 39.0385 42.3787 38.9583L42.4987 38.7178C42.5388 38.6376 42.5388 38.5174 42.5388 38.4372C42.5388 38.357 42.5388 38.2368 42.4987 38.1566C42.4587 38.0764 42.4187 37.9963 42.3387 37.9161C42.2987 37.8359 42.2186 37.7958 42.1386 37.7557C42.0585 37.7157 41.9785 37.7157 41.8985 37.7157H40.8179V39.1587ZM45.3398 37.1128L43.699 41.1213H44.3394L44.7796 40.039H46.3403L46.7806 41.1213H47.4609L45.8601 37.1128H45.3398ZM45.581 37.794L44.9407 39.5577H46.2614L45.581 37.794ZM48.7024 41.1213V38.2752L50.9835 41.1213H51.5037V37.1128H50.8634V39.9989L48.5423 37.1128H48.062V41.1213H48.7024ZM58.3866 37.9145C58.4667 37.9545 58.5067 37.9946 58.5467 38.0347L58.9069 37.5537C58.7468 37.4334 58.5467 37.3132 58.3066 37.233C58.0665 37.1528 57.8264 37.1128 57.5462 37.1128C57.3461 37.1128 57.146 37.1528 56.9859 37.1929C56.7858 37.233 56.6258 37.3132 56.5057 37.4334C56.3456 37.5537 56.2656 37.6739 56.1856 37.8343C56.1055 37.9946 56.0655 38.155 56.0655 38.3554C56.0655 38.5157 56.1055 38.636 56.1455 38.7562C56.1855 38.7963 56.2255 38.8464 56.2655 38.8965C56.3056 38.9466 56.3456 38.9967 56.3856 39.0368C56.4657 39.117 56.5857 39.1972 56.7458 39.2373C56.8138 39.2543 56.8817 39.2785 56.9527 39.3038C57.049 39.3382 57.1509 39.3745 57.2661 39.3976C57.4662 39.4377 57.6263 39.4778 57.7463 39.5179C57.9064 39.5579 58.0265 39.598 58.1065 39.6381C58.1865 39.6782 58.2666 39.7183 58.3066 39.7985C58.3466 39.8385 58.3866 39.9187 58.3866 40.039C58.3866 40.2394 58.3066 40.3596 58.1865 40.4398C58.0665 40.52 57.8664 40.5601 57.6263 40.5601C57.5062 40.5601 57.3461 40.5601 57.186 40.52C57.026 40.4799 56.9059 40.4398 56.7858 40.3997C56.6658 40.3596 56.5457 40.3196 56.4657 40.2394C56.3856 40.1993 56.3056 40.1191 56.2656 40.079L55.9855 40.6402C56.1856 40.8006 56.4657 40.9609 56.7458 41.0411C57.026 41.1213 57.3061 41.1613 57.6263 41.1613C57.8264 41.1613 58.0265 41.1213 58.1865 41.0812C58.3866 41.0411 58.5467 40.9609 58.6668 40.8807C58.7868 40.8006 58.9069 40.6803 58.9869 40.52C59.067 40.3997 59.107 40.1993 59.107 39.9989C59.107 39.7985 59.107 39.6381 59.0269 39.5179C58.9469 39.3976 58.8669 39.2773 58.7468 39.1972C58.6267 39.117 58.4667 39.0368 58.3066 38.9968C58.2065 38.9767 58.1165 38.9466 58.0264 38.9166C57.9364 38.8865 57.8464 38.8565 57.7463 38.8364C57.5863 38.7963 57.4261 38.7562 57.3061 38.7162C57.186 38.6761 57.066 38.636 56.9859 38.5959C56.9059 38.5558 56.8259 38.5157 56.7858 38.4356C56.7458 38.3554 56.7058 38.2752 56.7058 38.1951C56.7058 38.0347 56.7858 37.8744 56.9059 37.7942C57.026 37.6739 57.2261 37.6339 57.4662 37.6339C57.5862 37.6339 57.7063 37.6339 57.8264 37.6739C57.9464 37.714 58.0665 37.7541 58.1465 37.7942L58.3866 37.9145ZM61.0282 41.0812V37.1128H62.709C62.9091 37.1128 63.0692 37.1528 63.2292 37.233C63.3893 37.3132 63.5094 37.3933 63.6294 37.5136C63.7495 37.6339 63.8295 37.7942 63.8696 37.9145C63.9496 38.0748 63.9496 38.2351 63.9496 38.3955C63.9496 38.5558 63.9096 38.7162 63.8696 38.8765C63.8402 38.9941 63.7677 39.0902 63.6996 39.1805C63.6749 39.2133 63.6508 39.2453 63.6294 39.2773C63.5094 39.3976 63.3893 39.5179 63.2292 39.5579C63.0692 39.6381 62.9091 39.6782 62.749 39.6782H61.6685V41.0812H61.0282ZM62.7103 39.1585H61.6698V37.6754H62.6703C62.7503 37.6754 62.8304 37.6754 62.9104 37.7155C62.9904 37.7556 63.0305 37.7956 63.1105 37.8758C63.1905 37.956 63.2306 37.9961 63.2706 38.1163C63.3106 38.2366 63.3106 38.3167 63.3106 38.437C63.3106 38.5172 63.3106 38.6374 63.2706 38.7176L63.1505 38.9581C63.0705 39.0383 63.0305 39.0784 62.9504 39.1185C62.8704 39.1585 62.7903 39.1585 62.7103 39.1585ZM66.432 41.1619C66.1519 41.1619 65.8718 41.1219 65.6717 41.0016C65.4316 40.8813 65.2315 40.721 65.0714 40.5607C64.9113 40.3602 64.7912 40.1598 64.6712 39.9193C64.5911 39.6788 64.5511 39.4383 64.5511 39.1577C64.5511 38.8771 64.5911 38.6366 64.7112 38.3961C64.7912 38.1556 64.9513 37.9151 65.1114 37.7547C65.2715 37.5543 65.4716 37.434 65.7117 37.3138C65.9518 37.1935 66.1919 37.1534 66.4721 37.1534C66.7522 37.1534 67.0323 37.1935 67.2324 37.3138C67.4726 37.434 67.6727 37.5944 67.8327 37.7948C67.9928 37.9952 68.1129 38.1956 68.2329 38.4362C68.313 38.6767 68.353 38.9172 68.353 39.1978C68.353 39.4784 68.313 39.7189 68.1929 39.9594C68.1129 40.1999 67.9528 40.4404 67.7927 40.6008C67.6326 40.8012 67.4325 40.9214 67.1924 41.0417C67.1178 41.0541 67.0432 41.0705 66.9674 41.0871C66.7992 41.1239 66.6251 41.1619 66.432 41.1619ZM65.2537 39.5942C65.2202 39.4316 65.191 39.2896 65.191 39.1185C65.191 38.918 65.191 38.7577 65.271 38.5973C65.3111 38.3969 65.3911 38.2366 65.5112 38.1163C65.6312 37.9961 65.7513 37.8758 65.9114 37.7956C66.0714 37.7155 66.2315 37.6754 66.4316 37.6754C66.6317 37.6754 66.7918 37.7155 66.9519 37.7956C67.1119 37.8758 67.232 37.9961 67.3521 38.1163L67.5922 38.5973L67.6023 38.6472L67.6096 38.6827C67.643 38.8454 67.6722 38.9873 67.6722 39.1585C67.6722 39.3189 67.6322 39.5193 67.5922 39.6796C67.5522 39.8801 67.4721 40.0404 67.3521 40.1607C67.232 40.2809 67.1119 40.4012 66.9519 40.4813C66.7918 40.5615 66.6317 40.6016 66.4316 40.6016C66.2315 40.6016 66.0714 40.5615 65.9114 40.4813C65.7513 40.4012 65.6312 40.2809 65.5112 40.1607C65.4845 40.1072 65.4534 40.0538 65.4222 40.0003C65.36 39.8934 65.2977 39.7865 65.271 39.6796L65.2612 39.6311L65.2537 39.5942ZM69.1119 41.1213V37.1128H70.8728C71.0729 37.1128 71.233 37.1528 71.393 37.233C71.5531 37.3132 71.6732 37.3933 71.7932 37.5136C71.9133 37.6339 71.9933 37.7942 72.0333 37.9145C72.1134 38.0748 72.1134 38.2351 72.1134 38.3955C72.1134 38.5157 72.1134 38.6761 72.0734 38.7963C72.0334 38.9166 71.9933 39.0369 71.9133 39.1571C71.8333 39.2773 71.7532 39.3575 71.6732 39.4377C71.5931 39.5179 71.4731 39.5579 71.353 39.598L72.3135 41.1213H71.5931L70.7127 39.7183H69.7923V41.1213H69.1119ZM70.8741 39.1574H69.7535V37.7143H70.8341C70.9141 37.7143 70.9941 37.7143 71.0742 37.7544C71.1542 37.7945 71.2343 37.8346 71.2743 37.9148C71.3543 37.9949 71.3943 38.0751 71.4344 38.1553C71.4744 38.2354 71.4744 38.3557 71.4744 38.4359C71.4744 38.516 71.4744 38.6363 71.4344 38.7165L71.3143 38.957C71.2343 39.0371 71.1942 39.0772 71.1142 39.1173C71.0342 39.1574 70.9541 39.1574 70.8741 39.1574ZM75.9163 37.6341H74.5956V41.0814H73.9553V37.6341H72.5946V37.0729H75.9163V37.6341ZM77.4768 37.1128L75.836 41.1213H76.4763L76.9166 40.039H78.4773L78.9175 41.1213H79.5979L77.9971 37.1128H77.4768ZM77.7178 37.794L77.0375 39.5577H78.3581L77.7178 37.794ZM80.1986 37.1128V41.1213H83V40.5601H80.8389V37.1128H80.1986ZM9.56978 15.2656V6.62665H11.1654C12.7178 6.62665 13.8391 6.97221 14.6584 7.70652C15.4778 8.44083 15.8659 9.4775 15.8659 10.9029C15.8659 12.3283 15.4778 13.4082 14.6584 14.1857C13.8391 14.92 12.6747 15.2656 10.9498 15.2656H9.56978ZM16.9009 26.9266C17.9359 26.0627 18.4534 24.9829 18.4102 23.687C18.4102 22.348 17.8927 21.2681 16.944 20.4042C15.9953 19.5403 14.3134 19.0652 11.8554 19.0652H9.56978V28.1361H12.3728C14.4428 28.1361 15.909 27.7473 16.9009 26.9266ZM62.5286 11.6366C62.4424 14.9626 60.243 16.6472 55.9306 16.6472H54.1625V6.75563H55.7581C60.2862 6.75563 62.5286 8.35383 62.5286 11.6366Z",
    fill: "#492FF5"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5746 32.5802C79.1014 32.5802 78.6699 32.483 78.2802 32.2886C77.8905 32.0849 77.5564 31.7887 77.2781 31.3998C77.009 31.011 76.7956 30.5295 76.6378 29.9555C76.4894 29.3815 76.4151 28.7196 76.4151 27.9697C76.4151 27.2197 76.4894 26.5624 76.6378 25.9977C76.7956 25.4329 77.009 24.9607 77.2781 24.5812C77.5564 24.1923 77.8905 23.9053 78.2802 23.7201C78.6699 23.5257 79.1014 23.4285 79.5746 23.4285C80.0479 23.4285 80.4794 23.5257 80.8691 23.7201C81.2588 23.9053 81.5882 24.1923 81.8573 24.5812C82.1357 24.9607 82.3491 25.4329 82.4976 25.9977C82.6553 26.5624 82.7342 27.2197 82.7342 27.9697C82.7342 28.7196 82.6553 29.3815 82.4976 29.9555C82.3491 30.5295 82.1357 31.011 81.8573 31.3998C81.5882 31.7887 81.2588 32.0849 80.8691 32.2886C80.4794 32.483 80.0479 32.5802 79.5746 32.5802ZM79.5746 30.9971C79.7509 30.9971 79.9133 30.9554 80.0618 30.8721C80.2103 30.7795 80.3402 30.6175 80.4515 30.386C80.5629 30.1546 80.6464 29.8444 80.702 29.4556C80.767 29.0667 80.7995 28.5714 80.7995 27.9697C80.7995 27.3679 80.767 26.8772 80.702 26.4976C80.6464 26.1088 80.5629 25.8079 80.4515 25.5949C80.3402 25.3727 80.2103 25.22 80.0618 25.1367C79.9133 25.0533 79.7509 25.0117 79.5746 25.0117C79.4076 25.0117 79.2499 25.0533 79.1014 25.1367C78.9529 25.22 78.823 25.3727 78.7117 25.5949C78.6003 25.8079 78.5122 26.1088 78.4472 26.4976C78.3823 26.8772 78.3498 27.3679 78.3498 27.9697C78.3498 28.5714 78.3823 29.0667 78.4472 29.4556C78.5122 29.8444 78.6003 30.1546 78.7117 30.386C78.823 30.6175 78.9529 30.7795 79.1014 30.8721C79.2499 30.9554 79.4076 30.9971 79.5746 30.9971Z",
    fill: "#492FF5"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M75.3082 32.5325C75.0683 32.5325 74.862 32.4555 74.6893 32.3014C74.5262 32.1383 74.4446 31.9344 74.4446 31.6898C74.4446 31.427 74.5262 31.2185 74.6893 31.0645C74.862 30.9014 75.0683 30.8198 75.3082 30.8198C75.5385 30.8198 75.7352 30.9014 75.8983 31.0645C76.071 31.2185 76.1573 31.427 76.1573 31.6898C76.1573 31.9344 76.071 32.1383 75.8983 32.3014C75.7352 32.4555 75.5385 32.5325 75.3082 32.5325Z",
    fill: "#492FF5"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M67.143 31.3728V32.5418H73.3638V30.8161H71.5825C71.3691 30.8161 71.1232 30.8301 70.8449 30.8579C70.5758 30.8764 70.3299 30.8996 70.1073 30.9275C70.4691 30.5564 70.817 30.1806 71.151 29.8002C71.4943 29.4105 71.7959 29.0255 72.0556 28.6451C72.3247 28.2554 72.5381 27.8704 72.6958 27.49C72.8535 27.1003 72.9324 26.7199 72.9324 26.3488C72.9324 25.922 72.8628 25.537 72.7236 25.1937C72.5845 24.8504 72.385 24.5582 72.1252 24.3169C71.8654 24.0664 71.5546 23.8762 71.1928 23.7463C70.8402 23.6072 70.4459 23.5376 70.0098 23.5376C69.3789 23.5376 68.8362 23.6582 68.3816 23.8994C67.9269 24.1314 67.4816 24.4793 67.0455 24.9432L68.1589 26.0426C68.3816 25.8014 68.6182 25.5926 68.8687 25.4164C69.1192 25.2308 69.4068 25.138 69.7315 25.138C70.1212 25.138 70.4274 25.254 70.65 25.486C70.8727 25.7086 70.984 26.038 70.984 26.4741C70.984 26.7895 70.8866 27.1235 70.6918 27.4761C70.5062 27.8194 70.2418 28.1951 69.8985 28.6033C69.5645 29.0023 69.1609 29.4337 68.6877 29.8976C68.2238 30.3522 67.7089 30.844 67.143 31.3728Z",
    fill: "#492FF5"
  }
)), H7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 72, height: 36, viewBox: "0 0 72 36", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4954 6.52671C48.5264 4.69302 47.8748 3.13904 46.6026 1.86478C45.858 1.11887 44.9891 0.683751 44.0583 0.372955C43.0654 0.124318 41.6691 0 39.7763 0H35.8977V10.1941H27.5509V13.271H32.7638C32.6086 14.7006 31.926 16.006 30.7159 17.0316C29.5057 18.0572 28.0784 18.5856 26.527 18.5856C24.7273 18.5856 23.0207 17.8708 21.4693 16.5343C19.7937 15.0425 18.9559 13.1467 18.9559 10.8468C18.9559 8.60905 19.7006 6.77535 21.221 5.28353C22.7104 3.76063 24.5411 3.01472 26.7752 3.01472C29.2575 3.01472 31.3364 4.13359 33.043 6.4024L35.3081 4.2579C34.0049 2.76608 32.6707 1.70938 31.3054 1.05671C29.816 0.341875 28.2956 0 26.6821 0C23.6413 0 21.0349 1.05671 18.9559 3.17012C16.8149 5.28353 15.791 7.83206 15.791 10.8468C15.791 11.2197 15.791 11.5616 15.822 11.8724C15.1704 10.9711 14.3016 10.3184 13.1845 9.94547C14.3636 8.88876 14.9532 7.55234 14.9532 6.02944C14.9532 5.19029 14.798 4.35114 14.4257 3.51199C14.0534 2.67284 13.5879 2.02017 12.9984 1.46074C12.3778 0.932388 11.6952 0.559433 10.7643 0.341875C9.89549 0.124318 8.74742 0 7.25803 0H4V21.5071H8.96462C10.454 21.5071 11.6952 21.3828 12.6571 21.103C13.5569 20.8233 14.3947 20.326 15.0773 19.6112C16.1943 18.5545 16.8149 17.2181 16.877 15.6641C17.3734 16.6276 18.0251 17.5289 18.8628 18.337C20.9728 20.4504 23.4861 21.476 26.4028 21.476C29.4126 21.476 31.8639 20.4193 33.8188 18.2126C34.6876 17.2492 35.3081 16.1925 35.6184 15.0736C35.7425 14.7006 35.8356 14.3277 35.8977 13.9237V21.4449H39.3109V13.1777H40.8623C43.2205 13.1777 45.0512 12.5872 46.4475 11.4062C47.8438 10.2252 48.4954 8.60905 48.4954 6.52671ZM7.28831 9.20005V2.98414H8.43638C9.55342 2.98414 10.3602 3.23277 10.9497 3.76113C11.5393 4.28948 11.8185 5.03539 11.8185 6.06102C11.8185 7.08664 11.5393 7.86363 10.9497 8.42306C10.3602 8.95142 9.52239 9.20005 8.28123 9.20005H7.28831ZM12.5632 17.5904C13.3079 16.9688 13.6803 16.1918 13.6492 15.2594C13.6492 14.2959 13.2769 13.5189 12.5942 12.8974C11.9116 12.2758 10.7015 11.9339 8.93284 11.9339H7.28831V18.4606H9.30518C10.7946 18.4606 11.8496 18.1809 12.5632 17.5904ZM45.3925 6.58866C45.3305 8.98178 43.748 10.1939 40.6451 10.1939H39.3729V3.07666H40.521C43.779 3.07666 45.3925 4.22661 45.3925 6.58866Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4.6456 33V26.4545H7.15128C7.62429 26.4545 8.0174 26.5291 8.33061 26.6783C8.64595 26.8253 8.88139 27.0266 9.03693 27.2823C9.1946 27.538 9.27344 27.8278 9.27344 28.1516C9.27344 28.418 9.2223 28.646 9.12003 28.8356C9.01776 29.0231 8.88033 29.1754 8.70774 29.2926C8.53516 29.4098 8.34233 29.494 8.12926 29.5451V29.609C8.36151 29.6218 8.58416 29.6932 8.79723 29.8232C9.01243 29.951 9.18821 30.1321 9.32457 30.3665C9.46094 30.6009 9.52912 30.8842 9.52912 31.2166C9.52912 31.5554 9.44709 31.8601 9.28303 32.1307C9.11896 32.3991 8.8718 32.6112 8.54155 32.7667C8.21129 32.9222 7.79581 33 7.2951 33H4.6456ZM5.83132 32.0092H7.10653C7.53693 32.0092 7.84695 31.9272 8.03658 31.7631C8.22834 31.5969 8.32422 31.3839 8.32422 31.1239C8.32422 30.93 8.27628 30.7553 8.1804 30.5998C8.08452 30.4421 7.94815 30.3185 7.77131 30.229C7.59446 30.1374 7.38352 30.0916 7.13849 30.0916H5.83132V32.0092ZM5.83132 29.2383H7.00426C7.20881 29.2383 7.39311 29.201 7.55717 29.1264C7.72124 29.0497 7.85014 28.9421 7.94389 28.8036C8.03977 28.663 8.08771 28.4968 8.08771 28.305C8.08771 28.0515 7.99822 27.8427 7.81925 27.6786C7.6424 27.5146 7.37926 27.4325 7.02983 27.4325H5.83132V29.2383ZM11.9221 33.0991C11.6111 33.0991 11.3309 33.0437 11.0816 32.9329C10.8344 32.82 10.6384 32.6538 10.4935 32.4343C10.3508 32.2148 10.2794 31.9442 10.2794 31.6225C10.2794 31.3455 10.3305 31.1165 10.4328 30.9354C10.5351 30.7543 10.6746 30.6094 10.8515 30.5007C11.0283 30.392 11.2275 30.31 11.4491 30.2546C11.6729 30.1971 11.904 30.1555 12.1427 30.13C12.4303 30.1001 12.6636 30.0735 12.8426 30.0501C13.0216 30.0245 13.1515 29.9862 13.2325 29.935C13.3156 29.8817 13.3572 29.7997 13.3572 29.6889V29.6697C13.3572 29.429 13.2858 29.2425 13.143 29.1104C13.0003 28.9783 12.7947 28.9123 12.5262 28.9123C12.2428 28.9123 12.018 28.9741 11.8518 29.0977C11.6878 29.2212 11.577 29.3672 11.5194 29.5355L10.4392 29.3821C10.5244 29.0838 10.665 28.8345 10.8611 28.6342C11.0571 28.4318 11.2968 28.2805 11.5802 28.1804C11.8635 28.0781 12.1768 28.027 12.5198 28.027C12.7563 28.027 12.9917 28.0547 13.2261 28.1101C13.4605 28.1655 13.6746 28.2571 13.8685 28.3849C14.0624 28.5107 14.218 28.6822 14.3351 28.8995C14.4545 29.1168 14.5141 29.3885 14.5141 29.7145V33H13.4019V32.3256H13.3635C13.2932 32.462 13.1942 32.5898 13.0663 32.7092C12.9406 32.8263 12.7819 32.9212 12.5901 32.9936C12.4005 33.0639 12.1778 33.0991 11.9221 33.0991ZM12.2226 32.2489C12.4548 32.2489 12.6562 32.2031 12.8266 32.1115C12.9971 32.0178 13.1281 31.8942 13.2197 31.7408C13.3135 31.5874 13.3604 31.4201 13.3604 31.239V30.6605C13.3241 30.6903 13.2623 30.718 13.175 30.7436C13.0898 30.7692 12.9939 30.7915 12.8873 30.8107C12.7808 30.8299 12.6753 30.8469 12.5709 30.8619C12.4665 30.8768 12.376 30.8896 12.2993 30.9002C12.1267 30.9237 11.9722 30.962 11.8358 31.0153C11.6995 31.0685 11.5919 31.1431 11.5131 31.239C11.4342 31.3327 11.3948 31.4542 11.3948 31.6033C11.3948 31.8164 11.4726 31.9773 11.6281 32.0859C11.7836 32.1946 11.9818 32.2489 12.2226 32.2489ZM17.8188 33.0959C17.3287 33.0959 16.9079 32.9883 16.5564 32.7731C16.2069 32.5579 15.9374 32.2607 15.7478 31.8814C15.5603 31.5 15.4665 31.0611 15.4665 30.5646C15.4665 30.0661 15.5624 29.6261 15.7542 29.2447C15.9459 28.8612 16.2165 28.5629 16.566 28.3498C16.9175 28.1346 17.333 28.027 17.8124 28.027C18.2108 28.027 18.5635 28.1005 18.8703 28.2475C19.1792 28.3924 19.4253 28.598 19.6086 28.8643C19.7918 29.1286 19.8962 29.4375 19.9218 29.7912H18.816C18.7712 29.5547 18.6647 29.3576 18.4964 29.1999C18.3302 29.0401 18.1075 28.9602 17.8284 28.9602C17.5919 28.9602 17.3841 29.0241 17.2052 29.152C17.0262 29.2777 16.8866 29.4588 16.7865 29.6953C16.6885 29.9318 16.6395 30.2152 16.6395 30.5455C16.6395 30.88 16.6885 31.1676 16.7865 31.4084C16.8845 31.647 17.0219 31.8313 17.1988 31.9613C17.3778 32.0891 17.5876 32.1531 17.8284 32.1531C17.9988 32.1531 18.1512 32.1211 18.2854 32.0572C18.4218 31.9911 18.5358 31.8963 18.6274 31.7727C18.719 31.6491 18.7819 31.4989 18.816 31.3221H19.9218C19.8941 31.6694 19.7918 31.9773 19.615 32.2457C19.4381 32.5121 19.1974 32.7209 18.8927 32.8722C18.588 33.0213 18.23 33.0959 17.8188 33.0959ZM21.9265 31.4595L21.9233 30.0629H22.1087L23.8729 28.0909H25.2248L23.0547 30.5071H22.815L21.9265 31.4595ZM20.8718 33V26.4545H22.0288V33H20.8718ZM23.9528 33L22.3548 30.766L23.1346 29.951L25.3366 33H23.9528ZM34.1281 29.7273C34.1281 30.4325 33.996 31.0366 33.7318 31.5394C33.4697 32.0401 33.1118 32.4237 32.6579 32.69C32.2062 32.9563 31.6938 33.0895 31.1207 33.0895C30.5475 33.0895 30.034 32.9563 29.5802 32.69C29.1285 32.4215 28.7705 32.0369 28.5063 31.5362C28.2442 31.0334 28.1132 30.4304 28.1132 29.7273C28.1132 29.022 28.2442 28.419 28.5063 27.9183C28.7705 27.4155 29.1285 27.0309 29.5802 26.7646C30.034 26.4982 30.5475 26.3651 31.1207 26.3651C31.6938 26.3651 32.2062 26.4982 32.6579 26.7646C33.1118 27.0309 33.4697 27.4155 33.7318 27.9183C33.996 28.419 34.1281 29.022 34.1281 29.7273ZM32.936 29.7273C32.936 29.2308 32.8582 28.8121 32.7027 28.4712C32.5493 28.1282 32.3362 27.8693 32.0635 27.6946C31.7907 27.5178 31.4765 27.4293 31.1207 27.4293C30.7648 27.4293 30.4506 27.5178 30.1778 27.6946C29.9051 27.8693 29.691 28.1282 29.5354 28.4712C29.382 28.8121 29.3053 29.2308 29.3053 29.7273C29.3053 30.2237 29.382 30.6435 29.5354 30.9865C29.691 31.3274 29.9051 31.5863 30.1778 31.7631C30.4506 31.9379 30.7648 32.0252 31.1207 32.0252C31.4765 32.0252 31.7907 31.9379 32.0635 31.7631C32.3362 31.5863 32.5493 31.3274 32.7027 30.9865C32.8582 30.6435 32.936 30.2237 32.936 29.7273ZM37.6845 28.0909V28.9858H34.7825V28.0909H37.6845ZM35.508 33V27.6275C35.508 27.2972 35.5762 27.0224 35.7125 26.8029C35.851 26.5835 36.0364 26.4194 36.2686 26.3107C36.5009 26.2021 36.7587 26.1477 37.0421 26.1477C37.2424 26.1477 37.4203 26.1637 37.5758 26.1957C37.7314 26.2276 37.8464 26.2564 37.921 26.282L37.6909 27.1768C37.6419 27.1619 37.5801 27.147 37.5055 27.1321C37.4309 27.1151 37.3478 27.1065 37.2562 27.1065C37.041 27.1065 36.8887 27.1587 36.7992 27.2631C36.7118 27.3654 36.6681 27.5124 36.6681 27.7042V33H35.508ZM41.0771 28.0909V28.9858H38.1751V28.0909H41.0771ZM38.9006 33V27.6275C38.9006 27.2972 38.9688 27.0224 39.1051 26.8029C39.2436 26.5835 39.429 26.4194 39.6612 26.3107C39.8935 26.2021 40.1513 26.1477 40.4347 26.1477C40.6349 26.1477 40.8129 26.1637 40.9684 26.1957C41.1239 26.2276 41.239 26.2564 41.3136 26.282L41.0835 27.1768C41.0344 27.1619 40.9727 27.147 40.8981 27.1321C40.8235 27.1151 40.7404 27.1065 40.6488 27.1065C40.4336 27.1065 40.2813 27.1587 40.1918 27.2631C40.1044 27.3654 40.0607 27.5124 40.0607 27.7042V33H38.9006ZM41.9831 33V28.0909H43.1401V33H41.9831ZM42.5648 27.3942C42.3816 27.3942 42.2239 27.3335 42.0918 27.212C41.9597 27.0884 41.8936 26.9403 41.8936 26.7678C41.8936 26.593 41.9597 26.445 42.0918 26.3235C42.2239 26.1999 42.3816 26.1381 42.5648 26.1381C42.7502 26.1381 42.9078 26.1999 43.0378 26.3235C43.1699 26.445 43.236 26.593 43.236 26.7678C43.236 26.9403 43.1699 27.0884 43.0378 27.212C42.9078 27.3335 42.7502 27.3942 42.5648 27.3942ZM46.4711 33.0959C45.9811 33.0959 45.5603 32.9883 45.2087 32.7731C44.8593 32.5579 44.5898 32.2607 44.4001 31.8814C44.2126 31.5 44.1189 31.0611 44.1189 30.5646C44.1189 30.0661 44.2148 29.6261 44.4065 29.2447C44.5983 28.8612 44.8689 28.5629 45.2183 28.3498C45.5699 28.1346 45.9854 28.027 46.4648 28.027C46.8632 28.027 47.2158 28.1005 47.5226 28.2475C47.8316 28.3924 48.0777 28.598 48.2609 28.8643C48.4442 29.1286 48.5486 29.4375 48.5741 29.7912H47.4683C47.4236 29.5547 47.317 29.3576 47.1487 29.1999C46.9825 29.0401 46.7599 28.9602 46.4807 28.9602C46.2442 28.9602 46.0365 29.0241 45.8575 29.152C45.6785 29.2777 45.539 29.4588 45.4388 29.6953C45.3408 29.9318 45.2918 30.2152 45.2918 30.5455C45.2918 30.88 45.3408 31.1676 45.4388 31.4084C45.5368 31.647 45.6743 31.8313 45.8511 31.9613C46.0301 32.0891 46.24 32.1531 46.4807 32.1531C46.6512 32.1531 46.8035 32.1211 46.9378 32.0572C47.0741 31.9911 47.1881 31.8963 47.2797 31.7727C47.3714 31.6491 47.4342 31.4989 47.4683 31.3221H48.5741C48.5464 31.6694 48.4442 31.9773 48.2673 32.2457C48.0905 32.5121 47.8497 32.7209 47.545 32.8722C47.2403 33.0213 46.8824 33.0959 46.4711 33.0959ZM51.6974 33.0959C51.2053 33.0959 50.7802 32.9936 50.4222 32.7891C50.0664 32.5824 49.7926 32.2905 49.6009 31.9134C49.4091 31.5341 49.3132 31.0877 49.3132 30.5742C49.3132 30.0692 49.4091 29.6261 49.6009 29.2447C49.7947 28.8612 50.0653 28.5629 50.4126 28.3498C50.7599 28.1346 51.168 28.027 51.6367 28.027C51.9393 28.027 52.2248 28.076 52.4933 28.174C52.7638 28.2699 53.0025 28.419 53.2092 28.6214C53.418 28.8239 53.582 29.0817 53.7013 29.3949C53.8207 29.706 53.8803 30.0767 53.8803 30.5071V30.8619H49.8565V30.082H52.7713C52.7692 29.8604 52.7212 29.6634 52.6275 29.4908C52.5337 29.3161 52.4027 29.1786 52.2344 29.0785C52.0682 28.9783 51.8743 28.9283 51.6527 28.9283C51.4162 28.9283 51.2085 28.9858 51.0295 29.1009C50.8505 29.2138 50.7109 29.3629 50.6108 29.5483C50.5128 29.7315 50.4627 29.9329 50.4606 30.1523V30.8331C50.4606 31.1186 50.5128 31.3636 50.6172 31.5682C50.7216 31.7706 50.8675 31.9261 51.055 32.0348C51.2425 32.1413 51.462 32.1946 51.7134 32.1946C51.8817 32.1946 52.0341 32.1712 52.1705 32.1243C52.3068 32.0753 52.4251 32.0039 52.5252 31.9102C52.6254 31.8164 52.701 31.7003 52.7521 31.5618L53.8324 31.6832C53.7642 31.9687 53.6342 32.218 53.4425 32.4311C53.2528 32.642 53.0099 32.8061 52.7138 32.9233C52.4176 33.0384 52.0788 33.0959 51.6974 33.0959Z",
    fill: "#D6E4FF"
  }
)), M7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M4.63574 12C5.84067 12 6.76975 12.1004 7.47266 12.2764C8.22574 12.4524 8.77821 12.7542 9.28027 13.1816C9.75726 13.6343 10.1333 14.1629 10.4346 14.8418C10.7357 15.5206 10.8623 16.1991 10.8623 16.8779C10.8623 18.1101 10.3846 19.1919 9.43066 20.0469C10.3343 20.3486 11.0373 20.8763 11.5645 21.6055C11.5394 21.354 11.54 21.0771 11.54 20.7754C11.5401 18.3364 12.3685 16.2743 14.1006 14.5645C15.7825 12.8548 17.8915 12 20.3516 12C21.6568 12 22.8869 12.2763 24.0918 12.8545C25.1964 13.3825 26.2757 14.2383 27.3301 15.4453L25.498 17.1797C24.1173 15.3441 22.435 14.4395 20.4268 14.4395C18.6192 14.4395 17.1376 15.0423 15.9326 16.2744C14.7026 17.4813 14.1007 18.9651 14.1006 20.7754C14.1006 22.6361 14.7783 24.17 16.1338 25.377C17.389 26.4582 18.7696 27.0371 20.2256 27.0371C21.4808 27.0371 22.6362 26.6091 23.6152 25.7793C24.594 24.9496 25.1459 23.8937 25.2715 22.7373H21.0537V20.248H27.8076V12H30.9453C32.4767 12 33.6068 12.1006 34.4102 12.3018C35.163 12.5532 35.8654 12.9055 36.4678 13.5088C37.497 14.5397 38.025 15.7968 38 17.2803C38 18.965 37.4725 20.273 36.3428 21.2285C35.2131 22.184 33.732 22.6621 31.8242 22.6621H30.5684V29.3506H27.8076V23.2646C27.7574 23.5915 27.6815 23.8936 27.5811 24.1953C27.33 25.1005 26.8279 25.9558 26.125 26.7354C24.5435 28.5205 22.56 29.375 20.125 29.375C17.7655 29.3749 15.7323 28.5455 14.0254 26.8359C13.3476 26.1822 12.8196 25.4524 12.418 24.6729C12.3678 25.9301 11.8657 27.0122 10.9619 27.8672C10.4097 28.4453 9.73176 28.847 9.00391 29.0732C8.22568 29.2995 7.22158 29.4004 6.0166 29.4004H2V12H4.63574ZM4.65918 26.9365H6.29102C7.49577 26.9365 8.34944 26.7101 8.92676 26.2324C9.52913 25.7296 9.82967 25.1008 9.80469 24.3467C9.80469 23.5672 9.50346 22.9384 8.95117 22.4355C8.39887 21.9327 7.42011 21.6553 5.98926 21.6553H4.65918V26.9365ZM30.6152 20.249H31.6445C34.1549 20.249 35.4351 19.2682 35.4854 17.332C35.4852 15.4212 34.1797 14.4912 31.5439 14.4912H30.6152V20.249ZM4.65918 19.4443H5.46191C6.46602 19.4443 7.14412 19.2429 7.62109 18.8154C8.09806 18.3628 8.32421 17.7341 8.32422 16.9043C8.32422 16.0746 8.09793 15.4714 7.62109 15.0439C7.14416 14.6165 6.49151 14.4151 5.58789 14.415H4.65918V19.4443Z",
    fill: "#492FF5"
  }
)), V7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 118, height: 59, viewBox: "0 0 118 59", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M48.9609 52.3066C49.5043 52.3066 49.9876 52.4271 50.4102 52.6689C50.7723 52.9108 51.074 53.2135 51.3154 53.6367L50.5908 54.1807C50.4098 53.8784 50.2285 53.576 49.9268 53.4551C49.625 53.2738 49.323 53.2139 48.9609 53.2139C48.6594 53.2139 48.418 53.2738 48.1768 53.3945C47.9353 53.5155 47.7534 53.6975 47.5723 53.8789C47.3913 54.0603 47.2703 54.3023 47.21 54.6045C47.1496 54.8463 47.0898 55.1489 47.0898 55.4512C47.0899 55.7534 47.1496 56.0561 47.21 56.2979C47.3307 56.5397 47.4517 56.7816 47.6328 57.0234C47.8138 57.2047 47.995 57.3859 48.2363 57.5068C48.4778 57.6278 48.7196 57.6885 49.0215 57.6885C49.6252 57.6885 50.1686 57.3859 50.7119 56.7812V55.9346H49.4443V55.209H51.4971V58.293H50.7119L50.6514 57.5068C50.1081 58.051 49.5644 58.3535 48.9004 58.3535C48.478 58.3535 48.1162 58.2926 47.8145 58.1113C47.5126 57.9299 47.1497 57.6882 46.9082 57.4463C46.6668 57.144 46.4254 56.8413 46.3047 56.4785C46.184 56.1158 46.0635 55.6927 46.0635 55.3301C46.0635 54.9068 46.1236 54.5435 46.3047 54.1807C46.4254 53.8181 46.6669 53.516 46.9082 53.2139C47.1497 52.9115 47.4522 52.7293 47.8145 52.5479C48.1765 52.3667 48.5386 52.3067 48.9609 52.3066ZM92.7314 52.3066C93.1539 52.3066 93.5771 52.3666 93.8789 52.5479C94.2411 52.7293 94.5427 52.9721 94.7842 53.2744C95.0256 53.5767 95.2076 53.8785 95.3887 54.2412C95.5094 54.604 95.5693 54.9673 95.5693 55.3906C95.5693 55.8137 95.5091 56.1764 95.3281 56.5391C95.2074 56.9019 94.9651 57.265 94.7236 57.5068C94.4822 57.809 94.1805 57.9905 93.8184 58.1719C93.4563 58.2323 93.0942 58.3534 92.6719 58.3535C92.2493 58.3535 91.8263 58.2927 91.5244 58.1113C91.1623 57.9299 90.8606 57.6881 90.6191 57.4463C90.3777 57.1439 90.1967 56.8413 90.0156 56.4785C89.8949 56.1158 89.834 55.7532 89.834 55.3301C89.834 54.9068 89.8941 54.5435 90.0752 54.1807C90.196 53.8179 90.4382 53.4557 90.6797 53.2139C90.9212 52.9115 91.2227 52.7293 91.585 52.5479C91.947 52.3666 92.3092 52.3067 92.7314 52.3066ZM6.94434 55.3281C6.94434 55.6305 6.94452 55.8724 7.00488 56.1143C7.06525 56.3561 7.12553 56.5979 7.30664 56.7793C7.42738 56.9607 7.60813 57.1427 7.84961 57.2637C7.97047 57.3845 8.27251 57.4443 8.57422 57.4443C8.87575 57.4443 9.17727 57.3844 9.3584 57.2637C9.59988 57.1427 9.72106 56.9607 9.8418 56.7793C9.9625 56.5979 10.0832 56.3561 10.1436 56.1143C10.2039 55.8724 10.2041 55.57 10.2041 55.3281V52.2441H11.1699V55.3281C11.1699 55.7514 11.1092 56.1147 11.0488 56.4775C10.9282 56.8401 10.8076 57.1422 10.5664 57.4443C10.3249 57.7467 10.0829 57.9289 9.7207 58.1104C9.35864 58.2916 8.99642 58.3516 8.51367 58.3516C8.03096 58.3516 7.60846 58.2915 7.30664 58.1104C6.94442 57.9289 6.7026 57.6862 6.52148 57.4443C6.34047 57.1422 6.15903 56.8401 6.09863 56.4775C5.97789 56.1147 5.97852 55.7514 5.97852 55.3281V52.2441H6.94434V55.3281ZM14.7295 52.2441C15.1521 52.2441 15.5147 52.3048 15.877 52.4258C16.239 52.5467 16.5408 52.7279 16.7822 52.9092C16.6627 52.8508 16.2502 53.6145 16.2393 53.6348C16.1789 53.5743 16.1177 53.5145 15.9971 53.4541L15.6357 53.2725C15.515 53.212 15.3335 53.1513 15.1523 53.0908C14.9714 53.0304 14.7904 53.0303 14.6094 53.0303C14.2472 53.0303 13.9448 53.0911 13.7637 53.2725C13.5827 53.3934 13.4619 53.6352 13.4619 53.877C13.4619 53.9979 13.5226 54.1193 13.583 54.2402C13.6434 54.3609 13.7642 54.421 13.8848 54.4814C14.0054 54.5419 14.1862 54.6027 14.3672 54.6631C14.5482 54.7235 14.7899 54.7843 15.0312 54.8447C15.3331 54.9052 15.5751 55.0264 15.877 55.0869C16.1184 55.1474 16.36 55.2678 16.541 55.3887C16.7221 55.5096 16.8432 55.6907 16.9639 55.8721C17.0846 56.0535 17.084 56.2963 17.084 56.5986C17.0839 56.9006 17.0238 57.2024 16.9033 57.3838C16.7826 57.6257 16.601 57.8078 16.4199 57.9287C16.2388 58.0496 15.997 58.17 15.6953 58.2305C15.4539 58.2909 15.1523 58.3516 14.8506 58.3516C14.3676 58.3516 13.9451 58.2909 13.5225 58.1699C13.0999 58.049 12.6768 57.8073 12.375 57.5654L12.7979 56.7188C12.8582 56.7792 12.9789 56.9004 13.0996 56.9609C13.2204 57.0819 13.4019 57.1427 13.583 57.2031C13.764 57.2636 13.9452 57.3234 14.1865 57.3838C14.428 57.4443 14.6695 57.4443 14.8506 57.4443C15.2125 57.4443 15.5142 57.3844 15.6953 57.2637C15.8764 57.1427 15.9971 56.9605 15.9971 56.6582C15.997 56.4771 15.9372 56.3564 15.877 56.2959C15.8166 56.175 15.6959 56.1142 15.5752 56.0537C15.4545 55.9932 15.2727 55.9325 15.0312 55.8721C14.8503 55.8117 14.609 55.7518 14.3076 55.6914C14.0058 55.6309 13.7639 55.5097 13.5225 55.4492C13.281 55.3888 13.1002 55.2674 12.9795 55.1465C12.8588 55.0256 12.7379 54.8446 12.6172 54.7236C12.5568 54.5423 12.4961 54.3609 12.4961 54.1191C12.4961 53.8169 12.5561 53.5748 12.6768 53.333C12.7975 53.0912 12.9188 52.9099 13.1602 52.7285C13.3413 52.5471 13.5829 52.4257 13.8848 52.3652C14.1261 52.3048 14.4278 52.2442 14.7295 52.2441ZM35.5596 52.2441C35.9822 52.2441 36.3448 52.3048 36.707 52.4258C37.069 52.5467 37.3709 52.7279 37.6123 52.9092L37.0693 53.6348C37.009 53.5743 36.9479 53.5146 36.8271 53.4541L36.4648 53.2725C36.3441 53.212 36.1634 53.1512 35.9824 53.0908C35.8013 53.0303 35.6196 53.0303 35.4385 53.0303C35.0764 53.0303 34.7748 53.0911 34.5938 53.2725C34.4127 53.3934 34.292 53.6351 34.292 53.877C34.292 53.9979 34.3517 54.1193 34.4121 54.2402C34.4725 54.3611 34.5941 54.421 34.7148 54.4814C34.8356 54.5419 35.0163 54.6027 35.1973 54.6631C35.3784 54.7235 35.6199 54.7843 35.8613 54.8447C36.1632 54.9052 36.4052 55.0264 36.707 55.0869C36.9484 55.1474 37.1901 55.2678 37.3711 55.3887C37.5519 55.5095 37.6724 55.6909 37.793 55.8721C37.9137 56.0535 37.9141 56.2963 37.9141 56.5986C37.914 56.9005 37.8538 57.2024 37.7334 57.3838C37.6127 57.6257 37.4311 57.8078 37.25 57.9287C37.0689 58.0496 36.8272 58.17 36.5254 58.2305C36.284 58.2909 35.9824 58.3515 35.6807 58.3516C35.1978 58.3516 34.7751 58.2908 34.3525 58.1699C33.9299 58.049 33.5069 57.8073 33.2051 57.5654L33.6279 56.7188C33.6883 56.7792 33.8089 56.9005 33.9297 56.9609C34.0504 57.0818 34.2311 57.1427 34.4121 57.2031C34.5932 57.2636 34.7751 57.3233 35.0166 57.3838C35.258 57.4442 35.4996 57.4443 35.6807 57.4443C36.0426 57.4443 36.3443 57.3845 36.5254 57.2637C36.7065 57.1427 36.8271 56.9605 36.8271 56.6582C36.8271 56.4773 36.7673 56.3564 36.707 56.2959C36.6467 56.2355 36.5259 56.1142 36.4053 56.0537C36.2845 55.9932 36.1028 55.9325 35.8613 55.8721C35.62 55.8116 35.4385 55.7519 35.1367 55.6914C34.8351 55.6309 34.5939 55.5097 34.3525 55.4492C34.1111 55.3887 33.9293 55.2674 33.8086 55.1465C33.688 55.0255 33.5669 54.8445 33.4463 54.7236C33.3859 54.5423 33.3262 54.3609 33.3262 54.1191C33.3262 53.8169 33.3862 53.5748 33.5068 53.333C33.6276 53.0911 33.7488 52.9099 33.9902 52.7285C34.1713 52.5471 34.413 52.4257 34.7148 52.3652C34.9562 52.3048 35.2579 52.2441 35.5596 52.2441ZM41.1729 52.2441C41.5952 52.2441 41.9573 52.3049 42.3193 52.4258C42.6815 52.5467 42.9841 52.7278 43.2256 52.9092L42.6816 53.6348C42.6214 53.5744 42.5609 53.5144 42.4404 53.4541L42.0781 53.2725C41.9574 53.212 41.7767 53.1512 41.5957 53.0908C41.4146 53.0303 41.2329 53.0303 41.0518 53.0303C40.6897 53.0303 40.3881 53.0911 40.207 53.2725C40.0259 53.3934 39.9053 53.6351 39.9053 53.877C39.9053 53.9979 39.965 54.1193 40.0254 54.2402C40.0857 54.3609 40.2066 54.4211 40.3271 54.4814C40.4479 54.5419 40.6294 54.6026 40.8105 54.6631C40.9917 54.7236 41.2331 54.7843 41.4746 54.8447C41.7763 54.9052 42.0177 55.0264 42.3193 55.0869C42.5606 55.1473 42.8023 55.2678 42.9834 55.3887C43.1644 55.5095 43.2856 55.6908 43.4062 55.8721C43.527 56.0535 43.5273 56.2963 43.5273 56.5986C43.5273 56.9007 43.4663 57.2025 43.3457 57.3838C43.225 57.6257 43.0444 57.8078 42.8633 57.9287C42.6822 58.0496 42.4405 58.17 42.1387 58.2305C41.8973 58.2909 41.5956 58.3515 41.2939 58.3516C40.8111 58.3516 40.3883 58.2908 39.9658 58.1699C39.5432 58.049 39.1202 57.8073 38.8184 57.5654L39.2412 56.7188C39.3016 56.7792 39.4222 56.9005 39.543 56.9609C39.6637 57.0818 39.8444 57.1427 40.0254 57.2031C40.2065 57.2636 40.3884 57.3233 40.6299 57.3838C40.8713 57.4442 41.1129 57.4443 41.2939 57.4443C41.6559 57.4443 41.9576 57.3845 42.1387 57.2637C42.3198 57.1427 42.4404 56.9605 42.4404 56.6582C42.4403 56.477 42.3797 56.3563 42.3193 56.2959C42.2589 56.2354 42.1382 56.1141 42.0176 56.0537C41.8968 55.9933 41.7158 55.9325 41.4746 55.8721C41.2332 55.8116 41.0518 55.7519 40.75 55.6914C40.4484 55.631 40.2071 55.5097 39.9658 55.4492C39.7243 55.3887 39.5426 55.2674 39.4219 55.1465C39.3012 55.0255 39.1802 54.8445 39.0596 54.7236C38.9992 54.5423 38.9395 54.3609 38.9395 54.1191C38.9395 53.8169 38.9994 53.5748 39.1201 53.333C39.2409 53.0911 39.362 52.9099 39.6035 52.7285C39.7845 52.5472 40.0255 52.4257 40.3271 52.3652C40.5686 52.3048 40.871 52.2441 41.1729 52.2441ZM79.2666 52.2441C79.6892 52.2441 80.0518 52.3048 80.4141 52.4258C80.7761 52.5467 81.0779 52.7279 81.3193 52.9092L80.7764 53.6348C80.7161 53.5744 80.6555 53.5144 80.5352 53.4541L80.1729 53.2725C80.0521 53.212 79.8706 53.1513 79.6895 53.0908C79.5085 53.0304 79.3275 53.0303 79.1465 53.0303C78.7843 53.0303 78.4819 53.0911 78.3008 53.2725C78.1198 53.3934 77.9991 53.6352 77.999 53.877C77.999 53.9979 78.0597 54.1193 78.1201 54.2402C78.1805 54.3609 78.3013 54.421 78.4219 54.4814C78.5425 54.5419 78.7233 54.6027 78.9043 54.6631C79.0853 54.7235 79.327 54.7843 79.5684 54.8447C79.8702 54.9052 80.1122 55.0264 80.4141 55.0869C80.6555 55.1474 80.8971 55.2678 81.0781 55.3887C81.2592 55.5096 81.3803 55.6907 81.501 55.8721C81.6217 56.0535 81.6211 56.2963 81.6211 56.5986C81.621 56.9006 81.5609 57.2024 81.4404 57.3838C81.3197 57.6257 81.1381 57.8078 80.957 57.9287C80.7761 58.0495 80.5348 58.17 80.2334 58.2305C79.9919 58.2909 79.6895 58.3516 79.3877 58.3516C78.9047 58.3516 78.4822 58.2909 78.0596 58.1699C77.637 58.049 77.2139 57.8073 76.9121 57.5654L77.335 56.7188C77.3953 56.7792 77.5161 56.9004 77.6367 56.9609C77.7575 57.0819 77.939 57.1427 78.1201 57.2031C78.3011 57.2636 78.4823 57.3234 78.7236 57.3838C78.9651 57.4443 79.2066 57.4443 79.3877 57.4443C79.7499 57.4443 80.0523 57.3846 80.2334 57.2637C80.4144 57.1427 80.5352 56.9605 80.5352 56.6582C80.5351 56.4771 80.4744 56.3563 80.4141 56.2959C80.3537 56.175 80.233 56.1142 80.1123 56.0537C79.9916 55.9932 79.8098 55.9325 79.5684 55.8721C79.3874 55.8117 79.1461 55.7518 78.8447 55.6914C78.5429 55.6309 78.3011 55.5097 78.0596 55.4492C77.8181 55.3887 77.6373 55.2674 77.5166 55.1465C77.3959 55.0256 77.275 54.8446 77.1543 54.7236C77.0939 54.5423 77.0332 54.3609 77.0332 54.1191C77.0332 53.8168 77.0941 53.5749 77.2148 53.333C77.3355 53.0912 77.456 52.9099 77.6973 52.7285C77.8784 52.5471 78.12 52.4257 78.4219 52.3652C78.6632 52.3048 78.9649 52.2442 79.2666 52.2441ZM3.13965 52.2441C3.38094 52.2442 3.56215 52.3048 3.74316 52.3652C3.92423 52.4861 4.04529 52.5471 4.16602 52.7285C4.28662 52.8495 4.40747 53.0307 4.46777 53.2119C4.5281 53.3932 4.58783 53.5746 4.58789 53.7559C4.58789 54.0582 4.52774 54.3002 4.34668 54.6025C4.1656 54.8444 3.98437 55.0257 3.68262 55.207C4.04482 55.328 4.28588 55.5101 4.52734 55.752C4.70839 55.9938 4.83 56.3561 4.83008 56.7188C4.83008 56.9604 4.7693 57.2024 4.70898 57.3838C4.52787 57.5652 4.4067 57.7472 4.22559 57.8682C4.04458 57.989 3.86341 58.1095 3.62207 58.1699C3.3806 58.2304 3.13893 58.291 2.89746 58.291H0V52.2441H3.13965ZM19.3799 58.291H18.4131V52.2441H19.3799V58.291ZM25.3574 56.5986V52.2441H26.3232V58.291H25.5381L22.0967 53.998V58.291H21.1309V52.2441H21.8555L25.3574 56.5986ZM32.1172 53.0908H28.9775V54.8447H31.6943V55.6309H28.9775V57.5049H32.1768V58.291H28.0117V52.2441H32.1172V53.0908ZM55.7227 52.2441C56.0245 52.2441 56.2663 52.3049 56.5078 52.4258C56.7491 52.5466 56.9303 52.6674 57.1113 52.8486C57.2924 53.03 57.4133 53.2727 57.4736 53.4541C57.5943 53.6959 57.5947 53.9379 57.5947 54.1797C57.5947 54.3611 57.5945 54.6029 57.5342 54.7842C57.4738 54.9655 57.4136 55.1468 57.293 55.3281C57.1722 55.5095 57.0514 55.631 56.9307 55.752C56.8099 55.8728 56.6283 55.9327 56.4473 55.9932L57.8965 58.291H56.749L55.4209 56.1748H54.0322V58.291H53.0664V52.2441H55.7227ZM64.0527 58.291H63.0264L62.3623 56.6582H60.0078L59.3438 58.291H58.3779L60.8535 52.2441H61.6387L64.0527 58.291ZM69.1855 56.5986V52.2441H70.1523V58.291H69.3672L65.9258 53.998V58.291H64.96V52.2441H65.6846L69.1855 56.5986ZM99.3701 52.2441C99.672 52.2441 99.9138 52.3048 100.155 52.4258C100.397 52.5466 100.578 52.6674 100.759 52.8486C100.94 53.03 101.061 53.2727 101.121 53.4541C101.242 53.6959 101.242 53.9379 101.242 54.1797C101.242 54.3611 101.242 54.6029 101.182 54.7842C101.121 54.9655 101.061 55.1468 100.94 55.3281C100.82 55.5095 100.699 55.631 100.578 55.752C100.457 55.8729 100.276 55.9327 100.095 55.9932L101.544 58.291H100.457L99.1289 56.1748H97.7402V58.291H96.7139V52.2441H99.3701ZM112.532 58.291H111.506L110.842 56.6582H108.487L107.823 58.291H106.857L109.333 52.2441H110.117L112.532 58.291ZM114.404 57.4443H117.664V58.291H113.438V52.2441H114.404V57.4443ZM76.25 53.0322H74.2578V58.2324H73.292V53.0322H71.2393V52.1855H76.25V53.0322ZM106.979 53.0322H104.986V58.2324H104.021V53.0322H101.968V52.1855H106.979V53.0322ZM87.0547 52.2441C87.3565 52.2441 87.5984 52.3049 87.8398 52.4258C88.0812 52.5466 88.2624 52.6674 88.4434 52.8486C88.6245 53.03 88.7453 53.2727 88.8057 53.4541C88.9263 53.6959 88.9268 53.9379 88.9268 54.1797C88.9267 54.4215 88.866 54.6635 88.8057 54.9053C88.7452 55.147 88.564 55.3284 88.4434 55.5098C88.2623 55.6911 88.0812 55.8722 87.8398 55.9326C87.5984 56.0536 87.3567 56.1143 87.1152 56.1143H85.4854V58.2305H84.5195V52.2441H87.0547ZM92.6709 53.0947C92.369 53.0947 92.1272 53.1545 91.8857 53.2754C91.6443 53.3963 91.4633 53.5784 91.2822 53.7598C91.1012 53.9412 90.9803 54.1831 90.9199 54.4854C90.7993 54.7272 90.7998 54.9692 90.7998 55.2715C90.7998 55.5737 90.8596 55.8159 90.9199 56.1182C90.9804 56.3599 91.1615 56.602 91.2822 56.8438C91.4632 57.0251 91.6444 57.2062 91.8857 57.3271C92.1272 57.4481 92.369 57.5088 92.6709 57.5088C92.9727 57.5088 93.2146 57.4481 93.4561 57.3271C93.6973 57.2062 93.8786 57.0251 94.0596 56.8438C94.2406 56.6624 94.3615 56.4204 94.4219 56.1182C94.4822 55.8764 94.5419 55.5739 94.542 55.332C94.542 55.0298 94.4822 54.7876 94.4219 54.4854L94.0596 53.7598C93.8785 53.5784 93.6974 53.3963 93.4561 53.2754C93.2146 53.1545 92.9727 53.0947 92.6709 53.0947ZM0.964844 57.5068H2.89648C3.01722 57.5068 3.13806 57.5067 3.25879 57.4463C3.3794 57.3859 3.44007 57.326 3.56055 57.2656C3.62092 57.2052 3.68182 57.0838 3.74219 56.9629C3.80246 56.7817 3.80273 56.6608 3.80273 56.54C3.80273 56.4191 3.80253 56.2977 3.74219 56.1768C3.68182 56.0558 3.62092 55.9345 3.56055 55.874C3.50006 55.8134 3.37959 55.6934 3.31934 55.6934C3.19859 55.6329 3.07777 55.6328 2.95703 55.6328H0.964844V57.5068ZM60.251 55.9336H62.2432L61.2178 53.2725L60.251 55.9336ZM108.67 55.9336H110.662L109.696 53.2725L108.67 55.9336ZM54.0322 55.332H55.7227C55.8433 55.332 55.9643 55.3319 56.085 55.2715C56.2055 55.2111 56.2661 55.1502 56.3867 55.0293L56.5674 54.667C56.6278 54.5461 56.6279 54.3641 56.6279 54.2432C56.6279 54.1222 56.6277 53.9412 56.5674 53.8203C56.507 53.6994 56.4469 53.578 56.3262 53.457C56.2658 53.3363 56.145 53.2762 56.0244 53.2158C55.9037 53.1554 55.7828 53.1553 55.6621 53.1553H54.0322V55.332ZM85.4873 55.332H87.0576C87.1781 55.332 87.2985 55.3317 87.4189 55.2715C87.5397 55.211 87.6009 55.1502 87.7217 55.0293L87.9023 54.667C87.9627 54.5461 87.9629 54.3641 87.9629 54.2432C87.9629 54.0619 87.9626 53.941 87.9023 53.7598C87.842 53.5784 87.7819 53.5174 87.6611 53.3965C87.5406 53.2757 87.4798 53.2157 87.3594 53.1553C87.2387 53.0949 87.1177 53.0947 86.9971 53.0947H85.4873V55.332ZM97.6816 55.3291H99.3721C99.4927 55.3291 99.6137 55.3289 99.7344 55.2686C99.8551 55.2081 99.9155 55.1472 100.036 55.0264L100.218 54.6641C100.278 54.5431 100.278 54.3612 100.278 54.2402C100.278 54.1194 100.278 53.9383 100.218 53.8174C100.157 53.6965 100.097 53.575 99.9766 53.4541C99.9162 53.3332 99.7946 53.2724 99.6738 53.2119C99.5533 53.1517 99.4321 53.1523 99.3115 53.1523H97.6816V55.3291ZM0.964844 54.8467H2.71582C2.83651 54.8467 2.95719 54.8465 3.01758 54.7861C3.13826 54.7257 3.19845 54.6649 3.25879 54.6045C3.31912 54.5441 3.3801 54.4236 3.44043 54.3027C3.5008 54.1818 3.50098 54.0604 3.50098 53.9395C3.50097 53.6976 3.43989 53.4558 3.25879 53.2744C3.13803 53.0931 2.89689 53.0322 2.71582 53.0322C2.77583 53.0322 0.964844 53.0322 0.964844 53.0322V54.8467ZM6.83105 0C9.95337 1.48324e-05 12.3602 0.260734 14.1816 0.716797C16.1333 1.17293 17.5651 1.95476 18.8662 3.0625C20.1022 4.23539 21.0778 5.60396 21.8584 7.36328C22.6391 9.12264 22.9648 10.8822 22.9648 12.6416C22.9648 15.8344 21.7279 18.6361 19.2559 20.8516C21.5978 21.6335 23.42 23.0019 24.7861 24.8916C24.7211 24.24 24.7207 23.5231 24.7207 22.7412C24.7207 16.4206 26.8677 11.0774 31.3564 6.64648C35.7151 2.21551 41.1803 0 47.5557 0C50.9383 5.23219e-05 54.1256 0.717241 57.248 2.21582C60.1104 3.58418 62.9084 5.79911 65.6406 8.92676L60.8916 13.4229C57.3136 8.66624 52.9543 6.32031 47.75 6.32031C43.0663 6.32041 39.228 7.8844 36.1055 11.0771C32.9178 14.2049 31.3565 18.0496 31.3564 22.7412C31.3564 27.5632 33.113 31.5383 36.626 34.666C39.8787 37.4679 43.4573 38.9668 47.2305 38.9668C50.4831 38.9667 53.4757 37.8582 56.0127 35.708C58.5495 33.5578 59.9803 30.8214 60.3057 27.8242H49.377V21.373H66.877V0H75.0088C78.977 1.03027e-05 81.9046 0.260945 83.9863 0.782227C85.9379 1.43384 87.7591 2.34635 89.3203 3.91016C91.9875 6.58169 93.354 9.83923 93.2891 13.6836C93.2891 18.0494 91.9226 21.4379 88.9951 23.9141C86.0676 26.3902 82.2293 27.6289 77.2852 27.6289H74.0332V44.9609H66.877V29.1924C66.7468 30.0395 66.5512 30.8216 66.291 31.6035C65.6404 33.9492 64.3391 36.1646 62.5176 38.1846C58.4191 42.8109 53.28 45.0264 46.9697 45.0264C40.8546 45.0264 35.5849 42.8763 31.1611 38.4453C29.4048 36.7513 28.0389 34.8616 26.998 32.8418C26.8678 36.0997 25.5665 38.9018 23.2246 41.1172C21.7935 42.6158 20.0368 43.6577 18.1504 44.2441C16.1338 44.8306 13.5317 45.0918 10.4092 45.0918H0V0H6.83105ZM6.89355 38.7031H11.1221C14.2446 38.7031 16.4569 38.1169 17.9531 36.8789C19.5142 35.5758 20.2945 33.9468 20.2295 31.9922C20.2295 29.9722 19.4488 28.3432 18.0176 27.04C16.5864 25.7369 14.0496 25.0196 10.3418 25.0195H6.89355V38.7031ZM74.1631 21.3721H76.8301C83.3354 21.372 86.6531 18.8308 86.7832 13.8135C86.7831 8.86147 83.3999 6.4502 76.5693 6.4502H74.1631V21.3721ZM6.89355 19.2881H8.97559C11.5776 19.2881 13.3343 18.7669 14.5703 17.6592C15.8061 16.4863 16.3916 14.8571 16.3916 12.707C16.3915 10.5571 15.8061 8.99339 14.5703 7.88574C13.3343 6.77804 11.6427 6.25685 9.30078 6.25684H6.89355V19.2881Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M112.498 31.602C113.211 31.602 113.863 31.7482 114.451 32.0414C115.038 32.3207 115.535 32.7539 115.941 33.3403C116.361 33.9128 116.683 34.6252 116.907 35.477C117.145 36.3289 117.264 37.3213 117.264 38.4526C117.264 39.5836 117.145 40.5819 116.907 41.4477C116.683 42.3136 116.361 43.0398 115.941 43.6264C115.535 44.2129 115.038 44.66 114.451 44.9672C113.863 45.2605 113.211 45.4077 112.498 45.4077C111.784 45.4076 111.133 45.2604 110.545 44.9672C109.958 44.66 109.454 44.213 109.034 43.6264C108.628 43.0398 108.306 42.3136 108.068 41.4477C107.844 40.5819 107.732 39.5836 107.732 38.4526C107.732 37.3213 107.844 36.3289 108.068 35.477C108.306 34.6253 108.628 33.9128 109.034 33.3403C109.454 32.7539 109.958 32.3207 110.545 32.0414C111.133 31.7483 111.784 31.602 112.498 31.602ZM98.0688 31.767C98.7265 31.767 99.3213 31.8717 99.853 32.0815C100.399 32.2774 100.868 32.5649 101.26 32.9428C101.652 33.3066 101.953 33.7474 102.163 34.2651C102.372 34.7828 102.478 35.3636 102.478 36.0073C102.478 36.567 102.358 37.1412 102.121 37.7289C101.883 38.3028 101.561 38.8843 101.155 39.4721C100.763 40.0458 100.308 40.6266 99.7905 41.2143C99.2868 41.788 98.762 42.3548 98.2163 42.9145C98.5521 42.8725 98.9229 42.838 99.3286 42.81C99.7483 42.768 100.119 42.7465 100.441 42.7465H103.128V45.35H93.7437V43.5864C94.5974 42.7886 95.3749 42.0466 96.0747 41.3608C96.7884 40.6611 97.3971 40.0104 97.9009 39.4086C98.4186 38.793 98.8173 38.2262 99.0972 37.7084C99.3911 37.1766 99.5386 36.6726 99.5386 36.1967C99.5386 35.5391 99.3704 35.0424 99.0347 34.7065C98.6988 34.3566 98.2368 34.1811 97.6489 34.1811C97.1591 34.1811 96.725 34.3211 96.3472 34.601C95.9694 34.8668 95.6126 35.1816 95.2769 35.5453L93.5972 33.8871C94.255 33.1874 94.927 32.6628 95.6128 32.3129C96.2986 31.9491 97.1172 31.767 98.0688 31.767ZM106.062 42.7524C106.409 42.7525 106.706 42.8756 106.952 43.1215C107.212 43.3539 107.342 43.6684 107.342 44.0649C107.342 44.4339 107.212 44.7417 106.952 44.9877C106.706 45.2199 106.409 45.3363 106.062 45.3364C105.7 45.3364 105.389 45.2199 105.128 44.9877C104.882 44.7417 104.759 44.4339 104.759 44.0649C104.759 43.6684 104.882 43.3539 105.128 43.1215C105.389 42.8755 105.7 42.7524 106.062 42.7524ZM112.498 33.9897C112.246 33.9897 112.008 34.0525 111.784 34.1782C111.56 34.3038 111.364 34.5345 111.196 34.8696C111.028 35.1908 110.895 35.6453 110.797 36.2319C110.699 36.8044 110.65 37.5449 110.65 38.4526C110.65 39.3602 110.699 40.1073 110.797 40.6938C110.895 41.2802 111.028 41.748 111.196 42.0971C111.364 42.4462 111.56 42.6908 111.784 42.8305C112.008 42.9562 112.246 43.019 112.498 43.019C112.764 43.019 113.009 42.9562 113.233 42.8305C113.457 42.6908 113.653 42.4461 113.821 42.0971C113.989 41.748 114.115 41.2802 114.199 40.6938C114.297 40.1073 114.345 39.3602 114.345 38.4526C114.345 37.545 114.297 36.8044 114.199 36.2319C114.115 35.6453 113.989 35.1908 113.821 34.8696C113.653 34.5345 113.457 34.3039 113.233 34.1782C113.009 34.0525 112.764 33.9897 112.498 33.9897Z",
    fill: "white"
  }
)), $7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 112, height: 48, viewBox: "0 0 112 48", fill: "none", ...e }, /* @__PURE__ */ t.createElement("g", { clipPath: "url(#clip0_328_8232)" }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M13.1617 42.7521C12.8291 42.7521 12.5238 42.6849 12.2459 42.5367C11.5979 42.1906 11.4957 41.452 11.4813 40.7742C11.4633 39.9395 11.5993 38.7652 11.7865 37.14C11.8153 36.8914 11.8456 36.6312 11.8758 36.3609C11.8996 36.1528 11.9241 35.9418 11.9485 35.7279C12.3654 32.1081 12.8838 27.6038 12.0961 24.4921C11.3725 21.6325 8.92597 17.5365 7.46437 15.0889C7.23037 14.6972 7.02877 14.359 6.85669 14.0649C5.88253 12.397 5.58013 11.3766 5.84581 10.6518C5.99557 10.2435 6.32965 9.94651 6.83869 9.76874C8.94325 9.03452 17.1498 10.1402 24.1828 12.6138C25.2815 13.0004 26.3903 13.4622 27.3681 13.8698C27.8195 14.0577 28.2465 14.2355 28.6432 14.3944C32.1769 15.8072 34.7142 17.0668 36.4005 18.2447C37.8505 19.2572 38.6598 20.1937 38.9485 21.191C39.2805 22.3386 39.0652 23.3987 38.2278 24.7371C37.4502 25.9793 36.1161 27.5055 33.6213 30.0059C31.7118 31.9195 28.6792 34.2045 24.609 36.796C21.3186 38.8917 18.3393 40.5538 17.211 41.1716C15.5565 42.0771 14.2173 42.7542 13.161 42.7542L13.1617 42.7521ZM8.80501 10.1467C8.00437 10.1467 7.39597 10.2103 7.03597 10.336C6.69973 10.4531 6.49453 10.6244 6.40813 10.8592C6.21589 11.3824 6.52261 12.3045 7.37365 13.7599C7.54429 14.0519 7.74517 14.3887 7.97845 14.7789C9.45733 17.2547 11.9313 21.3984 12.6772 24.3432C13.4922 27.5626 12.9666 32.1276 12.5447 35.7965C12.5202 36.0104 12.4957 36.2215 12.472 36.4296C12.441 36.7006 12.4108 36.9607 12.382 37.21C12.04 40.1693 11.8686 41.6544 12.5274 42.0063C13.3432 42.4421 14.6485 41.8885 16.9252 40.6419C18.8512 39.5876 28.6885 34.0983 33.1986 29.5788C37.7958 24.9712 38.9089 23.2043 38.3747 21.3572C37.6633 18.898 32.3541 16.5241 28.4229 14.9523C28.0218 14.7919 27.5934 14.6134 27.1398 14.4248C26.1693 14.0201 25.0684 13.5619 23.9862 13.1811C18.1945 11.1439 11.9838 10.1474 8.80573 10.1474L8.80501 10.1467Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12.5475 40.2727C11.7893 40.2727 11.25 40.1253 10.916 39.8304C9.5998 38.6677 9.56812 37.2404 9.8122 33.7543C10.0916 29.7639 10.2348 26.7294 9.53284 24.005C8.90428 21.5654 8.03668 20.0651 7.11796 18.476C6.86524 18.0381 6.60316 17.5857 6.34252 17.1066C5.56636 15.6801 5.53828 14.3663 6.26116 13.2021C6.71476 12.4708 7.447 11.8262 8.49964 11.2321C11.785 9.37781 15.9466 9.00058 20.87 10.1099C22.8226 10.5499 25.29 11.5248 26.6199 12.2186C30.0888 14.0274 32.7053 15.7942 34.3966 17.4694C36.0303 19.0881 36.859 20.6794 36.859 22.1984C36.859 26.4621 33.5348 30.1888 32.516 31.2287C31.0832 32.6928 26.0511 36.22 21.1256 38.0382C18.4536 39.0247 16.2706 39.6917 14.6355 40.0219C13.8118 40.1881 13.1177 40.2712 12.5475 40.2712V40.2727ZM15.678 10.0903C13.0637 10.0903 10.7597 10.6468 8.79268 11.7568C7.83004 12.3002 7.16836 12.8769 6.76876 13.5201C6.169 14.4862 6.20284 15.5962 6.8674 16.8182C7.12444 17.2909 7.38436 17.7396 7.63564 18.1747C8.57524 19.7999 9.463 21.3356 10.1124 23.8547C10.8375 26.6673 10.6928 29.7494 10.4098 33.797C10.1765 37.1356 10.1945 38.3916 11.312 39.3795C11.6064 39.6396 12.402 39.8608 14.5167 39.4337C16.1216 39.1099 18.2751 38.4509 20.9182 37.4753C25.7595 35.6882 30.6893 32.2382 32.0883 30.8088C35.9583 26.8559 36.2592 23.2195 36.2592 22.1998C36.2592 19.3627 32.9228 16.1845 26.3427 12.7533C25.2317 12.1745 22.7585 11.1534 20.7375 10.6981C18.9425 10.2934 17.2534 10.0911 15.6773 10.0911L15.678 10.0903Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M12.7979 37.8315C11.4126 37.8315 9.73067 37.5728 8.58155 36.5293C7.80251 35.8211 7.37771 34.8455 7.31939 33.6293C7.24595 32.0929 7.31507 31.0487 7.38203 30.0392C7.46123 28.8453 7.53611 27.718 7.34171 25.9193C7.09979 23.6755 6.47987 22.2504 5.82395 20.7408C5.63027 20.2949 5.42939 19.8339 5.23499 19.3425C4.79147 18.2238 5.07659 17.0386 6.08243 15.8202C6.84635 14.8952 8.02715 13.9262 9.79835 12.7699C10.2361 12.4845 10.6955 12.1557 11.1822 11.8073C13.461 10.1778 16.2978 8.14927 19.7415 8.58503C21.4285 8.79822 23.091 9.2795 24.3035 9.90388C26.5304 11.0515 28.9489 12.8877 30.7719 14.815C32.3891 16.5241 34.3719 19.1791 34.6376 22.1232C35.0646 26.8443 32.3603 31.7396 30.9836 33.3706C29.7387 34.8455 28.4456 35.5841 26.2129 36.095C21.2543 37.2303 17.5038 37.6039 13.3991 37.8156C13.2068 37.8258 13.0052 37.8315 12.7971 37.8315H12.7979ZM18.8034 9.12702C15.9637 9.12702 13.5258 10.8708 11.5307 12.2973C11.0389 12.6492 10.5738 12.9817 10.1252 13.2743C8.40587 14.3959 7.26827 15.3274 6.54395 16.204C5.67635 17.2547 5.43011 18.2086 5.79155 19.1206C5.98235 19.6026 6.18107 20.0593 6.37331 20.5009C7.04795 22.0538 7.68515 23.5201 7.93715 25.855C8.13659 27.705 8.06027 28.8584 7.97963 30.0789C7.91411 31.0718 7.84571 32.0987 7.91771 33.6004C7.96811 34.6511 8.32667 35.4865 8.98331 36.0834C9.62843 36.6695 10.9129 37.3423 13.3688 37.2151C17.4426 37.0048 21.1635 36.6341 26.0804 35.5089C28.1987 35.024 29.3622 34.3628 30.5279 32.9818C31.1888 32.1985 32.1759 30.6375 32.9629 28.6061C33.5771 27.0214 34.2632 24.6193 34.0422 22.1767C33.7916 19.4053 31.8901 16.8688 30.3385 15.2284C28.5594 13.3473 26.2014 11.5566 24.0306 10.4379C23.4855 10.1568 21.9685 9.47173 19.6674 9.1805C19.3751 9.14365 19.0871 9.1263 18.8027 9.1263L18.8034 9.12702Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M26.3398 38.0736C25.8135 38.0736 25.334 37.9825 24.9963 37.9182C24.9106 37.9023 24.8343 37.8872 24.7673 37.8763C23.8702 37.7289 22.886 37.4911 21.7462 37.2158C20.0751 36.8119 17.995 36.3096 15.241 35.8623C14.611 35.7604 13.9299 35.6766 13.2085 35.5877C9.97422 35.1895 6.30798 34.7386 5.42166 32.3328C4.9335 31.0075 4.85646 29.6496 4.73982 27.5944C4.71678 27.1876 4.69302 26.767 4.6635 26.3052C4.60014 25.3007 4.41726 24.4342 4.25526 23.6704C3.76494 21.3514 3.4107 19.6756 7.04382 17.3385C10.615 15.0419 13.3409 12.8631 15.3785 10.6793C16.7444 9.21517 19.4149 6.88172 21.9536 7.70627C23.876 8.33137 26.2354 10.2724 28.2658 12.9C30.4813 15.7675 31.9054 18.9002 32.2755 21.7214C32.7161 25.0803 32.4512 28.3619 31.4871 31.4743C30.572 34.4278 29.3213 36.2684 28.826 36.9224C28.1261 37.8467 27.1736 38.0743 26.3398 38.0743V38.0736ZM20.8585 8.13625C20.0693 8.13625 19.2003 8.42965 18.265 9.01283C17.4637 9.5129 16.6162 10.2312 15.8156 11.089C13.7441 13.3097 10.9801 15.5189 7.3671 17.8437C5.8047 18.8481 4.97742 19.7168 4.68294 20.6591C4.41366 21.522 4.6023 22.4144 4.84134 23.5447C5.00694 24.3295 5.19558 25.2183 5.2611 26.2669C5.29062 26.7308 5.31438 27.1521 5.33742 27.5604C5.4555 29.633 5.52606 30.8839 5.98326 32.1247C6.74286 34.1865 10.2161 34.6143 13.2812 34.9915C14.0084 35.0811 14.696 35.1656 15.3368 35.2697C18.1131 35.7199 20.2054 36.2258 21.8866 36.6319C23.0149 36.9044 23.989 37.1399 24.8645 37.2837C24.9351 37.2953 25.0172 37.3112 25.1079 37.3278C25.9201 37.4825 27.4321 37.7694 28.3493 36.5582C28.8253 35.9295 30.0284 34.1575 30.9154 31.2951C31.8536 28.2665 32.1113 25.0716 31.6822 21.7995C31.3309 19.122 29.9132 16.0124 27.7928 13.2685C25.8625 10.7703 23.5549 8.85818 21.7693 8.27789C21.4791 8.18322 21.1753 8.13625 20.8585 8.13625Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M25.4837 40.548C24.7543 40.548 24.0574 40.225 23.5843 40.0061C23.5001 39.967 23.4209 39.9302 23.3489 39.8984C22.3524 39.4626 20.4142 38.2796 17.8913 36.5691C15.1985 34.7437 12.0535 33.5896 7.14456 31.8589C4.88448 31.0618 3.70944 30.4591 3.08808 29.7783C2.44152 29.0694 2.42064 28.3041 2.39544 27.3351C2.38392 26.9007 2.37096 26.4086 2.30256 25.837C2.0628 23.8193 2.04336 22.5128 4.55544 21.1347C5.09976 20.8362 7.28784 19.5044 10.8814 17.2837C13.4122 15.7198 15.5743 13.4312 16.7544 11.8103C17.4326 10.8788 18.0518 9.87503 18.5983 8.98978C19.4976 7.53219 20.0282 6.6968 20.4854 6.46772C21.3466 6.03557 22.0068 6.55949 23.323 7.60228L23.3366 7.61312C24.6521 8.65591 27.3643 13.0164 28.4285 15.7993C28.471 15.9114 28.5149 16.0241 28.5588 16.139C29.4854 18.5454 30.6389 21.5408 30.3674 27.5186C30.1248 32.8605 28.1722 38.5008 27.2318 39.6686C26.6976 40.332 26.0798 40.5473 25.4844 40.5473L25.4837 40.548ZM21.0823 6.92154C20.97 6.92154 20.8634 6.95045 20.7518 7.00682C20.425 7.17086 19.7546 8.25701 19.1066 9.30774C18.5544 10.2024 17.9287 11.217 17.2368 12.1666C16.0236 13.833 13.7988 16.1874 11.1938 17.7968C7.53984 20.055 5.40288 21.3558 4.84128 21.6637C2.65392 22.8633 2.66688 23.8417 2.89584 25.7669C2.96712 26.366 2.9808 26.8726 2.99232 27.3199C3.01752 28.2615 3.03264 28.8302 3.528 29.3729C4.07016 29.967 5.21064 30.5415 7.34112 31.2923C12.2954 33.0397 15.4714 34.2053 18.2246 36.0719C21.5892 38.3533 23.0285 39.1035 23.5865 39.3484C23.6621 39.3817 23.7449 39.42 23.8334 39.4612C24.9062 39.9576 25.9373 40.3182 26.7638 39.2921C27.5623 38.3006 29.525 32.8142 29.767 27.4933C30.0326 21.642 28.9044 18.7124 27.9979 16.358C27.9533 16.243 27.9101 16.1289 27.8669 16.0169C26.851 13.3604 24.1927 9.06204 22.963 8.08718L22.9493 8.07634C21.9377 7.27492 21.4718 6.92299 21.0809 6.92299L21.0823 6.92154Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M23.9048 42.9998C23.3979 42.9998 22.8716 42.7396 22.3049 42.2099C21.8376 41.7735 21.2386 41.0812 20.4812 40.2053C18.6214 38.0561 16.074 35.112 13.04 33.1045C8.45355 30.0694 3.77787 27.6593 1.66971 27.2452C0.259231 26.9677 0.0187511 26.2689 0.00147107 25.8773C-0.0294889 25.1958 0.594031 24.4507 1.39179 24.2173C4.51659 23.3017 10.7309 20.2695 13.7614 17.8775C16.2029 15.9502 18.0267 13.8256 18.8972 11.8954C19.7187 10.0721 20.1917 8.01182 20.1939 6.24132C20.1939 5.71595 20.25 5.16095 20.6583 5.02581C21.1263 4.87189 21.6288 5.40954 22.4504 6.52604C23.4382 7.86873 25.3448 11.5839 26.2073 14.7889C27.0699 17.9938 27.9324 21.4705 28.1859 25.6243C28.394 29.041 28.2658 32.0892 27.8036 34.6842C27.4947 36.42 26.7207 39.8122 25.7818 41.514C25.2908 42.4036 24.7536 42.8835 24.1395 42.9817C24.0617 42.994 23.984 43.0005 23.9062 43.0005L23.9048 42.9998ZM20.8599 5.62128C20.8332 5.69355 20.7929 5.86481 20.7922 6.24204C20.79 8.09492 20.2976 10.2455 19.4422 12.1432C18.5328 14.1602 16.6464 16.3642 14.1308 18.3501C10.9988 20.8223 4.80099 23.8444 1.55883 24.794C1.02891 24.9494 0.581071 25.4422 0.599071 25.8498C0.615631 26.222 1.03683 26.5074 1.78347 26.6548C3.20331 26.9338 5.32155 27.9397 6.84939 28.7346C8.88267 29.7926 11.1982 31.1663 13.3683 32.6023C16.4708 34.6553 19.0491 37.6355 20.9319 39.8107C21.649 40.6389 22.2675 41.3543 22.7117 41.7691C23.215 42.2396 23.6636 42.4477 24.043 42.387C24.4577 42.3212 24.8652 41.9288 25.2555 41.2221C26.0403 39.8006 26.8193 36.7814 27.2117 34.578C27.6653 32.0299 27.7913 29.0302 27.5854 25.6605C27.3356 21.563 26.4809 18.1196 25.6263 14.945C24.7832 11.8108 22.927 8.18814 21.9658 6.88303C21.2854 5.95876 20.9873 5.68921 20.8577 5.62128H20.8599Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M50.0889 22.7005C50.4655 22.7005 50.7938 22.6666 51.0739 22.5979C51.3532 22.5292 51.6196 22.4346 51.8723 22.3139V20.6735H50.7477C50.6397 20.6735 50.5547 20.6431 50.4928 20.5831C50.4309 20.5232 50.3999 20.4495 50.3999 20.362V19.4146H53.3879V23.0626C53.1604 23.2288 52.9228 23.3733 52.6766 23.4962C52.4303 23.619 52.1668 23.7195 51.8875 23.799C51.6081 23.8784 51.3086 23.937 50.9896 23.9767C50.6707 24.0165 50.3272 24.036 49.9586 24.036C49.3041 24.036 48.7015 23.9218 48.1507 23.6927C47.5999 23.4644 47.1232 23.1464 46.7215 22.7388C46.3197 22.3312 46.0058 21.8449 45.7804 21.2798C45.5543 20.7147 45.442 20.0975 45.442 19.4276C45.442 18.7577 45.5515 18.1283 45.7711 17.5632C45.9907 16.9981 46.3024 16.5117 46.7063 16.1041C47.1103 15.6966 47.5999 15.3808 48.1759 15.156C48.7511 14.932 49.3977 14.8193 50.1141 14.8193C50.8305 14.8193 51.4821 14.9284 52.0185 15.1466C52.5549 15.3649 53.0092 15.6489 53.3822 15.9979L52.8976 16.7589C52.8026 16.9128 52.6759 16.9894 52.5189 16.9894C52.4195 16.9894 52.318 16.9561 52.2143 16.8897C52.0819 16.8102 51.9458 16.7314 51.8075 16.6526C51.6686 16.5731 51.5152 16.5052 51.3482 16.4467C51.1804 16.3889 50.9918 16.3412 50.783 16.3036C50.5735 16.266 50.3323 16.2472 50.0594 16.2472C49.6159 16.2472 49.2155 16.3224 48.857 16.472C48.4984 16.6216 48.1931 16.8355 47.9404 17.1144C47.6877 17.3934 47.4933 17.7272 47.3565 18.1182C47.2197 18.5091 47.1513 18.9456 47.1513 19.4276C47.1513 19.9472 47.2233 20.4097 47.3687 20.8151C47.5135 21.2205 47.7165 21.5623 47.9779 21.8406C48.2385 22.1195 48.5495 22.3327 48.9095 22.4801C49.2695 22.6275 49.6634 22.7012 50.0903 22.7012L50.0889 22.7005Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M64.1865 19.4264C64.1865 20.0876 64.0771 20.6997 63.8575 21.2627C63.6379 21.8263 63.329 22.3134 62.9316 22.7253C62.5341 23.1365 62.0561 23.4574 61.4966 23.6886C60.9372 23.9192 60.318 24.0348 59.639 24.0348C58.9601 24.0348 58.3394 23.9192 57.7778 23.6886C57.2162 23.4574 56.736 23.1365 56.3364 22.7253C55.9368 22.3134 55.6272 21.8263 55.4076 21.2627C55.188 20.6997 55.0778 20.0869 55.0778 19.4264C55.0778 18.7659 55.1873 18.1538 55.4076 17.5902C55.6272 17.0265 55.9368 16.5394 56.3364 16.1282C56.736 15.7163 57.2162 15.3955 57.7778 15.1649C58.3394 14.9344 58.9593 14.8188 59.639 14.8188C60.3187 14.8188 60.9372 14.9351 61.4966 15.1685C62.0561 15.4012 62.5341 15.7221 62.9316 16.1318C63.329 16.5416 63.6379 17.0279 63.8575 17.5909C64.0771 18.1545 64.1865 18.7666 64.1865 19.4271V19.4264ZM62.4715 19.4264C62.4715 18.9321 62.406 18.4877 62.2757 18.0953C62.1453 17.7022 61.9574 17.369 61.7133 17.0944C61.4685 16.8198 61.1719 16.6102 60.822 16.4643C60.4721 16.319 60.0775 16.246 59.6383 16.246C59.1991 16.246 58.8038 16.319 58.4517 16.4643C58.0997 16.6102 57.8001 16.8198 57.5539 17.0944C57.3077 17.369 57.1176 17.7022 56.9851 18.0953C56.8526 18.4884 56.7864 18.9321 56.7864 19.4264C56.7864 19.9207 56.8526 20.3651 56.9851 20.7575C57.1176 21.1507 57.3069 21.4831 57.5539 21.7555C57.8001 22.028 58.0997 22.2368 58.4517 22.3821C58.8038 22.528 59.1991 22.6003 59.6383 22.6003C60.0775 22.6003 60.4713 22.528 60.822 22.3821C61.1719 22.2361 61.4693 22.028 61.7133 21.7555C61.9574 21.4838 62.1453 21.1507 62.2757 20.7575C62.406 20.3644 62.4715 19.9214 62.4715 19.4264Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M64.8943 14.9183H66.2429C66.3876 14.9183 66.5057 14.9537 66.5972 15.0245C66.6879 15.0953 66.757 15.1864 66.8023 15.2991L68.9148 20.7992C68.9854 20.9785 69.0524 21.1743 69.1164 21.3882C69.1805 21.6021 69.2417 21.8283 69.3 22.0646C69.3951 21.5869 69.5131 21.1649 69.6543 20.7985L71.7603 15.2984C71.7977 15.2023 71.8639 15.1148 71.959 15.0361C72.054 14.9573 72.1721 14.9176 72.3132 14.9176H73.6611L70.033 23.9348H68.5232L64.8943 14.9176V14.9183Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M82.049 14.9184V16.2965H79.3461V23.9357H77.675V16.2965H74.9598V14.9184H82.049Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M89.3988 14.9184V16.2532H85.4164V18.7535H88.5542V20.0442H85.4164V22.5952H89.3988V23.9357H83.7324V14.9184H89.3988Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M97.6434 21.8088C97.7341 21.8088 97.8133 21.8442 97.8796 21.9151L98.5377 22.6319C98.1733 23.085 97.7248 23.4319 97.1927 23.6733C96.6606 23.9146 96.0213 24.0353 95.2761 24.0353C94.6093 24.0353 94.0096 23.9212 93.4775 23.6921C92.9454 23.4637 92.4904 23.1457 92.1138 22.7382C91.7365 22.3306 91.4478 21.8442 91.2469 21.2791C91.0461 20.714 90.946 20.0969 90.946 19.427C90.946 18.7571 91.0576 18.1291 91.2815 17.5661C91.5054 17.0025 91.8201 16.5176 92.2261 16.11C92.6322 15.7024 93.1182 15.3859 93.6834 15.159C94.2486 14.9328 94.8729 14.8193 95.5561 14.8193C96.2394 14.8193 96.8061 14.9263 97.305 15.1402C97.804 15.3541 98.2317 15.6381 98.5881 15.9915L98.0286 16.7705C97.9955 16.8204 97.953 16.8644 97.9012 16.9013C97.8493 16.9389 97.7781 16.9577 97.6866 16.9577C97.5952 16.9577 97.4937 16.9201 97.3943 16.8457C97.2949 16.7705 97.1682 16.6896 97.0156 16.6021C96.8622 16.5147 96.6685 16.4337 96.4345 16.3586C96.2005 16.2842 95.9032 16.2466 95.5425 16.2466C95.1198 16.2466 94.7317 16.321 94.3775 16.4677C94.0233 16.6151 93.7187 16.8269 93.4645 17.1008C93.2097 17.3754 93.0109 17.7085 92.8684 18.1016C92.7258 18.4948 92.6538 18.9363 92.6538 19.427C92.6538 19.9177 92.7251 20.3852 92.8684 20.7798C93.0109 21.1751 93.2046 21.5075 93.4494 21.7778C93.6942 22.048 93.9815 22.2547 94.3134 22.3985C94.6446 22.5416 95.001 22.6132 95.3819 22.6132C95.6094 22.6132 95.8161 22.6009 96.0004 22.5756C96.1847 22.551 96.3546 22.5113 96.5101 22.4571C96.6657 22.4029 96.8125 22.3335 96.9515 22.2482C97.0905 22.1629 97.228 22.0582 97.3648 21.9331C97.4065 21.8956 97.4497 21.8659 97.4951 21.8428C97.5405 21.8197 97.5901 21.8088 97.6441 21.8088H97.6434Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M108 23.9348H106.317V19.9935H102.105V23.9348H100.421V14.9176H102.105V18.796H106.317V14.9176H108V23.9348Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M49.5388 29.4119C49.5122 29.4661 49.4805 29.5044 49.4452 29.5268C49.4092 29.5492 49.3674 29.5601 49.3178 29.5601C49.2681 29.5601 49.2134 29.5413 49.1522 29.503C49.091 29.4647 49.0182 29.422 48.9347 29.3758C48.8512 29.3288 48.7533 29.2862 48.6417 29.2479C48.5301 29.2096 48.3976 29.1908 48.2457 29.1908C48.1082 29.1908 47.9886 29.2074 47.8864 29.2406C47.7842 29.2739 47.6985 29.3201 47.6286 29.3794C47.5588 29.4386 47.5062 29.5095 47.4724 29.5918C47.4378 29.6742 47.4206 29.7646 47.4206 29.8636C47.4206 29.9893 47.4558 30.0934 47.5257 30.1772C47.5955 30.261 47.6884 30.3326 47.8036 30.3918C47.9188 30.4511 48.0498 30.5038 48.1974 30.5508C48.345 30.5978 48.4955 30.6476 48.6489 30.7004C48.8022 30.7532 48.9527 30.8153 49.1003 30.8854C49.2479 30.9555 49.379 31.0444 49.4942 31.1513C49.6094 31.2583 49.7022 31.3898 49.7721 31.5452C49.8419 31.7006 49.8772 31.8892 49.8772 32.111C49.8772 32.3524 49.8362 32.5786 49.7541 32.7889C49.672 32.9999 49.5518 33.1834 49.3934 33.3395C49.235 33.4956 49.0413 33.6192 48.813 33.7088C48.5848 33.7991 48.3234 33.8439 48.029 33.8439C47.8598 33.8439 47.6927 33.8273 47.5278 33.7941C47.363 33.7608 47.2053 33.7131 47.0548 33.6517C46.9036 33.5903 46.7625 33.5166 46.6314 33.4299C46.5004 33.3439 46.3831 33.2478 46.2801 33.1415L46.5674 32.6646C46.594 32.6299 46.6271 32.601 46.6646 32.5779C46.7027 32.5547 46.7452 32.5424 46.792 32.5424C46.8532 32.5424 46.9194 32.5677 46.9907 32.6183C47.062 32.6689 47.1462 32.7246 47.2427 32.7867C47.3399 32.8481 47.4537 32.9045 47.5854 32.9544C47.7165 33.0049 47.8749 33.0302 48.0585 33.0302C48.3407 33.0302 48.5596 32.963 48.7137 32.8286C48.8685 32.6942 48.9455 32.5012 48.9455 32.2498C48.9455 32.1096 48.9102 31.9947 48.8404 31.9058C48.7706 31.8176 48.6777 31.7425 48.5625 31.6825C48.4473 31.6225 48.3155 31.5712 48.1686 31.5293C48.0218 31.4874 47.8713 31.4418 47.7194 31.3927C47.5667 31.3436 47.4177 31.2843 47.2701 31.2149C47.1225 31.1456 46.9914 31.0559 46.8762 30.9454C46.761 30.8341 46.6682 30.6953 46.5983 30.5291C46.5285 30.3629 46.4932 30.1577 46.4932 29.9142C46.4932 29.7198 46.5321 29.5297 46.6091 29.3447C46.6869 29.1597 46.7992 28.9957 46.9482 28.8526C47.0966 28.7095 47.2787 28.5953 47.4947 28.5093C47.7107 28.4233 47.9577 28.38 48.2349 28.38C48.5488 28.38 48.839 28.4291 49.1039 28.5274C49.3689 28.6257 49.595 28.7637 49.7814 28.9415L49.5381 29.4112L49.5388 29.4119Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement("path", { d: "M54.7027 33.7847H53.7084V28.44H54.7027V33.7847Z", fill: e.color }), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M59.3561 28.4458C59.3856 28.4494 59.4115 28.4566 59.4353 28.4682C59.4583 28.479 59.4814 28.4949 59.503 28.5166C59.5253 28.5375 59.5498 28.565 59.5764 28.5997L62.3722 32.1739C62.3621 32.0879 62.3556 32.0034 62.352 31.921C62.3484 31.8386 62.3462 31.7613 62.3462 31.6897V28.4407H63.2189V33.7854H62.707C62.6285 33.7854 62.5637 33.7732 62.5118 33.7486C62.4607 33.724 62.4096 33.6799 62.3606 33.6156L59.5764 30.0558C59.5836 30.1346 59.5894 30.2134 59.593 30.2907C59.5966 30.3687 59.5987 30.4388 59.5987 30.5031V33.7854H58.7261V28.4407H59.2452C59.2891 28.4407 59.3266 28.4421 59.3561 28.4465V28.4458Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M69.3807 33.0533C69.6046 33.0533 69.799 33.0331 69.9646 32.9919C70.1302 32.9514 70.2879 32.895 70.4376 32.8235V31.8515H69.7709C69.7068 31.8515 69.6564 31.8335 69.6197 31.7981C69.583 31.7626 69.5643 31.7186 69.5643 31.6665V31.105H71.3355V33.2672C71.2008 33.3662 71.0597 33.4515 70.9136 33.5245C70.7674 33.5975 70.6119 33.6574 70.4463 33.7037C70.2807 33.7507 70.1028 33.7853 69.9142 33.8092C69.7248 33.833 69.5211 33.8446 69.3029 33.8446C68.9148 33.8446 68.5577 33.7767 68.2308 33.6415C67.9047 33.5057 67.6224 33.3171 67.3841 33.0757C67.1458 32.8343 66.96 32.546 66.8261 32.2107C66.6922 31.8754 66.6252 31.5097 66.6252 31.113C66.6252 30.7162 66.69 30.3434 66.8204 30.0073C66.95 29.672 67.135 29.3844 67.374 29.1423C67.6138 28.9009 67.904 28.7138 68.2452 28.5808C68.5865 28.4471 68.9696 28.3813 69.3944 28.3813C69.8192 28.3813 70.2051 28.4464 70.5233 28.5757C70.8416 28.7051 71.1108 28.8728 71.3319 29.0802L71.0446 29.5311C70.9884 29.6221 70.9136 29.6677 70.82 29.6677C70.7609 29.6677 70.7012 29.6482 70.64 29.6084C70.5615 29.5614 70.4808 29.5152 70.3988 29.4682C70.3167 29.4212 70.226 29.3808 70.1259 29.3461C70.0265 29.3114 69.9142 29.2832 69.7904 29.2608C69.6665 29.2384 69.5232 29.2276 69.3612 29.2276C69.0984 29.2276 68.8608 29.2717 68.6484 29.3605C68.436 29.4494 68.2546 29.5759 68.1048 29.7414C67.9551 29.9069 67.8399 30.1049 67.7585 30.3361C67.6779 30.5681 67.6368 30.8268 67.6368 31.1123C67.6368 31.4201 67.6793 31.6947 67.7657 31.9346C67.8514 32.1746 67.9716 32.3776 68.1264 32.5424C68.2812 32.7079 68.4648 32.8336 68.6787 32.9218C68.8925 33.0092 69.1258 33.0533 69.3785 33.0533H69.3807Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M79.395 33.7847H78.6289C78.5432 33.7847 78.4719 33.7631 78.4172 33.7197C78.3618 33.6763 78.3222 33.6229 78.2977 33.5593L77.9003 32.4688H75.6942L75.2967 33.5593C75.2773 33.6164 75.2384 33.6677 75.1808 33.7146C75.1232 33.7616 75.0527 33.7847 74.9691 33.7847H74.1995L76.2918 28.44H77.3041L79.3964 33.7847H79.395ZM75.9476 31.7664H77.6454L76.9974 29.9886C76.9679 29.9099 76.9355 29.8166 76.8995 29.7097C76.8635 29.6027 76.8289 29.4864 76.7943 29.3599C76.7598 29.4857 76.7259 29.6027 76.6928 29.7111C76.6597 29.8195 76.6273 29.9142 76.5956 29.9959L75.9476 31.7664Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M83.545 31.9037V33.7847H82.5543V28.44H84.2887C84.6444 28.44 84.9526 28.4819 85.2132 28.5657C85.4739 28.6496 85.6884 28.7666 85.8576 28.9169C86.0275 29.0673 86.1521 29.2472 86.2335 29.4568C86.3148 29.6663 86.3551 29.8954 86.3551 30.144C86.3551 30.3926 86.3119 30.6397 86.2263 30.8558C86.1399 31.0712 86.011 31.2569 85.8396 31.4123C85.6675 31.5676 85.453 31.6883 85.1952 31.7743C84.9375 31.8603 84.6358 31.9037 84.2895 31.9037H83.545ZM83.545 31.1275H84.2895C84.4709 31.1275 84.6293 31.1044 84.7647 31.0589C84.9 31.0134 85.0116 30.9483 85.1002 30.863C85.1887 30.7778 85.255 30.6744 85.2989 30.5523C85.3428 30.4302 85.3651 30.2943 85.3651 30.144C85.3651 29.9937 85.3428 29.8716 85.2989 29.7559C85.255 29.6403 85.1887 29.5413 85.1002 29.4604C85.0116 29.3794 84.9 29.3173 84.7647 29.2739C84.63 29.2306 84.4716 29.2089 84.2895 29.2089H83.545V31.1275Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M94.5633 31.1123C94.5633 31.5039 94.4978 31.8667 94.3682 32.2006C94.2378 32.5344 94.055 32.8235 93.8195 33.067C93.5834 33.3113 93.3004 33.5013 92.9685 33.6379C92.6373 33.7745 92.2701 33.8432 91.8676 33.8432C91.4651 33.8432 91.0972 33.7752 90.7646 33.6379C90.4319 33.5013 90.1468 33.3113 89.9099 33.067C89.673 32.8228 89.4894 32.5344 89.3591 32.2006C89.2288 31.8667 89.164 31.5039 89.164 31.1123C89.164 30.7206 89.2288 30.3578 89.3591 30.0239C89.4894 29.6901 89.673 29.401 89.9099 29.1575C90.1468 28.9132 90.4319 28.7232 90.7646 28.5866C91.0972 28.45 91.4651 28.3813 91.8676 28.3813C92.2701 28.3813 92.6373 28.45 92.9685 28.588C93.2997 28.7261 93.5834 28.9161 93.8195 29.1589C94.055 29.4017 94.2378 29.6901 94.3682 30.0239C94.4978 30.3578 94.5633 30.7206 94.5633 31.1123ZM93.5466 31.1123C93.5466 30.8189 93.5078 30.5558 93.4307 30.3231C93.3537 30.0904 93.2421 29.8924 93.0974 29.7298C92.9526 29.5672 92.7762 29.4429 92.5689 29.3569C92.3615 29.2709 92.1275 29.2276 91.8676 29.2276C91.6077 29.2276 91.373 29.2709 91.1642 29.3569C90.9554 29.4429 90.7782 29.5672 90.6321 29.7298C90.4859 29.8931 90.3736 30.0904 90.2951 30.3231C90.2166 30.5558 90.177 30.8196 90.177 31.1123C90.177 31.4049 90.2159 31.6687 90.2951 31.9014C90.3736 32.1348 90.4859 32.3314 90.6321 32.4932C90.7782 32.6544 90.9554 32.7787 91.1642 32.8647C91.373 32.9507 91.607 32.994 91.8676 32.994C92.1282 32.994 92.3615 32.9507 92.5689 32.8647C92.7762 32.7787 92.9526 32.6544 93.0974 32.4932C93.2421 32.3321 93.3537 32.1348 93.4307 31.9014C93.5085 31.6687 93.5466 31.4057 93.5466 31.1123Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M98.6349 31.6962V33.7847H97.6442V28.44H99.2685C99.6321 28.44 99.9432 28.4775 100.202 28.5527C100.462 28.6278 100.674 28.7334 100.84 28.8685C101.005 29.0036 101.127 29.1655 101.205 29.3541C101.282 29.5427 101.321 29.7501 101.321 29.977C101.321 30.157 101.295 30.3268 101.241 30.4872C101.189 30.6477 101.112 30.7929 101.013 30.9237C100.914 31.0545 100.791 31.1687 100.645 31.2677C100.499 31.3667 100.333 31.4455 100.146 31.5047C100.272 31.5763 100.38 31.6782 100.47 31.8119L101.804 33.7854H100.912C100.827 33.7854 100.753 33.7681 100.693 33.7341C100.633 33.6994 100.583 33.6503 100.541 33.586L99.4212 31.8747C99.3794 31.8104 99.3333 31.7649 99.2829 31.7381C99.2325 31.7114 99.1584 31.6977 99.0605 31.6977H98.6371L98.6349 31.6962ZM98.6349 30.983H99.2534C99.4399 30.983 99.6026 30.9598 99.7416 30.9129C99.8805 30.8659 99.9943 30.8016 100.084 30.7185C100.174 30.6361 100.241 30.5385 100.285 30.4244C100.329 30.3109 100.351 30.1866 100.351 30.0515C100.351 29.7805 100.262 29.5724 100.084 29.4264C99.9065 29.2811 99.6343 29.2081 99.2685 29.2081H98.6349V30.9823V30.983Z",
    fill: e.color
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M108 28.44V29.2313H105.639V30.7135H107.499V31.4787H105.639V32.9905H108V33.7855H104.641V28.4407H108V28.44Z",
    fill: e.color
  }
)), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement("clipPath", { id: "clip0_328_8232" }, /* @__PURE__ */ t.createElement("rect", { width: 108, height: 38, fill: "white", transform: "translate(0 5)" })))), O7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 112, height: 48, viewBox: "0 0 112 48", fill: "none", ...e }, /* @__PURE__ */ t.createElement("g", { clipPath: "url(#clip0_6428_5002)" }, /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15.1617 42.7519C14.8291 42.7519 14.5238 42.6847 14.2459 42.5366C13.5979 42.1904 13.4957 41.4519 13.4813 40.774C13.4633 39.9393 13.5993 38.765 13.7865 37.1398C13.8153 36.8912 13.8456 36.631 13.8758 36.3608C13.8996 36.1526 13.9241 35.9416 13.9485 35.7277C14.3654 32.1079 14.8838 27.6037 14.0961 24.4919C13.3725 21.6324 10.926 17.5364 9.46437 15.0887C9.23037 14.6971 9.02877 14.3589 8.85669 14.0647C7.88253 12.3969 7.58013 11.3765 7.84581 10.6517C7.99557 10.2434 8.32965 9.94634 8.83869 9.76857C10.9433 9.03435 19.1498 10.14 26.1828 12.6137C27.2815 13.0003 28.3903 13.462 29.3681 13.8696C29.8195 14.0575 30.2465 14.2353 30.6432 14.3943C34.1769 15.8071 36.7142 17.0666 38.4005 18.2446C39.8505 19.257 40.6598 20.1936 40.9485 21.1908C41.2805 22.3384 41.0652 23.3985 40.2278 24.7369C39.4502 25.9791 38.1161 27.5054 35.6213 30.0058C33.7118 31.9193 30.6792 34.2044 26.609 36.7958C23.3186 38.8915 20.3393 40.5536 19.211 41.1715C17.5565 42.077 16.2173 42.7541 15.161 42.7541L15.1617 42.7519ZM10.805 10.1465C10.0044 10.1465 9.39597 10.2101 9.03597 10.3359C8.69973 10.4529 8.49453 10.6242 8.40813 10.8591C8.21589 11.3823 8.52261 12.3044 9.37365 13.7598C9.54429 14.0517 9.74517 14.3885 9.97845 14.7787C11.4573 17.2545 13.9313 21.3982 14.6772 24.343C15.4922 27.5625 14.9666 32.1275 14.5447 35.7964C14.5202 36.0103 14.4957 36.2213 14.472 36.4294C14.441 36.7004 14.4108 36.9606 14.382 37.2099C14.04 40.1691 13.8686 41.6542 14.5274 42.0061C15.3432 42.4419 16.6485 41.8883 18.9252 40.6418C20.8512 39.5874 30.6885 34.0981 35.1986 29.5787C39.7958 24.971 40.9089 23.2041 40.3747 21.357C39.6633 18.8978 34.3541 16.5239 30.4229 14.9522C30.0218 14.7917 29.5934 14.6132 29.1398 14.4246C28.1693 14.0199 27.0684 13.5618 25.9862 13.1809C20.1945 11.1438 13.9838 10.1472 10.8057 10.1472L10.805 10.1465Z",
    fill: "#F4333D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.5468 40.2724C13.7887 40.2724 13.2494 40.125 12.9153 39.8302C11.5991 38.6674 11.5675 37.2402 11.8115 33.7541C12.0909 29.7636 12.2342 26.7292 11.5322 24.0048C10.9036 21.5651 10.036 20.0649 9.11729 18.4758C8.86457 18.0378 8.60249 17.5854 8.34185 17.1063C7.56569 15.6798 7.53761 14.366 8.26049 13.2018C8.71409 12.4705 9.44633 11.8259 10.499 11.2319C13.7843 9.37755 17.9459 9.00033 22.8693 10.1096C24.8219 10.5497 27.2894 11.5246 28.6192 12.2183C32.0882 14.0271 34.7047 15.794 36.3959 17.4691C38.0296 19.0878 38.8583 20.6791 38.8583 22.1981C38.8583 26.4618 35.5341 30.1885 34.5153 31.2284C33.0825 32.6925 28.0504 36.2198 23.1249 38.038C20.453 39.0244 18.2699 39.6914 16.6348 40.0217C15.8111 40.1879 15.1171 40.271 14.5468 40.271V40.2724ZM17.6774 10.0901C15.0631 10.0901 12.7591 10.6465 10.792 11.7565C9.82937 12.3 9.16769 12.8766 8.76809 13.5198C8.16833 14.486 8.20217 15.596 8.86673 16.818C9.12377 17.2906 9.38369 17.7394 9.63497 18.1744C10.5746 19.7997 11.4623 21.3353 12.1118 23.8545C12.8368 26.667 12.6921 29.7491 12.4091 33.7967C12.1759 37.1354 12.1939 38.3914 13.3113 39.3792C13.6058 39.6394 14.4014 39.8605 16.516 39.4334C18.1209 39.1097 20.2744 38.4506 22.9175 37.475C27.7588 35.6879 32.6887 32.238 34.0876 30.8086C37.9576 26.8556 38.2586 23.2193 38.2586 22.1996C38.2586 19.3625 34.9221 16.1842 28.342 12.7531C27.231 12.1742 24.7578 11.1531 22.7368 10.6978C20.9418 10.2932 19.2527 10.0908 17.6767 10.0908L17.6774 10.0901Z",
    fill: "#E02D77"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.7968 37.8313C13.4116 37.8313 11.7296 37.5726 10.5805 36.5291C9.80147 35.8209 9.37667 34.8453 9.31835 33.6291C9.24491 32.0928 9.31403 31.0485 9.38099 30.039C9.46019 28.8452 9.53507 27.7178 9.34067 25.9191C9.09875 23.6753 8.47883 22.2502 7.82291 20.7406C7.62923 20.2947 7.42835 19.8337 7.23395 19.3423C6.79043 18.2236 7.07555 17.0384 8.08139 15.82C8.84531 14.8951 10.0261 13.926 11.7973 12.7697C12.2351 12.4843 12.6944 12.1555 13.1812 11.8072C15.46 10.1776 18.2968 8.14908 21.7405 8.58484C23.4275 8.79803 25.0899 9.27931 26.3024 9.90369C28.5294 11.0513 30.9479 12.8875 32.7709 14.8148C34.388 16.5239 36.3709 19.1789 36.6366 22.123C37.0635 26.8441 34.3592 31.7394 32.9826 33.3704C31.7377 34.8453 30.4446 35.5839 28.2119 36.0948C23.2532 37.2301 19.5028 37.6037 15.398 37.8154C15.2058 37.8256 15.0042 37.8313 14.7961 37.8313H14.7968ZM20.8024 9.12683C17.9627 9.12683 15.5247 10.8706 13.5296 12.2971C13.0379 12.649 12.5728 12.9815 12.1242 13.2741C10.4048 14.3957 9.26723 15.3272 8.54291 16.2038C7.67531 17.2545 7.42907 18.2084 7.79051 19.1204C7.98131 19.6024 8.18003 20.0591 8.37227 20.5007C9.04691 22.0537 9.68411 23.5199 9.93611 25.8548C10.1356 27.7048 10.0592 28.8582 9.97859 30.0787C9.91307 31.0716 9.84467 32.0985 9.91667 33.6002C9.96707 34.6509 10.3256 35.4863 10.9823 36.0832C11.6274 36.6693 12.9119 37.3421 15.3678 37.2149C19.4415 37.0046 23.1625 36.6339 28.0794 35.5087C30.1976 35.0238 31.3611 34.3626 32.5268 32.9816C33.1878 32.1983 34.1749 30.6373 34.9619 28.606C35.576 27.0212 36.2622 24.6191 36.0411 22.1765C35.7906 19.4051 33.8891 16.8686 32.3375 15.2282C30.5583 13.3471 28.2004 11.5564 26.0296 10.4377C25.4845 10.1566 23.9675 9.47154 21.6664 9.18031C21.374 9.14345 21.086 9.12611 20.8016 9.12611L20.8024 9.12683Z",
    fill: "#BA2FA2"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M28.3404 38.0738C27.8141 38.0738 27.3346 37.9827 26.9969 37.9184C26.9112 37.9025 26.8349 37.8873 26.768 37.8765C25.8708 37.7291 24.8866 37.4913 23.7468 37.216C22.0757 36.812 19.9956 36.3098 17.2416 35.8625C16.6116 35.7606 15.9305 35.6767 15.2091 35.5879C11.9748 35.1897 8.30859 34.7387 7.42227 32.333C6.93411 31.0077 6.85707 29.6498 6.74043 27.5946C6.71739 27.1877 6.69363 26.7671 6.66411 26.3054C6.60075 25.3009 6.41787 24.4344 6.25587 23.6706C5.76555 21.3516 5.41131 19.6758 9.04443 17.3387C12.6156 15.0421 15.3416 12.8633 17.3792 10.6794C18.745 9.21535 21.4155 6.8819 23.9542 7.70645C25.8766 8.33154 28.236 10.2726 30.2664 12.9002C32.4819 15.7676 33.906 18.9003 34.2761 21.7216C34.7168 25.0805 34.4518 28.362 33.4877 31.4745C32.5726 34.428 31.322 36.2686 30.8266 36.9226C30.1268 37.8469 29.1742 38.0745 28.3404 38.0745V38.0738ZM22.8591 8.13642C22.07 8.13642 21.2009 8.42982 20.2656 9.013C19.4643 9.51308 18.6168 10.2314 17.8162 11.0892C15.7448 13.3099 12.9807 15.5191 9.36771 17.8438C7.80531 18.8483 6.97803 19.7169 6.68355 20.6593C6.41427 21.5221 6.60291 22.4146 6.84195 23.5448C7.00755 24.3296 7.19619 25.2185 7.26171 26.2671C7.29123 26.731 7.31499 27.1523 7.33803 27.5606C7.45611 29.6332 7.52667 30.8841 7.98387 32.1249C8.74347 34.1866 12.2168 34.6144 15.2818 34.9917C16.009 35.0813 16.6966 35.1658 17.3374 35.2699C20.1137 35.7201 22.206 36.226 23.8872 36.6321C25.0155 36.9045 25.9896 37.1401 26.8652 37.2839C26.9357 37.2955 27.0178 37.3114 27.1085 37.328C27.9207 37.4827 29.4327 37.7695 30.35 36.5584C30.8259 35.9297 32.029 34.1577 32.916 31.2953C33.8542 28.2667 34.112 25.0718 33.6828 21.7996C33.3315 19.1222 31.9138 16.0126 29.7934 13.2687C27.8631 10.7705 25.5555 8.85836 23.7699 8.27806C23.4797 8.1834 23.1759 8.13642 22.8591 8.13642Z",
    fill: "#885AC6"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M27.4829 40.5477C26.7536 40.5477 26.0566 40.2247 25.5836 40.0058C25.4993 39.9667 25.4201 39.9299 25.3481 39.8981C24.3517 39.4623 22.4134 38.2793 19.8905 36.5688C17.1977 34.7434 14.0528 33.5893 9.14383 31.8586C6.88375 31.0615 5.70871 30.4588 5.08735 29.778C4.44079 29.0691 4.41991 28.3038 4.39471 27.3347C4.38319 26.9004 4.37023 26.4083 4.30183 25.8367C4.06207 23.819 4.04263 22.5125 6.55471 21.1344C7.09903 20.8359 9.28711 19.5041 12.8806 17.2834C15.4114 15.7195 17.5736 13.4309 18.7537 11.81C19.4319 10.8785 20.0511 9.87472 20.5976 8.98947C21.4969 7.53188 22.0275 6.69649 22.4847 6.46741C23.3458 6.03527 24.0061 6.55919 25.3222 7.60198L25.3359 7.61282C26.6513 8.65561 29.3636 13.0161 30.4277 15.799C30.4702 15.911 30.5141 16.0238 30.5581 16.1387C31.4847 18.5451 32.6381 21.5405 32.3667 27.5183C32.1241 32.8602 30.1714 38.5005 29.2311 39.6683C28.6969 40.3317 28.0791 40.547 27.4837 40.547L27.4829 40.5477ZM23.0816 6.92124C22.9693 6.92124 22.8627 6.95014 22.7511 7.00651C22.4242 7.17055 21.7539 8.2567 21.1059 9.30744C20.5537 10.2021 19.928 11.2167 19.2361 12.1663C18.0229 13.8327 15.7981 16.1871 13.1931 17.7964C9.53911 20.0547 7.40215 21.3555 6.84055 21.6634C4.65319 22.863 4.66615 23.8414 4.89511 25.7666C4.96639 26.3657 4.98007 26.8722 4.99159 27.3196C5.01679 28.2612 5.03191 28.8299 5.52727 29.3726C6.06943 29.9667 7.20991 30.5412 9.34039 31.292C14.2947 33.0394 17.4706 34.205 20.2239 36.0716C23.5885 38.353 25.0277 39.1032 25.5857 39.3481C25.6613 39.3814 25.7441 39.4197 25.8327 39.4609C26.9055 39.9573 27.9365 40.3179 28.7631 39.2918C29.5616 38.3003 31.5243 32.8139 31.7662 27.493C32.0319 21.6417 30.9037 18.712 29.9972 16.3576C29.9525 16.2427 29.9093 16.1286 29.8661 16.0166C28.8502 13.3601 26.192 9.06174 24.9622 8.08688L24.9485 8.07604C23.9369 7.27462 23.4711 6.92268 23.0801 6.92268L23.0816 6.92124Z",
    fill: "#448DDD"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M25.9044 42.9998C25.3975 42.9998 24.8712 42.7397 24.3045 42.21C23.8373 41.7735 23.2382 41.0812 22.4808 40.2053C20.621 38.0562 18.0737 35.1121 15.0396 33.1045C10.4532 30.0694 5.77751 27.6594 3.66935 27.2453C2.25886 26.9678 2.01838 26.269 2.0011 25.8773C1.97014 25.1958 2.59366 24.4508 3.39142 24.2174C6.51623 23.3018 12.7305 20.2695 15.761 17.8775C18.2025 15.9502 20.0263 13.8256 20.8968 11.8954C21.7183 10.0721 22.1913 8.01186 22.1935 6.24135C22.1935 5.71599 22.2497 5.16099 22.6579 5.02585C23.1259 4.87193 23.6285 5.40958 24.45 6.52608C25.4378 7.86877 27.3444 11.5839 28.2069 14.7889C29.0695 17.9939 29.9321 21.4705 30.1855 25.6244C30.3936 29.0411 30.2654 32.0892 29.8032 34.6843C29.4943 36.4201 28.7203 39.8122 27.7814 41.5141C27.2904 42.4036 26.7533 42.8835 26.1391 42.9818C26.0613 42.9941 25.9836 43.0006 25.9058 43.0006L25.9044 42.9998ZM22.8595 5.62132C22.8329 5.69358 22.7925 5.86485 22.7918 6.24208C22.7897 8.09496 22.2972 10.2456 21.4418 12.1433C20.5325 14.1602 18.6461 16.3643 16.1304 18.3501C12.9984 20.8223 6.80063 23.8445 3.55846 24.794C3.02854 24.9494 2.5807 25.4423 2.5987 25.8498C2.61526 26.222 3.03647 26.5074 3.78311 26.6549C5.20295 26.9338 7.32119 27.9397 8.84903 28.7347C10.8823 29.7926 13.1978 31.1664 15.3679 32.6023C18.4704 34.6554 21.0487 37.6356 22.9315 39.8108C23.6486 40.6389 24.2671 41.3544 24.7113 41.7692C25.2146 42.2396 25.6632 42.4477 26.0426 42.387C26.4573 42.3213 26.8649 41.9289 27.2551 41.2221C28.0399 39.8006 28.8189 36.7814 29.2113 34.578C29.6649 32.03 29.7909 29.0302 29.585 25.6605C29.3352 21.563 28.4805 18.1196 27.6259 14.945C26.7828 11.8108 24.9266 8.18818 23.9654 6.88307C23.285 5.9588 22.9869 5.68925 22.8573 5.62132H22.8595Z",
    fill: "#00C0F3"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M52.0883 22.7006C52.4648 22.7006 52.7932 22.6666 53.0732 22.598C53.3526 22.5293 53.619 22.4347 53.8717 22.314V20.6735H52.7471C52.6391 20.6735 52.5541 20.6432 52.4922 20.5832C52.4303 20.5232 52.3993 20.4495 52.3993 20.3621V19.4147H55.3873V23.0626C55.1598 23.2289 54.9222 23.3734 54.676 23.4962C54.4297 23.6191 54.1662 23.7195 53.8868 23.799C53.6075 23.8785 53.308 23.9371 52.989 23.9768C52.67 24.0165 52.3266 24.0361 51.958 24.0361C51.3035 24.0361 50.7008 23.9219 50.15 23.6928C49.5992 23.4644 49.1226 23.1465 48.7208 22.7389C48.3191 22.3313 48.0052 21.845 47.7798 21.2799C47.5537 20.7147 47.4414 20.0976 47.4414 19.4277C47.4414 18.7578 47.5508 18.1284 47.7704 17.5633C47.99 16.9981 48.3018 16.5118 48.7057 16.1042C49.1096 15.6966 49.5992 15.3808 50.1752 15.1561C50.7505 14.9321 51.3971 14.8193 52.1135 14.8193C52.8299 14.8193 53.4815 14.9285 54.0179 15.1467C54.5543 15.3649 55.0086 15.6489 55.3816 15.998L54.897 16.7589C54.802 16.9129 54.6752 16.9895 54.5183 16.9895C54.4189 16.9895 54.3174 16.9562 54.2137 16.8897C54.0812 16.8102 53.9452 16.7315 53.8069 16.6527C53.668 16.5732 53.5146 16.5053 53.3476 16.4468C53.1798 16.3889 52.9912 16.3412 52.7824 16.3037C52.5728 16.2661 52.3316 16.2473 52.0588 16.2473C51.6152 16.2473 51.2149 16.3225 50.8564 16.472C50.4978 16.6216 50.1925 16.8355 49.9398 17.1145C49.6871 17.3934 49.4927 17.7273 49.3559 18.1182C49.2191 18.5092 49.1507 18.9457 49.1507 19.4277C49.1507 19.9473 49.2227 20.4098 49.3681 20.8152C49.5128 21.2206 49.7159 21.5624 49.9772 21.8406C50.2379 22.1196 50.5489 22.3328 50.9089 22.4802C51.2689 22.6276 51.6628 22.7013 52.0897 22.7013L52.0883 22.7006Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M66.1868 19.4265C66.1868 20.0877 66.0774 20.6998 65.8578 21.2627C65.6382 21.8264 65.3293 22.3135 64.9319 22.7254C64.5344 23.1366 64.0564 23.4574 63.4969 23.6887C62.9375 23.9192 62.3183 24.0348 61.6393 24.0348C60.9604 24.0348 60.3397 23.9192 59.7781 23.6887C59.2165 23.4574 58.7363 23.1366 58.3367 22.7254C57.9371 22.3135 57.6275 21.8264 57.4079 21.2627C57.1883 20.6998 57.0781 20.087 57.0781 19.4265C57.0781 18.766 57.1876 18.1539 57.4079 17.5902C57.6275 17.0266 57.9371 16.5395 58.3367 16.1283C58.7363 15.7164 59.2165 15.3955 59.7781 15.165C60.3397 14.9345 60.9596 14.8188 61.6393 14.8188C62.319 14.8188 62.9375 14.9352 63.4969 15.1686C64.0564 15.4013 64.5344 15.7222 64.9319 16.1319C65.3293 16.5417 65.6382 17.028 65.8578 17.5909C66.0774 18.1546 66.1868 18.7667 66.1868 19.4272V19.4265ZM64.4718 19.4265C64.4718 18.9322 64.4063 18.4878 64.276 18.0954C64.1456 17.7022 63.9577 17.3691 63.7136 17.0945C63.4688 16.8199 63.1722 16.6103 62.8223 16.4643C62.4724 16.3191 62.0778 16.2461 61.6386 16.2461C61.1994 16.2461 60.8041 16.3191 60.452 16.4643C60.1 16.6103 59.8004 16.8199 59.5542 17.0945C59.308 17.3691 59.1179 17.7022 58.9854 18.0954C58.8529 18.4885 58.7867 18.9322 58.7867 19.4265C58.7867 19.9208 58.8529 20.3652 58.9854 20.7576C59.1179 21.1507 59.3072 21.4832 59.5542 21.7556C59.8004 22.028 60.1 22.2369 60.452 22.3821C60.8041 22.5281 61.1994 22.6004 61.6386 22.6004C62.0778 22.6004 62.4716 22.5281 62.8223 22.3821C63.1722 22.2362 63.4696 22.028 63.7136 21.7556C63.9577 21.4839 64.1456 21.1507 64.276 20.7576C64.4063 20.3645 64.4718 19.9215 64.4718 19.4265Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M66.8945 14.9187H68.2431C68.3878 14.9187 68.5059 14.9541 68.5973 15.0249C68.6881 15.0957 68.7572 15.1868 68.8025 15.2995L70.915 20.7996C70.9856 20.9789 71.0525 21.1747 71.1166 21.3886C71.1807 21.6025 71.2419 21.8287 71.3002 22.065C71.3953 21.5873 71.5133 21.1653 71.6544 20.7989L73.7604 15.2988C73.7979 15.2027 73.8641 15.1153 73.9592 15.0365C74.0542 14.9577 74.1723 14.918 74.3134 14.918H75.6613L72.0332 23.9352H70.5233L66.8945 14.918V14.9187Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M84.0481 14.9185V16.2966H81.3452V23.9357H79.6741V16.2966H76.959V14.9185H84.0481Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M91.3988 14.9185V16.2532H87.4165V18.7536H90.5543V20.0442H87.4165V22.5952H91.3988V23.9357H85.7324V14.9185H91.3988Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M99.6428 21.8088C99.7335 21.8088 99.8127 21.8442 99.8789 21.9151L100.537 22.6319C100.173 23.085 99.7241 23.4319 99.192 23.6733C98.66 23.9147 98.0206 24.0353 97.2754 24.0353C96.6087 24.0353 96.0089 23.9212 95.4768 23.6921C94.9448 23.4637 94.4897 23.1457 94.1132 22.7382C93.7359 22.3306 93.4471 21.8442 93.2463 21.2791C93.0454 20.714 92.9453 20.0969 92.9453 19.427C92.9453 18.7571 93.0569 18.1291 93.2808 17.5661C93.5048 17.0025 93.8194 16.5176 94.2255 16.11C94.6316 15.7024 95.1176 15.3859 95.6828 15.159C96.248 14.9328 96.8722 14.8193 97.5555 14.8193C98.2388 14.8193 98.8054 14.9263 99.3043 15.1402C99.8033 15.3541 100.231 15.6381 100.587 15.9915L100.028 16.7705C99.9948 16.8204 99.9524 16.8644 99.9005 16.9013C99.8487 16.9389 99.7774 16.9577 99.686 16.9577C99.5945 16.9577 99.493 16.9201 99.3936 16.8457C99.2943 16.7705 99.1675 16.6896 99.0149 16.6021C98.8615 16.5147 98.6679 16.4337 98.4339 16.3586C98.1999 16.2842 97.9025 16.2466 97.5418 16.2466C97.1192 16.2466 96.7311 16.321 96.3768 16.4677C96.0226 16.6151 95.718 16.8269 95.4639 17.1008C95.209 17.3754 95.0103 17.7085 94.8677 18.1016C94.7251 18.4948 94.6532 18.9363 94.6532 19.427C94.6532 19.9177 94.7244 20.3852 94.8677 20.7798C95.0103 21.1751 95.204 21.5075 95.4488 21.7778C95.6936 22.048 95.9808 22.2547 96.3128 22.3985C96.644 22.5416 97.0004 22.6132 97.3812 22.6132C97.6088 22.6132 97.8154 22.6009 97.9997 22.5756C98.184 22.551 98.354 22.5113 98.5095 22.4571C98.665 22.4029 98.8119 22.3335 98.9508 22.2482C99.0898 22.1629 99.2273 22.0582 99.3641 21.9331C99.4059 21.8956 99.4491 21.8659 99.4944 21.8428C99.5398 21.8197 99.5895 21.8088 99.6435 21.8088H99.6428Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M109.999 23.9352H108.315V19.9939H104.103V23.9352H102.42V14.918H104.103V18.7964H108.315V14.918H109.999V23.9352Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M51.538 29.4123C51.5114 29.4665 51.4797 29.5048 51.4444 29.5272C51.4084 29.5496 51.3667 29.5605 51.317 29.5605C51.2673 29.5605 51.2126 29.5417 51.1514 29.5034C51.0902 29.4651 51.0175 29.4224 50.9339 29.3762C50.8504 29.3292 50.7525 29.2866 50.6409 29.2483C50.5293 29.21 50.3968 29.1912 50.2449 29.1912C50.1074 29.1912 49.9879 29.2078 49.8856 29.2411C49.7834 29.2743 49.6977 29.3205 49.6279 29.3798C49.558 29.4391 49.5055 29.5099 49.4716 29.5923C49.4371 29.6746 49.4198 29.765 49.4198 29.864C49.4198 29.9897 49.4551 30.0938 49.5249 30.1776C49.5947 30.2614 49.6876 30.333 49.8028 30.3922C49.918 30.4515 50.0491 30.5042 50.1967 30.5512C50.3443 30.5982 50.4947 30.6481 50.6481 30.7008C50.8015 30.7536 50.9519 30.8157 51.0995 30.8858C51.2471 30.9559 51.3782 31.0448 51.4934 31.1517C51.6086 31.2587 51.7015 31.3902 51.7713 31.5456C51.8411 31.701 51.8764 31.8896 51.8764 32.1114C51.8764 32.3528 51.8354 32.579 51.7533 32.7893C51.6712 33.0003 51.551 33.1838 51.3926 33.3399C51.2342 33.496 51.0405 33.6196 50.8123 33.7092C50.584 33.7995 50.3227 33.8444 50.0282 33.8444C49.859 33.8444 49.6919 33.8277 49.5271 33.7945C49.3622 33.7612 49.2045 33.7136 49.054 33.6521C48.9028 33.5907 48.7617 33.517 48.6307 33.4303C48.4996 33.3443 48.3823 33.2482 48.2793 33.1419L48.5666 32.665C48.5932 32.6303 48.6263 32.6014 48.6638 32.5783C48.7019 32.5551 48.7444 32.5429 48.7912 32.5429C48.8524 32.5429 48.9187 32.5681 48.9899 32.6187C49.0612 32.6693 49.1455 32.725 49.2419 32.7871C49.3391 32.8485 49.4529 32.9049 49.5847 32.9548C49.7157 33.0054 49.8741 33.0306 50.0577 33.0306C50.3399 33.0306 50.5588 32.9634 50.7129 32.829C50.8677 32.6946 50.9447 32.5017 50.9447 32.2502C50.9447 32.11 50.9095 31.9951 50.8396 31.9062C50.7698 31.818 50.6769 31.7429 50.5617 31.6829C50.4465 31.6229 50.3147 31.5716 50.1679 31.5297C50.021 31.4878 49.8705 31.4423 49.7186 31.3931C49.5659 31.344 49.4169 31.2847 49.2693 31.2153C49.1217 31.146 48.9907 31.0564 48.8755 30.9458C48.7603 30.8345 48.6674 30.6958 48.5975 30.5295C48.5277 30.3633 48.4924 30.1581 48.4924 29.9146C48.4924 29.7202 48.5313 29.5301 48.6083 29.3451C48.6861 29.1601 48.7984 28.9961 48.9475 28.853C49.0958 28.7099 49.2779 28.5957 49.4939 28.5097C49.7099 28.4237 49.9569 28.3804 50.2341 28.3804C50.548 28.3804 50.8382 28.4295 51.1031 28.5278C51.3681 28.6261 51.5942 28.7641 51.7807 28.9419L51.5373 29.4116L51.538 29.4123Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement("path", { d: "M56.7014 33.7852H55.707V28.4404H56.7014V33.7852Z", fill: "#3D3D3D" }), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M61.3546 28.446C61.3841 28.4496 61.41 28.4568 61.4338 28.4684C61.4568 28.4792 61.4799 28.4951 61.5015 28.5168C61.5238 28.5378 61.5483 28.5652 61.5749 28.5999L64.3707 32.1741C64.3606 32.0881 64.3541 32.0036 64.3505 31.9212C64.3469 31.8388 64.3448 31.7615 64.3448 31.69V28.4409H65.2174V33.7857H64.7055C64.627 33.7857 64.5622 33.7734 64.5104 33.7488C64.4592 33.7242 64.4081 33.6802 64.3592 33.6158L61.5749 30.056C61.5821 30.1348 61.5879 30.2136 61.5915 30.2909C61.5951 30.369 61.5972 30.4391 61.5972 30.5034V33.7857H60.7246V28.4409H61.2437C61.2876 28.4409 61.3251 28.4424 61.3546 28.4467V28.446Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M71.3804 33.0538C71.6044 33.0538 71.7988 33.0336 71.9644 32.9924C72.13 32.9519 72.2876 32.8955 72.4374 32.824V31.852H71.7707C71.7066 31.852 71.6562 31.834 71.6195 31.7985C71.5828 31.7631 71.564 31.719 71.564 31.667V31.1055H73.3352V33.2677C73.2006 33.3667 73.0595 33.452 72.9133 33.525C72.7672 33.5979 72.6116 33.6579 72.446 33.7042C72.2804 33.7512 72.1026 33.7858 71.914 33.8097C71.7246 33.8335 71.5208 33.8451 71.3027 33.8451C70.9146 33.8451 70.5575 33.7772 70.2306 33.642C69.9044 33.5062 69.6222 33.3176 69.3839 33.0762C69.1456 32.8348 68.9598 32.5465 68.8259 32.2112C68.692 31.8759 68.625 31.5102 68.625 31.1135C68.625 30.7167 68.6898 30.3438 68.8201 30.0078C68.9497 29.6725 69.1348 29.3849 69.3738 29.1428C69.6136 28.9014 69.9037 28.7143 70.245 28.5813C70.5863 28.4476 70.9693 28.3818 71.3941 28.3818C71.8189 28.3818 72.2048 28.4469 72.5231 28.5762C72.8413 28.7056 73.1106 28.8732 73.3316 29.0806L73.0444 29.5316C72.9882 29.6226 72.9133 29.6682 72.8197 29.6682C72.7607 29.6682 72.7009 29.6486 72.6397 29.6089C72.5612 29.5619 72.4806 29.5157 72.3985 29.4687C72.3164 29.4217 72.2257 29.3813 72.1256 29.3466C72.0263 29.3119 71.914 29.2837 71.7901 29.2613C71.6663 29.2389 71.523 29.2281 71.361 29.2281C71.0982 29.2281 70.8606 29.2721 70.6482 29.361C70.4358 29.4499 70.2544 29.5764 70.1046 29.7419C69.9548 29.9074 69.8396 30.1054 69.7583 30.3366C69.6776 30.5686 69.6366 30.8273 69.6366 31.1127C69.6366 31.4206 69.6791 31.6952 69.7655 31.9351C69.8512 32.175 69.9714 32.3781 70.1262 32.5429C70.281 32.7084 70.4646 32.8341 70.6784 32.9223C70.8923 33.0097 71.1256 33.0538 71.3783 33.0538H71.3804Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M81.3947 33.7852H80.6287C80.543 33.7852 80.4717 33.7635 80.417 33.7201C80.3615 33.6768 80.3219 33.6233 80.2975 33.5597L79.9 32.4692H77.6939L77.2965 33.5597C77.2771 33.6168 77.2382 33.6681 77.1806 33.7151C77.123 33.762 77.0524 33.7852 76.9689 33.7852H76.1992L78.2915 28.4404H79.3039L81.3962 33.7852H81.3947ZM77.9474 31.7668H79.6451L78.9971 29.9891C78.9676 29.9103 78.9352 29.8171 78.8992 29.7101C78.8632 29.6032 78.8287 29.4868 78.7941 29.3604C78.7595 29.4861 78.7257 29.6032 78.6926 29.7116C78.6595 29.82 78.6271 29.9146 78.5954 29.9963L77.9474 31.7668Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M85.5435 31.9041V33.7852H84.5527V28.4404H86.2872C86.6429 28.4404 86.9511 28.4823 87.2117 28.5662C87.4723 28.65 87.6869 28.7671 87.8561 28.9174C88.026 29.0677 88.1506 29.2476 88.2319 29.4572C88.3133 29.6668 88.3536 29.8959 88.3536 30.1444C88.3536 30.393 88.3104 30.6402 88.2247 30.8563C88.1383 31.0716 88.0095 31.2573 87.8381 31.4127C87.666 31.5681 87.4515 31.6888 87.1937 31.7748C86.9359 31.8607 86.6343 31.9041 86.2879 31.9041H85.5435ZM85.5435 31.128H86.2879C86.4694 31.128 86.6278 31.1049 86.7631 31.0593C86.8985 31.0138 87.0101 30.9488 87.0987 30.8635C87.1872 30.7782 87.2535 30.6749 87.2974 30.5527C87.3413 30.4306 87.3636 30.2948 87.3636 30.1444C87.3636 29.9941 87.3413 29.872 87.2974 29.7564C87.2535 29.6408 87.1872 29.5418 87.0987 29.4608C87.0101 29.3799 86.8985 29.3177 86.7631 29.2744C86.6285 29.231 86.4701 29.2093 86.2879 29.2093H85.5435V31.128Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M96.5633 31.1127C96.5633 31.5044 96.4978 31.8672 96.3682 32.2011C96.2379 32.5349 96.055 32.824 95.8196 33.0675C95.5834 33.3118 95.3005 33.5018 94.9685 33.6384C94.6373 33.775 94.2701 33.8437 93.8677 33.8437C93.4652 33.8437 93.0973 33.7757 92.7646 33.6384C92.432 33.5018 92.1469 33.3118 91.91 33.0675C91.6731 32.8233 91.4895 32.5349 91.3592 32.2011C91.2289 31.8672 91.1641 31.5044 91.1641 31.1127C91.1641 30.7211 91.2289 30.3583 91.3592 30.0244C91.4895 29.6906 91.6731 29.4015 91.91 29.158C92.1469 28.9137 92.432 28.7237 92.7646 28.5871C93.0973 28.4505 93.4652 28.3818 93.8677 28.3818C94.2701 28.3818 94.6373 28.4505 94.9685 28.5885C95.2997 28.7265 95.5834 28.9166 95.8196 29.1594C96.055 29.4022 96.2379 29.6906 96.3682 30.0244C96.4978 30.3583 96.5633 30.7211 96.5633 31.1127ZM95.5467 31.1127C95.5467 30.8193 95.5078 30.5563 95.4308 30.3236C95.3537 30.0909 95.2421 29.8929 95.0974 29.7303C94.9527 29.5677 94.7763 29.4434 94.5689 29.3574C94.3616 29.2714 94.1276 29.2281 93.8677 29.2281C93.6077 29.2281 93.373 29.2714 93.1642 29.3574C92.9554 29.4434 92.7783 29.5677 92.6321 29.7303C92.486 29.8936 92.3737 30.0909 92.2952 30.3236C92.2167 30.5563 92.1771 30.8201 92.1771 31.1127C92.1771 31.4054 92.216 31.6692 92.2952 31.9019C92.3737 32.1353 92.486 32.3319 92.6321 32.4937C92.7783 32.6549 92.9554 32.7792 93.1642 32.8652C93.373 32.9512 93.607 32.9945 93.8677 32.9945C94.1283 32.9945 94.3616 32.9512 94.5689 32.8652C94.7763 32.7792 94.9527 32.6549 95.0974 32.4937C95.2421 32.3326 95.3537 32.1353 95.4308 31.9019C95.5085 31.6692 95.5467 31.4061 95.5467 31.1127Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M100.633 31.6967V33.7852H99.6426V28.4404H101.267C101.63 28.4404 101.942 28.478 102.201 28.5532C102.46 28.6283 102.672 28.7338 102.838 28.869C103.004 29.0041 103.125 29.166 103.203 29.3546C103.281 29.5432 103.319 29.7506 103.319 29.9775C103.319 30.1575 103.293 30.3273 103.24 30.4877C103.187 30.6481 103.111 30.7934 103.011 30.9242C102.912 31.055 102.79 31.1692 102.644 31.2682C102.497 31.3672 102.331 31.4459 102.145 31.5052C102.27 31.5767 102.378 31.6786 102.469 31.8123L103.802 33.7859H102.911C102.825 33.7859 102.752 33.7686 102.692 33.7346C102.631 33.6999 102.581 33.6508 102.539 33.5864L101.42 31.8752C101.378 31.8109 101.332 31.7654 101.281 31.7386C101.231 31.7119 101.157 31.6982 101.059 31.6982H100.635L100.633 31.6967ZM100.633 30.9834H101.252C101.438 30.9834 101.601 30.9603 101.74 30.9133C101.879 30.8664 101.993 30.8021 102.083 30.719C102.173 30.6366 102.24 30.539 102.284 30.4248C102.327 30.3114 102.35 30.1871 102.35 30.0519C102.35 29.781 102.26 29.5728 102.083 29.4269C101.905 29.2816 101.633 29.2086 101.267 29.2086H100.633V30.9827V30.9834Z",
    fill: "#3D3D3D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M109.999 28.4404V29.2317H107.639V30.7139H109.498V31.4792H107.639V32.991H109.999V33.7859H106.641V28.4412H109.999V28.4404Z",
    fill: "#3D3D3D"
  }
)), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement("clipPath", { id: "clip0_6428_5002" }, /* @__PURE__ */ t.createElement("rect", { width: 108, height: 38, fill: "white", transform: "translate(2 5)" })))), S7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 88, height: 44, viewBox: "0 0 88 44", fill: "none", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M85.4636 29.5317V22.4727H86.9477V29.5317H85.4636Z", fill: "#333333" }), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M83.207 29.5318V28.5329L83.1119 28.3141V26.5255C83.1119 26.2084 83.0136 25.961 82.817 25.7835C82.6267 25.6059 82.3318 25.5171 81.9322 25.5171C81.6595 25.5171 81.39 25.5615 81.1236 25.6503C80.8636 25.7327 80.6416 25.8469 80.4576 25.9928L79.9249 24.9558C80.204 24.7592 80.5401 24.607 80.9333 24.4991C81.3265 24.3913 81.7261 24.3374 82.132 24.3374C82.9121 24.3374 83.5178 24.5213 83.9491 24.8892C84.3804 25.257 84.596 25.831 84.596 26.6111V29.5318H83.207ZM81.6468 29.6079C81.2473 29.6079 80.9048 29.5413 80.6194 29.4081C80.334 29.2686 80.1152 29.0815 79.9629 28.8468C79.8107 28.6121 79.7346 28.3489 79.7346 28.0572C79.7346 27.7528 79.8076 27.4864 79.9534 27.2581C80.1056 27.0297 80.3435 26.8521 80.6669 26.7253C80.9904 26.5921 81.4122 26.5255 81.9322 26.5255H83.2927V27.3912H82.094C81.7451 27.3912 81.5041 27.4483 81.3709 27.5625C81.2441 27.6766 81.1807 27.8193 81.1807 27.9906C81.1807 28.1809 81.2536 28.3331 81.3995 28.4472C81.5517 28.5551 81.7578 28.609 82.0179 28.609C82.2652 28.609 82.4872 28.5519 82.6838 28.4377C82.8804 28.3172 83.0231 28.1428 83.1119 27.9145L83.3402 28.5995C83.2324 28.9293 83.0358 29.1798 82.7504 29.351C82.465 29.5223 82.0971 29.6079 81.6468 29.6079Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M78.5019 29.6079C77.8994 29.6079 77.43 29.4556 77.0939 29.1512C76.7577 28.8404 76.5897 28.3806 76.5897 27.7718V23.2814H78.0738V27.7527C78.0738 27.9684 78.1309 28.1364 78.245 28.2569C78.3592 28.3711 78.5146 28.4282 78.7112 28.4282C78.9458 28.4282 79.1456 28.3648 79.3105 28.2379L79.7101 29.2844C79.5579 29.3922 79.374 29.4747 79.1583 29.5318C78.949 29.5825 78.7302 29.6079 78.5019 29.6079ZM75.8 25.6693V24.5276H79.3486V25.6693H75.8Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M72.6482 29.5318V24.4135H74.0657V25.8596L73.8659 25.441C74.0181 25.0795 74.2623 24.8067 74.5985 24.6228C74.9346 24.4325 75.3437 24.3374 75.8257 24.3374V25.7073C75.7623 25.701 75.7052 25.6978 75.6545 25.6978C75.6037 25.6915 75.5498 25.6883 75.4927 25.6883C75.0868 25.6883 74.757 25.8057 74.5033 26.0403C74.256 26.2686 74.1323 26.627 74.1323 27.1153V29.5318H72.6482Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M69.3255 29.6079C68.7801 29.6079 68.2949 29.4937 67.87 29.2654C67.4514 29.0371 67.1184 28.7263 66.871 28.3331C66.63 27.9335 66.5095 27.48 66.5095 26.9726C66.5095 26.4589 66.63 26.0054 66.871 25.6122C67.1184 25.2126 67.4514 24.9019 67.87 24.6799C68.2949 24.4516 68.7801 24.3374 69.3255 24.3374C69.8646 24.3374 70.3466 24.4516 70.7716 24.6799C71.1965 24.9019 71.5295 25.2095 71.7705 25.6027C72.0115 25.9959 72.132 26.4526 72.132 26.9726C72.132 27.48 72.0115 27.9335 71.7705 28.3331C71.5295 28.7263 71.1965 29.0371 70.7716 29.2654C70.3466 29.4937 69.8646 29.6079 69.3255 29.6079ZM69.3255 28.3902C69.5729 28.3902 69.7949 28.3331 69.9915 28.2189C70.1881 28.1048 70.3435 27.943 70.4576 27.7337C70.5718 27.5181 70.6289 27.2644 70.6289 26.9726C70.6289 26.6746 70.5718 26.4209 70.4576 26.2116C70.3435 26.0023 70.1881 25.8405 69.9915 25.7264C69.7949 25.6122 69.5729 25.5551 69.3255 25.5551C69.0782 25.5551 68.8562 25.6122 68.6596 25.7264C68.463 25.8405 68.3044 26.0023 68.1839 26.2116C68.0697 26.4209 68.0127 26.6746 68.0127 26.9726C68.0127 27.2644 68.0697 27.5181 68.1839 27.7337C68.3044 27.943 68.463 28.1048 68.6596 28.2189C68.8562 28.3331 69.0782 28.3902 69.3255 28.3902Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M60.6045 29.5317V22.8722H63.4871C64.0833 22.8722 64.597 22.9705 65.0283 23.1671C65.4596 23.3574 65.7925 23.6333 66.0272 23.9948C66.2619 24.3563 66.3792 24.7876 66.3792 25.2886C66.3792 25.7833 66.2619 26.2114 66.0272 26.5729C65.7925 26.9345 65.4596 27.2135 65.0283 27.4101C64.597 27.6004 64.0833 27.6955 63.4871 27.6955H61.4607L62.1457 27.0011V29.5317H60.6045ZM62.1457 27.1723L61.4607 26.4398H63.4015C63.8771 26.4398 64.2323 26.3383 64.467 26.1353C64.7016 25.9324 64.819 25.6501 64.819 25.2886C64.819 24.9208 64.7016 24.6354 64.467 24.4324C64.2323 24.2295 63.8771 24.128 63.4015 24.128H61.4607L62.1457 23.3954V27.1723Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M55.4251 29.6079C54.9875 29.6079 54.5658 29.5571 54.1598 29.4557C53.7603 29.3479 53.4432 29.2147 53.2085 29.0561L53.7032 27.9906C53.9379 28.1365 54.2138 28.257 54.5309 28.3521C54.8543 28.4409 55.1715 28.4853 55.4822 28.4853C55.8247 28.4853 56.0657 28.4441 56.2053 28.3616C56.3511 28.2792 56.4241 28.165 56.4241 28.0191C56.4241 27.8986 56.367 27.8098 56.2528 27.7528C56.145 27.6893 55.9991 27.6418 55.8152 27.6101C55.6313 27.5783 55.4283 27.5466 55.2063 27.5149C54.9907 27.4832 54.7719 27.442 54.5499 27.3912C54.3279 27.3342 54.125 27.2517 53.941 27.1439C53.7571 27.0361 53.6081 26.8902 53.4939 26.7063C53.3861 26.5223 53.3322 26.2845 53.3322 25.9928C53.3322 25.6693 53.4241 25.3839 53.6081 25.1365C53.7983 24.8892 54.0711 24.6957 54.4262 24.5562C54.7814 24.4103 55.2063 24.3374 55.701 24.3374C56.0499 24.3374 56.405 24.3755 56.7665 24.4516C57.1281 24.5277 57.4293 24.6387 57.6703 24.7845L57.1756 25.8405C56.9283 25.6947 56.6778 25.5964 56.4241 25.5456C56.1767 25.4885 55.9357 25.46 55.701 25.46C55.3712 25.46 55.1302 25.5044 54.978 25.5932C54.8258 25.682 54.7497 25.7961 54.7497 25.9357C54.7497 26.0625 54.8036 26.1577 54.9114 26.2211C55.0256 26.2845 55.1746 26.3352 55.3585 26.3733C55.5425 26.4113 55.7423 26.4462 55.9579 26.4779C56.1799 26.5033 56.4019 26.5445 56.6238 26.6016C56.8458 26.6587 57.0456 26.7411 57.2232 26.849C57.4071 26.9504 57.5562 27.0932 57.6703 27.2771C57.7845 27.4547 57.8416 27.6893 57.8416 27.9811C57.8416 28.2982 57.7464 28.5804 57.5562 28.8278C57.3659 29.0688 57.09 29.2591 56.7285 29.3986C56.3733 29.5381 55.9389 29.6079 55.4251 29.6079Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M52.1376 29.6079C51.5351 29.6079 51.0658 29.4556 50.7296 29.1512C50.3935 28.8404 50.2254 28.3806 50.2254 27.7718V23.2814H51.7095V27.7527C51.7095 27.9684 51.7666 28.1364 51.8808 28.2569C51.9949 28.3711 52.1503 28.4282 52.3469 28.4282C52.5816 28.4282 52.7814 28.3648 52.9463 28.2379L53.3458 29.2844C53.1936 29.3922 53.0097 29.4747 52.7941 29.5318C52.5848 29.5825 52.366 29.6079 52.1376 29.6079ZM49.4358 25.6693V24.5276H52.9843V25.6693H49.4358Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M47.0538 24.3374C47.4597 24.3374 47.8212 24.4199 48.1383 24.5848C48.4618 24.7433 48.7155 24.9907 48.8994 25.3268C49.0833 25.6566 49.1753 26.0815 49.1753 26.6016V29.5318H47.6912V26.8299C47.6912 26.4177 47.5992 26.1133 47.4153 25.9166C47.2377 25.72 46.984 25.6217 46.6542 25.6217C46.4196 25.6217 46.2071 25.6725 46.0168 25.7739C45.8329 25.8691 45.687 26.0181 45.5792 26.2211C45.4777 26.424 45.427 26.6841 45.427 27.0012V29.5318H43.9429V24.4135H45.3604V25.831L45.094 25.4029C45.2779 25.0604 45.5411 24.7972 45.8836 24.6133C46.2261 24.4294 46.6162 24.3374 47.0538 24.3374Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M41.6861 29.5318V28.5329L41.5909 28.3141V26.5255C41.5909 26.2084 41.4926 25.961 41.296 25.7835C41.1057 25.6059 40.8108 25.5171 40.4112 25.5171C40.1385 25.5171 39.869 25.5615 39.6026 25.6503C39.3426 25.7327 39.1206 25.8469 38.9366 25.9928L38.4039 24.9558C38.683 24.7592 39.0191 24.607 39.4123 24.4991C39.8056 24.3913 40.2051 24.3374 40.611 24.3374C41.3911 24.3374 41.9968 24.5213 42.4281 24.8892C42.8594 25.257 43.075 25.831 43.075 26.6111V29.5318H41.6861ZM40.1258 29.6079C39.7263 29.6079 39.3838 29.5413 39.0984 29.4081C38.813 29.2686 38.5942 29.0815 38.4419 28.8468C38.2897 28.6121 38.2136 28.3489 38.2136 28.0572C38.2136 27.7528 38.2866 27.4864 38.4324 27.2581C38.5847 27.0297 38.8225 26.8521 39.1459 26.7253C39.4694 26.5921 39.8912 26.5255 40.4112 26.5255H41.7717V27.3912H40.573C40.2241 27.3912 39.9831 27.4483 39.8499 27.5625C39.7231 27.6766 39.6597 27.8193 39.6597 27.9906C39.6597 28.1809 39.7326 28.3331 39.8785 28.4472C40.0307 28.5551 40.2368 28.609 40.4969 28.609C40.7442 28.609 40.9662 28.5519 41.1628 28.4377C41.3594 28.3172 41.5021 28.1428 41.5909 27.9145L41.8192 28.5995C41.7114 28.9293 41.5148 29.1798 41.2294 29.351C40.944 29.5223 40.5761 29.6079 40.1258 29.6079Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M35.2964 29.5318V24.4135H36.7139V25.8596L36.5141 25.441C36.6663 25.0795 36.9105 24.8067 37.2467 24.6228C37.5828 24.4325 37.9919 24.3374 38.4739 24.3374V25.7073C38.4105 25.701 38.3534 25.6978 38.3027 25.6978C38.2519 25.6915 38.198 25.6883 38.1409 25.6883C37.735 25.6883 37.4052 25.8057 37.1515 26.0403C36.9042 26.2686 36.7805 26.627 36.7805 27.1153V29.5318H35.2964Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M31.7528 29.6457C31.2264 29.6457 30.7412 29.5633 30.2972 29.3984C29.8596 29.2271 29.4759 28.9861 29.1461 28.6753C28.8227 28.3646 28.569 27.9999 28.385 27.5813C28.2074 27.1627 28.1187 26.7029 28.1187 26.2018C28.1187 25.7008 28.2074 25.241 28.385 24.8224C28.569 24.4038 28.8258 24.0391 29.1556 23.7283C29.4854 23.4175 29.8723 23.1797 30.3163 23.0148C30.7602 22.8436 31.2486 22.7579 31.7814 22.7579C32.3712 22.7579 32.9008 22.8562 33.3701 23.0529C33.8458 23.2495 34.2454 23.5349 34.5688 23.9091L33.5794 24.8224C33.3384 24.5687 33.0752 24.3816 32.7898 24.2611C32.5044 24.1342 32.1936 24.0708 31.8575 24.0708C31.534 24.0708 31.2391 24.1215 30.9727 24.223C30.7063 24.3245 30.4748 24.4704 30.2782 24.6606C30.0879 24.8509 29.9389 25.0761 29.8311 25.3361C29.7296 25.5961 29.6789 25.8847 29.6789 26.2018C29.6789 26.5126 29.7296 26.798 29.8311 27.058C29.9389 27.3181 30.0879 27.5464 30.2782 27.743C30.4748 27.9333 30.7032 28.0792 30.9632 28.1806C31.2296 28.2821 31.5213 28.3329 31.8384 28.3329C32.1429 28.3329 32.4378 28.2853 32.7232 28.1902C33.0149 28.0887 33.2972 27.9206 33.5699 27.6859L34.4451 28.799C34.0836 29.0717 33.6619 29.281 33.1798 29.4269C32.7042 29.5728 32.2285 29.6457 31.7528 29.6457ZM33.0371 28.5992V26.0972H34.4451V28.799L33.0371 28.5992Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M67.6153 16.4094C68.0212 16.4094 68.3827 16.4918 68.6999 16.6567C69.0233 16.8153 69.277 17.0626 69.4609 17.3988C69.6449 17.7286 69.7368 18.1535 69.7368 18.6736V21.6038H68.2527V18.9019C68.2527 18.4897 68.1608 18.1852 67.9768 17.9886C67.7992 17.792 67.5455 17.6937 67.2157 17.6937C66.9811 17.6937 66.7686 17.7445 66.5783 17.8459C66.3944 17.9411 66.2485 18.0901 66.1407 18.2931C66.0392 18.496 65.9885 18.7561 65.9885 19.0732V21.6038H64.5044V14.5447H65.9885V17.903L65.6555 17.4749C65.8395 17.1324 66.1027 16.8692 66.4452 16.6853C66.7876 16.5014 67.1777 16.4094 67.6153 16.4094Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M61.8606 21.6799C61.3089 21.6799 60.8173 21.5689 60.3861 21.3469C59.9548 21.1186 59.6155 20.8047 59.3681 20.4051C59.1271 20.0055 59.0066 19.5521 59.0066 19.0447C59.0066 18.5309 59.1271 18.0775 59.3681 17.6842C59.6155 17.2847 59.9548 16.9739 60.3861 16.7519C60.8173 16.5236 61.3089 16.4094 61.8606 16.4094C62.3997 16.4094 62.8691 16.5236 63.2686 16.7519C63.6682 16.9739 63.9631 17.2942 64.1534 17.7128L63.0023 18.3312C62.8691 18.0901 62.701 17.9126 62.4981 17.7984C62.3014 17.6842 62.0858 17.6272 61.8511 17.6272C61.5974 17.6272 61.3691 17.6842 61.1662 17.7984C60.9632 17.9126 60.8015 18.0743 60.681 18.2836C60.5668 18.4929 60.5097 18.7466 60.5097 19.0447C60.5097 19.3428 60.5668 19.5965 60.681 19.8057C60.8015 20.015 60.9632 20.1768 61.1662 20.2909C61.3691 20.4051 61.5974 20.4622 61.8511 20.4622C62.0858 20.4622 62.3014 20.4083 62.4981 20.3005C62.701 20.1863 62.8691 20.0055 63.0023 19.7582L64.1534 20.3861C63.9631 20.7983 63.6682 21.1186 63.2686 21.3469C62.8691 21.5689 62.3997 21.6799 61.8606 21.6799Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M55.8401 21.6038V16.4855H57.2576V17.9316L57.0578 17.513C57.21 17.1515 57.4542 16.8788 57.7904 16.6948C58.1265 16.5046 58.5356 16.4094 59.0176 16.4094V17.7794C58.9542 17.773 58.8971 17.7699 58.8464 17.7699C58.7956 17.7635 58.7417 17.7603 58.6846 17.7603C58.2787 17.7603 57.9489 17.8777 57.6952 18.1123C57.4479 18.3407 57.3242 18.699 57.3242 19.1874V21.6038H55.8401Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M53.5833 21.6038V20.6049L53.4881 20.3861V18.5975C53.4881 18.2804 53.3898 18.0331 53.1932 17.8555C53.0029 17.6779 52.708 17.5891 52.3085 17.5891C52.0357 17.5891 51.7662 17.6335 51.4998 17.7223C51.2398 17.8047 51.0178 17.9189 50.8339 18.0648L50.3011 17.0278C50.5802 16.8312 50.9163 16.679 51.3095 16.5712C51.7028 16.4633 52.1023 16.4094 52.5082 16.4094C53.2884 16.4094 53.894 16.5934 54.3253 16.9612C54.7566 17.3291 54.9722 17.903 54.9722 18.6832V21.6038H53.5833ZM52.0231 21.6799C51.6235 21.6799 51.281 21.6133 50.9956 21.4801C50.7102 21.3406 50.4914 21.1535 50.3392 20.9188C50.1869 20.6842 50.1108 20.421 50.1108 20.1292C50.1108 19.8248 50.1838 19.5584 50.3296 19.3301C50.4819 19.1017 50.7197 18.9242 51.0432 18.7973C51.3666 18.6641 51.7884 18.5975 52.3085 18.5975H53.6689V19.4633H52.4702C52.1214 19.4633 51.8804 19.5203 51.7472 19.6345C51.6203 19.7487 51.5569 19.8914 51.5569 20.0626C51.5569 20.2529 51.6298 20.4051 51.7757 20.5193C51.9279 20.6271 52.134 20.681 52.3941 20.681C52.6414 20.681 52.8634 20.6239 53.06 20.5097C53.2566 20.3892 53.3993 20.2148 53.4881 19.9865L53.7165 20.6715C53.6086 21.0013 53.412 21.2518 53.1266 21.423C52.8412 21.5943 52.4734 21.6799 52.0231 21.6799Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M47.5974 21.6799C47.0139 21.6799 46.5002 21.5657 46.0562 21.3374C45.6186 21.1091 45.2793 20.7983 45.0383 20.4051C44.7973 20.0055 44.6768 19.5521 44.6768 19.0447C44.6768 18.5309 44.7941 18.0775 45.0288 17.6842C45.2698 17.2847 45.5964 16.9739 46.0086 16.7519C46.4209 16.5236 46.8871 16.4094 47.4071 16.4094C47.9082 16.4094 48.3585 16.5172 48.7581 16.7329C49.164 16.9422 49.4843 17.2466 49.7189 17.6462C49.9536 18.0394 50.0709 18.5119 50.0709 19.0637C50.0709 19.1208 50.0677 19.1874 50.0614 19.2635C50.0551 19.3332 50.0487 19.3998 50.0424 19.4633H45.885V18.5975H49.2623L48.6915 18.8544C48.6915 18.588 48.6375 18.3565 48.5297 18.1599C48.4219 17.9633 48.2729 17.8111 48.0826 17.7033C47.8923 17.5891 47.6703 17.532 47.4166 17.532C47.163 17.532 46.9378 17.5891 46.7412 17.7033C46.5509 17.8111 46.4019 17.9665 46.2941 18.1694C46.1862 18.366 46.1323 18.6007 46.1323 18.8734V19.1017C46.1323 19.3808 46.1926 19.6282 46.3131 19.8438C46.4399 20.0531 46.6143 20.2148 46.8363 20.329C47.0646 20.4368 47.331 20.4907 47.6355 20.4907C47.9082 20.4907 48.146 20.4495 48.349 20.367C48.5583 20.2846 48.7485 20.1609 48.9198 19.996L49.7094 20.8522C49.4747 21.1186 49.1798 21.3247 48.8247 21.4706C48.4695 21.6101 48.0604 21.6799 47.5974 21.6799Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M42.2008 21.6799C41.7632 21.6799 41.3414 21.6292 40.9355 21.5277C40.5359 21.4199 40.2188 21.2867 39.9841 21.1281L40.4788 20.0626C40.7135 20.2085 40.9894 20.329 41.3065 20.4241C41.63 20.5129 41.9471 20.5573 42.2579 20.5573C42.6003 20.5573 42.8414 20.5161 42.9809 20.4336C43.1268 20.3512 43.1997 20.237 43.1997 20.0912C43.1997 19.9706 43.1426 19.8819 43.0285 19.8248C42.9206 19.7614 42.7748 19.7138 42.5908 19.6821C42.4069 19.6504 42.204 19.6186 41.982 19.5869C41.7663 19.5552 41.5475 19.514 41.3255 19.4633C41.1036 19.4062 40.9006 19.3237 40.7167 19.2159C40.5327 19.1081 40.3837 18.9622 40.2695 18.7783C40.1617 18.5944 40.1078 18.3565 40.1078 18.0648C40.1078 17.7413 40.1998 17.4559 40.3837 17.2086C40.574 16.9612 40.8467 16.7678 41.2019 16.6282C41.557 16.4824 41.982 16.4094 42.4767 16.4094C42.8255 16.4094 43.1807 16.4475 43.5422 16.5236C43.9037 16.5997 44.205 16.7107 44.446 16.8566L43.9513 17.9126C43.7039 17.7667 43.4534 17.6684 43.1997 17.6176C42.9523 17.5606 42.7113 17.532 42.4767 17.532C42.1469 17.532 41.9059 17.5764 41.7536 17.6652C41.6014 17.754 41.5253 17.8682 41.5253 18.0077C41.5253 18.1345 41.5792 18.2297 41.687 18.2931C41.8012 18.3565 41.9503 18.4073 42.1342 18.4453C42.3181 18.4834 42.5179 18.5183 42.7335 18.55C42.9555 18.5753 43.1775 18.6166 43.3995 18.6736C43.6215 18.7307 43.8212 18.8132 43.9988 18.921C44.1828 19.0225 44.3318 19.1652 44.446 19.3491C44.5601 19.5267 44.6172 19.7614 44.6172 20.0531C44.6172 20.3702 44.5221 20.6525 44.3318 20.8998C44.1415 21.1408 43.8656 21.3311 43.5041 21.4706C43.149 21.6101 42.7145 21.6799 42.2008 21.6799Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M37.4932 21.6799C36.9097 21.6799 36.3959 21.5657 35.952 21.3374C35.5143 21.1091 35.175 20.7983 34.934 20.4051C34.693 20.0055 34.5725 19.5521 34.5725 19.0447C34.5725 18.5309 34.6898 18.0775 34.9245 17.6842C35.1655 17.2847 35.4921 16.9739 35.9044 16.7519C36.3167 16.5236 36.7828 16.4094 37.3029 16.4094C37.8039 16.4094 38.2542 16.5172 38.6538 16.7329C39.0597 16.9422 39.38 17.2466 39.6147 17.6462C39.8493 18.0394 39.9667 18.5119 39.9667 19.0637C39.9667 19.1208 39.9635 19.1874 39.9572 19.2635C39.9508 19.3332 39.9445 19.3998 39.9381 19.4633H35.7807V18.5975H39.158L38.5872 18.8544C38.5872 18.588 38.5333 18.3565 38.4255 18.1599C38.3177 17.9633 38.1686 17.8111 37.9783 17.7033C37.7881 17.5891 37.5661 17.532 37.3124 17.532C37.0587 17.532 36.8336 17.5891 36.6369 17.7033C36.4467 17.8111 36.2976 17.9665 36.1898 18.1694C36.082 18.366 36.0281 18.6007 36.0281 18.8734V19.1017C36.0281 19.3808 36.0883 19.6282 36.2088 19.8438C36.3357 20.0531 36.5101 20.2148 36.7321 20.329C36.9604 20.4368 37.2268 20.4907 37.5312 20.4907C37.8039 20.4907 38.0418 20.4495 38.2447 20.367C38.454 20.2846 38.6443 20.1609 38.8155 19.996L39.6052 20.8522C39.3705 21.1186 39.0756 21.3247 38.7204 21.4706C38.3652 21.6101 37.9561 21.6799 37.4932 21.6799Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M28.5376 21.6037V14.9442H31.4202C32.0164 14.9442 32.5301 15.0425 32.9614 15.2391C33.3927 15.4294 33.7256 15.7053 33.9603 16.0668C34.195 16.4283 34.3123 16.8596 34.3123 17.3606C34.3123 17.8553 34.195 18.2835 33.9603 18.645C33.7256 19.0001 33.3927 19.2729 32.9614 19.4631C32.5301 19.6534 32.0164 19.7485 31.4202 19.7485H29.3938L30.0788 19.0731V21.6037H28.5376ZM32.7711 21.6037L31.1062 19.1872H32.7521L34.436 21.6037H32.7711ZM30.0788 19.2443L29.3938 18.5213H31.3346C31.8102 18.5213 32.1654 18.4198 32.4001 18.2169C32.6348 18.0076 32.7521 17.7222 32.7521 17.3606C32.7521 16.9928 32.6348 16.7074 32.4001 16.5044C32.1654 16.3015 31.8102 16.2 31.3346 16.2H29.3938L30.0788 15.4675V19.2443Z",
    fill: "#333333"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8829 19.6216C11.4599 19.6216 10.3063 20.7752 10.3063 22.1982C10.3063 23.6212 11.4599 24.7747 12.8829 24.7747C14.3059 24.7747 15.4595 23.6212 15.4595 22.1982C15.4595 20.7752 14.3059 19.6216 12.8829 19.6216ZM6.73877 22.1982C6.73877 18.8048 9.4896 16.054 12.8829 16.054C16.2762 16.054 19.0271 18.8048 19.0271 22.1982C19.0271 25.5915 16.2762 28.3423 12.8829 28.3423C9.4896 28.3423 6.73877 25.5915 6.73877 22.1982Z",
    fill: "#0D9FDE"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7928 23.7838C21.8076 23.7838 21.009 22.9852 21.009 22C21.009 26.4879 17.3708 30.1261 12.8829 30.1261C11.8977 30.1261 11.0991 30.9247 11.0991 31.9099C11.0991 32.8952 11.8977 33.6937 12.8829 33.6937C19.3412 33.6937 24.5766 28.4582 24.5766 22C24.5766 22.9852 23.7781 23.7838 22.7928 23.7838Z",
    fill: "#FD712D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M14.6666 12.0901C14.6666 13.0752 13.868 13.8738 12.8828 13.8738C17.3708 13.8738 21.0089 17.512 21.0089 22C21.0089 22.9851 21.8075 23.7838 22.7927 23.7838C23.778 23.7838 24.5765 22.9851 24.5765 22C24.5765 15.5417 19.3411 10.3063 12.8828 10.3063C13.868 10.3063 14.6666 11.1049 14.6666 12.0901Z",
    fill: "#FDB40F"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75678 22C4.75678 21.0148 3.95816 20.2162 2.97299 20.2162C1.98784 20.2162 1.18921 21.0148 1.18921 22C1.18921 28.4582 6.42465 33.6937 12.8829 33.6937C11.8977 33.6937 11.0991 32.8951 11.0991 31.9099C11.0991 30.9246 11.8977 30.1261 12.8829 30.1261C8.39496 30.1261 4.75678 26.4879 4.75678 22Z",
    fill: "#EB1362"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75678 22C4.75678 17.512 8.39496 13.8738 12.8829 13.8738C13.8681 13.8738 14.6667 13.0752 14.6667 12.0901C14.6667 11.1049 13.8681 10.3063 12.8829 10.3063C6.42465 10.3063 1.18921 15.5417 1.18921 22C1.18921 21.0148 1.98784 20.2162 2.97299 20.2162C3.95816 20.2162 4.75678 21.0148 4.75678 22Z",
    fill: "#BC2283"
  }
)), Z7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", ...e }, /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9985 17.3567C18.4165 17.3567 17.1341 18.6392 17.1341 20.2211C17.1341 21.8031 18.4165 23.0855 19.9985 23.0855C21.5804 23.0855 22.8629 21.8031 22.8629 20.2211C22.8629 18.6392 21.5804 17.3567 19.9985 17.3567ZM13.168 20.2211C13.168 16.4488 16.2261 13.3906 19.9985 13.3906C23.7709 13.3906 26.829 16.4488 26.829 20.2211C26.829 23.9935 23.7709 27.0516 19.9985 27.0516C16.2261 27.0516 13.168 23.9935 13.168 20.2211Z",
    fill: "#0D9FDE"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0156 21.9831C29.9203 21.9831 29.0326 21.0952 29.0326 20C29.0326 24.9893 24.988 29.0339 19.9987 29.0339C18.9035 29.0339 18.0156 29.9216 18.0156 31.0169C18.0156 32.1123 18.9035 33 19.9987 33C27.1784 33 32.9987 27.1797 32.9987 20C32.9987 21.0952 32.1109 21.9831 31.0156 21.9831Z",
    fill: "#FD712D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M21.9831 8.98305C21.9831 10.0783 21.0952 10.9661 20 10.9661C24.9893 10.9661 29.0339 15.0107 29.0339 20C29.0339 21.0952 29.9216 21.983 31.0169 21.983C32.1123 21.983 33 21.0952 33 20C33 12.8203 27.1797 7 20 7C21.0952 7 21.9831 7.88784 21.9831 8.98305Z",
    fill: "#FDB40F"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9661 19.9987C10.9661 18.9035 10.0783 18.0156 8.98305 18.0156C7.88784 18.0156 7 18.9035 7 19.9987C7 27.1784 12.8203 32.9987 20 32.9987C18.9048 32.9987 18.0169 32.1109 18.0169 31.0156C18.0169 29.9203 18.9048 29.0326 20 29.0326C15.0107 29.0326 10.9661 24.988 10.9661 19.9987Z",
    fill: "#EB1362"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9661 20C10.9661 15.0107 15.0107 10.9661 20 10.9661C21.0952 10.9661 21.983 10.0783 21.983 8.98305C21.983 7.88784 21.0952 7 20 7C12.8203 7 7 12.8203 7 20C7 18.9048 7.88784 18.0169 8.98305 18.0169C10.0783 18.0169 10.9661 18.9048 10.9661 20Z",
    fill: "#BC2283"
  }
)), D7 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 95, height: 36, viewBox: "0 0 95 36", fill: "none", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M92.2618 26.0272V18.5038H93.864V26.0272H92.2618Z", fill: "white" }), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M89.8257 26.0273V24.9627L89.7231 24.7295V22.8232C89.7231 22.4853 89.617 22.2216 89.4047 22.0324C89.1993 21.8431 88.8809 21.7485 88.4495 21.7485C88.1551 21.7485 87.8642 21.7958 87.5766 21.8905C87.2959 21.9783 87.0563 22.1 86.8576 22.2555L86.2826 21.1503C86.5839 20.9407 86.9467 20.7785 87.3712 20.6635C87.7956 20.5486 88.227 20.4912 88.6652 20.4912C89.5074 20.4912 90.1613 20.6872 90.6269 21.0793C91.0925 21.4713 91.3252 22.083 91.3252 22.9145V26.0273H89.8257ZM88.1414 26.1084C87.7101 26.1084 87.3404 26.0374 87.0323 25.8955C86.7242 25.7468 86.488 25.5474 86.3236 25.2973C86.1593 25.0471 86.0771 24.7666 86.0771 24.4557C86.0771 24.1313 86.1559 23.8474 86.3133 23.604C86.4776 23.3606 86.7345 23.1713 87.0836 23.0362C87.4328 22.8942 87.8882 22.8232 88.4495 22.8232H89.9183V23.7459H88.6242C88.2475 23.7459 87.9874 23.8067 87.8436 23.9285C87.7067 24.0501 87.6383 24.2022 87.6383 24.3847C87.6383 24.5875 87.7169 24.7498 87.8745 24.8714C88.0388 24.9864 88.2613 25.0438 88.542 25.0438C88.809 25.0438 89.0487 24.9829 89.2609 24.8612C89.4732 24.7328 89.6272 24.5469 89.7231 24.3036L89.9695 25.0337C89.8532 25.3852 89.6409 25.6522 89.3328 25.8346C89.0247 26.0172 88.6275 26.1084 88.1414 26.1084Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M84.7463 26.1084C84.0959 26.1084 83.5892 25.9461 83.2264 25.6217C82.8634 25.2904 82.682 24.8004 82.682 24.1515V19.3657H84.2842V24.1312C84.2842 24.3611 84.3458 24.5401 84.469 24.6685C84.5923 24.7902 84.7601 24.8511 84.9723 24.8511C85.2256 24.8511 85.4413 24.7835 85.6193 24.6483L86.0507 25.7636C85.8863 25.8785 85.6878 25.9665 85.455 26.0273C85.229 26.0813 84.9928 26.1084 84.7463 26.1084ZM81.8295 21.9107V20.6939H85.6604V21.9107H81.8295Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M78.427 26.0273V20.5723H79.9573V22.1135L79.7416 21.6674C79.9059 21.2821 80.1695 20.9914 80.5325 20.7954C80.8953 20.5925 81.3369 20.4912 81.8573 20.4912V21.9512C81.7888 21.9445 81.7272 21.9411 81.6725 21.9411C81.6176 21.9344 81.5594 21.931 81.4978 21.931C81.0596 21.931 80.7036 22.0561 80.4297 22.3061C80.1627 22.5494 80.0292 22.9314 80.0292 23.4518V26.0273H78.427Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M74.84 26.1084C74.2512 26.1084 73.7274 25.9867 73.2687 25.7434C72.8168 25.5001 72.4574 25.1688 72.1903 24.7498C71.9301 24.3239 71.8 23.8405 71.8 23.2997C71.8 22.7523 71.9301 22.2689 72.1903 21.8498C72.4574 21.424 72.8168 21.0928 73.2687 20.8562C73.7274 20.6129 74.2512 20.4912 74.84 20.4912C75.422 20.4912 75.9423 20.6129 76.4011 20.8562C76.8598 21.0928 77.2193 21.4207 77.4795 21.8397C77.7397 22.2588 77.8698 22.7455 77.8698 23.2997C77.8698 23.8405 77.7397 24.3239 77.4795 24.7498C77.2193 25.1688 76.8598 25.5001 76.4011 25.7434C75.9423 25.9867 75.422 26.1084 74.84 26.1084ZM74.84 24.8106C75.1071 24.8106 75.3468 24.7498 75.559 24.628C75.7712 24.5064 75.939 24.334 76.0622 24.1109C76.1855 23.8811 76.2471 23.6107 76.2471 23.2997C76.2471 22.9821 76.1855 22.7118 76.0622 22.4887C75.939 22.2656 75.7712 22.0932 75.559 21.9716C75.3468 21.8498 75.1071 21.789 74.84 21.789C74.573 21.789 74.3334 21.8498 74.1211 21.9716C73.9089 22.0932 73.7377 22.2656 73.6076 22.4887C73.4843 22.7118 73.4228 22.9821 73.4228 23.2997C73.4228 23.6107 73.4843 23.8811 73.6076 24.1109C73.7377 24.334 73.9089 24.5064 74.1211 24.628C74.3334 24.7498 74.573 24.8106 74.84 24.8106Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M65.4253 26.0272V18.9296H68.5372C69.1808 18.9296 69.7354 19.0343 70.201 19.2439C70.6666 19.4467 71.026 19.7408 71.2793 20.126C71.5327 20.5113 71.6593 20.971 71.6593 21.505C71.6593 22.0322 71.5327 22.4885 71.2793 22.8737C71.026 23.2591 70.6666 23.5565 70.201 23.766C69.7354 23.9688 69.1808 24.0702 68.5372 24.0702H66.3496L67.0891 23.3301V26.0272H65.4253ZM67.0891 23.5126L66.3496 22.7319H68.4448C68.9582 22.7319 69.3417 22.6237 69.595 22.4074C69.8483 22.1911 69.975 21.8902 69.975 21.505C69.975 21.113 69.8483 20.8088 69.595 20.5924C69.3417 20.3762 68.9582 20.268 68.4448 20.268H66.3496L67.0891 19.4872V23.5126Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M59.8339 26.1084C59.3615 26.1084 58.9062 26.0543 58.468 25.9462C58.0367 25.8313 57.6943 25.6894 57.441 25.5203L57.975 24.3847C58.2284 24.5402 58.5262 24.6686 58.8686 24.77C59.2177 24.8646 59.5601 24.912 59.8955 24.912C60.2653 24.912 60.5255 24.8681 60.6762 24.7801C60.8336 24.6923 60.9124 24.5706 60.9124 24.4151C60.9124 24.2867 60.8507 24.192 60.7274 24.1313C60.6111 24.0636 60.4536 24.013 60.255 23.9792C60.0565 23.9453 59.8374 23.9115 59.5977 23.8777C59.3649 23.8439 59.1287 23.8 58.8891 23.7459C58.6494 23.6851 58.4304 23.5972 58.2317 23.4823C58.0332 23.3674 57.8724 23.2119 57.7491 23.0159C57.6327 22.8198 57.5745 22.5664 57.5745 22.2555C57.5745 21.9107 57.6737 21.6065 57.8724 21.3429C58.0777 21.0793 58.3722 20.8731 58.7555 20.7244C59.139 20.5689 59.5977 20.4912 60.1317 20.4912C60.5084 20.4912 60.8917 20.5318 61.282 20.6129C61.6724 20.694 61.9975 20.8123 62.2577 20.9677L61.7236 22.0932C61.4567 21.9378 61.1862 21.833 60.9124 21.7789C60.6453 21.718 60.3851 21.6876 60.1317 21.6876C59.7757 21.6876 59.5155 21.735 59.3512 21.8296C59.1869 21.9242 59.1048 22.0458 59.1048 22.1946C59.1048 22.3298 59.163 22.4312 59.2793 22.4988C59.4026 22.5664 59.5635 22.6204 59.762 22.661C59.9606 22.7015 60.1763 22.7387 60.4091 22.7725C60.6487 22.7996 60.8884 22.8435 61.1279 22.9043C61.3676 22.9652 61.5833 23.053 61.775 23.168C61.9736 23.2761 62.1345 23.4283 62.2577 23.6243C62.381 23.8136 62.4426 24.0636 62.4426 24.3746C62.4426 24.7126 62.3398 25.0133 62.1345 25.277C61.9291 25.5339 61.6312 25.7367 61.241 25.8854C60.8575 26.034 60.3886 26.1084 59.8339 26.1084Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M56.2849 26.1084C55.6345 26.1084 55.1279 25.9461 54.7649 25.6217C54.4021 25.2904 54.2206 24.8004 54.2206 24.1515V19.3657H55.8228V24.1312C55.8228 24.3611 55.8844 24.5401 56.0077 24.6685C56.1309 24.7902 56.2986 24.8511 56.5109 24.8511C56.7642 24.8511 56.9799 24.7835 57.1579 24.6483L57.5892 25.7636C57.4249 25.8785 57.2264 25.9665 56.9936 26.0273C56.7677 26.0813 56.5315 26.1084 56.2849 26.1084ZM53.3682 21.9107V20.6939H57.199V21.9107H53.3682Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M50.7967 20.4912C51.2349 20.4912 51.6252 20.5791 51.9675 20.7549C52.3167 20.9238 52.5906 21.1875 52.7891 21.5457C52.9876 21.8972 53.087 22.35 53.087 22.9043V26.0273H51.4848V23.1477C51.4848 22.7083 51.3855 22.3839 51.187 22.1743C50.9952 21.9647 50.7214 21.86 50.3653 21.86C50.1121 21.86 49.8827 21.9141 49.6772 22.0222C49.4787 22.1236 49.3212 22.2825 49.2048 22.4988C49.0952 22.7151 49.0405 22.9923 49.0405 23.3302V26.0273H47.4384V20.5723H48.9686V22.083L48.681 21.6268C48.8795 21.2617 49.1637 20.9812 49.5334 20.7852C49.9032 20.5892 50.3243 20.4912 50.7967 20.4912Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M45.002 26.0273V24.9627L44.8993 24.7295V22.8232C44.8993 22.4853 44.7932 22.2216 44.5809 22.0324C44.3755 21.8431 44.0571 21.7485 43.6257 21.7485C43.3313 21.7485 43.0404 21.7958 42.7528 21.8905C42.4721 21.9783 42.2325 22.1 42.0338 22.2555L41.4588 21.1503C41.7601 20.9407 42.1229 20.7785 42.5474 20.6635C42.972 20.5486 43.4032 20.4912 43.8414 20.4912C44.6836 20.4912 45.3375 20.6872 45.8031 21.0793C46.2687 21.4713 46.5014 22.083 46.5014 22.9145V26.0273H45.002ZM43.3176 26.1084C42.8864 26.1084 42.5166 26.0374 42.2085 25.8955C41.9004 25.7468 41.6642 25.5474 41.4998 25.2973C41.3355 25.0471 41.2533 24.7666 41.2533 24.4557C41.2533 24.1313 41.3321 23.8474 41.4895 23.604C41.6539 23.3606 41.9107 23.1713 42.2598 23.0362C42.609 22.8942 43.0644 22.8232 43.6257 22.8232H45.0945V23.7459H43.8004C43.4238 23.7459 43.1636 23.8067 43.0198 23.9285C42.8829 24.0501 42.8145 24.2022 42.8145 24.3847C42.8145 24.5875 42.8932 24.7498 43.0507 24.8714C43.215 24.9864 43.4375 25.0438 43.7183 25.0438C43.9852 25.0438 44.2249 24.9829 44.4371 24.8612C44.6494 24.7328 44.8034 24.5469 44.8993 24.3036L45.1457 25.0337C45.0294 25.3852 44.8171 25.6522 44.509 25.8346C44.2009 26.0172 43.8038 26.1084 43.3176 26.1084Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M38.1041 26.0273V20.5723H39.6343V22.1135L39.4186 21.6674C39.5829 21.2821 39.8466 20.9914 40.2095 20.7954C40.5723 20.5925 41.014 20.4912 41.5343 20.4912V21.9512C41.4659 21.9445 41.4042 21.9411 41.3495 21.9411C41.2947 21.9344 41.2365 21.931 41.1748 21.931C40.7366 21.931 40.3806 22.0561 40.1067 22.3061C39.8398 22.5494 39.7062 22.9314 39.7062 23.4518V26.0273H38.1041Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M34.2786 26.1487C33.7103 26.1487 33.1865 26.0609 32.7072 25.8851C32.2348 25.7026 31.8206 25.4457 31.4645 25.1145C31.1154 24.7833 30.8415 24.3946 30.6429 23.9485C30.4512 23.5024 30.3554 23.0123 30.3554 22.4782C30.3554 21.9443 30.4512 21.4542 30.6429 21.0081C30.8415 20.562 31.1188 20.1733 31.4748 19.842C31.8308 19.5108 32.2485 19.2573 32.7278 19.0816C33.207 18.8991 33.7343 18.8078 34.3095 18.8078C34.9462 18.8078 35.5179 18.9125 36.0245 19.1222C36.5381 19.3317 36.9695 19.6359 37.3186 20.0347L36.2505 21.0081C35.9903 20.7377 35.7062 20.5383 35.3981 20.4099C35.09 20.2746 34.7544 20.207 34.3916 20.207C34.0424 20.207 33.724 20.2611 33.4364 20.3693C33.1488 20.4774 32.8989 20.6329 32.6867 20.8356C32.4812 21.0385 32.3204 21.2785 32.204 21.5556C32.0944 21.8327 32.0397 22.1403 32.0397 22.4782C32.0397 22.8095 32.0944 23.1137 32.204 23.3908C32.3204 23.668 32.4812 23.9113 32.6867 24.1208C32.8989 24.3237 33.1455 24.4792 33.4262 24.5872C33.7138 24.6954 34.0287 24.7495 34.371 24.7495C34.6997 24.7495 35.0181 24.6988 35.3262 24.5975C35.6411 24.4893 35.9458 24.3101 36.2402 24.06L37.185 25.2463C36.7948 25.537 36.3395 25.76 35.8191 25.9155C35.3057 26.071 34.7921 26.1487 34.2786 26.1487ZM35.665 25.0334V22.3668H37.185V25.2463L35.665 25.0334Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M72.9938 12.0416C73.432 12.0416 73.8222 12.1294 74.1647 12.3052C74.5138 12.4742 74.7877 12.7378 74.9862 13.0961C75.1848 13.4476 75.284 13.9004 75.284 14.4548V17.5777H73.6819V14.6981C73.6819 14.2588 73.5827 13.9342 73.384 13.7247C73.1923 13.5152 72.9184 13.4104 72.5624 13.4104C72.3091 13.4104 72.0797 13.4645 71.8743 13.5726C71.6758 13.6741 71.5183 13.8329 71.4019 14.0492C71.2923 14.2655 71.2376 14.5427 71.2376 14.8806V17.5777H69.6354V10.0542H71.2376V13.6335L70.8781 13.1772C71.0767 12.8122 71.3609 12.5316 71.7306 12.3356C72.1003 12.1396 72.5214 12.0416 72.9938 12.0416Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M66.7813 17.6588C66.1857 17.6588 65.655 17.5405 65.1895 17.3039C64.7239 17.0606 64.3576 16.7261 64.0905 16.3002C63.8304 15.8743 63.7003 15.3911 63.7003 14.8503C63.7003 14.3027 63.8304 13.8194 64.0905 13.4003C64.3576 12.9745 64.7239 12.6432 65.1895 12.4066C65.655 12.1633 66.1857 12.0416 66.7813 12.0416C67.3633 12.0416 67.87 12.1633 68.3013 12.4066C68.7327 12.6432 69.0511 12.9846 69.2565 13.4308L68.0138 14.0898C67.87 13.8329 67.6886 13.6437 67.4695 13.522C67.2572 13.4003 67.0244 13.3395 66.7711 13.3395C66.4972 13.3395 66.2507 13.4003 66.0317 13.522C65.8125 13.6437 65.638 13.816 65.5079 14.0391C65.3846 14.2622 65.323 14.5326 65.323 14.8503C65.323 15.168 65.3846 15.4384 65.5079 15.6613C65.638 15.8844 65.8125 16.0569 66.0317 16.1785C66.2507 16.3002 66.4972 16.361 66.7711 16.361C67.0244 16.361 67.2572 16.3036 67.4695 16.1887C67.6886 16.067 67.87 15.8743 68.0138 15.6107L69.2565 16.2799C69.0511 16.7192 68.7327 17.0606 68.3013 17.3039C67.87 17.5405 67.3633 17.6588 66.7813 17.6588Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M60.2819 17.5777V12.1227H61.8122V13.6639L61.5965 13.2178C61.7608 12.8325 62.0244 12.5419 62.3874 12.3458C62.7502 12.1431 63.1918 12.0416 63.7122 12.0416V13.5017C63.6437 13.4949 63.5821 13.4916 63.5274 13.4916C63.4725 13.4848 63.4143 13.4814 63.3527 13.4814C62.9145 13.4814 62.5585 13.6065 62.2846 13.8565C62.0176 14.1 61.8841 14.4818 61.8841 15.0024V17.5777H60.2819Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M57.8456 17.5777V16.5131L57.7428 16.2799V14.3737C57.7428 14.0357 57.6367 13.7721 57.4245 13.5828C57.219 13.3936 56.9007 13.2989 56.4694 13.2989C56.1749 13.2989 55.884 13.3462 55.5964 13.4409C55.3157 13.5287 55.076 13.6504 54.8775 13.8059L54.3023 12.7007C54.6036 12.4912 54.9665 12.3289 55.3909 12.214C55.8155 12.099 56.2468 12.0416 56.685 12.0416C57.5273 12.0416 58.181 12.2377 58.6466 12.6297C59.1122 13.0218 59.345 13.6335 59.345 14.465V17.5777H57.8456ZM56.1613 17.6588C55.7299 17.6588 55.3602 17.5879 55.0521 17.4459C54.744 17.2972 54.5078 17.0978 54.3435 16.8477C54.179 16.5976 54.0969 16.3171 54.0969 16.0061C54.0969 15.6817 54.1757 15.3978 54.3331 15.1545C54.4975 14.911 54.7542 14.7219 55.1035 14.5866C55.4526 14.4446 55.9079 14.3737 56.4694 14.3737H57.938V15.2964H56.644C56.2674 15.2964 56.0073 15.3572 55.8635 15.4789C55.7265 15.6006 55.658 15.7527 55.658 15.9351C55.658 16.138 55.7367 16.3002 55.8942 16.4219C56.0585 16.5368 56.281 16.5942 56.5618 16.5942C56.8288 16.5942 57.0684 16.5334 57.2807 16.4117C57.4929 16.2832 57.647 16.0974 57.7428 15.854L57.9894 16.5841C57.8729 16.9356 57.6607 17.2026 57.3526 17.385C57.0445 17.5676 56.6474 17.6588 56.1613 17.6588Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M51.3835 17.6588C50.7536 17.6588 50.1991 17.5371 49.7197 17.2938C49.2473 17.0505 48.881 16.7192 48.6209 16.3002C48.3607 15.8743 48.2306 15.3911 48.2306 14.8503C48.2306 14.3027 48.3573 13.8194 48.6106 13.4003C48.8708 12.9745 49.2234 12.6432 49.6684 12.4066C50.1135 12.1633 50.6167 12.0416 51.1781 12.0416C51.7191 12.0416 52.2052 12.1565 52.6366 12.3864C53.0748 12.6095 53.4205 12.9339 53.6738 13.3598C53.9272 13.7788 54.0538 14.2824 54.0538 14.8705C54.0538 14.9314 54.0503 15.0024 54.0435 15.0835C54.0367 15.1578 54.0298 15.2287 54.023 15.2964H49.5349V14.3737H53.1809L52.5647 14.6475C52.5647 14.3635 52.5064 14.1168 52.39 13.9073C52.2736 13.6977 52.1128 13.5355 51.9073 13.4206C51.7019 13.2989 51.4622 13.2381 51.1884 13.2381C50.9146 13.2381 50.6715 13.2989 50.4592 13.4206C50.2538 13.5355 50.0929 13.7011 49.9766 13.9174C49.8601 14.1269 49.8019 14.3771 49.8019 14.6677V14.911C49.8019 15.2085 49.867 15.4722 49.9971 15.7019C50.134 15.925 50.3222 16.0974 50.5619 16.2191C50.8084 16.334 51.096 16.3914 51.4247 16.3914C51.7191 16.3914 51.9758 16.3475 52.1949 16.2596C52.4209 16.1718 52.6262 16.0399 52.8111 15.8642L53.6635 16.7767C53.4102 17.0606 53.0918 17.2803 52.7085 17.4358C52.325 17.5845 51.8834 17.6588 51.3835 17.6588Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M45.5577 17.6588C45.0853 17.6588 44.6299 17.6048 44.1918 17.4966C43.7604 17.3817 43.418 17.2398 43.1647 17.0707L43.6987 15.9351C43.9521 16.0906 44.2499 16.2191 44.5923 16.3204C44.9415 16.4151 45.2838 16.4624 45.6193 16.4624C45.989 16.4624 46.2493 16.4185 46.3999 16.3306C46.5574 16.2427 46.6361 16.121 46.6361 15.9656C46.6361 15.8371 46.5744 15.7426 46.4512 15.6817C46.3348 15.6141 46.1774 15.5634 45.9787 15.5296C45.7802 15.4958 45.5612 15.4619 45.3215 15.4281C45.0886 15.3944 44.8524 15.3505 44.6128 15.2964C44.3732 15.2356 44.1541 15.1476 43.9555 15.0327C43.7569 14.9178 43.5961 14.7623 43.4728 14.5664C43.3564 14.3704 43.2982 14.1168 43.2982 13.8059C43.2982 13.4611 43.3975 13.1569 43.5961 12.8934C43.8015 12.6297 44.0959 12.4236 44.4793 12.2748C44.8627 12.1194 45.3215 12.0416 45.8555 12.0416C46.2321 12.0416 46.6155 12.0822 47.0058 12.1633C47.3961 12.2444 47.7213 12.3627 47.9815 12.5182L47.4474 13.6437C47.1804 13.4882 46.9099 13.3834 46.6361 13.3293C46.369 13.2685 46.1088 13.2381 45.8555 13.2381C45.4995 13.2381 45.2393 13.2854 45.0749 13.38C44.9106 13.4747 44.8285 13.5964 44.8285 13.7451C44.8285 13.8802 44.8867 13.9817 45.003 14.0492C45.1263 14.1168 45.2873 14.1709 45.4858 14.2114C45.6843 14.252 45.9 14.2892 46.1328 14.323C46.3724 14.35 46.6121 14.394 46.8518 14.4548C47.0914 14.5156 47.307 14.6035 47.4987 14.7184C47.6974 14.8266 47.8582 14.9787 47.9815 15.1747C48.1047 15.364 48.1663 15.6141 48.1663 15.925C48.1663 16.263 48.0636 16.5639 47.8582 16.8274C47.6528 17.0843 47.3549 17.2871 46.9647 17.4358C46.5813 17.5845 46.1123 17.6588 45.5577 17.6588Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M40.4756 17.6588C39.8457 17.6588 39.291 17.5371 38.8118 17.2938C38.3393 17.0505 37.973 16.7192 37.7129 16.3002C37.4527 15.8743 37.3226 15.3911 37.3226 14.8503C37.3226 14.3027 37.4492 13.8194 37.7026 13.4003C37.9628 12.9745 38.3154 12.6432 38.7604 12.4066C39.2055 12.1633 39.7087 12.0416 40.2702 12.0416C40.811 12.0416 41.2972 12.1565 41.7286 12.3864C42.1667 12.6095 42.5125 12.9339 42.7659 13.3598C43.0191 13.7788 43.1459 14.2824 43.1459 14.8705C43.1459 14.9314 43.1424 15.0024 43.1356 15.0835C43.1287 15.1578 43.1219 15.2287 43.115 15.2964H38.6269V14.3737H42.2729L41.6567 14.6475C41.6567 14.3635 41.5985 14.1168 41.4821 13.9073C41.3657 13.6977 41.2048 13.5355 40.9993 13.4206C40.794 13.2989 40.5543 13.2381 40.2805 13.2381C40.0066 13.2381 39.7636 13.2989 39.5512 13.4206C39.3459 13.5355 39.1849 13.7011 39.0686 13.9174C38.9522 14.1269 38.894 14.3771 38.894 14.6677V14.911C38.894 15.2085 38.959 15.4722 39.0891 15.7019C39.2261 15.925 39.4143 16.0974 39.654 16.2191C39.9005 16.334 40.188 16.3914 40.5167 16.3914C40.811 16.3914 41.0679 16.3475 41.2869 16.2596C41.5129 16.1718 41.7183 16.0399 41.9031 15.8642L42.7556 16.7767C42.5023 17.0606 42.1839 17.2803 41.8005 17.4358C41.417 17.5845 40.9754 17.6588 40.4756 17.6588Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M30.8076 17.5776V10.48H33.9195C34.5632 10.48 35.1177 10.5848 35.5833 10.7943C36.0489 10.9971 36.4083 11.2912 36.6617 11.6765C36.9151 12.0617 37.0417 12.5214 37.0417 13.0554C37.0417 13.5826 36.9151 14.039 36.6617 14.4243C36.4083 14.8027 36.0489 15.0935 35.5833 15.2962C35.1177 15.499 34.5632 15.6004 33.9195 15.6004H31.732L32.4714 14.8805V17.5776H30.8076ZM35.3779 17.5776L33.5806 15.0021H35.3574L37.1752 17.5776H35.3779ZM32.4714 15.063L31.732 14.2924H33.8271C34.3406 14.2924 34.724 14.1843 34.9774 13.968C35.2308 13.7449 35.3574 13.4408 35.3574 13.0554C35.3574 12.6634 35.2308 12.3592 34.9774 12.1428C34.724 11.9266 34.3406 11.8184 33.8271 11.8184H31.732L32.4714 11.0377V15.063Z",
    fill: "white"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9077 15.4651C12.3715 15.4651 11.1261 16.6946 11.1261 18.2112C11.1261 19.7279 12.3715 20.9572 13.9077 20.9572C15.4439 20.9572 16.6892 19.7279 16.6892 18.2112C16.6892 16.6946 15.4439 15.4651 13.9077 15.4651ZM7.27481 18.2112C7.27481 14.5946 10.2445 11.6628 13.9077 11.6628C17.5709 11.6628 20.5406 14.5946 20.5406 18.2112C20.5406 21.8278 17.5709 24.7596 13.9077 24.7596C10.2445 24.7596 7.27481 21.8278 7.27481 18.2112Z",
    fill: "#0D9FDE"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6058 19.9012C23.5423 19.9012 22.6802 19.05 22.6802 18C22.6802 22.7832 18.7525 26.6607 13.9077 26.6607C12.8441 26.6607 11.982 27.5119 11.982 28.5619C11.982 29.612 12.8441 30.463 13.9077 30.463C20.8797 30.463 26.5315 24.8831 26.5315 18C26.5315 19.05 25.6695 19.9012 24.6058 19.9012Z",
    fill: "#FD712D"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    d: "M15.8333 7.43813C15.8333 8.48804 14.9712 9.33918 13.9076 9.33918C18.7526 9.33918 22.6801 13.2167 22.6801 18C22.6801 19.0499 23.5422 19.9011 24.6058 19.9011C25.6695 19.9011 26.5315 19.0499 26.5315 18C26.5315 11.1168 20.8796 5.53697 13.9076 5.53697C14.9712 5.53697 15.8333 6.38811 15.8333 7.43813Z",
    fill: "#FDB40F"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13517 18C5.13517 16.95 4.27302 16.0988 3.20948 16.0988C2.14597 16.0988 1.28381 16.95 1.28381 18C1.28381 24.8831 6.93571 30.463 13.9077 30.463C12.8441 30.463 11.982 29.6119 11.982 28.5619C11.982 27.5117 12.8441 26.6607 13.9077 26.6607C9.06275 26.6607 5.13517 22.7832 5.13517 18Z",
    fill: "#EB1362"
  }
), /* @__PURE__ */ t.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13517 18C5.13517 13.2167 9.06275 9.33918 13.9077 9.33918C14.9713 9.33918 15.8334 8.48804 15.8334 7.43813C15.8334 6.38811 14.9713 5.53697 13.9077 5.53697C6.93571 5.53697 1.28381 11.1168 1.28381 18C1.28381 16.95 2.14597 16.0988 3.20949 16.0988C4.27302 16.0988 5.13517 16.95 5.13517 18Z",
    fill: "#BC2283"
  }
)), o1 = ({ name: e, color: r, ...n }) => {
  const a = l5(), o = r && a.colors[r] || "currentColor";
  switch (e) {
    case "adjustments-outline":
      return /* @__PURE__ */ t.createElement(Ee, { color: o, style: { flexShrink: 0 }, ...n });
    case "archive-outline":
      return /* @__PURE__ */ t.createElement(ke, { color: o, style: { flexShrink: 0 }, ...n });
    case "arrow-down-outline":
      return /* @__PURE__ */ t.createElement(Le, { color: o, style: { flexShrink: 0 }, ...n });
    case "arrow-left-outline":
      return /* @__PURE__ */ t.createElement(xe, { color: o, style: { flexShrink: 0 }, ...n });
    case "arrow-right-outline":
      return /* @__PURE__ */ t.createElement(He, { color: o, style: { flexShrink: 0 }, ...n });
    case "arrow-up-outline":
      return /* @__PURE__ */ t.createElement(Me, { color: o, style: { flexShrink: 0 }, ...n });
    case "arrows-expand-outline":
      return /* @__PURE__ */ t.createElement(Ve, { color: o, style: { flexShrink: 0 }, ...n });
    case "at-symbol-outline":
      return /* @__PURE__ */ t.createElement($e, { color: o, style: { flexShrink: 0 }, ...n });
    case "ban-outline":
      return /* @__PURE__ */ t.createElement(Oe, { color: o, style: { flexShrink: 0 }, ...n });
    case "ban-solid":
      return /* @__PURE__ */ t.createElement(Se, { color: o, style: { flexShrink: 0 }, ...n });
    case "bell-outline":
      return /* @__PURE__ */ t.createElement(Ze, { color: o, style: { flexShrink: 0 }, ...n });
    case "bold-outline":
      return /* @__PURE__ */ t.createElement(De, { color: o, style: { flexShrink: 0 }, ...n });
    case "book-open-outline":
      return /* @__PURE__ */ t.createElement(_e, { color: o, style: { flexShrink: 0 }, ...n });
    case "bookmark-outline":
      return /* @__PURE__ */ t.createElement(Be, { color: o, style: { flexShrink: 0 }, ...n });
    case "briefcase-outline":
      return /* @__PURE__ */ t.createElement(Te, { color: o, style: { flexShrink: 0 }, ...n });
    case "calculator-outline":
      return /* @__PURE__ */ t.createElement(We, { color: o, style: { flexShrink: 0 }, ...n });
    case "calendar-outline":
      return /* @__PURE__ */ t.createElement(Re, { color: o, style: { flexShrink: 0 }, ...n });
    case "camera-outline":
      return /* @__PURE__ */ t.createElement(je, { color: o, style: { flexShrink: 0 }, ...n });
    case "chat-outline":
      return /* @__PURE__ */ t.createElement(Ae, { color: o, style: { flexShrink: 0 }, ...n });
    case "check-circle-outline":
      return /* @__PURE__ */ t.createElement(Ie, { color: o, style: { flexShrink: 0 }, ...n });
    case "check-circle-solid":
      return /* @__PURE__ */ t.createElement(Ne, { color: o, style: { flexShrink: 0 }, ...n });
    case "check-outline":
      return /* @__PURE__ */ t.createElement(Fe, { color: o, style: { flexShrink: 0 }, ...n });
    case "checkedbox-solid":
      return /* @__PURE__ */ t.createElement(Pe, { color: o, style: { flexShrink: 0 }, ...n });
    case "chevron-down-outline":
      return /* @__PURE__ */ t.createElement(Ge, { color: o, style: { flexShrink: 0 }, ...n });
    case "chevron-left-outline":
      return /* @__PURE__ */ t.createElement(ze, { color: o, style: { flexShrink: 0 }, ...n });
    case "chevron-right-outline":
      return /* @__PURE__ */ t.createElement(Ye, { color: o, style: { flexShrink: 0 }, ...n });
    case "chevron-up-outline":
      return /* @__PURE__ */ t.createElement(Ue, { color: o, style: { flexShrink: 0 }, ...n });
    case "clipboard-check-outline":
      return /* @__PURE__ */ t.createElement(qe, { color: o, style: { flexShrink: 0 }, ...n });
    case "clipboard-copy-outline":
      return /* @__PURE__ */ t.createElement(Xe, { color: o, style: { flexShrink: 0 }, ...n });
    case "clipboard-list-outline":
      return /* @__PURE__ */ t.createElement(Ke, { color: o, style: { flexShrink: 0 }, ...n });
    case "clipboard-outline":
      return /* @__PURE__ */ t.createElement(Je, { color: o, style: { flexShrink: 0 }, ...n });
    case "clock-outline":
      return /* @__PURE__ */ t.createElement(Qe, { color: o, style: { flexShrink: 0 }, ...n });
    case "clock-solid":
      return /* @__PURE__ */ t.createElement(e8, { color: o, style: { flexShrink: 0 }, ...n });
    case "cloud-download-outline":
      return /* @__PURE__ */ t.createElement(t8, { color: o, style: { flexShrink: 0 }, ...n });
    case "cloud-outline":
      return /* @__PURE__ */ t.createElement(r8, { color: o, style: { flexShrink: 0 }, ...n });
    case "cloud-upload-outline":
      return /* @__PURE__ */ t.createElement(n8, { color: o, style: { flexShrink: 0 }, ...n });
    case "cog-outline":
      return /* @__PURE__ */ t.createElement(o8, { color: o, style: { flexShrink: 0 }, ...n });
    case "credit-card-outline":
      return /* @__PURE__ */ t.createElement(a8, { color: o, style: { flexShrink: 0 }, ...n });
    case "cursor-click-outline":
      return /* @__PURE__ */ t.createElement(i8, { color: o, style: { flexShrink: 0 }, ...n });
    case "delete-bin-outline":
      return /* @__PURE__ */ t.createElement(l8, { color: o, style: { flexShrink: 0 }, ...n });
    case "delete-column-outline":
      return /* @__PURE__ */ t.createElement(c8, { color: o, style: { flexShrink: 0 }, ...n });
    case "delete-row-outline":
      return /* @__PURE__ */ t.createElement(C8, { color: o, style: { flexShrink: 0 }, ...n });
    case "divider-outline":
      return /* @__PURE__ */ t.createElement(s8, { color: o, style: { flexShrink: 0 }, ...n });
    case "document-add-outline":
      return /* @__PURE__ */ t.createElement(u8, { color: o, style: { flexShrink: 0 }, ...n });
    case "document-download-outline":
      return /* @__PURE__ */ t.createElement(d8, { color: o, style: { flexShrink: 0 }, ...n });
    case "document-duplicate-outline":
      return /* @__PURE__ */ t.createElement(f8, { color: o, style: { flexShrink: 0 }, ...n });
    case "document-outline":
      return /* @__PURE__ */ t.createElement(m8, { color: o, style: { flexShrink: 0 }, ...n });
    case "document-remove-outline":
      return /* @__PURE__ */ t.createElement(h8, { color: o, style: { flexShrink: 0 }, ...n });
    case "document-search-outline":
      return /* @__PURE__ */ t.createElement(v8, { color: o, style: { flexShrink: 0 }, ...n });
    case "document-text-outline":
      return /* @__PURE__ */ t.createElement(g8, { color: o, style: { flexShrink: 0 }, ...n });
    case "dots-circle-horizontal-solid":
      return /* @__PURE__ */ t.createElement(p8, { color: o, style: { flexShrink: 0 }, ...n });
    case "dots-horizontal-outline":
      return /* @__PURE__ */ t.createElement(y8, { color: o, style: { flexShrink: 0 }, ...n });
    case "dots-vertical-outline":
      return /* @__PURE__ */ t.createElement(w8, { color: o, style: { flexShrink: 0 }, ...n });
    case "download-outline":
      return /* @__PURE__ */ t.createElement(b8, { color: o, style: { flexShrink: 0 }, ...n });
    case "dropdown-solid":
      return /* @__PURE__ */ t.createElement(E8, { color: o, style: { flexShrink: 0 }, ...n });
    case "duplicate-outline":
      return /* @__PURE__ */ t.createElement(k8, { color: o, style: { flexShrink: 0 }, ...n });
    case "edit-outline":
      return /* @__PURE__ */ t.createElement(L8, { color: o, style: { flexShrink: 0 }, ...n });
    case "exclamation-circle-solid":
      return /* @__PURE__ */ t.createElement(x8, { color: o, style: { flexShrink: 0 }, ...n });
    case "exclamation-solid":
      return /* @__PURE__ */ t.createElement(H8, { color: o, style: { flexShrink: 0 }, ...n });
    case "external-link-outline":
      return /* @__PURE__ */ t.createElement(M8, { color: o, style: { flexShrink: 0 }, ...n });
    case "eye-off-outline":
      return /* @__PURE__ */ t.createElement(V8, { color: o, style: { flexShrink: 0 }, ...n });
    case "eye-off-solid":
      return /* @__PURE__ */ t.createElement($8, { color: o, style: { flexShrink: 0 }, ...n });
    case "eye-outline":
      return /* @__PURE__ */ t.createElement(O8, { color: o, style: { flexShrink: 0 }, ...n });
    case "eye-solid":
      return /* @__PURE__ */ t.createElement(S8, { color: o, style: { flexShrink: 0 }, ...n });
    case "filter-outline":
      return /* @__PURE__ */ t.createElement(Z8, { color: o, style: { flexShrink: 0 }, ...n });
    case "finger-print-outline":
      return /* @__PURE__ */ t.createElement(D8, { color: o, style: { flexShrink: 0 }, ...n });
    case "folder-add-outline":
      return /* @__PURE__ */ t.createElement(_8, { color: o, style: { flexShrink: 0 }, ...n });
    case "folder-download-outline":
      return /* @__PURE__ */ t.createElement(B8, { color: o, style: { flexShrink: 0 }, ...n });
    case "folder-open-outline":
      return /* @__PURE__ */ t.createElement(T8, { color: o, style: { flexShrink: 0 }, ...n });
    case "folder-outline":
      return /* @__PURE__ */ t.createElement(W8, { color: o, style: { flexShrink: 0 }, ...n });
    case "folder-remove-outline":
      return /* @__PURE__ */ t.createElement(R8, { color: o, style: { flexShrink: 0 }, ...n });
    case "form-outline":
      return /* @__PURE__ */ t.createElement(j8, { color: o, style: { flexShrink: 0 }, ...n });
    case "globe-alt-outline":
      return /* @__PURE__ */ t.createElement(A8, { color: o, style: { flexShrink: 0 }, ...n });
    case "globe-outline":
      return /* @__PURE__ */ t.createElement(I8, { color: o, style: { flexShrink: 0 }, ...n });
    case "hand-outline":
      return /* @__PURE__ */ t.createElement(N8, { color: o, style: { flexShrink: 0 }, ...n });
    case "heading-outline":
      return /* @__PURE__ */ t.createElement(F8, { color: o, style: { flexShrink: 0 }, ...n });
    case "heart-outline":
      return /* @__PURE__ */ t.createElement(P8, { color: o, style: { flexShrink: 0 }, ...n });
    case "home-outline":
      return /* @__PURE__ */ t.createElement(G8, { color: o, style: { flexShrink: 0 }, ...n });
    case "identification-outline":
      return /* @__PURE__ */ t.createElement(z8, { color: o, style: { flexShrink: 0 }, ...n });
    case "inbox-in-outline":
      return /* @__PURE__ */ t.createElement(Y8, { color: o, style: { flexShrink: 0 }, ...n });
    case "inbox-outline":
      return /* @__PURE__ */ t.createElement(U8, { color: o, style: { flexShrink: 0 }, ...n });
    case "information-circle-solid":
      return /* @__PURE__ */ t.createElement(q8, { color: o, style: { flexShrink: 0 }, ...n });
    case "insert-column-left-outline":
      return /* @__PURE__ */ t.createElement(X8, { color: o, style: { flexShrink: 0 }, ...n });
    case "insert-column-right-outline":
      return /* @__PURE__ */ t.createElement(K8, { color: o, style: { flexShrink: 0 }, ...n });
    case "insert-row-bottom-outline":
      return /* @__PURE__ */ t.createElement(J8, { color: o, style: { flexShrink: 0 }, ...n });
    case "insert-row-top-outline":
      return /* @__PURE__ */ t.createElement(Q8, { color: o, style: { flexShrink: 0 }, ...n });
    case "italic-outline":
      return /* @__PURE__ */ t.createElement(e6, { color: o, style: { flexShrink: 0 }, ...n });
    case "light-bulb-outline":
      return /* @__PURE__ */ t.createElement(t6, { color: o, style: { flexShrink: 0 }, ...n });
    case "lightning-bolt-outline":
      return /* @__PURE__ */ t.createElement(r6, { color: o, style: { flexShrink: 0 }, ...n });
    case "link-outline":
      return /* @__PURE__ */ t.createElement(n6, { color: o, style: { flexShrink: 0 }, ...n });
    case "link-unlink-outline":
      return /* @__PURE__ */ t.createElement(o6, { color: o, style: { flexShrink: 0 }, ...n });
    case "link-unlink-small-outline":
      return /* @__PURE__ */ t.createElement(a6, { color: o, style: { flexShrink: 0 }, ...n });
    case "list-ordered-outline":
      return /* @__PURE__ */ t.createElement(i6, { color: o, style: { flexShrink: 0 }, ...n });
    case "list-unordered-outline":
      return /* @__PURE__ */ t.createElement(l6, { color: o, style: { flexShrink: 0 }, ...n });
    case "location-marker-outline":
      return /* @__PURE__ */ t.createElement(c6, { color: o, style: { flexShrink: 0 }, ...n });
    case "lock-closed-outline":
      return /* @__PURE__ */ t.createElement(C6, { color: o, style: { flexShrink: 0 }, ...n });
    case "lock-open-outline":
      return /* @__PURE__ */ t.createElement(s6, { color: o, style: { flexShrink: 0 }, ...n });
    case "login-outline":
      return /* @__PURE__ */ t.createElement(u6, { color: o, style: { flexShrink: 0 }, ...n });
    case "logout-outline":
      return /* @__PURE__ */ t.createElement(d6, { color: o, style: { flexShrink: 0 }, ...n });
    case "mail-open-outline":
      return /* @__PURE__ */ t.createElement(f6, { color: o, style: { flexShrink: 0 }, ...n });
    case "mail-outline":
      return /* @__PURE__ */ t.createElement(m6, { color: o, style: { flexShrink: 0 }, ...n });
    case "map-outline":
      return /* @__PURE__ */ t.createElement(h6, { color: o, style: { flexShrink: 0 }, ...n });
    case "menu-outline":
      return /* @__PURE__ */ t.createElement(v6, { color: o, style: { flexShrink: 0 }, ...n });
    case "minus-circle-outline":
      return /* @__PURE__ */ t.createElement(g6, { color: o, style: { flexShrink: 0 }, ...n });
    case "minus-circle-solid":
      return /* @__PURE__ */ t.createElement(p6, { color: o, style: { flexShrink: 0 }, ...n });
    case "minus-outline":
      return /* @__PURE__ */ t.createElement(y6, { color: o, style: { flexShrink: 0 }, ...n });
    case "move-outline":
      return /* @__PURE__ */ t.createElement(w6, { color: o, style: { flexShrink: 0 }, ...n });
    case "myself-outline":
      return /* @__PURE__ */ t.createElement(b6, { color: o, style: { flexShrink: 0 }, ...n });
    case "newspaper-outline":
      return /* @__PURE__ */ t.createElement(E6, { color: o, style: { flexShrink: 0 }, ...n });
    case "office-building-outline":
      return /* @__PURE__ */ t.createElement(k6, { color: o, style: { flexShrink: 0 }, ...n });
    case "others-outline":
      return /* @__PURE__ */ t.createElement(L6, { color: o, style: { flexShrink: 0 }, ...n });
    case "paper-clip-outline":
      return /* @__PURE__ */ t.createElement(x6, { color: o, style: { flexShrink: 0 }, ...n });
    case "pencil-alt-solid":
      return /* @__PURE__ */ t.createElement(H6, { color: o, style: { flexShrink: 0 }, ...n });
    case "pencil-outline":
      return /* @__PURE__ */ t.createElement(M6, { color: o, style: { flexShrink: 0 }, ...n });
    case "phone-outline":
      return /* @__PURE__ */ t.createElement(V6, { color: o, style: { flexShrink: 0 }, ...n });
    case "placeholder-outline":
      return /* @__PURE__ */ t.createElement($6, { color: o, style: { flexShrink: 0 }, ...n });
    case "play-solid":
      return /* @__PURE__ */ t.createElement(O6, { color: o, style: { flexShrink: 0 }, ...n });
    case "plus-circle-outline":
      return /* @__PURE__ */ t.createElement(S6, { color: o, style: { flexShrink: 0 }, ...n });
    case "plus-circle-solid":
      return /* @__PURE__ */ t.createElement(Z6, { color: o, style: { flexShrink: 0 }, ...n });
    case "plus-outline":
      return /* @__PURE__ */ t.createElement(D6, { color: o, style: { flexShrink: 0 }, ...n });
    case "printer-outline":
      return /* @__PURE__ */ t.createElement(_6, { color: o, style: { flexShrink: 0 }, ...n });
    case "question-mark-circle-solid":
      return /* @__PURE__ */ t.createElement(B6, { color: o, style: { flexShrink: 0 }, ...n });
    case "receipt-outline":
      return /* @__PURE__ */ t.createElement(T6, { color: o, style: { flexShrink: 0 }, ...n });
    case "redo-outline":
      return /* @__PURE__ */ t.createElement(W6, { color: o, style: { flexShrink: 0 }, ...n });
    case "refresh-outline":
      return /* @__PURE__ */ t.createElement(R6, { color: o, style: { flexShrink: 0 }, ...n });
    case "refresh-solid":
      return /* @__PURE__ */ t.createElement(j6, { color: o, style: { flexShrink: 0 }, ...n });
    case "search-outline":
      return /* @__PURE__ */ t.createElement(A6, { color: o, style: { flexShrink: 0 }, ...n });
    case "selector-outline":
      return /* @__PURE__ */ t.createElement(I6, { color: o, style: { flexShrink: 0 }, ...n });
    case "send-outline":
      return /* @__PURE__ */ t.createElement(N6, { color: o, style: { flexShrink: 0 }, ...n });
    case "set-link-outline":
      return /* @__PURE__ */ t.createElement(F6, { color: o, style: { flexShrink: 0 }, ...n });
    case "sort-ascending-outline":
      return /* @__PURE__ */ t.createElement(P6, { color: o, style: { flexShrink: 0 }, ...n });
    case "sort-descending-outline":
      return /* @__PURE__ */ t.createElement(G6, { color: o, style: { flexShrink: 0 }, ...n });
    case "star-outline":
      return /* @__PURE__ */ t.createElement(z6, { color: o, style: { flexShrink: 0 }, ...n });
    case "subscript-outline":
      return /* @__PURE__ */ t.createElement(Y6, { color: o, style: { flexShrink: 0 }, ...n });
    case "superscript-outline":
      return /* @__PURE__ */ t.createElement(U6, { color: o, style: { flexShrink: 0 }, ...n });
    case "support-outline":
      return /* @__PURE__ */ t.createElement(q6, { color: o, style: { flexShrink: 0 }, ...n });
    case "switch-outline":
      return /* @__PURE__ */ t.createElement(X6, { color: o, style: { flexShrink: 0 }, ...n });
    case "table-line-outline":
      return /* @__PURE__ */ t.createElement(K6, { color: o, style: { flexShrink: 0 }, ...n });
    case "template-outline":
      return /* @__PURE__ */ t.createElement(J6, { color: o, style: { flexShrink: 0 }, ...n });
    case "thumb-down-outline":
      return /* @__PURE__ */ t.createElement(Q6, { color: o, style: { flexShrink: 0 }, ...n });
    case "thumb-up-outline":
      return /* @__PURE__ */ t.createElement(e7, { color: o, style: { flexShrink: 0 }, ...n });
    case "translate-outline":
      return /* @__PURE__ */ t.createElement(t7, { color: o, style: { flexShrink: 0 }, ...n });
    case "trash-outline":
      return /* @__PURE__ */ t.createElement(r7, { color: o, style: { flexShrink: 0 }, ...n });
    case "underline-outline":
      return /* @__PURE__ */ t.createElement(n7, { color: o, style: { flexShrink: 0 }, ...n });
    case "undo-outline":
      return /* @__PURE__ */ t.createElement(o7, { color: o, style: { flexShrink: 0 }, ...n });
    case "upload-outline":
      return /* @__PURE__ */ t.createElement(a7, { color: o, style: { flexShrink: 0 }, ...n });
    case "user-add-outline":
      return /* @__PURE__ */ t.createElement(i7, { color: o, style: { flexShrink: 0 }, ...n });
    case "user-circle-outline":
      return /* @__PURE__ */ t.createElement(l7, { color: o, style: { flexShrink: 0 }, ...n });
    case "user-group-outline":
      return /* @__PURE__ */ t.createElement(c7, { color: o, style: { flexShrink: 0 }, ...n });
    case "user-outline":
      return /* @__PURE__ */ t.createElement(C7, { color: o, style: { flexShrink: 0 }, ...n });
    case "user-remove-outline":
      return /* @__PURE__ */ t.createElement(s7, { color: o, style: { flexShrink: 0 }, ...n });
    case "users-outline":
      return /* @__PURE__ */ t.createElement(u7, { color: o, style: { flexShrink: 0 }, ...n });
    case "video-camera-outline":
      return /* @__PURE__ */ t.createElement(d7, { color: o, style: { flexShrink: 0 }, ...n });
    case "video-camera-solid":
      return /* @__PURE__ */ t.createElement(f7, { color: o, style: { flexShrink: 0 }, ...n });
    case "view-grid-add-outline":
      return /* @__PURE__ */ t.createElement(m7, { color: o, style: { flexShrink: 0 }, ...n });
    case "view-grid-outline":
      return /* @__PURE__ */ t.createElement(h7, { color: o, style: { flexShrink: 0 }, ...n });
    case "view-list-outline":
      return /* @__PURE__ */ t.createElement(v7, { color: o, style: { flexShrink: 0 }, ...n });
    case "x-circle-solid":
      return /* @__PURE__ */ t.createElement(g7, { color: o, style: { flexShrink: 0 }, ...n });
    case "x-outline":
      return /* @__PURE__ */ t.createElement(p7, { color: o, style: { flexShrink: 0 }, ...n });
    case "zoom-in-outline":
      return /* @__PURE__ */ t.createElement(y7, { color: o, style: { flexShrink: 0 }, ...n });
    case "zoom-out-outline":
      return /* @__PURE__ */ t.createElement(w7, { color: o, style: { flexShrink: 0 }, ...n });
    case "apply-sg-black-full":
      return /* @__PURE__ */ t.createElement(b7, { color: o, style: { flexShrink: 0 }, ...n });
    case "apply-sg-full":
      return /* @__PURE__ */ t.createElement(E7, { color: o, style: { flexShrink: 0 }, ...n });
    case "apply-sg-icon":
      return /* @__PURE__ */ t.createElement(k7, { color: o, style: { flexShrink: 0 }, ...n });
    case "apply-sg-white-full":
      return /* @__PURE__ */ t.createElement(L7, { color: o, style: { flexShrink: 0 }, ...n });
    case "bgp":
      return /* @__PURE__ */ t.createElement(x7, { color: o, style: { flexShrink: 0 }, ...n });
    case "bgp-backoffice":
      return /* @__PURE__ */ t.createElement(H7, { color: o, style: { flexShrink: 0 }, ...n });
    case "bgp-icon":
      return /* @__PURE__ */ t.createElement(M7, { color: o, style: { flexShrink: 0 }, ...n });
    case "bgp-icon-white-text":
      return /* @__PURE__ */ t.createElement(V7, { color: o, style: { flexShrink: 0 }, ...n });
    case "gt2025-black":
      return /* @__PURE__ */ t.createElement($7, { color: o, style: { flexShrink: 0 }, ...n });
    case "gt2025-colour":
      return /* @__PURE__ */ t.createElement(O7, { color: o, style: { flexShrink: 0 }, ...n });
    case "rgp-black-text":
      return /* @__PURE__ */ t.createElement(S7, { color: o, style: { flexShrink: 0 }, ...n });
    case "rgp-icon":
      return /* @__PURE__ */ t.createElement(Z7, { color: o, style: { flexShrink: 0 }, ...n });
    case "rgp-white-text":
      return /* @__PURE__ */ t.createElement(D7, { color: o, style: { flexShrink: 0 }, ...n });
  }
}, j4 = ({ variant: e = "dark", ...r }) => {
  const n = l5(), { accentColor: a, ringColor: o, ringOpacity: i } = _7(n, e);
  return /* @__PURE__ */ t.createElement(
    T7,
    {
      width: "1rem",
      height: "1rem",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M16 1.90735e-06C24.8366 1.52109e-06 32 7.16345 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 -1.52109e-06 24.8366 -1.90735e-06 16C-2.29361e-06 7.16345 7.16344 2.29361e-06 16 1.90735e-06ZM16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37259 4 16C4 22.6274 9.37258 28 16 28Z",
        fill: o,
        fillOpacity: i
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M30 16C31.1046 16 32.0129 15.1011 31.8752 14.0052C31.6973 12.5895 31.3304 11.2009 30.7821 9.87706C29.978 7.93586 28.7994 6.17203 27.3137 4.68629C25.828 3.20056 24.0641 2.022 22.1229 1.21793C20.7991 0.669597 19.4105 0.302738 17.9948 0.12484C16.8989 -0.0128746 16 0.895432 16 2C16 3.10457 16.9015 3.98304 17.9908 4.16628C18.8812 4.31609 19.754 4.56627 20.5922 4.91345C22.0481 5.5165 23.371 6.40042 24.4853 7.51472C25.5996 8.62902 26.4835 9.95189 27.0865 11.4078C27.4337 12.246 27.6839 13.1188 27.8337 14.0092C28.017 15.0985 28.8954 16 30 16Z",
        fill: a
      }
    )
  );
};
function _7(e, r) {
  switch (r) {
    case "dark":
      return {
        accentColor: e.colors.white,
        ringColor: e.colors.white,
        ringOpacity: 0.2
      };
    default:
      return {
        accentColor: e.colors.primary60,
        ringColor: e.colors.grey100,
        ringOpacity: 0.08
      };
  }
}
const B7 = i3`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`, T7 = y.svg`
  animation: ${B7} 0.75s infinite linear;
`, A4 = t.forwardRef(
  ({ children: e, title: r, ...n }, a) => {
    const o = f1(null), [i, l] = c1(!1);
    return y1(() => {
      const c = o.current;
      if (!c) return;
      const C = new ResizeObserver(() => {
        l(c.scrollWidth > c.offsetWidth);
      });
      return C.observe(c), l(c.scrollWidth > c.offsetWidth), () => C.disconnect();
    }, [e]), /* @__PURE__ */ t.createElement(
      W7,
      {
        ref: N1(a, o),
        ...n,
        title: i ? e : r
      },
      e
    );
  }
);
A4.displayName = "TruncatedText";
const W7 = y.span`
  display: block;
  overflow: hidden;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
`, I4 = t.forwardRef(
  ({
    variant: e = "primary",
    size: r = "large",
    isDisabled: n = !1,
    isLoading: a = !1,
    useFullWidth: o = !1,
    leftIcon: i,
    rightIcon: l,
    children: c,
    ...C
  }, s) => {
    const u = e == "primary" || e == "danger" ? "dark" : "light", h = n || e === "primary" ? "white" : e === "secondary-light" || e === "secondary-dark" ? "primary60" : "grey80";
    return /* @__PURE__ */ t.createElement(
      R7,
      {
        disabled: n || a,
        ref: s,
        $variant: e,
        $size: r,
        $useFullWidth: o,
        $hasLeftIcon: !!i,
        $hasRightIcon: !!l,
        ...C
      },
      /* @__PURE__ */ t.createElement(z7, { $isLoading: a }, i && /* @__PURE__ */ t.createElement(o1, { name: i, width: "1.25rem", height: "1.25rem", color: h }), /* @__PURE__ */ t.createElement(A4, null, c), l && /* @__PURE__ */ t.createElement(o1, { name: l, width: "1.25rem", height: "1.25rem", color: h })),
      a && /* @__PURE__ */ t.createElement(
        Y7,
        {
          width: "1.25rem",
          height: "1.25rem",
          variant: u,
          "aria-label": "button spinner"
        }
      )
    );
  }
);
I4.displayName = "Button";
const R7 = y.button`
  position: relative;
  display: flex;
  justify-content: center;
  width: ${({ $useFullWidth: e }) => e ? "100%" : "fit-content"};
  max-width: 100%;
  height: fit-content;
  border-radius: 0.5rem;
  outline: none;
  cursor: pointer;

  ${({ $size: e, theme: r }) => r.getTextStyles(e === "large" ? "button-01-semibold" : "button-02-semibold")}
  ${({ $size: e, $hasLeftIcon: r, $hasRightIcon: n }) => G7(e, r, n)}

  ${({ $variant: e }) => {
  switch (e) {
    case "secondary-light":
      return A7;
    case "secondary-dark":
      return I7;
    case "tertiary-light":
      return N7;
    case "tertiary-dark":
      return F7;
    case "danger":
      return P7;
    default:
      return j7;
  }
}}
`, j7 = k`
  border: 2px solid ${({ theme: e }) => e.colors.primary60};
  background-color: ${({ theme: e }) => e.colors.primary60};
  color: ${({ theme: e }) => e.colors.white};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.primary70};
    background-color: ${({ theme: e }) => e.colors.primary70};
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    cursor: not-allowed;
  }
`, A7 = k`
  border: 2px solid ${({ theme: e }) => e.colors.primary10};
  background-color: ${({ theme: e }) => e.colors.primary10};
  color: ${({ theme: e }) => e.colors.primary60};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.primary20};
    background-color: ${({ theme: e }) => e.colors.primary20};
    color: ${({ theme: e }) => e.colors.primary70};
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    color: ${({ theme: e }) => e.colors.white};
    cursor: not-allowed;
  }
`, I7 = k`
  border: 2px solid ${({ theme: e }) => e.colors.primary20};
  background-color: ${({ theme: e }) => e.colors.primary20};
  color: ${({ theme: e }) => e.colors.primary60};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.primary20};
    background-color: ${({ theme: e }) => e.colors.primary20};
    color: ${({ theme: e }) => e.colors.primary70};
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    color: ${({ theme: e }) => e.colors.white};
    cursor: not-allowed;
  }
`, N7 = k`
  border: 2px solid ${({ theme: e }) => e.colors.white};
  background-color: ${({ theme: e }) => e.colors.white};
  color: ${({ theme: e }) => e.colors.grey80};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    color: ${({ theme: e }) => e.colors.white};
    cursor: not-allowed;
  }
`, F7 = k`
  border: 2px solid ${({ theme: e }) => e.colors.grey10};
  background-color: ${({ theme: e }) => e.colors.grey10};
  color: ${({ theme: e }) => e.colors.grey80};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    color: ${({ theme: e }) => e.colors.white};
    cursor: not-allowed;
  }
`, P7 = k`
  border: 2px solid ${({ theme: e }) => e.colors.error};
  background-color: ${({ theme: e }) => e.colors.error};
  color: ${({ theme: e }) => e.colors.white};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.errorDark};
    background-color: ${({ theme: e }) => e.colors.errorDark};
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    color: ${({ theme: e }) => e.colors.white};
    cursor: not-allowed;
  }
`;
function G7(e, r, n) {
  switch (e) {
    case "small":
      return k`
        min-width: 4.5rem;
        padding-block: 0.375rem;
        padding-right: calc(0.875rem - ${n ? "0.25rem" : "0rem"});
        padding-left: calc(0.875rem - ${r ? "0.25rem" : "0rem"});
      `;
    default:
      return k`
        min-width: 5.5rem;
        padding-block: 0.625rem;
        padding-right: calc(1.375rem - ${n ? "0.25rem" : "0rem"});
        padding-left: calc(1.375rem - ${r ? "0.25rem" : "0rem"});
      `;
  }
}
const z7 = y.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  min-width: 0;
  visibility: ${({ $isLoading: e }) => e ? "hidden" : "visible"};
`, Y7 = y(j4)`
  position: absolute;
  inset: 0;
  margin: auto;
`, N4 = t.createContext(
  void 0
);
function U7() {
  return t.useContext(N4);
}
function w1(e) {
  const { defaultValue: r, value: n, onChange: a } = e, [o, i] = c1(r), l = n !== void 0, c = l ? n : o, C = n1(
    (s) => {
      c !== s && (l || i(s), a == null || a(s));
    },
    [l, a, c]
  );
  return [c, C];
}
function q7(e, ...r) {
  const n = H1(), a = e || n;
  return z1(() => r.map((o) => `${o}-${a}`), [a, r]);
}
const l1 = t.forwardRef(
  ({ variant: e, color: r = "inherit", textAlign: n, children: a, ...o }, i) => /* @__PURE__ */ t.createElement(
    X7,
    {
      $variant: e,
      $color: r,
      $textAlign: n,
      ref: i,
      ...o
    },
    a
  )
);
l1.displayName = "Text";
const X7 = y.span`
  ${({ theme: e, $variant: r }) => e.getTextStyles(r)}

  display: block;
  color: ${({ $color: e, theme: r }) => e === "inherit" ? e : r.colors[e]};
  ${({ $textAlign: e }) => e && `text-align: ${e};`};
  white-space: pre-wrap;
  word-break: break-word;
`, Y1 = t.forwardRef(
  ({ variant: e = "helper", isDisabled: r = !1, children: n, ...a }, o) => {
    let i;
    switch (e) {
      case "error":
        i = "error";
        break;
      case "warning":
        i = "warning";
        break;
      default:
        i = "grey70";
        break;
    }
    return r && e !== "error" && (i = "grey40"), /* @__PURE__ */ t.createElement(K7, { variant: "caption-01-regular", color: i, ref: o, ...a }, n);
  }
), K7 = y(l1)`
  position: relative;
  white-space: pre-line;
`;
Y1.displayName = "InfoText";
const C5 = t.forwardRef(
  ({
    label: e,
    description: r,
    value: n,
    isChecked: a,
    defaultIsChecked: o = !1,
    onChange: i,
    isIndeterminate: l = !1,
    errorText: c,
    warningText: C,
    isDisabled: s = !1,
    ...u
  }, f) => {
    const d = `checkbox-${H1()}`, v = !!c, m = U7(), [g, L] = w1({
      defaultValue: o,
      value: a ?? (m == null ? void 0 : m.value.includes(n)),
      onChange: i
    }), E = (V) => {
      if (m) {
        const { addValue: O, removeValue: D } = m;
        V.target.checked ? O(V.target.value) : D(V.target.value);
      }
      L(V.target.checked);
    };
    return /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5 }, /* @__PURE__ */ t.createElement(J7, { $isDisabled: s, htmlFor: d }, /* @__PURE__ */ t.createElement(
      Q7,
      {
        $hasError: v,
        type: "checkbox",
        id: d,
        name: m == null ? void 0 : m.name,
        value: n,
        checked: g,
        onChange: E,
        ref: f,
        disabled: s,
        ...u
      }
    ), /* @__PURE__ */ t.createElement(e0, { $isDisabled: s }, g && !l && /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 20 20", fill: "none" }, /* @__PURE__ */ t.createElement("g", null, /* @__PURE__ */ t.createElement("rect", { width: "20", height: "20", rx: "4", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M5.5 10L8.5 13L14.5 7", stroke: "white", strokeWidth: "2" }))), l && !g && /* @__PURE__ */ t.createElement("svg", { "data-testid": "indeterminate-state", viewBox: "0 0 20 20", fill: "none" }, /* @__PURE__ */ t.createElement("g", null, /* @__PURE__ */ t.createElement("rect", { width: "20", height: "20", rx: "4", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M5 10H15", stroke: "white", strokeWidth: "2" })))), /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5 }, /* @__PURE__ */ t.createElement(l1, { variant: "label-01-regular" }, e), r && /* @__PURE__ */ t.createElement(l1, { variant: "caption-01-regular", color: s ? "grey40" : "grey70" }, r))), (c || C) && /* @__PURE__ */ t.createElement(Y1, { variant: c ? "error" : C ? "warning" : "helper" }, c || C));
  }
);
C5.displayName = "Checkbox";
const J7 = y.label`
  position: relative;
  display: flex;
  width: fit-content;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey40 : r.colors.grey80};
  cursor: ${({ $isDisabled: e }) => e ? "not-allowed" : "pointer"};
  column-gap: 0.75rem;
`, Q7 = y.input`
  min-width: 1.25rem;
  height: 1.25rem;
  margin: 0;
  border: ${({ theme: e }) => `1px solid ${e.colors.grey50}`};
  border-radius: 4px;
  background-color: ${({ theme: e }) => e.colors.white};
  cursor: pointer;
  appearance: none;

  &:hover {
    border-color: ${({ theme: e }) => e.colors.grey80};
    background-color: ${({ theme: e }) => e.colors.grey10};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey30};
    background-color: ${({ theme: e }) => e.colors.grey10};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
  }

  ${({ $hasError: e, theme: r }) => e && k`
      &,
      &:hover {
        border: 2px solid ${r.colors.error};
        background-color: ${r.colors.errorLight};
      }

      &:checked {
        outline: 2px solid ${r.colors.error};
      }

      &:disabled {
        border: 2px solid ${r.colors.error};
        background-color: ${r.colors.grey10};
      }
    `}
`, e0 = y.span`
  position: absolute;
  width: 1.25rem;
  height: 1.25rem;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey60 : r.colors.primary60};
  pointer-events: none;
`, t0 = t.forwardRef(
  ({ defaultValue: e = [], value: r, onChange: n, name: a, children: o, rowGap: i }, l) => {
    const c = H1(), C = a || `checkbox-group-${c}`, [s, u] = w1({
      defaultValue: e,
      value: r,
      onChange: n
    }), f = t.Children.toArray(o).filter(
      (v) => t.isValidElement(v) && v.type === C5 && v.props.value
    ), h = n1(
      (v) => {
        u([...s, v]);
      },
      [u, s]
    ), d = n1(
      (v) => {
        u(s.filter((m) => m !== v));
      },
      [u, s]
    );
    return /* @__PURE__ */ t.createElement(N4.Provider, { value: { value: s, addValue: h, removeValue: d, name: C } }, /* @__PURE__ */ t.createElement(z, { ref: l, ...i && { flex: !0, flexColumn: !0, rowGap: i } }, f));
  }
);
t0.displayName = "CheckboxGroup";
const W1 = "15rem", r0 = ({
  columns: e,
  data: r,
  emptyMessage: n,
  sorting: a,
  ariaLabel: o,
  isHeaderRowHidden: i = !1
}) => {
  const [l, c] = w1({
    defaultValue: (a == null ? void 0 : a.defaultSortingState) ?? null,
    value: a == null ? void 0 : a.sortingState,
    onChange: a == null ? void 0 : a.onChange
  }), [C, s] = c1(!1), u = f1(null);
  y1(() => {
    const d = u.current;
    if (!d) return;
    const v = () => {
      s(d.scrollLeft + d.offsetWidth < d.scrollWidth - 1);
    }, m = new ResizeObserver(v);
    return m.observe(d), d == null || d.addEventListener("scroll", v), window.addEventListener("resize", v), () => {
      m.disconnect(), d == null || d.removeEventListener("scroll", v), window.removeEventListener("resize", v);
    };
  }, []);
  const f = z1(() => e.map((d) => {
    const v = (l == null ? void 0 : l.colName) === d.name ? l.desc : null, m = d.type === "fixed" ? { type: "fixed", width: d.width ?? W1, minWidth: d.minWidth } : {
      type: "expandable",
      minWidth: d.minWidth ?? W1,
      maxWidth: d.maxWidth ?? W1
    };
    return {
      id: d.id,
      name: d.name,
      description: d.description,
      isSortable: d.isSortable,
      sortDirection: v,
      dimensions: m,
      render: () => d.displayName ?? d.name,
      onClickSort: d.isSortable ? () => {
        (l == null ? void 0 : l.colName) === d.name ? c(v ? { colName: d.name, desc: !1 } : null) : c({ colName: d.name, desc: !0 });
      } : void 0,
      onClickInfo: d.onClickInfo
    };
  }), [e, l, c]), h = z1(() => r.map((d) => ({
    id: d.id,
    variant: d.rowVariant,
    cells: e.map((v) => {
      const m = v.type === "fixed" ? { type: "fixed", width: v.width ?? W1, minWidth: v.minWidth } : {
        type: "expandable",
        minWidth: v.minWidth ?? W1,
        maxWidth: v.maxWidth ?? W1
      };
      return {
        id: v.id,
        dimensions: m,
        render: () => v.render(d)
      };
    })
  })), [r, e]);
  return /* @__PURE__ */ t.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ t.createElement(n0, { ref: u }, /* @__PURE__ */ t.createElement(o0, { "aria-label": o }, !i && /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, f.map((d) => /* @__PURE__ */ t.createElement(F4, { role: "columnheader", key: d.id, $dimensions: d.dimensions }, /* @__PURE__ */ t.createElement(i0, null, /* @__PURE__ */ t.createElement("div", { style: { display: "block", flex: 1, minWidth: 0 } }, /* @__PURE__ */ t.createElement(l0, null, d.render(), d.onClickInfo && /* @__PURE__ */ t.createElement(c0, null, /* @__PURE__ */ t.createElement(
    o1,
    {
      "data-testid": "info-icon",
      name: "question-mark-circle-solid",
      role: "img",
      "aria-label": "question mark circle solid",
      onClick: d.onClickInfo,
      width: 16,
      height: 16,
      color: "grey60"
    }
  ))), d.description && /* @__PURE__ */ t.createElement(C0, null, d.description)), d.isSortable && /* @__PURE__ */ t.createElement(s0, { hideSvgOnMouseLeave: d.sortDirection === null }, /* @__PURE__ */ t.createElement(
    o1,
    {
      "data-testid": "sort-icon",
      name: d.sortDirection === !0 ? "sort-descending-outline" : d.sortDirection === !1 ? "sort-ascending-outline" : "switch-outline",
      role: "img",
      "aria-label": d.sortDirection === !0 ? "sorted descending" : d.sortDirection === !1 ? "sorted ascending" : "unsorted",
      width: 16,
      height: 16,
      color: "grey60",
      onClick: d.onClickSort
    }
  ))))))), /* @__PURE__ */ t.createElement(u0, null, h.length === 0 && /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("td", { colSpan: f.length }, /* @__PURE__ */ t.createElement(
    z,
    {
      flex: !0,
      alignItems: "center",
      justifyContent: "center",
      px: 1.25,
      py: 1.25,
      columnGap: 1.25
    },
    /* @__PURE__ */ t.createElement(l1, { variant: "label-01-regular" }, n)
  ))), h.length > 0 && h.map((d) => d.variant === "skeleton" ? /* @__PURE__ */ t.createElement("tr", { key: d.id }, /* @__PURE__ */ t.createElement(
    h0,
    {
      colSpan: f.length,
      $dimensions: d.cells.length > 0 ? d.cells[0].dimensions : {
        type: "fixed",
        width: W1
      }
    },
    /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25, py: 0.75, "data-testid": "skeleton-row" }, /* @__PURE__ */ t.createElement(I5, null), /* @__PURE__ */ t.createElement(I5, { $width: "70%" }))
  )) : /* @__PURE__ */ t.createElement(a0, { key: d.id, variant: d.variant }, d.cells.map((v) => /* @__PURE__ */ t.createElement(d0, { key: `${d.id}-${v.id}`, $dimensions: v.dimensions }, /* @__PURE__ */ t.createElement(f0, null, v.render())))))))), C && /* @__PURE__ */ t.createElement(m0, null));
}, n0 = y.div`
  overflow-x: auto;
`, o0 = y.table`
  display: table;
  width: max-content;
  border-collapse: collapse;
  table-layout: auto;
`, a0 = y.tr`
  ${({ variant: e, theme: r }) => {
  switch (e) {
    case "error":
      return `
          background-color: ${r.colors.errorLight};
          border-bottom: 1px solid ${r.colors.borderError};
        `;
    case "regular":
    default:
      return `
          background-color: inherit;
          border-bottom: none;
        `;
  }
}}
`, F4 = y.th`
  vertical-align: top;
  padding: 1.25rem 0 1.25rem 1.25rem;
  color: ${({ theme: e }) => e.colors.grey60};
  text-align: left;

  &:last-child {
    padding-right: 1.25rem;
  }

  ${({ $dimensions: e }) => e.type === "fixed" ? `
        ${G("width", e.width)}
        ${e.minWidth !== void 0 ? G("min-width", e.minWidth) : ""}
      ` : `
        ${G("min-width", e.minWidth)}
        ${G("max-width", e.maxWidth)}
      `}
`, i0 = y.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
`, l0 = y.div`
  display: inline-block;
  vertical-align: top;
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  user-select: none;

  ${({ theme: e }) => e.getTextStyles("overline-01-regular")}
`, c0 = y.span`
  display: inline-flex;
  vertical-align: text-bottom;
  margin-left: 0.25rem;
  cursor: pointer;
`, C0 = y.div`
  min-width: 0;
  margin-top: 0.25rem;
  white-space: normal;
  overflow-wrap: break-word;
  user-select: none;

  ${({ theme: e }) => e.getTextStyles("caption-01-regular")}
`, s0 = y.div`
  cursor: pointer;

  svg {
    opacity: ${({ hideSvgOnMouseLeave: e }) => e ? 0 : 1};
  }
  ${F4}:hover & svg {
    opacity: 1;
  }
`, u0 = y.tbody`
  & > tr {
    box-shadow: inset 0 1px 0 rgb(224 228 232 / 60%);
  }
`, d0 = y.td`
  vertical-align: top;
  padding: 1.25rem 0 1.25rem 1.25rem;

  &:last-child {
    padding-right: 1.25rem;
  }

  ${({ $dimensions: e }) => e.type === "fixed" ? `
        ${G("width", e.width)}
        ${e.minWidth !== void 0 ? G("min-width", e.minWidth) : ""}
      ` : `
        ${G("min-width", e.minWidth)}
        ${G("max-width", e.maxWidth)}
      `}
`, f0 = y.div`
  display: block;
  width: 100%;
  min-width: 0;
  white-space: normal;
  overflow-wrap: break-word;

  ${({ theme: e }) => e.getTextStyles("label-01-regular")}
`, m0 = y.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 5rem;
  height: 100%;
  background: linear-gradient(
    to left,
    rgb(255 255 255 / 100%) 0%,
    rgb(255 255 255 / 80%) 40%,
    rgb(255 255 255 / 20%) 80%,
    rgb(255 255 255 / 0%) 100%
  );
  pointer-events: none;
`, h0 = y.td`
  vertical-align: top;
  padding: 1.25rem;

  ${({ $dimensions: e }) => e.type === "fixed" ? `
        ${G("width", e.width)}
        ${e.minWidth !== void 0 ? G("min-width", e.minWidth) : ""}
      ` : `
        ${G("min-width", e.minWidth)}
        ${G("max-width", e.maxWidth)}
      `}
`, v0 = i3`
  0%, 40% {
    background-position: 150% 0;
  }
  50% {
    background-position: 0 0;
  }
  60%, 100% {
    background-position: -50% 0;
  }
`, I5 = y.div`
  width: ${({ $width: e }) => e || "100%"};
  height: 1rem;
  border-radius: 0.25rem;
  background: linear-gradient(
    90deg,
    ${({ theme: e }) => e.colors.grey10} 0%,
    ${({ theme: e }) => e.colors.grey10} 25%,
    ${({ theme: e }) => e.colors.grey20} 50%,
    ${({ theme: e }) => e.colors.grey10} 75%,
    ${({ theme: e }) => e.colors.grey10} 100%
  );
  background-size: 200% 100%;
  animation: ${v0} 5s linear infinite;
`, g0 = ({
  columns: e,
  data: r,
  emptyMessage: n,
  sorting: a,
  ariaLabel: o
}) => {
  const [i, l] = w1({
    defaultValue: (a == null ? void 0 : a.defaultSortingState) ?? null,
    value: a == null ? void 0 : a.sortingState,
    onChange: a == null ? void 0 : a.onChange
  }), c = z1(() => e.map((s) => {
    const u = (i == null ? void 0 : i.colName) === s.name ? i.desc : null;
    return {
      id: s.id,
      name: s.name,
      description: s.description,
      isSortable: s.isSortable,
      sortDirection: u,
      width: s.width ?? W1,
      render: () => s.displayName ?? s.name,
      onClickSort: s.isSortable ? () => {
        (i == null ? void 0 : i.colName) === s.name ? l(u ? { colName: s.name, desc: !1 } : null) : l({ colName: s.name, desc: !0 });
      } : void 0,
      onClickInfo: s.onClickInfo
    };
  }), [e, i, l]), C = z1(() => r.map((s) => ({
    id: s.id,
    cells: e.map((u) => ({
      id: u.id,
      width: u.width ?? W1,
      render: () => u.render(s)
    }))
  })), [r, e]);
  return /* @__PURE__ */ t.createElement(p0, null, /* @__PURE__ */ t.createElement(y0, { "aria-label": o }, /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, c.map((s) => /* @__PURE__ */ t.createElement(P4, { role: "columnheader", key: s.id, $width: s.width }, /* @__PURE__ */ t.createElement(w0, null, /* @__PURE__ */ t.createElement("div", { style: { display: "block", flex: 1, minWidth: 0 } }, /* @__PURE__ */ t.createElement(b0, null, s.render(), s.onClickInfo && /* @__PURE__ */ t.createElement(E0, null, /* @__PURE__ */ t.createElement(
    o1,
    {
      "data-testid": "info-icon",
      name: "question-mark-circle-solid",
      role: "img",
      "aria-label": "question mark circle solid",
      onClick: s.onClickInfo,
      width: 16,
      height: 16,
      color: "grey60"
    }
  ))), s.description && /* @__PURE__ */ t.createElement(k0, null, s.description)), s.isSortable && /* @__PURE__ */ t.createElement(L0, { hideSvgOnMouseLeave: s.sortDirection === null }, /* @__PURE__ */ t.createElement(
    o1,
    {
      "data-testid": "sort-icon",
      name: s.sortDirection === !0 ? "sort-descending-outline" : s.sortDirection === !1 ? "sort-ascending-outline" : "switch-outline",
      role: "img",
      "aria-label": s.sortDirection === !0 ? "sorted descending" : s.sortDirection === !1 ? "sorted ascending" : "unsorted",
      width: 16,
      height: 16,
      color: "grey60",
      onClick: s.onClickSort
    }
  ))))))), /* @__PURE__ */ t.createElement(x0, null, C.length === 0 && /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("td", { colSpan: c.length }, /* @__PURE__ */ t.createElement(
    z,
    {
      flex: !0,
      alignItems: "center",
      justifyContent: "center",
      px: 1.25,
      py: 1.25,
      columnGap: 1.25
    },
    /* @__PURE__ */ t.createElement(l1, { variant: "label-01-regular" }, n)
  ))), C.length > 0 && C.map((s) => /* @__PURE__ */ t.createElement("tr", { key: s.id }, s.cells.map((u) => /* @__PURE__ */ t.createElement(
    H0,
    {
      key: `${s.id}-${u.id}`,
      $width: u.width ?? W1
    },
    /* @__PURE__ */ t.createElement(M0, null, u.render())
  )))))));
}, p0 = y.div`
  overflow-x: visible;
`, y0 = y.table`
  display: table;
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
`, P4 = y.th`
  vertical-align: top;
  padding: 1.25rem 0 1.25rem 1.25rem;
  color: ${({ theme: e }) => e.colors.grey60};
  text-align: left;

  &:last-child {
    padding-right: 1.25rem;
  }

  ${({ $width: e }) => G("width", e)};
`, w0 = y.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
`, b0 = y.div`
  display: inline-block;
  vertical-align: top;
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  user-select: none;

  ${({ theme: e }) => e.getTextStyles("overline-01-regular")}
`, E0 = y.span`
  display: inline-flex;
  vertical-align: text-bottom;
  margin-left: 0.25rem;
  cursor: pointer;
`, k0 = y.div`
  min-width: 0;
  margin-top: 0.25rem;
  white-space: normal;
  overflow-wrap: break-word;
  user-select: none;

  ${({ theme: e }) => e.getTextStyles("caption-01-regular")}
`, L0 = y.div`
  cursor: pointer;

  svg {
    opacity: ${({ hideSvgOnMouseLeave: e }) => e ? 0 : 1};
  }
  ${P4}:hover & svg {
    opacity: 1;
  }
`, x0 = y.tbody`
  & > tr {
    box-shadow: inset 0 1px 0 rgb(224 228 232 / 60%);
  }
`, H0 = y.td`
  vertical-align: top;
  padding: 1.25rem 0 1.25rem 1.25rem;

  &:last-child {
    padding-right: 1.25rem;
  }

  ${({ $width: e }) => G("width", e)};
`, M0 = y.div`
  display: block;
  width: 100%;
  min-width: 0;
  white-space: normal;
  overflow-wrap: break-word;

  ${({ theme: e }) => e.getTextStyles("label-01-regular")}
`, G3 = t.forwardRef(
  ({ name: e, variant: r = "primary", size: n = "large", isDisabled: a = !1, ...o }, i) => /* @__PURE__ */ t.createElement(
    V0,
    {
      disabled: a,
      ref: i,
      $size: n,
      $variant: r,
      ...o
    },
    /* @__PURE__ */ t.createElement(o1, { name: e, width: n === "small" ? 20 : 24, height: n === "small" ? 20 : 24 })
  )
);
G3.displayName = "IconButton";
const V0 = y.button`
  position: relative;
  outline: none;
  cursor: pointer;

  ${({ $size: e, theme: r }) => r.getTextStyles(e === "small" ? "button-02-semibold" : "button-01-semibold")}

  ${({ $size: e }) => {
  switch (e) {
    case "small":
      return k`
          width: 2.25rem;
          height: 2.25rem;
          padding: 0.375rem;
        `;
    default:
      return k`
          width: 2.75rem;
          height: 2.75rem;
          padding: 0.5rem;
        `;
  }
}}

  ${({ $variant: e }) => {
  switch (e) {
    case "secondary":
      return O0;
    case "tertiary":
      return S0;
    case "block":
      return Z0;
    case "ghost":
      return D0;
    case "ghost-light":
      return _0;
    case "error":
      return B0;
    default:
      return $0;
  }
}}
`, $0 = k`
  border: 2px solid ${({ theme: e }) => e.colors.primary60};
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.colors.primary60};
  color: ${({ theme: e }) => e.colors.white};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.primary70};
    background-color: ${({ theme: e }) => e.colors.primary70};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    cursor: not-allowed;
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }
`, O0 = k`
  border: 2px solid ${({ theme: e }) => e.colors.primary10};
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.colors.primary10};
  color: ${({ theme: e }) => e.colors.primary60};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.primary20};
    background-color: ${({ theme: e }) => e.colors.primary20};
    color: ${({ theme: e }) => e.colors.primary70};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    color: ${({ theme: e }) => e.colors.white};
    cursor: not-allowed;
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }
`, S0 = k`
  border: 2px solid ${({ theme: e }) => e.colors.grey10};
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.colors.grey10};
  color: ${({ theme: e }) => e.colors.grey70};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    color: ${({ theme: e }) => e.colors.white};
    cursor: not-allowed;
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }
`, Z0 = k`
  border: 2px solid ${({ theme: e }) => e.colors.primary10};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.primary10};
  color: ${({ theme: e }) => e.colors.primary60};

  &:hover,
  &:active {
    border-color: ${({ theme: e }) => e.colors.primary20};
    background-color: ${({ theme: e }) => e.colors.primary20};
    color: ${({ theme: e }) => e.colors.primary70};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
    color: ${({ theme: e }) => e.colors.white};
    cursor: not-allowed;
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }
`, D0 = k`
  border: 2px solid transparent;
  border-radius: 50%;
  background-color: transparent;
  color: ${({ theme: e }) => e.colors.grey70};

  &:disabled {
    color: ${({ theme: e }) => e.colors.grey30};
    cursor: not-allowed;
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.primary60};
  }

  &:not(:disabled):hover,
  &:not(:disabled):active {
    border-color: ${({ theme: e }) => e.colors.grey20};
    background-color: ${({ theme: e }) => e.colors.grey20};
  }
`, _0 = k`
  border: 2px solid transparent;
  border-radius: 50%;
  background-color: transparent;
  color: ${({ theme: e }) => e.colors.white};

  &:disabled {
    color: ${({ theme: e }) => e.colors.grey30};
    cursor: not-allowed;
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.white};
  }

  &:not(:disabled):hover,
  &:not(:disabled):active {
    border-color: color-mix(in srgb, ${({ theme: e }) => e.colors.white} 30%, transparent);
    background-color: color-mix(in srgb, ${({ theme: e }) => e.colors.white} 10%, transparent);
  }
`, B0 = k`
  border: 2px solid transparent;
  border-radius: 50%;
  background-color: transparent;
  color: ${({ theme: e }) => e.colors.error};

  &:hover,
  &:active {
    background-color: ${({ theme: e }) => e.colors.errorLight};
  }

  &:disabled {
    color: ${({ theme: e }) => e.colors.grey30};
    cursor: not-allowed;
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.white};
    box-shadow: 0 0 0 2px ${({ theme: e }) => e.colors.error};
  }
`, ai = ({
  dataTestId: e,
  ariaLabel: r,
  variant: n,
  columns: a,
  data: o,
  emptyMessage: i = "No data!",
  sorting: l,
  pagination: c,
  isHeaderRowHidden: C = !1
}) => {
  const [s, u] = w1({
    defaultValue: (c == null ? void 0 : c.defaultPaginationState) ?? null,
    value: c == null ? void 0 : c.paginationState,
    onChange: c == null ? void 0 : c.onChange
  });
  return /* @__PURE__ */ t.createElement(T0, { "data-testid": e }, n === "fixed" ? /* @__PURE__ */ t.createElement(
    g0,
    {
      columns: a,
      data: o,
      emptyMessage: i,
      sorting: l,
      ariaLabel: r
    }
  ) : /* @__PURE__ */ t.createElement(
    r0,
    {
      columns: a,
      data: o,
      emptyMessage: i,
      sorting: l,
      ariaLabel: r,
      isHeaderRowHidden: C
    }
  ), s && /* @__PURE__ */ t.createElement(W0, null, /* @__PURE__ */ t.createElement(R0, null, /* @__PURE__ */ t.createElement(l1, { variant: "label-01-regular", color: "grey60" }, !o.length || s.totalCount === 0 ? "0 - 0 of 0 items" : `${(s.pageNumber - 1) * s.pageLimit + 1} - ${(s.pageNumber - 1) * s.pageLimit + o.length} of ${s.totalCount} items`)), /* @__PURE__ */ t.createElement(j0, null, /* @__PURE__ */ t.createElement(
    G3,
    {
      name: "chevron-left-outline",
      variant: "ghost",
      size: "small",
      "aria-label": "prev page",
      onClick: () => u({
        pageNumber: s.pageNumber - 1,
        pageLimit: s.pageLimit,
        totalCount: s.totalCount
      }),
      isDisabled: s.pageNumber === 1
    }
  ), /* @__PURE__ */ t.createElement(
    G3,
    {
      name: "chevron-right-outline",
      variant: "ghost",
      size: "small",
      "aria-label": "next page",
      onClick: () => {
        u({
          pageNumber: s.pageNumber + 1,
          pageLimit: s.pageLimit,
          totalCount: s.totalCount
        });
      },
      isDisabled: s.pageNumber === Math.ceil(s.totalCount / s.pageLimit) || s.totalCount < s.pageLimit
    }
  ))));
}, T0 = y.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: fit-content;
  max-width: 100%;
  border-radius: 0.5rem;
  background-color: white;
`, W0 = y.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  box-shadow: inset 0 1px 0 rgb(224 228 232 / 60%);
`, R0 = y.div`
  display: flex;
`, j0 = y.div`
  display: flex;
  column-gap: 0.5rem;
`;
function l3(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var G2 = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var O3, N5;
function A0() {
  if (N5) return O3;
  N5 = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function a(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, c = 0; c < 10; c++)
        l["_" + String.fromCharCode(c)] = c;
      var C = Object.getOwnPropertyNames(l).map(function(u) {
        return l[u];
      });
      if (C.join("") !== "0123456789")
        return !1;
      var s = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        s[u] = u;
      }), Object.keys(Object.assign({}, s)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return O3 = o() ? Object.assign : function(i, l) {
    for (var c, C = a(i), s, u = 1; u < arguments.length; u++) {
      c = Object(arguments[u]);
      for (var f in c)
        r.call(c, f) && (C[f] = c[f]);
      if (e) {
        s = e(c);
        for (var h = 0; h < s.length; h++)
          n.call(c, s[h]) && (C[s[h]] = c[s[h]]);
      }
    }
    return C;
  }, O3;
}
var S3, F5;
function s5() {
  if (F5) return S3;
  F5 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return S3 = e, S3;
}
var Z3, P5;
function G4() {
  return P5 || (P5 = 1, Z3 = Function.call.bind(Object.prototype.hasOwnProperty)), Z3;
}
var D3, G5;
function I0() {
  if (G5) return D3;
  G5 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ s5(), n = {}, a = /* @__PURE__ */ G4();
    e = function(i) {
      var l = "Warning: " + i;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(i, l, c, C, s) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (a(i, u)) {
          var f;
          try {
            if (typeof i[u] != "function") {
              var h = Error(
                (C || "React class") + ": " + c + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = i[u](l, u, C, c, null, r);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (C || "React class") + ": type specification of " + c + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var d = s ? s() : "";
            e(
              "Failed " + c + " type: " + f.message + (d ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, D3 = o, D3;
}
var _3, z5;
function N0() {
  if (z5) return _3;
  z5 = 1;
  var e = W4, r = A0(), n = /* @__PURE__ */ s5(), a = /* @__PURE__ */ G4(), o = /* @__PURE__ */ I0(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(c) {
    var C = "Warning: " + c;
    typeof console < "u" && console.error(C);
    try {
      throw new Error(C);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return _3 = function(c, C) {
    var s = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(w) {
      var p = w && (s && w[s] || w[u]);
      if (typeof p == "function")
        return p;
    }
    var h = "<<anonymous>>", d = {
      array: L("array"),
      bigint: L("bigint"),
      bool: L("boolean"),
      func: L("function"),
      number: L("number"),
      object: L("object"),
      string: L("string"),
      symbol: L("symbol"),
      any: E(),
      arrayOf: V,
      element: O(),
      elementType: D(),
      instanceOf: H,
      node: W(),
      objectOf: _,
      oneOf: F,
      oneOfType: Y,
      shape: N,
      exact: j
    };
    function v(w, p) {
      return w === p ? w !== 0 || 1 / w === 1 / p : w !== w && p !== p;
    }
    function m(w, p) {
      this.message = w, this.data = p && typeof p == "object" ? p : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function g(w) {
      if (process.env.NODE_ENV !== "production")
        var p = {}, $ = 0;
      function x(T, R, M, Z, P, q, m1) {
        if (Z = Z || h, q = q || M, m1 !== n) {
          if (C) {
            var s1 = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw s1.name = "Invariant Violation", s1;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var b1 = Z + ":" + M;
            !p[b1] && // Avoid spamming the console because they are often not actionable except for lib authors
            $ < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + q + "` prop on `" + Z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), p[b1] = !0, $++);
          }
        }
        return R[M] == null ? T ? R[M] === null ? new m("The " + P + " `" + q + "` is marked as required " + ("in `" + Z + "`, but its value is `null`.")) : new m("The " + P + " `" + q + "` is marked as required in " + ("`" + Z + "`, but its value is `undefined`.")) : null : w(R, M, Z, P, q);
      }
      var S = x.bind(null, !1);
      return S.isRequired = x.bind(null, !0), S;
    }
    function L(w) {
      function p($, x, S, T, R, M) {
        var Z = $[x], P = B(Z);
        if (P !== w) {
          var q = U(Z);
          return new m(
            "Invalid " + T + " `" + R + "` of type " + ("`" + q + "` supplied to `" + S + "`, expected ") + ("`" + w + "`."),
            { expectedType: w }
          );
        }
        return null;
      }
      return g(p);
    }
    function E() {
      return g(l);
    }
    function V(w) {
      function p($, x, S, T, R) {
        if (typeof w != "function")
          return new m("Property `" + R + "` of component `" + S + "` has invalid PropType notation inside arrayOf.");
        var M = $[x];
        if (!Array.isArray(M)) {
          var Z = B(M);
          return new m("Invalid " + T + " `" + R + "` of type " + ("`" + Z + "` supplied to `" + S + "`, expected an array."));
        }
        for (var P = 0; P < M.length; P++) {
          var q = w(M, P, S, T, R + "[" + P + "]", n);
          if (q instanceof Error)
            return q;
        }
        return null;
      }
      return g(p);
    }
    function O() {
      function w(p, $, x, S, T) {
        var R = p[$];
        if (!c(R)) {
          var M = B(R);
          return new m("Invalid " + S + " `" + T + "` of type " + ("`" + M + "` supplied to `" + x + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(w);
    }
    function D() {
      function w(p, $, x, S, T) {
        var R = p[$];
        if (!e.isValidElementType(R)) {
          var M = B(R);
          return new m("Invalid " + S + " `" + T + "` of type " + ("`" + M + "` supplied to `" + x + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(w);
    }
    function H(w) {
      function p($, x, S, T, R) {
        if (!($[x] instanceof w)) {
          var M = w.name || h, Z = t1($[x]);
          return new m("Invalid " + T + " `" + R + "` of type " + ("`" + Z + "` supplied to `" + S + "`, expected ") + ("instance of `" + M + "`."));
        }
        return null;
      }
      return g(p);
    }
    function F(w) {
      if (!Array.isArray(w))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function p($, x, S, T, R) {
        for (var M = $[x], Z = 0; Z < w.length; Z++)
          if (v(M, w[Z]))
            return null;
        var P = JSON.stringify(w, function(m1, s1) {
          var b1 = U(s1);
          return b1 === "symbol" ? String(s1) : s1;
        });
        return new m("Invalid " + T + " `" + R + "` of value `" + String(M) + "` " + ("supplied to `" + S + "`, expected one of " + P + "."));
      }
      return g(p);
    }
    function _(w) {
      function p($, x, S, T, R) {
        if (typeof w != "function")
          return new m("Property `" + R + "` of component `" + S + "` has invalid PropType notation inside objectOf.");
        var M = $[x], Z = B(M);
        if (Z !== "object")
          return new m("Invalid " + T + " `" + R + "` of type " + ("`" + Z + "` supplied to `" + S + "`, expected an object."));
        for (var P in M)
          if (a(M, P)) {
            var q = w(M, P, S, T, R + "." + P, n);
            if (q instanceof Error)
              return q;
          }
        return null;
      }
      return g(p);
    }
    function Y(w) {
      if (!Array.isArray(w))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var p = 0; p < w.length; p++) {
        var $ = w[p];
        if (typeof $ != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + a1($) + " at index " + p + "."
          ), l;
      }
      function x(S, T, R, M, Z) {
        for (var P = [], q = 0; q < w.length; q++) {
          var m1 = w[q], s1 = m1(S, T, R, M, Z, n);
          if (s1 == null)
            return null;
          s1.data && a(s1.data, "expectedType") && P.push(s1.data.expectedType);
        }
        var b1 = P.length > 0 ? ", expected one of type [" + P.join(", ") + "]" : "";
        return new m("Invalid " + M + " `" + Z + "` supplied to " + ("`" + R + "`" + b1 + "."));
      }
      return g(x);
    }
    function W() {
      function w(p, $, x, S, T) {
        return J(p[$]) ? null : new m("Invalid " + S + " `" + T + "` supplied to " + ("`" + x + "`, expected a ReactNode."));
      }
      return g(w);
    }
    function A(w, p, $, x, S) {
      return new m(
        (w || "React class") + ": " + p + " type `" + $ + "." + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + S + "`."
      );
    }
    function N(w) {
      function p($, x, S, T, R) {
        var M = $[x], Z = B(M);
        if (Z !== "object")
          return new m("Invalid " + T + " `" + R + "` of type `" + Z + "` " + ("supplied to `" + S + "`, expected `object`."));
        for (var P in w) {
          var q = w[P];
          if (typeof q != "function")
            return A(S, T, R, P, U(q));
          var m1 = q(M, P, S, T, R + "." + P, n);
          if (m1)
            return m1;
        }
        return null;
      }
      return g(p);
    }
    function j(w) {
      function p($, x, S, T, R) {
        var M = $[x], Z = B(M);
        if (Z !== "object")
          return new m("Invalid " + T + " `" + R + "` of type `" + Z + "` " + ("supplied to `" + S + "`, expected `object`."));
        var P = r({}, $[x], w);
        for (var q in P) {
          var m1 = w[q];
          if (a(w, q) && typeof m1 != "function")
            return A(S, T, R, q, U(m1));
          if (!m1)
            return new m(
              "Invalid " + T + " `" + R + "` key `" + q + "` supplied to `" + S + "`.\nBad object: " + JSON.stringify($[x], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(w), null, "  ")
            );
          var s1 = m1(M, q, S, T, R + "." + q, n);
          if (s1)
            return s1;
        }
        return null;
      }
      return g(p);
    }
    function J(w) {
      switch (typeof w) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !w;
        case "object":
          if (Array.isArray(w))
            return w.every(J);
          if (w === null || c(w))
            return !0;
          var p = f(w);
          if (p) {
            var $ = p.call(w), x;
            if (p !== w.entries) {
              for (; !(x = $.next()).done; )
                if (!J(x.value))
                  return !1;
            } else
              for (; !(x = $.next()).done; ) {
                var S = x.value;
                if (S && !J(S[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function X(w, p) {
      return w === "symbol" ? !0 : p ? p["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && p instanceof Symbol : !1;
    }
    function B(w) {
      var p = typeof w;
      return Array.isArray(w) ? "array" : w instanceof RegExp ? "object" : X(p, w) ? "symbol" : p;
    }
    function U(w) {
      if (typeof w > "u" || w === null)
        return "" + w;
      var p = B(w);
      if (p === "object") {
        if (w instanceof Date)
          return "date";
        if (w instanceof RegExp)
          return "regexp";
      }
      return p;
    }
    function a1(w) {
      var p = U(w);
      switch (p) {
        case "array":
        case "object":
          return "an " + p;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + p;
        default:
          return p;
      }
    }
    function t1(w) {
      return !w.constructor || !w.constructor.name ? h : w.constructor.name;
    }
    return d.checkPropTypes = o, d.resetWarningCache = o.resetWarningCache, d.PropTypes = d, d;
  }, _3;
}
var B3, Y5;
function F0() {
  if (Y5) return B3;
  Y5 = 1;
  var e = /* @__PURE__ */ s5();
  function r() {
  }
  function n() {
  }
  return n.resetWarningCache = r, B3 = function() {
    function a(l, c, C, s, u, f) {
      if (f !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    a.isRequired = a;
    function o() {
      return a;
    }
    var i = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: o,
      element: a,
      elementType: a,
      instanceOf: o,
      node: a,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: r
    };
    return i.PropTypes = i, i;
  }, B3;
}
var U5;
function P0() {
  if (U5) return G2.exports;
  if (U5 = 1, process.env.NODE_ENV !== "production") {
    var e = W4, r = !0;
    G2.exports = /* @__PURE__ */ N0()(e.isElement, r);
  } else
    G2.exports = /* @__PURE__ */ F0()();
  return G2.exports;
}
var G0 = /* @__PURE__ */ P0();
const b = /* @__PURE__ */ l3(G0);
function z4(e) {
  var r, n, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (r = 0; r < o; r++) e[r] && (n = z4(e[r])) && (a && (a += " "), a += n);
  } else for (n in e) e[n] && (a && (a += " "), a += n);
  return a;
}
function c3() {
  for (var e, r, n = 0, a = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (r = z4(e)) && (a && (a += " "), a += r);
  return a;
}
var T3, q5;
function z0() {
  if (q5) return T3;
  q5 = 1;
  const e = (C, s, u, f) => {
    if (u === "length" || u === "prototype" || u === "arguments" || u === "caller")
      return;
    const h = Object.getOwnPropertyDescriptor(C, u), d = Object.getOwnPropertyDescriptor(s, u);
    !r(h, d) && f || Object.defineProperty(C, u, d);
  }, r = function(C, s) {
    return C === void 0 || C.configurable || C.writable === s.writable && C.enumerable === s.enumerable && C.configurable === s.configurable && (C.writable || C.value === s.value);
  }, n = (C, s) => {
    const u = Object.getPrototypeOf(s);
    u !== Object.getPrototypeOf(C) && Object.setPrototypeOf(C, u);
  }, a = (C, s) => `/* Wrapped ${C}*/
${s}`, o = Object.getOwnPropertyDescriptor(Function.prototype, "toString"), i = Object.getOwnPropertyDescriptor(Function.prototype.toString, "name"), l = (C, s, u) => {
    const f = u === "" ? "" : `with ${u.trim()}() `, h = a.bind(null, f, s.toString());
    Object.defineProperty(h, "name", i), Object.defineProperty(C, "toString", { ...o, value: h });
  };
  return T3 = (C, s, { ignoreNonConfigurable: u = !1 } = {}) => {
    const { name: f } = C;
    for (const h of Reflect.ownKeys(s))
      e(C, s, h, u);
    return n(C, s), l(C, s, f), C;
  }, T3;
}
var b2 = { exports: {} }, W3, X5;
function Y0() {
  return X5 || (X5 = 1, W3 = () => {
    const e = {};
    return e.promise = new Promise((r, n) => {
      e.resolve = r, e.reject = n;
    }), e;
  }), W3;
}
var z2 = b2.exports, K5;
function U0() {
  return K5 || (K5 = 1, (function(e, r) {
    var n = z2 && z2.__awaiter || function(l, c, C, s) {
      return new (C || (C = Promise))(function(u, f) {
        function h(m) {
          try {
            v(s.next(m));
          } catch (g) {
            f(g);
          }
        }
        function d(m) {
          try {
            v(s.throw(m));
          } catch (g) {
            f(g);
          }
        }
        function v(m) {
          m.done ? u(m.value) : new C(function(g) {
            g(m.value);
          }).then(h, d);
        }
        v((s = s.apply(l, c || [])).next());
      });
    }, a = z2 && z2.__importDefault || function(l) {
      return l && l.__esModule ? l : { default: l };
    };
    Object.defineProperty(r, "__esModule", { value: !0 });
    const o = a(Y0());
    function i(l, c = "maxAge") {
      let C, s, u;
      const f = () => n(this, void 0, void 0, function* () {
        if (C !== void 0)
          return;
        const v = (m) => n(this, void 0, void 0, function* () {
          u = o.default();
          const g = m[1][c] - Date.now();
          if (g <= 0) {
            l.delete(m[0]), u.resolve();
            return;
          }
          return C = m[0], s = setTimeout(() => {
            l.delete(m[0]), u && u.resolve();
          }, g), typeof s.unref == "function" && s.unref(), u.promise;
        });
        try {
          for (const m of l)
            yield v(m);
        } catch {
        }
        C = void 0;
      }), h = () => {
        C = void 0, s !== void 0 && (clearTimeout(s), s = void 0), u !== void 0 && (u.reject(void 0), u = void 0);
      }, d = l.set.bind(l);
      return l.set = (v, m) => {
        l.has(v) && l.delete(v);
        const g = d(v, m);
        return C && C === v && h(), f(), g;
      }, f(), l;
    }
    r.default = i, e.exports = i, e.exports.default = i;
  })(b2, b2.exports)), b2.exports;
}
var R3, J5;
function q0() {
  if (J5) return R3;
  J5 = 1;
  const e = z0(), r = /* @__PURE__ */ U0(), n = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), o = (i, { cacheKey: l, cache: c = /* @__PURE__ */ new Map(), maxAge: C } = {}) => {
    typeof C == "number" && r(c);
    const s = function(...u) {
      const f = l ? l(u) : u[0], h = c.get(f);
      if (h)
        return h.data;
      const d = i.apply(this, u);
      return c.set(f, {
        data: d,
        maxAge: C ? Date.now() + C : Number.POSITIVE_INFINITY
      }), d;
    };
    return e(s, i, {
      ignoreNonConfigurable: !0
    }), a.set(s, c), s;
  };
  return o.decorator = (i = {}) => (l, c, C) => {
    const s = l[c];
    if (typeof s != "function")
      throw new TypeError("The decorated value must be a function");
    delete C.value, delete C.writable, C.get = function() {
      if (!n.has(this)) {
        const u = o(s, i);
        return n.set(this, u), u;
      }
      return n.get(this);
    };
  }, o.clear = (i) => {
    const l = a.get(i);
    if (!l)
      throw new TypeError("Can't clear a function that was not memoized!");
    if (typeof l.clear != "function")
      throw new TypeError("The cache Map can't be cleared!");
    l.clear();
  }, R3 = o, R3;
}
var X0 = q0();
const Y4 = /* @__PURE__ */ l3(X0);
function K0(e) {
  return typeof e == "string";
}
function J0(e, r, n) {
  return n.indexOf(e) === r;
}
function Q0(e) {
  return e.toLowerCase() === e;
}
function Q5(e) {
  return e.indexOf(",") === -1 ? e : e.split(",");
}
function z3(e) {
  if (!e)
    return e;
  if (e === "C" || e === "posix" || e === "POSIX")
    return "en-US";
  if (e.indexOf(".") !== -1) {
    var r = e.split(".")[0], n = r === void 0 ? "" : r;
    return z3(n);
  }
  if (e.indexOf("@") !== -1) {
    var a = e.split("@")[0], n = a === void 0 ? "" : a;
    return z3(n);
  }
  if (e.indexOf("-") === -1 || !Q0(e))
    return e;
  var o = e.split("-"), i = o[0], l = o[1], c = l === void 0 ? "" : l;
  return "".concat(i, "-").concat(c.toUpperCase());
}
function et(e) {
  var r = e === void 0 ? {} : e, n = r.useFallbackLocale, a = n === void 0 ? !0 : n, o = r.fallbackLocale, i = o === void 0 ? "en-US" : o, l = [];
  if (typeof navigator < "u") {
    for (var c = navigator.languages || [], C = [], s = 0, u = c; s < u.length; s++) {
      var f = u[s];
      C = C.concat(Q5(f));
    }
    var h = navigator.language, d = h && Q5(h);
    l = l.concat(C, d);
  }
  return a && l.push(i), l.filter(K0).map(z3).filter(J0);
}
var tt = Y4(et, { cacheKey: JSON.stringify });
function rt(e) {
  return tt(e)[0] || null;
}
var U4 = Y4(rt, { cacheKey: JSON.stringify });
function G1(e, r, n) {
  return function(o, i) {
    i === void 0 && (i = n);
    var l = e(o) + i;
    return r(l);
  };
}
function Z2(e) {
  return function(n) {
    return new Date(e(n).getTime() - 1);
  };
}
function D2(e, r) {
  return function(a) {
    return [e(a), r(a)];
  };
}
function C1(e) {
  if (e instanceof Date)
    return e.getFullYear();
  if (typeof e == "number")
    return e;
  var r = parseInt(e, 10);
  if (typeof e == "string" && !isNaN(r))
    return r;
  throw new Error("Failed to get year from date: ".concat(e, "."));
}
function U1(e) {
  if (e instanceof Date)
    return e.getMonth();
  throw new Error("Failed to get month from date: ".concat(e, "."));
}
function C3(e) {
  if (e instanceof Date)
    return e.getDate();
  throw new Error("Failed to get year from date: ".concat(e, "."));
}
function h2(e) {
  var r = C1(e), n = r + (-r + 1) % 100, a = /* @__PURE__ */ new Date();
  return a.setFullYear(n, 0, 1), a.setHours(0, 0, 0, 0), a;
}
var nt = G1(C1, h2, -100), q4 = G1(C1, h2, 100), u5 = Z2(q4), ot = G1(C1, u5, -100), X4 = D2(h2, u5);
function q1(e) {
  var r = C1(e), n = r + (-r + 1) % 10, a = /* @__PURE__ */ new Date();
  return a.setFullYear(n, 0, 1), a.setHours(0, 0, 0, 0), a;
}
var K4 = G1(C1, q1, -10), d5 = G1(C1, q1, 10), s3 = Z2(d5), J4 = G1(C1, s3, -10), Q4 = D2(q1, s3);
function v2(e) {
  var r = C1(e), n = /* @__PURE__ */ new Date();
  return n.setFullYear(r, 0, 1), n.setHours(0, 0, 0, 0), n;
}
var e9 = G1(C1, v2, -1), f5 = G1(C1, v2, 1), u3 = Z2(f5), t9 = G1(C1, u3, -1), at = D2(v2, u3);
function m5(e, r) {
  return function(a, o) {
    o === void 0 && (o = r);
    var i = C1(a), l = U1(a) + o, c = /* @__PURE__ */ new Date();
    return c.setFullYear(i, l, 1), c.setHours(0, 0, 0, 0), e(c);
  };
}
function n2(e) {
  var r = C1(e), n = U1(e), a = /* @__PURE__ */ new Date();
  return a.setFullYear(r, n, 1), a.setHours(0, 0, 0, 0), a;
}
var r9 = m5(n2, -1), h5 = m5(n2, 1), _2 = Z2(h5), n9 = m5(_2, -1), it = D2(n2, _2);
function lt(e, r) {
  return function(a, o) {
    o === void 0 && (o = r);
    var i = C1(a), l = U1(a), c = C3(a) + o, C = /* @__PURE__ */ new Date();
    return C.setFullYear(i, l, c), C.setHours(0, 0, 0, 0), e(C);
  };
}
function B2(e) {
  var r = C1(e), n = U1(e), a = C3(e), o = /* @__PURE__ */ new Date();
  return o.setFullYear(r, n, a), o.setHours(0, 0, 0, 0), o;
}
var ct = lt(B2, 1), v5 = Z2(ct), Ct = D2(B2, v5);
function o9(e) {
  return C3(_2(e));
}
var y2, i1 = {
  GREGORY: "gregory",
  HEBREW: "hebrew",
  ISLAMIC: "islamic",
  ISO_8601: "iso8601"
}, l2 = {
  ARABIC: "Arabic",
  HEBREW: "Hebrew",
  ISO_8601: "ISO 8601",
  US: "US"
}, st = (y2 = {}, y2[i1.GREGORY] = [
  "en-CA",
  "en-US",
  "es-AR",
  "es-BO",
  "es-CL",
  "es-CO",
  "es-CR",
  "es-DO",
  "es-EC",
  "es-GT",
  "es-HN",
  "es-MX",
  "es-NI",
  "es-PA",
  "es-PE",
  "es-PR",
  "es-SV",
  "es-VE",
  "pt-BR"
], y2[i1.HEBREW] = ["he", "he-IL"], y2[i1.ISLAMIC] = [
  // ar-LB, ar-MA intentionally missing
  "ar",
  "ar-AE",
  "ar-BH",
  "ar-DZ",
  "ar-EG",
  "ar-IQ",
  "ar-JO",
  "ar-KW",
  "ar-LY",
  "ar-OM",
  "ar-QA",
  "ar-SA",
  "ar-SD",
  "ar-SY",
  "ar-YE",
  "dv",
  "dv-MV",
  "ps",
  "ps-AR"
], y2), g5 = [0, 1, 2, 3, 4, 5, 6], j3 = /* @__PURE__ */ new Map();
function ut(e) {
  return function(n, a) {
    var o = n || U4();
    j3.has(o) || j3.set(o, /* @__PURE__ */ new Map());
    var i = j3.get(o);
    return i.has(e) || i.set(e, new Intl.DateTimeFormat(o || void 0, e).format), i.get(e)(a);
  };
}
function dt(e) {
  var r = new Date(e);
  return new Date(r.setHours(12));
}
function o2(e) {
  return function(r, n) {
    return ut(e)(r, dt(n));
  };
}
var ft = { day: "numeric" }, mt = {
  day: "numeric",
  month: "long",
  year: "numeric"
}, ht = { month: "long" }, vt = {
  month: "long",
  year: "numeric"
}, gt = { weekday: "short" }, pt = { weekday: "long" }, yt = { year: "numeric" }, wt = o2(ft), bt = o2(mt), Et = o2(ht), a9 = o2(vt), kt = o2(gt), Lt = o2(pt), d3 = o2(yt), xt = g5[0], Ht = g5[5], e4 = g5[6];
function x2(e, r) {
  r === void 0 && (r = i1.ISO_8601);
  var n = e.getDay();
  switch (r) {
    case i1.ISO_8601:
      return (n + 6) % 7;
    case i1.ISLAMIC:
      return (n + 1) % 7;
    case i1.HEBREW:
    case i1.GREGORY:
      return n;
    default:
      throw new Error("Unsupported calendar type.");
  }
}
function Mt(e) {
  var r = h2(e);
  return C1(r);
}
function Vt(e) {
  var r = q1(e);
  return C1(r);
}
function Y3(e, r) {
  r === void 0 && (r = i1.ISO_8601);
  var n = C1(e), a = U1(e), o = e.getDate() - x2(e, r);
  return new Date(n, a, o);
}
function $t(e, r) {
  r === void 0 && (r = i1.ISO_8601);
  var n = r === i1.GREGORY ? i1.GREGORY : i1.ISO_8601, a = Y3(e, r), o = C1(e) + 1, i, l;
  do
    i = new Date(o, 0, n === i1.ISO_8601 ? 4 : 1), l = Y3(i, r), o -= 1;
  while (e < l);
  return Math.round((a.getTime() - l.getTime()) / (864e5 * 7)) + 1;
}
function e2(e, r) {
  switch (e) {
    case "century":
      return h2(r);
    case "decade":
      return q1(r);
    case "year":
      return v2(r);
    case "month":
      return n2(r);
    case "day":
      return B2(r);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function Ot(e, r) {
  switch (e) {
    case "century":
      return nt(r);
    case "decade":
      return K4(r);
    case "year":
      return e9(r);
    case "month":
      return r9(r);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function i9(e, r) {
  switch (e) {
    case "century":
      return q4(r);
    case "decade":
      return d5(r);
    case "year":
      return f5(r);
    case "month":
      return h5(r);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function St(e, r) {
  switch (e) {
    case "decade":
      return K4(r, -100);
    case "year":
      return e9(r, -10);
    case "month":
      return r9(r, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function Zt(e, r) {
  switch (e) {
    case "decade":
      return d5(r, 100);
    case "year":
      return f5(r, 10);
    case "month":
      return h5(r, 12);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function l9(e, r) {
  switch (e) {
    case "century":
      return u5(r);
    case "decade":
      return s3(r);
    case "year":
      return u3(r);
    case "month":
      return _2(r);
    case "day":
      return v5(r);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function Dt(e, r) {
  switch (e) {
    case "century":
      return ot(r);
    case "decade":
      return J4(r);
    case "year":
      return t9(r);
    case "month":
      return n9(r);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function _t(e, r) {
  switch (e) {
    case "decade":
      return J4(r, -100);
    case "year":
      return t9(r, -10);
    case "month":
      return n9(r, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function t4(e, r) {
  switch (e) {
    case "century":
      return X4(r);
    case "decade":
      return Q4(r);
    case "year":
      return at(r);
    case "month":
      return it(r);
    case "day":
      return Ct(r);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function Bt(e, r, n) {
  var a = [r, n].sort(function(o, i) {
    return o.getTime() - i.getTime();
  });
  return [e2(e, a[0]), l9(e, a[1])];
}
function c9(e, r, n) {
  return r === void 0 && (r = d3), n.map(function(a) {
    return r(e, a);
  }).join(" – ");
}
function Tt(e, r, n) {
  return c9(e, r, X4(n));
}
function C9(e, r, n) {
  return c9(e, r, Q4(n));
}
function Wt(e) {
  return e.getDay() === (/* @__PURE__ */ new Date()).getDay();
}
function s9(e, r) {
  r === void 0 && (r = i1.ISO_8601);
  var n = e.getDay();
  switch (r) {
    case i1.ISLAMIC:
    case i1.HEBREW:
      return n === Ht || n === e4;
    case i1.ISO_8601:
    case i1.GREGORY:
      return n === e4 || n === xt;
    default:
      throw new Error("Unsupported calendar type.");
  }
}
var T1 = "react-calendar__navigation";
function Rt(e) {
  var r = e.activeStartDate, n = e.drillUp, a = e.formatMonthYear, o = a === void 0 ? a9 : a, i = e.formatYear, l = i === void 0 ? d3 : i, c = e.locale, C = e.maxDate, s = e.minDate, u = e.navigationAriaLabel, f = u === void 0 ? "" : u, h = e.navigationAriaLive, d = e.navigationLabel, v = e.next2AriaLabel, m = v === void 0 ? "" : v, g = e.next2Label, L = g === void 0 ? "»" : g, E = e.nextAriaLabel, V = E === void 0 ? "" : E, O = e.nextLabel, D = O === void 0 ? "›" : O, H = e.prev2AriaLabel, F = H === void 0 ? "" : H, _ = e.prev2Label, Y = _ === void 0 ? "«" : _, W = e.prevAriaLabel, A = W === void 0 ? "" : W, N = e.prevLabel, j = N === void 0 ? "‹" : N, J = e.setActiveStartDate, X = e.showDoubleView, B = e.view, U = e.views, a1 = U.indexOf(B) > 0, t1 = B !== "century", w = Ot(B, r), p = t1 ? St(B, r) : void 0, $ = i9(B, r), x = t1 ? Zt(B, r) : void 0, S = (function() {
    if (w.getFullYear() < 0)
      return !0;
    var u1 = Dt(B, r);
    return s && s >= u1;
  })(), T = t1 && (function() {
    if (p.getFullYear() < 0)
      return !0;
    var u1 = _t(B, r);
    return s && s >= u1;
  })(), R = C && C < $, M = t1 && C && C < x;
  function Z() {
    J(w, "prev");
  }
  function P() {
    J(p, "prev2");
  }
  function q() {
    J($, "next");
  }
  function m1() {
    J(x, "next2");
  }
  function s1(u1) {
    var A1 = (function() {
      switch (B) {
        case "century":
          return Tt(c, l, u1);
        case "decade":
          return C9(c, l, u1);
        case "year":
          return l(c, u1);
        case "month":
          return o(c, u1);
        default:
          throw new Error("Invalid view: ".concat(B, "."));
      }
    })();
    return d ? d({
      date: u1,
      label: A1,
      locale: c || U4() || void 0,
      view: B
    }) : A1;
  }
  function b1() {
    var u1 = "".concat(T1, "__label");
    return t.createElement(
      "button",
      { "aria-label": f, "aria-live": h, className: u1, disabled: !a1, onClick: n, style: { flexGrow: 1 }, type: "button" },
      t.createElement("span", { className: "".concat(u1, "__labelText ").concat(u1, "__labelText--from") }, s1(r)),
      X ? t.createElement(
        t.Fragment,
        null,
        t.createElement("span", { className: "".concat(u1, "__divider") }, " – "),
        t.createElement("span", { className: "".concat(u1, "__labelText ").concat(u1, "__labelText--to") }, s1($))
      ) : null
    );
  }
  return t.createElement(
    "div",
    { className: T1 },
    Y !== null && t1 ? t.createElement("button", { "aria-label": F, className: "".concat(T1, "__arrow ").concat(T1, "__prev2-button"), disabled: T, onClick: P, type: "button" }, Y) : null,
    j !== null && t.createElement("button", { "aria-label": A, className: "".concat(T1, "__arrow ").concat(T1, "__prev-button"), disabled: S, onClick: Z, type: "button" }, j),
    b1(),
    D !== null && t.createElement("button", { "aria-label": V, className: "".concat(T1, "__arrow ").concat(T1, "__next-button"), disabled: R, onClick: q, type: "button" }, D),
    L !== null && t1 ? t.createElement("button", { "aria-label": m, className: "".concat(T1, "__arrow ").concat(T1, "__next2-button"), disabled: M, onClick: m1, type: "button" }, L) : null
  );
}
var c2 = function() {
  return c2 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, c2.apply(this, arguments);
}, jt = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
};
function r4(e) {
  return "".concat(e, "%");
}
function p5(e) {
  var r = e.children, n = e.className, a = e.count, o = e.direction, i = e.offset, l = e.style, c = e.wrap, C = jt(e, ["children", "className", "count", "direction", "offset", "style", "wrap"]);
  return t.createElement("div", c2({ className: n, style: c2({ display: "flex", flexDirection: o, flexWrap: c ? "wrap" : "nowrap" }, l) }, C), t.Children.map(r, function(s, u) {
    var f = i && u === 0 ? r4(100 * i / a) : null;
    return t.cloneElement(s, c2(c2({}, s.props), { style: {
      flexBasis: r4(100 / a),
      flexShrink: 0,
      flexGrow: 0,
      overflow: "hidden",
      marginLeft: f,
      marginInlineStart: f,
      marginInlineEnd: 0
    } }));
  }));
}
var A3, n4;
function At() {
  if (n4) return A3;
  n4 = 1;
  var e = process.env.NODE_ENV !== "production", r = function() {
  };
  if (e) {
    var n = function(o, i) {
      var l = arguments.length;
      i = new Array(l > 1 ? l - 1 : 0);
      for (var c = 1; c < l; c++)
        i[c - 1] = arguments[c];
      var C = 0, s = "Warning: " + o.replace(/%s/g, function() {
        return i[C++];
      });
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
    r = function(a, o, i) {
      var l = arguments.length;
      i = new Array(l > 2 ? l - 2 : 0);
      for (var c = 2; c < l; c++)
        i[c - 2] = arguments[c];
      if (o === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      a || n.apply(null, [o].concat(i));
    };
  }
  return A3 = r, A3;
}
var It = At();
const Nt = /* @__PURE__ */ l3(It);
var i2;
function Ft(e, r, n) {
  return r && r > e ? r : n && n < e ? n : e;
}
function H2(e, r) {
  return r[0] <= e && r[1] >= e;
}
function Pt(e, r) {
  return e[0] <= r[0] && e[1] >= r[1];
}
function u9(e, r) {
  return H2(e[0], r) || H2(e[1], r);
}
function o4(e, r, n) {
  var a = u9(r, e), o = [];
  if (a) {
    o.push(n);
    var i = H2(e[0], r), l = H2(e[1], r);
    i && o.push("".concat(n, "Start")), l && o.push("".concat(n, "End")), i && l && o.push("".concat(n, "BothEnds"));
  }
  return o;
}
function Gt(e) {
  return Array.isArray(e) ? e[0] !== null && e[1] !== null : e !== null;
}
function zt(e) {
  if (!e)
    throw new Error("args is required");
  var r = e.value, n = e.date, a = e.hover, o = "react-calendar__tile", i = [o];
  if (!n)
    return i;
  var l = /* @__PURE__ */ new Date(), c = (function() {
    if (Array.isArray(n))
      return n;
    var d = e.dateType;
    if (!d)
      throw new Error("dateType is required when date is not an array of two dates");
    return t4(d, n);
  })();
  if (H2(l, c) && i.push("".concat(o, "--now")), !r || !Gt(r))
    return i;
  var C = (function() {
    if (Array.isArray(r))
      return r;
    var d = e.valueType;
    if (!d)
      throw new Error("valueType is required when value is not an array of two dates");
    return t4(d, r);
  })();
  Pt(C, c) ? i.push("".concat(o, "--active")) : u9(C, c) && i.push("".concat(o, "--hasActive"));
  var s = o4(C, c, "".concat(o, "--range"));
  i.push.apply(i, s);
  var u = Array.isArray(r) ? r : [r];
  if (a && u.length === 1) {
    var f = a > C[0] ? [C[0], a] : [a, C[0]], h = o4(f, c, "".concat(o, "--hover"));
    i.push.apply(i, h);
  }
  return i;
}
var Yt = (i2 = {}, i2[l2.ARABIC] = i1.ISLAMIC, i2[l2.HEBREW] = i1.HEBREW, i2[l2.ISO_8601] = i1.ISO_8601, i2[l2.US] = i1.GREGORY, i2);
function Ut(e) {
  return e !== void 0 && e in l2;
}
var a4 = !1;
function f3(e) {
  if (Ut(e)) {
    var r = Yt[e];
    return Nt(a4, 'Specifying calendarType="'.concat(e, '" is deprecated. Use calendarType="').concat(r, '" instead.')), a4 = !0, r;
  }
  return e;
}
function m3(e) {
  for (var r = e.className, n = e.count, a = n === void 0 ? 3 : n, o = e.dateTransform, i = e.dateType, l = e.end, c = e.hover, C = e.offset, s = e.renderTile, u = e.start, f = e.step, h = f === void 0 ? 1 : f, d = e.value, v = e.valueType, m = [], g = u; g <= l; g += h) {
    var L = o(g);
    m.push(s({
      classes: zt({
        date: L,
        dateType: i,
        hover: c,
        value: d,
        valueType: v
      }),
      date: L
    }));
  }
  return t.createElement(p5, { className: r, count: a, offset: C, wrap: !0 }, m);
}
function h3(e) {
  var r = e.activeStartDate, n = e.children, a = e.classes, o = e.date, i = e.formatAbbr, l = e.locale, c = e.maxDate, C = e.maxDateTransform, s = e.minDate, u = e.minDateTransform, f = e.onClick, h = e.onMouseOver, d = e.style, v = e.tileClassName, m = e.tileContent, g = e.tileDisabled, L = e.view, E = z1(function() {
    var O = { activeStartDate: r, date: o, view: L };
    return typeof v == "function" ? v(O) : v;
  }, [r, o, v, L]), V = z1(function() {
    var O = { activeStartDate: r, date: o, view: L };
    return typeof m == "function" ? m(O) : m;
  }, [r, o, m, L]);
  return t.createElement(
    "button",
    { className: c3(a, E), disabled: s && u(s) > o || c && C(c) < o || g && g({ activeStartDate: r, date: o, view: L }), onClick: f ? function(O) {
      return f(o, O);
    } : void 0, onFocus: h ? function() {
      return h(o);
    } : void 0, onMouseOver: h ? function() {
      return h(o);
    } : void 0, style: d, type: "button" },
    i ? t.createElement("abbr", { "aria-label": i(l, o) }, n) : n,
    V
  );
}
var U3 = function() {
  return U3 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, U3.apply(this, arguments);
}, qt = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
}, i4 = "react-calendar__century-view__decades__decade";
function Xt(e) {
  var r = e.classes, n = r === void 0 ? [] : r, a = e.currentCentury, o = e.formatYear, i = o === void 0 ? d3 : o, l = qt(e, ["classes", "currentCentury", "formatYear"]), c = l.date, C = l.locale, s = [];
  return n && s.push.apply(s, n), s.push(i4), h2(c).getFullYear() !== a && s.push("".concat(i4, "--neighboringCentury")), t.createElement(h3, U3({}, l, { classes: s, maxDateTransform: s3, minDateTransform: q1, view: "century" }), C9(C, i, c));
}
var q3 = function() {
  return q3 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, q3.apply(this, arguments);
}, l4 = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
};
function Kt(e) {
  var r = e.activeStartDate, n = e.hover, a = e.showNeighboringCentury, o = e.value, i = e.valueType, l = l4(e, ["activeStartDate", "hover", "showNeighboringCentury", "value", "valueType"]), c = Mt(r), C = c + (a ? 119 : 99);
  return t.createElement(m3, { className: "react-calendar__century-view__decades", dateTransform: q1, dateType: "decade", end: C, hover: n, renderTile: function(s) {
    var u = s.date, f = l4(s, ["date"]);
    return t.createElement(Xt, q3({ key: u.getTime() }, l, f, { activeStartDate: r, currentCentury: c, date: u }));
  }, start: c, step: 10, value: o, valueType: i });
}
var c4 = function(e, r, n) {
  if (n || arguments.length === 2) for (var a = 0, o = r.length, i; a < o; a++)
    (i || !(a in r)) && (i || (i = Array.prototype.slice.call(r, 0, a)), i[a] = r[a]);
  return e.concat(i || Array.prototype.slice.call(r));
}, Jt = Object.values(i1), Qt = Object.values(l2), X3 = ["century", "decade", "year", "month"], d9 = b.oneOf(c4(c4([], Jt, !0), Qt, !0)), Q2 = b.oneOfType([
  b.string,
  b.arrayOf(b.string)
]), f9 = function(r, n, a) {
  var o = r, i = n, l = o[i];
  if (!l)
    return null;
  if (!(l instanceof Date))
    return new Error("Invalid prop `".concat(n, "` of type `").concat(typeof l, "` supplied to `").concat(a, "`, expected instance of `Date`."));
  var c = r.maxDate;
  return c && l > c ? new Error("Invalid prop `".concat(n, "` of type `").concat(typeof l, "` supplied to `").concat(a, "`, minDate cannot be larger than maxDate.")) : null;
}, m9 = function(r, n, a) {
  var o = r, i = n, l = o[i];
  if (!l)
    return null;
  if (!(l instanceof Date))
    return new Error("Invalid prop `".concat(n, "` of type `").concat(typeof l, "` supplied to `").concat(a, "`, expected instance of `Date`."));
  var c = r.minDate;
  return c && l < c ? new Error("Invalid prop `".concat(n, "` of type `").concat(typeof l, "` supplied to `").concat(a, "`, maxDate cannot be smaller than minDate.")) : null;
}, er = b.oneOfType([
  b.func,
  b.exact({
    current: b.any
  })
]), tr = b.arrayOf(b.oneOfType([b.instanceOf(Date), b.oneOf([null])]).isRequired), rr = b.oneOfType([
  b.instanceOf(Date),
  b.oneOf([null]),
  tr
]);
b.arrayOf(b.oneOf(X3));
var e3 = function(r, n, a) {
  var o = r, i = n, l = o[i];
  return l !== void 0 && (typeof l != "string" || X3.indexOf(l) === -1) ? new Error("Invalid prop `".concat(n, "` of value `").concat(l, "` supplied to `").concat(a, "`, expected one of [").concat(X3.map(function(c) {
    return '"'.concat(c, '"');
  }).join(", "), "].")) : null;
};
e3.isRequired = function(r, n, a, o, i) {
  var l = r, c = n, C = l[c];
  return C ? e3(r, n, a) : new Error("The prop `".concat(n, "` is marked as required in `").concat(a, "`, but its value is `").concat(C, "`."));
};
var nr = function(e) {
  return b.arrayOf(e);
}, v3 = {
  activeStartDate: b.instanceOf(Date).isRequired,
  hover: b.instanceOf(Date),
  locale: b.string,
  maxDate: m9,
  minDate: f9,
  onClick: b.func,
  onMouseOver: b.func,
  tileClassName: b.oneOfType([b.func, Q2]),
  tileContent: b.oneOfType([b.func, b.node]),
  value: rr,
  valueType: b.oneOf(["century", "decade", "year", "month", "day"]).isRequired
};
b.instanceOf(Date).isRequired, b.arrayOf(b.string.isRequired).isRequired, b.instanceOf(Date).isRequired, b.string, b.func, b.func, b.objectOf(b.oneOfType([b.string, b.number])), b.oneOfType([b.func, Q2]), b.oneOfType([b.func, b.node]), b.func;
var M2 = function() {
  return M2 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, M2.apply(this, arguments);
}, h9 = function(r) {
  function n() {
    return t.createElement(Kt, M2({}, r));
  }
  return t.createElement("div", { className: "react-calendar__century-view" }, n());
};
h9.propTypes = M2(M2({}, v3), { showNeighboringCentury: b.bool });
var K3 = function() {
  return K3 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, K3.apply(this, arguments);
}, or = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
}, C4 = "react-calendar__decade-view__years__year";
function ar(e) {
  var r = e.classes, n = r === void 0 ? [] : r, a = e.currentDecade, o = e.formatYear, i = o === void 0 ? d3 : o, l = or(e, ["classes", "currentDecade", "formatYear"]), c = l.date, C = l.locale, s = [];
  return n && s.push.apply(s, n), s.push(C4), q1(c).getFullYear() !== a && s.push("".concat(C4, "--neighboringDecade")), t.createElement(h3, K3({}, l, { classes: s, maxDateTransform: u3, minDateTransform: v2, view: "decade" }), i(C, c));
}
var J3 = function() {
  return J3 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, J3.apply(this, arguments);
}, s4 = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
};
function ir(e) {
  var r = e.activeStartDate, n = e.hover, a = e.showNeighboringDecade, o = e.value, i = e.valueType, l = s4(e, ["activeStartDate", "hover", "showNeighboringDecade", "value", "valueType"]), c = Vt(r), C = c + (a ? 11 : 9);
  return t.createElement(m3, { className: "react-calendar__decade-view__years", dateTransform: v2, dateType: "year", end: C, hover: n, renderTile: function(s) {
    var u = s.date, f = s4(s, ["date"]);
    return t.createElement(ar, J3({ key: u.getTime() }, l, f, { activeStartDate: r, currentDecade: c, date: u }));
  }, start: c, value: o, valueType: i });
}
var V2 = function() {
  return V2 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, V2.apply(this, arguments);
}, v9 = function(r) {
  function n() {
    return t.createElement(ir, V2({}, r));
  }
  return t.createElement("div", { className: "react-calendar__decade-view" }, n());
};
v9.propTypes = V2(V2({}, v3), { showNeighboringDecade: b.bool });
var Q3 = function() {
  return Q3 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, Q3.apply(this, arguments);
}, lr = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
}, u4 = function(e, r, n) {
  if (n || arguments.length === 2) for (var a = 0, o = r.length, i; a < o; a++)
    (i || !(a in r)) && (i || (i = Array.prototype.slice.call(r, 0, a)), i[a] = r[a]);
  return e.concat(i || Array.prototype.slice.call(r));
}, cr = "react-calendar__year-view__months__month";
function Cr(e) {
  var r = e.classes, n = r === void 0 ? [] : r, a = e.formatMonth, o = a === void 0 ? Et : a, i = e.formatMonthYear, l = i === void 0 ? a9 : i, c = lr(e, ["classes", "formatMonth", "formatMonthYear"]), C = c.date, s = c.locale;
  return t.createElement(h3, Q3({}, c, { classes: u4(u4([], n, !0), [cr], !1), formatAbbr: l, maxDateTransform: _2, minDateTransform: n2, view: "year" }), o(s, C));
}
var e5 = function() {
  return e5 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, e5.apply(this, arguments);
}, d4 = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
};
function sr(e) {
  var r = e.activeStartDate, n = e.hover, a = e.value, o = e.valueType, i = d4(e, ["activeStartDate", "hover", "value", "valueType"]), l = 0, c = 11, C = C1(r);
  return t.createElement(m3, { className: "react-calendar__year-view__months", dateTransform: function(s) {
    var u = /* @__PURE__ */ new Date();
    return u.setFullYear(C, s, 1), n2(u);
  }, dateType: "month", end: c, hover: n, renderTile: function(s) {
    var u = s.date, f = d4(s, ["date"]);
    return t.createElement(Cr, e5({ key: u.getTime() }, i, f, { activeStartDate: r, date: u }));
  }, start: l, value: a, valueType: o });
}
var t3 = function() {
  return t3 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, t3.apply(this, arguments);
}, g9 = function(r) {
  function n() {
    return t.createElement(sr, t3({}, r));
  }
  return t.createElement("div", { className: "react-calendar__year-view" }, n());
};
g9.propTypes = t3({}, v3);
var t5 = function() {
  return t5 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, t5.apply(this, arguments);
}, ur = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
}, I3 = "react-calendar__month-view__days__day";
function dr(e) {
  var r = e.calendarType, n = e.classes, a = n === void 0 ? [] : n, o = e.currentMonthIndex, i = e.formatDay, l = i === void 0 ? wt : i, c = e.formatLongDate, C = c === void 0 ? bt : c, s = ur(e, ["calendarType", "classes", "currentMonthIndex", "formatDay", "formatLongDate"]), u = f3(r), f = s.date, h = s.locale, d = [];
  return a && d.push.apply(d, a), d.push(I3), s9(f, u) && d.push("".concat(I3, "--weekend")), f.getMonth() !== o && d.push("".concat(I3, "--neighboringMonth")), t.createElement(h3, t5({}, s, { classes: d, formatAbbr: C, maxDateTransform: v5, minDateTransform: B2, view: "month" }), l(h, f));
}
var r5 = function() {
  return r5 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, r5.apply(this, arguments);
}, f4 = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
};
function fr(e) {
  var r = e.activeStartDate, n = e.calendarType, a = e.hover, o = e.showFixedNumberOfWeeks, i = e.showNeighboringMonth, l = e.value, c = e.valueType, C = f4(e, ["activeStartDate", "calendarType", "hover", "showFixedNumberOfWeeks", "showNeighboringMonth", "value", "valueType"]), s = f3(n), u = C1(r), f = U1(r), h = o || i, d = x2(r, s), v = h ? 0 : d, m = (h ? -d : 0) + 1, g = (function() {
    if (o)
      return m + 42 - 1;
    var L = o9(r);
    if (i) {
      var E = /* @__PURE__ */ new Date();
      E.setFullYear(u, f, L), E.setHours(0, 0, 0, 0);
      var V = 7 - x2(E, s) - 1;
      return L + V;
    }
    return L;
  })();
  return t.createElement(m3, { className: "react-calendar__month-view__days", count: 7, dateTransform: function(L) {
    var E = /* @__PURE__ */ new Date();
    return E.setFullYear(u, f, L), B2(E);
  }, dateType: "day", hover: a, end: g, renderTile: function(L) {
    var E = L.date, V = f4(L, ["date"]);
    return t.createElement(dr, r5({ key: E.getTime() }, C, V, { activeStartDate: r, calendarType: n, currentMonthIndex: f, date: E }));
  }, offset: v, start: m, value: l, valueType: c });
}
var p9 = "react-calendar__month-view__weekdays", N3 = "".concat(p9, "__weekday");
function mr(e) {
  for (var r = e.calendarType, n = e.formatShortWeekday, a = n === void 0 ? kt : n, o = e.formatWeekday, i = o === void 0 ? Lt : o, l = e.locale, c = e.onMouseLeave, C = f3(r), s = /* @__PURE__ */ new Date(), u = n2(s), f = C1(u), h = U1(u), d = [], v = 1; v <= 7; v += 1) {
    var m = new Date(f, h, v - x2(u, C)), g = i(l, m);
    d.push(t.createElement(
      "div",
      { key: v, className: c3(N3, Wt(m) && "".concat(N3, "--current"), s9(m, C) && "".concat(N3, "--weekend")) },
      t.createElement("abbr", { "aria-label": g, title: g }, a(l, m).replace(".", ""))
    ));
  }
  return t.createElement(p5, { className: p9, count: 7, onFocus: c, onMouseOver: c }, d);
}
var r3 = function() {
  return r3 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, r3.apply(this, arguments);
}, m4 = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
}, h4 = "react-calendar__tile";
function hr(e) {
  var r = e.onClickWeekNumber, n = e.weekNumber, a = t.createElement("span", null, n);
  if (r) {
    var o = e.date, i = e.onClickWeekNumber, l = e.weekNumber, c = m4(e, ["date", "onClickWeekNumber", "weekNumber"]);
    return t.createElement("button", r3({}, c, { className: h4, onClick: function(C) {
      return i(l, o, C);
    }, type: "button" }), a);
  } else {
    e.date, e.onClickWeekNumber, e.weekNumber;
    var c = m4(e, ["date", "onClickWeekNumber", "weekNumber"]);
    return t.createElement("div", r3({}, c, { className: h4 }), a);
  }
}
function vr(e) {
  var r = e.activeStartDate, n = e.calendarType, a = e.onClickWeekNumber, o = e.onMouseLeave, i = e.showFixedNumberOfWeeks, l = f3(n), c = (function() {
    if (i)
      return 6;
    var u = o9(r), f = x2(r, l), h = u - (7 - f);
    return 1 + Math.ceil(h / 7);
  })(), C = (function() {
    for (var u = C1(r), f = U1(r), h = C3(r), d = [], v = 0; v < c; v += 1)
      d.push(Y3(new Date(u, f, h + v * 7), l));
    return d;
  })(), s = C.map(function(u) {
    return $t(u, l);
  });
  return t.createElement(p5, { className: "react-calendar__month-view__weekNumbers", count: c, direction: "column", onFocus: o, onMouseOver: o, style: { flexBasis: "calc(100% * (1 / 8)", flexShrink: 0 } }, s.map(function(u, f) {
    var h = C[f];
    if (!h)
      throw new Error("date is not defined");
    return t.createElement(hr, { key: u, date: h, onClickWeekNumber: a, weekNumber: u });
  }));
}
var $2 = function() {
  return $2 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, $2.apply(this, arguments);
}, gr = function(e, r) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
      r.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
  return n;
};
function pr(e) {
  if (e)
    for (var r = 0, n = Object.entries(st); r < n.length; r++) {
      var a = n[r], o = a[0], i = a[1];
      if (i.includes(e))
        return o;
    }
  return i1.ISO_8601;
}
var y9 = function(r) {
  var n = r.activeStartDate, a = r.locale, o = r.onMouseLeave, i = r.showFixedNumberOfWeeks, l = r.calendarType, c = l === void 0 ? pr(a) : l, C = r.formatShortWeekday, s = r.formatWeekday, u = r.onClickWeekNumber, f = r.showWeekNumbers, h = gr(r, ["calendarType", "formatShortWeekday", "formatWeekday", "onClickWeekNumber", "showWeekNumbers"]);
  function d() {
    return t.createElement(mr, { calendarType: c, formatShortWeekday: C, formatWeekday: s, locale: a, onMouseLeave: o });
  }
  function v() {
    return f ? t.createElement(vr, { activeStartDate: n, calendarType: c, onClickWeekNumber: u, onMouseLeave: o, showFixedNumberOfWeeks: i }) : null;
  }
  function m() {
    return t.createElement(fr, $2({ calendarType: c }, h));
  }
  var g = "react-calendar__month-view";
  return t.createElement(
    "div",
    { className: c3(g, f ? "".concat(g, "--weekNumbers") : "") },
    t.createElement(
      "div",
      { style: {
        display: "flex",
        alignItems: "flex-end"
      } },
      v(),
      t.createElement(
        "div",
        { style: {
          flexGrow: 1,
          width: "100%"
        } },
        d(),
        m()
      )
    )
  );
};
y9.propTypes = $2($2({}, v3), { calendarType: d9, formatDay: b.func, formatLongDate: b.func, formatShortWeekday: b.func, formatWeekday: b.func, onClickWeekNumber: b.func, onMouseLeave: b.func, showFixedNumberOfWeeks: b.bool, showNeighboringMonth: b.bool, showWeekNumbers: b.bool });
var C2 = function() {
  return C2 = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, C2.apply(this, arguments);
}, Y2 = "react-calendar", s2 = ["century", "decade", "year", "month"], yr = ["decade", "year", "month", "day"], y5 = /* @__PURE__ */ new Date();
y5.setFullYear(1, 0, 1);
y5.setHours(0, 0, 0, 0);
var wr = /* @__PURE__ */ new Date(864e13);
function E2(e) {
  return e instanceof Date ? e : new Date(e);
}
function w9(e, r) {
  return s2.slice(s2.indexOf(e), s2.indexOf(r) + 1);
}
function br(e, r, n) {
  var a = w9(r, n);
  return a.indexOf(e) !== -1;
}
function w5(e, r, n) {
  return e && br(e, r, n) ? e : n;
}
function b9(e) {
  var r = s2.indexOf(e);
  return yr[r];
}
function Er(e, r) {
  var n = Array.isArray(e) ? e[r] : e;
  if (!n)
    return null;
  var a = E2(n);
  if (isNaN(a.getTime()))
    throw new Error("Invalid date: ".concat(e));
  return a;
}
function E9(e, r) {
  var n = e.value, a = e.minDate, o = e.maxDate, i = e.maxDetail, l = Er(n, r);
  if (!l)
    return null;
  var c = b9(i), C = (function() {
    switch (r) {
      case 0:
        return e2(c, l);
      case 1:
        return l9(c, l);
      default:
        throw new Error("Invalid index value: ".concat(r));
    }
  })();
  return Ft(C, a, o);
}
var b5 = function(e) {
  return E9(e, 0);
}, k9 = function(e) {
  return E9(e, 1);
}, kr = function(e) {
  return [b5, k9].map(function(r) {
    return r(e);
  });
};
function L9(e) {
  var r = e.maxDate, n = e.maxDetail, a = e.minDate, o = e.minDetail, i = e.value, l = e.view, c = w5(l, o, n), C = b5({
    value: i,
    minDate: a,
    maxDate: r,
    maxDetail: n
  }) || /* @__PURE__ */ new Date();
  return e2(c, C);
}
function Lr(e) {
  var r = e.activeStartDate, n = e.defaultActiveStartDate, a = e.defaultValue, o = e.defaultView, i = e.maxDate, l = e.maxDetail, c = e.minDate, C = e.minDetail, s = e.value, u = e.view, f = w5(u, C, l), h = r || n;
  return h ? e2(f, h) : L9({
    maxDate: i,
    maxDetail: l,
    minDate: c,
    minDetail: C,
    value: s || a,
    view: u || o
  });
}
function F3(e) {
  return e && (!Array.isArray(e) || e.length === 1);
}
function U2(e, r) {
  return e instanceof Date && r instanceof Date && e.getTime() === r.getTime();
}
var x9 = T4(function(r, n) {
  var a = r.activeStartDate, o = r.allowPartialRange, i = r.calendarType, l = r.className, c = r.defaultActiveStartDate, C = r.defaultValue, s = r.defaultView, u = r.formatDay, f = r.formatLongDate, h = r.formatMonth, d = r.formatMonthYear, v = r.formatShortWeekday, m = r.formatWeekday, g = r.formatYear, L = r.goToRangeStartOnSelect, E = L === void 0 ? !0 : L, V = r.inputRef, O = r.locale, D = r.maxDate, H = D === void 0 ? wr : D, F = r.maxDetail, _ = F === void 0 ? "month" : F, Y = r.minDate, W = Y === void 0 ? y5 : Y, A = r.minDetail, N = A === void 0 ? "century" : A, j = r.navigationAriaLabel, J = r.navigationAriaLive, X = r.navigationLabel, B = r.next2AriaLabel, U = r.next2Label, a1 = r.nextAriaLabel, t1 = r.nextLabel, w = r.onActiveStartDateChange, p = r.onChange, $ = r.onClickDay, x = r.onClickDecade, S = r.onClickMonth, T = r.onClickWeekNumber, R = r.onClickYear, M = r.onDrillDown, Z = r.onDrillUp, P = r.onViewChange, q = r.prev2AriaLabel, m1 = r.prev2Label, s1 = r.prevAriaLabel, b1 = r.prevLabel, u1 = r.returnValue, A1 = u1 === void 0 ? "start" : u1, p1 = r.selectRange, I1 = r.showDoubleView, a2 = r.showFixedNumberOfWeeks, I = r.showNavigation, r1 = I === void 0 ? !0 : I, h1 = r.showNeighboringCentury, D1 = r.showNeighboringDecade, _1 = r.showNeighboringMonth, K1 = _1 === void 0 ? !0 : _1, R2 = r.showWeekNumbers, j2 = r.tileClassName, A2 = r.tileContent, I2 = r.tileDisabled, b3 = r.value, S5 = r.view, Z5 = c1(c), te = Z5[0], N2 = Z5[1], D5 = c1(null), re = D5[0], _5 = D5[1], B5 = c1(Array.isArray(C) ? C.map(function(K) {
    return K !== null ? E2(K) : null;
  }) : C != null ? E2(C) : null), E3 = B5[0], ne = B5[1], T5 = c1(s), oe = T5[0], W5 = T5[1], E1 = a || te || Lr({
    activeStartDate: a,
    defaultActiveStartDate: c,
    defaultValue: C,
    defaultView: s,
    maxDate: H,
    maxDetail: _,
    minDate: W,
    minDetail: N,
    value: b3,
    view: S5
  }), k1 = (function() {
    var K = (function() {
      return p1 && F3(E3) ? E3 : b3 !== void 0 ? b3 : E3;
    })();
    return K ? Array.isArray(K) ? K.map(function(v1) {
      return v1 !== null ? E2(v1) : null;
    }) : K !== null ? E2(K) : null : null;
  })(), F2 = b9(_), d1 = w5(S5 || oe, N, _), B1 = w9(N, _), ae = p1 ? re : null, k3 = B1.indexOf(d1) < B1.length - 1, R5 = B1.indexOf(d1) > 0, j5 = n1(function(K) {
    var v1 = (function() {
      switch (A1) {
        case "start":
          return b5;
        case "end":
          return k9;
        case "range":
          return kr;
        default:
          throw new Error("Invalid returnValue.");
      }
    })();
    return v1({
      maxDate: H,
      maxDetail: _,
      minDate: W,
      value: K
    });
  }, [H, _, W, A1]), L3 = n1(function(K, v1) {
    N2(K);
    var g1 = {
      action: v1,
      activeStartDate: K,
      value: k1,
      view: d1
    };
    w && !U2(E1, K) && w(g1);
  }, [E1, w, k1, d1]), P2 = n1(function(K, v1) {
    var g1 = (function() {
      switch (d1) {
        case "century":
          return x;
        case "decade":
          return R;
        case "year":
          return S;
        case "month":
          return $;
        default:
          throw new Error("Invalid view: ".concat(d1, "."));
      }
    })();
    g1 && g1(K, v1);
  }, [$, x, S, R, d1]), x3 = n1(function(K, v1) {
    if (k3) {
      P2(K, v1);
      var g1 = B1[B1.indexOf(d1) + 1];
      if (!g1)
        throw new Error("Attempted to drill down from the lowest view.");
      N2(K), W5(g1);
      var S1 = {
        action: "drillDown",
        activeStartDate: K,
        value: k1,
        view: g1
      };
      w && !U2(E1, K) && w(S1), P && d1 !== g1 && P(S1), M && M(S1);
    }
  }, [
    E1,
    k3,
    w,
    P2,
    M,
    P,
    k1,
    d1,
    B1
  ]), H3 = n1(function() {
    if (R5) {
      var K = B1[B1.indexOf(d1) - 1];
      if (!K)
        throw new Error("Attempted to drill up from the highest view.");
      var v1 = e2(K, E1);
      N2(v1), W5(K);
      var g1 = {
        action: "drillUp",
        activeStartDate: v1,
        value: k1,
        view: K
      };
      w && !U2(E1, v1) && w(g1), P && d1 !== K && P(g1), Z && Z(g1);
    }
  }, [
    E1,
    R5,
    w,
    Z,
    P,
    k1,
    d1,
    B1
  ]), M3 = n1(function(K, v1) {
    var g1 = k1;
    P2(K, v1);
    var S1 = p1 && !F3(g1), Z1;
    if (p1)
      if (S1)
        Z1 = e2(F2, K);
      else {
        if (!g1)
          throw new Error("previousValue is required");
        if (Array.isArray(g1))
          throw new Error("previousValue must not be an array");
        Z1 = Bt(F2, g1, K);
      }
    else
      Z1 = j5(K);
    var $3 = (
      // Range selection turned off
      !p1 || // Range selection turned on, first value
      S1 || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
      E ? L9({
        maxDate: H,
        maxDetail: _,
        minDate: W,
        minDetail: N,
        value: Z1,
        view: d1
      }) : null
    );
    v1.persist(), N2($3), ne(Z1);
    var Ce = {
      action: "onChange",
      activeStartDate: $3,
      value: Z1,
      view: d1
    };
    if (w && !U2(E1, $3) && w(Ce), p)
      if (p1) {
        var se = F3(Z1);
        if (!se)
          p(Z1 || null, v1);
        else if (o) {
          if (Array.isArray(Z1))
            throw new Error("value must not be an array");
          p([Z1 || null, null], v1);
        }
      } else
        p(Z1 || null, v1);
  }, [
    E1,
    o,
    j5,
    E,
    H,
    _,
    W,
    N,
    w,
    p,
    P2,
    p1,
    k1,
    F2,
    d1
  ]);
  function ie(K) {
    _5(K);
  }
  function V3() {
    _5(null);
  }
  ue(n, function() {
    return {
      activeStartDate: E1,
      drillDown: x3,
      drillUp: H3,
      onChange: M3,
      setActiveStartDate: L3,
      value: k1,
      view: d1
    };
  }, [E1, x3, H3, M3, L3, k1, d1]);
  function A5(K) {
    var v1 = K ? i9(d1, E1) : e2(d1, E1), g1 = k3 ? x3 : M3, S1 = {
      activeStartDate: v1,
      hover: ae,
      locale: O,
      maxDate: H,
      minDate: W,
      onClick: g1,
      onMouseOver: p1 ? ie : void 0,
      tileClassName: j2,
      tileContent: A2,
      tileDisabled: I2,
      value: k1,
      valueType: F2
    };
    switch (d1) {
      case "century":
        return t.createElement(h9, C2({ formatYear: g, showNeighboringCentury: h1 }, S1));
      case "decade":
        return t.createElement(v9, C2({ formatYear: g, showNeighboringDecade: D1 }, S1));
      case "year":
        return t.createElement(g9, C2({ formatMonth: h, formatMonthYear: d }, S1));
      case "month":
        return t.createElement(y9, C2({ calendarType: i, formatDay: u, formatLongDate: f, formatShortWeekday: v, formatWeekday: m, onClickWeekNumber: T, onMouseLeave: p1 ? V3 : void 0, showFixedNumberOfWeeks: typeof a2 < "u" ? a2 : I1, showNeighboringMonth: K1, showWeekNumbers: R2 }, S1));
      default:
        throw new Error("Invalid view: ".concat(d1, "."));
    }
  }
  function le() {
    return r1 ? t.createElement(Rt, { activeStartDate: E1, drillUp: H3, formatMonthYear: d, formatYear: g, locale: O, maxDate: H, minDate: W, navigationAriaLabel: j, navigationAriaLive: J, navigationLabel: X, next2AriaLabel: B, next2Label: U, nextAriaLabel: a1, nextLabel: t1, prev2AriaLabel: q, prev2Label: m1, prevAriaLabel: s1, prevLabel: b1, setActiveStartDate: L3, showDoubleView: I1, view: d1, views: B1 }) : null;
  }
  var ce = Array.isArray(k1) ? k1 : [k1];
  return t.createElement(
    "div",
    { className: c3(Y2, p1 && ce.length === 1 && "".concat(Y2, "--selectRange"), I1 && "".concat(Y2, "--doubleView"), l), ref: V },
    le(),
    t.createElement(
      "div",
      { className: "".concat(Y2, "__viewContainer"), onBlur: p1 ? V3 : void 0, onMouseLeave: p1 ? V3 : void 0 },
      A5(),
      I1 ? A5(!0) : null
    )
  );
}), v4 = b.instanceOf(Date), g4 = b.oneOfType([b.string, b.instanceOf(Date)]), p4 = b.oneOfType([g4, nr(g4)]);
x9.propTypes = {
  activeStartDate: v4,
  allowPartialRange: b.bool,
  calendarType: d9,
  className: Q2,
  defaultActiveStartDate: v4,
  defaultValue: p4,
  defaultView: e3,
  formatDay: b.func,
  formatLongDate: b.func,
  formatMonth: b.func,
  formatMonthYear: b.func,
  formatShortWeekday: b.func,
  formatWeekday: b.func,
  formatYear: b.func,
  goToRangeStartOnSelect: b.bool,
  inputRef: er,
  locale: b.string,
  maxDate: m9,
  maxDetail: b.oneOf(s2),
  minDate: f9,
  minDetail: b.oneOf(s2),
  navigationAriaLabel: b.string,
  navigationAriaLive: b.oneOf(["off", "polite", "assertive"]),
  navigationLabel: b.func,
  next2AriaLabel: b.string,
  next2Label: b.node,
  nextAriaLabel: b.string,
  nextLabel: b.node,
  onActiveStartDateChange: b.func,
  onChange: b.func,
  onClickDay: b.func,
  onClickDecade: b.func,
  onClickMonth: b.func,
  onClickWeekNumber: b.func,
  onClickYear: b.func,
  onDrillDown: b.func,
  onDrillUp: b.func,
  onViewChange: b.func,
  prev2AriaLabel: b.string,
  prev2Label: b.node,
  prevAriaLabel: b.string,
  prevLabel: b.node,
  returnValue: b.oneOf(["start", "end", "range"]),
  selectRange: b.bool,
  showDoubleView: b.bool,
  showFixedNumberOfWeeks: b.bool,
  showNavigation: b.bool,
  showNeighboringCentury: b.bool,
  showNeighboringDecade: b.bool,
  showNeighboringMonth: b.bool,
  showWeekNumbers: b.bool,
  tileClassName: b.oneOfType([b.func, Q2]),
  tileContent: b.oneOfType([b.func, b.node]),
  tileDisabled: b.func,
  value: p4,
  view: e3
};
var y4 = function(r) {
  return r.reduce(function(n, a) {
    var o = a[0], i = a[1];
    return n[o] = i, n;
  }, {});
}, w4 = typeof window < "u" && window.document && window.document.createElement ? Q1.useLayoutEffect : Q1.useEffect, L1 = "top", $1 = "bottom", O1 = "right", x1 = "left", E5 = "auto", T2 = [L1, $1, O1, x1], u2 = "start", O2 = "end", xr = "clippingParents", H9 = "viewport", w2 = "popper", Hr = "reference", b4 = /* @__PURE__ */ T2.reduce(function(e, r) {
  return e.concat([r + "-" + u2, r + "-" + O2]);
}, []), M9 = /* @__PURE__ */ [].concat(T2, [E5]).reduce(function(e, r) {
  return e.concat([r, r + "-" + u2, r + "-" + O2]);
}, []), Mr = "beforeRead", Vr = "read", $r = "afterRead", Or = "beforeMain", Sr = "main", Zr = "afterMain", Dr = "beforeWrite", _r = "write", Br = "afterWrite", Tr = [Mr, Vr, $r, Or, Sr, Zr, Dr, _r, Br];
function j1(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function M1(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var r = e.ownerDocument;
    return r && r.defaultView || window;
  }
  return e;
}
function r2(e) {
  var r = M1(e).Element;
  return e instanceof r || e instanceof Element;
}
function V1(e) {
  var r = M1(e).HTMLElement;
  return e instanceof r || e instanceof HTMLElement;
}
function k5(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var r = M1(e).ShadowRoot;
  return e instanceof r || e instanceof ShadowRoot;
}
function Wr(e) {
  var r = e.state;
  Object.keys(r.elements).forEach(function(n) {
    var a = r.styles[n] || {}, o = r.attributes[n] || {}, i = r.elements[n];
    !V1(i) || !j1(i) || (Object.assign(i.style, a), Object.keys(o).forEach(function(l) {
      var c = o[l];
      c === !1 ? i.removeAttribute(l) : i.setAttribute(l, c === !0 ? "" : c);
    }));
  });
}
function Rr(e) {
  var r = e.state, n = {
    popper: {
      position: r.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(r.elements.popper.style, n.popper), r.styles = n, r.elements.arrow && Object.assign(r.elements.arrow.style, n.arrow), function() {
    Object.keys(r.elements).forEach(function(a) {
      var o = r.elements[a], i = r.attributes[a] || {}, l = Object.keys(r.styles.hasOwnProperty(a) ? r.styles[a] : n[a]), c = l.reduce(function(C, s) {
        return C[s] = "", C;
      }, {});
      !V1(o) || !j1(o) || (Object.assign(o.style, c), Object.keys(i).forEach(function(C) {
        o.removeAttribute(C);
      }));
    });
  };
}
const jr = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Wr,
  effect: Rr,
  requires: ["computeStyles"]
};
function R1(e) {
  return e.split("-")[0];
}
var t2 = Math.max, n3 = Math.min, d2 = Math.round;
function n5() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(r) {
    return r.brand + "/" + r.version;
  }).join(" ") : navigator.userAgent;
}
function V9() {
  return !/^((?!chrome|android).)*safari/i.test(n5());
}
function f2(e, r, n) {
  r === void 0 && (r = !1), n === void 0 && (n = !1);
  var a = e.getBoundingClientRect(), o = 1, i = 1;
  r && V1(e) && (o = e.offsetWidth > 0 && d2(a.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && d2(a.height) / e.offsetHeight || 1);
  var l = r2(e) ? M1(e) : window, c = l.visualViewport, C = !V9() && n, s = (a.left + (C && c ? c.offsetLeft : 0)) / o, u = (a.top + (C && c ? c.offsetTop : 0)) / i, f = a.width / o, h = a.height / i;
  return {
    width: f,
    height: h,
    top: u,
    right: s + f,
    bottom: u + h,
    left: s,
    x: s,
    y: u
  };
}
function L5(e) {
  var r = f2(e), n = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(r.width - n) <= 1 && (n = r.width), Math.abs(r.height - a) <= 1 && (a = r.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: a
  };
}
function $9(e, r) {
  var n = r.getRootNode && r.getRootNode();
  if (e.contains(r))
    return !0;
  if (n && k5(n)) {
    var a = r;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function F1(e) {
  return M1(e).getComputedStyle(e);
}
function Ar(e) {
  return ["table", "td", "th"].indexOf(j1(e)) >= 0;
}
function X1(e) {
  return ((r2(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function g3(e) {
  return j1(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (k5(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    X1(e)
  );
}
function E4(e) {
  return !V1(e) || // https://github.com/popperjs/popper-core/issues/837
  F1(e).position === "fixed" ? null : e.offsetParent;
}
function Ir(e) {
  var r = /firefox/i.test(n5()), n = /Trident/i.test(n5());
  if (n && V1(e)) {
    var a = F1(e);
    if (a.position === "fixed")
      return null;
  }
  var o = g3(e);
  for (k5(o) && (o = o.host); V1(o) && ["html", "body"].indexOf(j1(o)) < 0; ) {
    var i = F1(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || r && i.willChange === "filter" || r && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function W2(e) {
  for (var r = M1(e), n = E4(e); n && Ar(n) && F1(n).position === "static"; )
    n = E4(n);
  return n && (j1(n) === "html" || j1(n) === "body" && F1(n).position === "static") ? r : n || Ir(e) || r;
}
function x5(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function k2(e, r, n) {
  return t2(e, n3(r, n));
}
function Nr(e, r, n) {
  var a = k2(e, r, n);
  return a > n ? n : a;
}
function O9() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function S9(e) {
  return Object.assign({}, O9(), e);
}
function Z9(e, r) {
  return r.reduce(function(n, a) {
    return n[a] = e, n;
  }, {});
}
var Fr = function(r, n) {
  return r = typeof r == "function" ? r(Object.assign({}, n.rects, {
    placement: n.placement
  })) : r, S9(typeof r != "number" ? r : Z9(r, T2));
};
function Pr(e) {
  var r, n = e.state, a = e.name, o = e.options, i = n.elements.arrow, l = n.modifiersData.popperOffsets, c = R1(n.placement), C = x5(c), s = [x1, O1].indexOf(c) >= 0, u = s ? "height" : "width";
  if (!(!i || !l)) {
    var f = Fr(o.padding, n), h = L5(i), d = C === "y" ? L1 : x1, v = C === "y" ? $1 : O1, m = n.rects.reference[u] + n.rects.reference[C] - l[C] - n.rects.popper[u], g = l[C] - n.rects.reference[C], L = W2(i), E = L ? C === "y" ? L.clientHeight || 0 : L.clientWidth || 0 : 0, V = m / 2 - g / 2, O = f[d], D = E - h[u] - f[v], H = E / 2 - h[u] / 2 + V, F = k2(O, H, D), _ = C;
    n.modifiersData[a] = (r = {}, r[_] = F, r.centerOffset = F - H, r);
  }
}
function Gr(e) {
  var r = e.state, n = e.options, a = n.element, o = a === void 0 ? "[data-popper-arrow]" : a;
  o != null && (typeof o == "string" && (o = r.elements.popper.querySelector(o), !o) || $9(r.elements.popper, o) && (r.elements.arrow = o));
}
const zr = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Pr,
  effect: Gr,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function m2(e) {
  return e.split("-")[1];
}
var Yr = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ur(e, r) {
  var n = e.x, a = e.y, o = r.devicePixelRatio || 1;
  return {
    x: d2(n * o) / o || 0,
    y: d2(a * o) / o || 0
  };
}
function k4(e) {
  var r, n = e.popper, a = e.popperRect, o = e.placement, i = e.variation, l = e.offsets, c = e.position, C = e.gpuAcceleration, s = e.adaptive, u = e.roundOffsets, f = e.isFixed, h = l.x, d = h === void 0 ? 0 : h, v = l.y, m = v === void 0 ? 0 : v, g = typeof u == "function" ? u({
    x: d,
    y: m
  }) : {
    x: d,
    y: m
  };
  d = g.x, m = g.y;
  var L = l.hasOwnProperty("x"), E = l.hasOwnProperty("y"), V = x1, O = L1, D = window;
  if (s) {
    var H = W2(n), F = "clientHeight", _ = "clientWidth";
    if (H === M1(n) && (H = X1(n), F1(H).position !== "static" && c === "absolute" && (F = "scrollHeight", _ = "scrollWidth")), H = H, o === L1 || (o === x1 || o === O1) && i === O2) {
      O = $1;
      var Y = f && H === D && D.visualViewport ? D.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        H[F]
      );
      m -= Y - a.height, m *= C ? 1 : -1;
    }
    if (o === x1 || (o === L1 || o === $1) && i === O2) {
      V = O1;
      var W = f && H === D && D.visualViewport ? D.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        H[_]
      );
      d -= W - a.width, d *= C ? 1 : -1;
    }
  }
  var A = Object.assign({
    position: c
  }, s && Yr), N = u === !0 ? Ur({
    x: d,
    y: m
  }, M1(n)) : {
    x: d,
    y: m
  };
  if (d = N.x, m = N.y, C) {
    var j;
    return Object.assign({}, A, (j = {}, j[O] = E ? "0" : "", j[V] = L ? "0" : "", j.transform = (D.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + m + "px)" : "translate3d(" + d + "px, " + m + "px, 0)", j));
  }
  return Object.assign({}, A, (r = {}, r[O] = E ? m + "px" : "", r[V] = L ? d + "px" : "", r.transform = "", r));
}
function qr(e) {
  var r = e.state, n = e.options, a = n.gpuAcceleration, o = a === void 0 ? !0 : a, i = n.adaptive, l = i === void 0 ? !0 : i, c = n.roundOffsets, C = c === void 0 ? !0 : c, s = {
    placement: R1(r.placement),
    variation: m2(r.placement),
    popper: r.elements.popper,
    popperRect: r.rects.popper,
    gpuAcceleration: o,
    isFixed: r.options.strategy === "fixed"
  };
  r.modifiersData.popperOffsets != null && (r.styles.popper = Object.assign({}, r.styles.popper, k4(Object.assign({}, s, {
    offsets: r.modifiersData.popperOffsets,
    position: r.options.strategy,
    adaptive: l,
    roundOffsets: C
  })))), r.modifiersData.arrow != null && (r.styles.arrow = Object.assign({}, r.styles.arrow, k4(Object.assign({}, s, {
    offsets: r.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: C
  })))), r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-placement": r.placement
  });
}
const Xr = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: qr,
  data: {}
};
var q2 = {
  passive: !0
};
function Kr(e) {
  var r = e.state, n = e.instance, a = e.options, o = a.scroll, i = o === void 0 ? !0 : o, l = a.resize, c = l === void 0 ? !0 : l, C = M1(r.elements.popper), s = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return i && s.forEach(function(u) {
    u.addEventListener("scroll", n.update, q2);
  }), c && C.addEventListener("resize", n.update, q2), function() {
    i && s.forEach(function(u) {
      u.removeEventListener("scroll", n.update, q2);
    }), c && C.removeEventListener("resize", n.update, q2);
  };
}
const Jr = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Kr,
  data: {}
};
var Qr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function X2(e) {
  return e.replace(/left|right|bottom|top/g, function(r) {
    return Qr[r];
  });
}
var en = {
  start: "end",
  end: "start"
};
function L4(e) {
  return e.replace(/start|end/g, function(r) {
    return en[r];
  });
}
function H5(e) {
  var r = M1(e), n = r.pageXOffset, a = r.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: a
  };
}
function M5(e) {
  return f2(X1(e)).left + H5(e).scrollLeft;
}
function tn(e, r) {
  var n = M1(e), a = X1(e), o = n.visualViewport, i = a.clientWidth, l = a.clientHeight, c = 0, C = 0;
  if (o) {
    i = o.width, l = o.height;
    var s = V9();
    (s || !s && r === "fixed") && (c = o.offsetLeft, C = o.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: c + M5(e),
    y: C
  };
}
function rn(e) {
  var r, n = X1(e), a = H5(e), o = (r = e.ownerDocument) == null ? void 0 : r.body, i = t2(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), l = t2(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), c = -a.scrollLeft + M5(e), C = -a.scrollTop;
  return F1(o || n).direction === "rtl" && (c += t2(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: l,
    x: c,
    y: C
  };
}
function V5(e) {
  var r = F1(e), n = r.overflow, a = r.overflowX, o = r.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + a);
}
function D9(e) {
  return ["html", "body", "#document"].indexOf(j1(e)) >= 0 ? e.ownerDocument.body : V1(e) && V5(e) ? e : D9(g3(e));
}
function L2(e, r) {
  var n;
  r === void 0 && (r = []);
  var a = D9(e), o = a === ((n = e.ownerDocument) == null ? void 0 : n.body), i = M1(a), l = o ? [i].concat(i.visualViewport || [], V5(a) ? a : []) : a, c = r.concat(l);
  return o ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(L2(g3(l)))
  );
}
function o5(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function nn(e, r) {
  var n = f2(e, !1, r === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function x4(e, r, n) {
  return r === H9 ? o5(tn(e, n)) : r2(r) ? nn(r, n) : o5(rn(X1(e)));
}
function on(e) {
  var r = L2(g3(e)), n = ["absolute", "fixed"].indexOf(F1(e).position) >= 0, a = n && V1(e) ? W2(e) : e;
  return r2(a) ? r.filter(function(o) {
    return r2(o) && $9(o, a) && j1(o) !== "body";
  }) : [];
}
function an(e, r, n, a) {
  var o = r === "clippingParents" ? on(e) : [].concat(r), i = [].concat(o, [n]), l = i[0], c = i.reduce(function(C, s) {
    var u = x4(e, s, a);
    return C.top = t2(u.top, C.top), C.right = n3(u.right, C.right), C.bottom = n3(u.bottom, C.bottom), C.left = t2(u.left, C.left), C;
  }, x4(e, l, a));
  return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
}
function _9(e) {
  var r = e.reference, n = e.element, a = e.placement, o = a ? R1(a) : null, i = a ? m2(a) : null, l = r.x + r.width / 2 - n.width / 2, c = r.y + r.height / 2 - n.height / 2, C;
  switch (o) {
    case L1:
      C = {
        x: l,
        y: r.y - n.height
      };
      break;
    case $1:
      C = {
        x: l,
        y: r.y + r.height
      };
      break;
    case O1:
      C = {
        x: r.x + r.width,
        y: c
      };
      break;
    case x1:
      C = {
        x: r.x - n.width,
        y: c
      };
      break;
    default:
      C = {
        x: r.x,
        y: r.y
      };
  }
  var s = o ? x5(o) : null;
  if (s != null) {
    var u = s === "y" ? "height" : "width";
    switch (i) {
      case u2:
        C[s] = C[s] - (r[u] / 2 - n[u] / 2);
        break;
      case O2:
        C[s] = C[s] + (r[u] / 2 - n[u] / 2);
        break;
    }
  }
  return C;
}
function S2(e, r) {
  r === void 0 && (r = {});
  var n = r, a = n.placement, o = a === void 0 ? e.placement : a, i = n.strategy, l = i === void 0 ? e.strategy : i, c = n.boundary, C = c === void 0 ? xr : c, s = n.rootBoundary, u = s === void 0 ? H9 : s, f = n.elementContext, h = f === void 0 ? w2 : f, d = n.altBoundary, v = d === void 0 ? !1 : d, m = n.padding, g = m === void 0 ? 0 : m, L = S9(typeof g != "number" ? g : Z9(g, T2)), E = h === w2 ? Hr : w2, V = e.rects.popper, O = e.elements[v ? E : h], D = an(r2(O) ? O : O.contextElement || X1(e.elements.popper), C, u, l), H = f2(e.elements.reference), F = _9({
    reference: H,
    element: V,
    placement: o
  }), _ = o5(Object.assign({}, V, F)), Y = h === w2 ? _ : H, W = {
    top: D.top - Y.top + L.top,
    bottom: Y.bottom - D.bottom + L.bottom,
    left: D.left - Y.left + L.left,
    right: Y.right - D.right + L.right
  }, A = e.modifiersData.offset;
  if (h === w2 && A) {
    var N = A[o];
    Object.keys(W).forEach(function(j) {
      var J = [O1, $1].indexOf(j) >= 0 ? 1 : -1, X = [L1, $1].indexOf(j) >= 0 ? "y" : "x";
      W[j] += N[X] * J;
    });
  }
  return W;
}
function ln(e, r) {
  r === void 0 && (r = {});
  var n = r, a = n.placement, o = n.boundary, i = n.rootBoundary, l = n.padding, c = n.flipVariations, C = n.allowedAutoPlacements, s = C === void 0 ? M9 : C, u = m2(a), f = u ? c ? b4 : b4.filter(function(v) {
    return m2(v) === u;
  }) : T2, h = f.filter(function(v) {
    return s.indexOf(v) >= 0;
  });
  h.length === 0 && (h = f);
  var d = h.reduce(function(v, m) {
    return v[m] = S2(e, {
      placement: m,
      boundary: o,
      rootBoundary: i,
      padding: l
    })[R1(m)], v;
  }, {});
  return Object.keys(d).sort(function(v, m) {
    return d[v] - d[m];
  });
}
function cn(e) {
  if (R1(e) === E5)
    return [];
  var r = X2(e);
  return [L4(e), r, L4(r)];
}
function Cn(e) {
  var r = e.state, n = e.options, a = e.name;
  if (!r.modifiersData[a]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, l = n.altAxis, c = l === void 0 ? !0 : l, C = n.fallbackPlacements, s = n.padding, u = n.boundary, f = n.rootBoundary, h = n.altBoundary, d = n.flipVariations, v = d === void 0 ? !0 : d, m = n.allowedAutoPlacements, g = r.options.placement, L = R1(g), E = L === g, V = C || (E || !v ? [X2(g)] : cn(g)), O = [g].concat(V).reduce(function(S, T) {
      return S.concat(R1(T) === E5 ? ln(r, {
        placement: T,
        boundary: u,
        rootBoundary: f,
        padding: s,
        flipVariations: v,
        allowedAutoPlacements: m
      }) : T);
    }, []), D = r.rects.reference, H = r.rects.popper, F = /* @__PURE__ */ new Map(), _ = !0, Y = O[0], W = 0; W < O.length; W++) {
      var A = O[W], N = R1(A), j = m2(A) === u2, J = [L1, $1].indexOf(N) >= 0, X = J ? "width" : "height", B = S2(r, {
        placement: A,
        boundary: u,
        rootBoundary: f,
        altBoundary: h,
        padding: s
      }), U = J ? j ? O1 : x1 : j ? $1 : L1;
      D[X] > H[X] && (U = X2(U));
      var a1 = X2(U), t1 = [];
      if (i && t1.push(B[N] <= 0), c && t1.push(B[U] <= 0, B[a1] <= 0), t1.every(function(S) {
        return S;
      })) {
        Y = A, _ = !1;
        break;
      }
      F.set(A, t1);
    }
    if (_)
      for (var w = v ? 3 : 1, p = function(T) {
        var R = O.find(function(M) {
          var Z = F.get(M);
          if (Z)
            return Z.slice(0, T).every(function(P) {
              return P;
            });
        });
        if (R)
          return Y = R, "break";
      }, $ = w; $ > 0; $--) {
        var x = p($);
        if (x === "break") break;
      }
    r.placement !== Y && (r.modifiersData[a]._skip = !0, r.placement = Y, r.reset = !0);
  }
}
const sn = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Cn,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function H4(e, r, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - r.height - n.y,
    right: e.right - r.width + n.x,
    bottom: e.bottom - r.height + n.y,
    left: e.left - r.width - n.x
  };
}
function M4(e) {
  return [L1, O1, $1, x1].some(function(r) {
    return e[r] >= 0;
  });
}
function un(e) {
  var r = e.state, n = e.name, a = r.rects.reference, o = r.rects.popper, i = r.modifiersData.preventOverflow, l = S2(r, {
    elementContext: "reference"
  }), c = S2(r, {
    altBoundary: !0
  }), C = H4(l, a), s = H4(c, o, i), u = M4(C), f = M4(s);
  r.modifiersData[n] = {
    referenceClippingOffsets: C,
    popperEscapeOffsets: s,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const dn = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: un
};
function fn(e, r, n) {
  var a = R1(e), o = [x1, L1].indexOf(a) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, r, {
    placement: e
  })) : n, l = i[0], c = i[1];
  return l = l || 0, c = (c || 0) * o, [x1, O1].indexOf(a) >= 0 ? {
    x: c,
    y: l
  } : {
    x: l,
    y: c
  };
}
function mn(e) {
  var r = e.state, n = e.options, a = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, l = M9.reduce(function(u, f) {
    return u[f] = fn(f, r.rects, i), u;
  }, {}), c = l[r.placement], C = c.x, s = c.y;
  r.modifiersData.popperOffsets != null && (r.modifiersData.popperOffsets.x += C, r.modifiersData.popperOffsets.y += s), r.modifiersData[a] = l;
}
const hn = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: mn
};
function vn(e) {
  var r = e.state, n = e.name;
  r.modifiersData[n] = _9({
    reference: r.rects.reference,
    element: r.rects.popper,
    placement: r.placement
  });
}
const gn = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: vn,
  data: {}
};
function pn(e) {
  return e === "x" ? "y" : "x";
}
function yn(e) {
  var r = e.state, n = e.options, a = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, l = n.altAxis, c = l === void 0 ? !1 : l, C = n.boundary, s = n.rootBoundary, u = n.altBoundary, f = n.padding, h = n.tether, d = h === void 0 ? !0 : h, v = n.tetherOffset, m = v === void 0 ? 0 : v, g = S2(r, {
    boundary: C,
    rootBoundary: s,
    padding: f,
    altBoundary: u
  }), L = R1(r.placement), E = m2(r.placement), V = !E, O = x5(L), D = pn(O), H = r.modifiersData.popperOffsets, F = r.rects.reference, _ = r.rects.popper, Y = typeof m == "function" ? m(Object.assign({}, r.rects, {
    placement: r.placement
  })) : m, W = typeof Y == "number" ? {
    mainAxis: Y,
    altAxis: Y
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Y), A = r.modifiersData.offset ? r.modifiersData.offset[r.placement] : null, N = {
    x: 0,
    y: 0
  };
  if (H) {
    if (i) {
      var j, J = O === "y" ? L1 : x1, X = O === "y" ? $1 : O1, B = O === "y" ? "height" : "width", U = H[O], a1 = U + g[J], t1 = U - g[X], w = d ? -_[B] / 2 : 0, p = E === u2 ? F[B] : _[B], $ = E === u2 ? -_[B] : -F[B], x = r.elements.arrow, S = d && x ? L5(x) : {
        width: 0,
        height: 0
      }, T = r.modifiersData["arrow#persistent"] ? r.modifiersData["arrow#persistent"].padding : O9(), R = T[J], M = T[X], Z = k2(0, F[B], S[B]), P = V ? F[B] / 2 - w - Z - R - W.mainAxis : p - Z - R - W.mainAxis, q = V ? -F[B] / 2 + w + Z + M + W.mainAxis : $ + Z + M + W.mainAxis, m1 = r.elements.arrow && W2(r.elements.arrow), s1 = m1 ? O === "y" ? m1.clientTop || 0 : m1.clientLeft || 0 : 0, b1 = (j = A == null ? void 0 : A[O]) != null ? j : 0, u1 = U + P - b1 - s1, A1 = U + q - b1, p1 = k2(d ? n3(a1, u1) : a1, U, d ? t2(t1, A1) : t1);
      H[O] = p1, N[O] = p1 - U;
    }
    if (c) {
      var I1, a2 = O === "x" ? L1 : x1, I = O === "x" ? $1 : O1, r1 = H[D], h1 = D === "y" ? "height" : "width", D1 = r1 + g[a2], _1 = r1 - g[I], K1 = [L1, x1].indexOf(L) !== -1, R2 = (I1 = A == null ? void 0 : A[D]) != null ? I1 : 0, j2 = K1 ? D1 : r1 - F[h1] - _[h1] - R2 + W.altAxis, A2 = K1 ? r1 + F[h1] + _[h1] - R2 - W.altAxis : _1, I2 = d && K1 ? Nr(j2, r1, A2) : k2(d ? j2 : D1, r1, d ? A2 : _1);
      H[D] = I2, N[D] = I2 - r1;
    }
    r.modifiersData[a] = N;
  }
}
const wn = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: yn,
  requiresIfExists: ["offset"]
};
function bn(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function En(e) {
  return e === M1(e) || !V1(e) ? H5(e) : bn(e);
}
function kn(e) {
  var r = e.getBoundingClientRect(), n = d2(r.width) / e.offsetWidth || 1, a = d2(r.height) / e.offsetHeight || 1;
  return n !== 1 || a !== 1;
}
function Ln(e, r, n) {
  n === void 0 && (n = !1);
  var a = V1(r), o = V1(r) && kn(r), i = X1(r), l = f2(e, o, n), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, C = {
    x: 0,
    y: 0
  };
  return (a || !a && !n) && ((j1(r) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  V5(i)) && (c = En(r)), V1(r) ? (C = f2(r, !0), C.x += r.clientLeft, C.y += r.clientTop) : i && (C.x = M5(i))), {
    x: l.left + c.scrollLeft - C.x,
    y: l.top + c.scrollTop - C.y,
    width: l.width,
    height: l.height
  };
}
function xn(e) {
  var r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(i) {
    r.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var l = [].concat(i.requires || [], i.requiresIfExists || []);
    l.forEach(function(c) {
      if (!n.has(c)) {
        var C = r.get(c);
        C && o(C);
      }
    }), a.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), a;
}
function Hn(e) {
  var r = xn(e);
  return Tr.reduce(function(n, a) {
    return n.concat(r.filter(function(o) {
      return o.phase === a;
    }));
  }, []);
}
function Mn(e) {
  var r;
  return function() {
    return r || (r = new Promise(function(n) {
      Promise.resolve().then(function() {
        r = void 0, n(e());
      });
    })), r;
  };
}
function Vn(e) {
  var r = e.reduce(function(n, a) {
    var o = n[a.name];
    return n[a.name] = o ? Object.assign({}, o, a, {
      options: Object.assign({}, o.options, a.options),
      data: Object.assign({}, o.data, a.data)
    }) : a, n;
  }, {});
  return Object.keys(r).map(function(n) {
    return r[n];
  });
}
var V4 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function $4() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  return !r.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function $n(e) {
  e === void 0 && (e = {});
  var r = e, n = r.defaultModifiers, a = n === void 0 ? [] : n, o = r.defaultOptions, i = o === void 0 ? V4 : o;
  return function(c, C, s) {
    s === void 0 && (s = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, V4, i),
      modifiersData: {},
      elements: {
        reference: c,
        popper: C
      },
      attributes: {},
      styles: {}
    }, f = [], h = !1, d = {
      state: u,
      setOptions: function(L) {
        var E = typeof L == "function" ? L(u.options) : L;
        m(), u.options = Object.assign({}, i, u.options, E), u.scrollParents = {
          reference: r2(c) ? L2(c) : c.contextElement ? L2(c.contextElement) : [],
          popper: L2(C)
        };
        var V = Hn(Vn([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = V.filter(function(O) {
          return O.enabled;
        }), v(), d.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var L = u.elements, E = L.reference, V = L.popper;
          if ($4(E, V)) {
            u.rects = {
              reference: Ln(E, W2(V), u.options.strategy === "fixed"),
              popper: L5(V)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(W) {
              return u.modifiersData[W.name] = Object.assign({}, W.data);
            });
            for (var O = 0; O < u.orderedModifiers.length; O++) {
              if (u.reset === !0) {
                u.reset = !1, O = -1;
                continue;
              }
              var D = u.orderedModifiers[O], H = D.fn, F = D.options, _ = F === void 0 ? {} : F, Y = D.name;
              typeof H == "function" && (u = H({
                state: u,
                options: _,
                name: Y,
                instance: d
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Mn(function() {
        return new Promise(function(g) {
          d.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        m(), h = !0;
      }
    };
    if (!$4(c, C))
      return d;
    d.setOptions(s).then(function(g) {
      !h && s.onFirstUpdate && s.onFirstUpdate(g);
    });
    function v() {
      u.orderedModifiers.forEach(function(g) {
        var L = g.name, E = g.options, V = E === void 0 ? {} : E, O = g.effect;
        if (typeof O == "function") {
          var D = O({
            state: u,
            name: L,
            instance: d,
            options: V
          }), H = function() {
          };
          f.push(D || H);
        }
      });
    }
    function m() {
      f.forEach(function(g) {
        return g();
      }), f = [];
    }
    return d;
  };
}
var On = [Jr, gn, Xr, jr, hn, sn, wn, zr, dn], Sn = /* @__PURE__ */ $n({
  defaultModifiers: On
}), P3, O4;
function Zn() {
  if (O4) return P3;
  O4 = 1;
  var e = typeof Element < "u", r = typeof Map == "function", n = typeof Set == "function", a = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function o(i, l) {
    if (i === l) return !0;
    if (i && l && typeof i == "object" && typeof l == "object") {
      if (i.constructor !== l.constructor) return !1;
      var c, C, s;
      if (Array.isArray(i)) {
        if (c = i.length, c != l.length) return !1;
        for (C = c; C-- !== 0; )
          if (!o(i[C], l[C])) return !1;
        return !0;
      }
      var u;
      if (r && i instanceof Map && l instanceof Map) {
        if (i.size !== l.size) return !1;
        for (u = i.entries(); !(C = u.next()).done; )
          if (!l.has(C.value[0])) return !1;
        for (u = i.entries(); !(C = u.next()).done; )
          if (!o(C.value[1], l.get(C.value[0]))) return !1;
        return !0;
      }
      if (n && i instanceof Set && l instanceof Set) {
        if (i.size !== l.size) return !1;
        for (u = i.entries(); !(C = u.next()).done; )
          if (!l.has(C.value[0])) return !1;
        return !0;
      }
      if (a && ArrayBuffer.isView(i) && ArrayBuffer.isView(l)) {
        if (c = i.length, c != l.length) return !1;
        for (C = c; C-- !== 0; )
          if (i[C] !== l[C]) return !1;
        return !0;
      }
      if (i.constructor === RegExp) return i.source === l.source && i.flags === l.flags;
      if (i.valueOf !== Object.prototype.valueOf && typeof i.valueOf == "function" && typeof l.valueOf == "function") return i.valueOf() === l.valueOf();
      if (i.toString !== Object.prototype.toString && typeof i.toString == "function" && typeof l.toString == "function") return i.toString() === l.toString();
      if (s = Object.keys(i), c = s.length, c !== Object.keys(l).length) return !1;
      for (C = c; C-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(l, s[C])) return !1;
      if (e && i instanceof Element) return !1;
      for (C = c; C-- !== 0; )
        if (!((s[C] === "_owner" || s[C] === "__v" || s[C] === "__o") && i.$$typeof) && !o(i[s[C]], l[s[C]]))
          return !1;
      return !0;
    }
    return i !== i && l !== l;
  }
  return P3 = function(l, c) {
    try {
      return o(l, c);
    } catch (C) {
      if ((C.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw C;
    }
  }, P3;
}
var Dn = Zn();
const _n = /* @__PURE__ */ l3(Dn);
var Bn = [], Tn = function(r, n, a) {
  a === void 0 && (a = {});
  var o = Q1.useRef(null), i = {
    onFirstUpdate: a.onFirstUpdate,
    placement: a.placement || "bottom",
    strategy: a.strategy || "absolute",
    modifiers: a.modifiers || Bn
  }, l = Q1.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), c = l[0], C = l[1], s = Q1.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(d) {
        var v = d.state, m = Object.keys(v.elements);
        fe.flushSync(function() {
          C({
            styles: y4(m.map(function(g) {
              return [g, v.styles[g] || {}];
            })),
            attributes: y4(m.map(function(g) {
              return [g, v.attributes[g]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), u = Q1.useMemo(function() {
    var h = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [s, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return _n(o.current, h) ? o.current || h : (o.current = h, h);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, s]), f = Q1.useRef();
  return w4(function() {
    f.current && f.current.setOptions(u);
  }, [u]), w4(function() {
    if (!(r == null || n == null)) {
      var h = a.createPopper || Sn, d = h(r, n, u);
      return f.current = d, function() {
        d.destroy(), f.current = null;
      };
    }
  }, [r, n, a.createPopper]), {
    state: f.current ? f.current.state : null,
    styles: c.styles,
    attributes: c.attributes,
    update: f.current ? f.current.update : null,
    forceUpdate: f.current ? f.current.forceUpdate : null
  };
};
const B9 = a5(void 0);
function T9() {
  const e = i5(B9);
  if (!e)
    throw new Error(
      "'usePopoverContext' returned 'undefined'. Is the component wrapped within a Provider?"
    );
  return e;
}
const Wn = {
  initial: {
    opacity: 0,
    scale: 0.95
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  }
}, g2 = t.forwardRef(
  ({ children: e, ...r }, n) => {
    const { getContentProps: a } = T9();
    return /* @__PURE__ */ t.createElement("div", { ...a(r, n) }, /* @__PURE__ */ t.createElement(
      P1.div,
      {
        variants: Wn,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        style: { maxWidth: "inherit" }
      },
      e
    ));
  }
);
g2.displayName = "PopoverContent";
const p2 = t.forwardRef(({ children: e }, r) => {
  const n = t.Children.only(e), { getTriggerProps: a } = T9();
  return t.isValidElement(n) ? t.cloneElement(n, a(n.props, r)) : null;
});
p2.displayName = "PopoverTrigger";
const p3 = ({
  defaultIsOpen: e = !1,
  isOpen: r,
  onOpen: n,
  onClose: a,
  triggerType: o = "click",
  openDelay: i = 200,
  closeDelay: l = 200,
  closeOnEscape: c = !0,
  closeOnOutsideClick: C = !0,
  closeOnDrag: s = !1,
  placement: u = "bottom",
  offset: f = 8,
  preventOverflow: h = !0,
  flip: d = !0,
  contentRole: v,
  contentId: m,
  children: g
}) => {
  const L = H1(), E = m ?? L, V = f1(!1), O = t.Children.toArray(g).filter(
    (p) => t.isValidElement(p) && p.type === p2
  ), D = t.Children.toArray(g).filter(
    (p) => t.isValidElement(p) && p.type === g2
  ), [H, F] = c1(null), [_, Y] = c1(null), W = f1(!1), A = f1(), N = f1(), [j, J] = w1({
    defaultValue: e,
    value: r,
    onChange: (p) => p ? n == null ? void 0 : n() : a == null ? void 0 : a()
  }), X = n1(() => {
    J(!0);
  }, [J]), B = n1(() => {
    J(!1);
  }, [J]), U = n1(() => {
    j ? B() : X();
  }, [B, j, X]), { styles: a1 } = Tn(H, _, {
    placement: u,
    strategy: "absolute",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, f]
        }
      },
      {
        name: "preventOverflow",
        enabled: h,
        options: {
          padding: 8
        },
        phase: "main"
      },
      {
        name: "flip",
        enabled: d,
        options: {
          padding: 8
        },
        phase: "main"
      }
    ]
  }), t1 = n1(
    (p, $) => {
      const x = {
        ...p,
        ref: N1($, F),
        ...o === "click" && !v ? {
          "aria-expanded": j,
          "aria-haspopup": !0,
          "aria-controls": j ? E : void 0
        } : {}
      };
      if (o === "click" && (x.onClick = J1(p == null ? void 0 : p.onClick, U)), o === "hover") {
        x.onFocus = J1(p == null ? void 0 : p.onFocus, X), x.onBlur = J1(p == null ? void 0 : p.onBlur, B);
        const S = () => {
          W.current = !0, A.current = window.setTimeout(X, i);
        }, T = () => {
          W.current = !1, A.current && (window.clearTimeout(A.current), A.current = void 0), N.current && (window.clearTimeout(N.current), N.current = void 0), N.current = window.setTimeout(() => {
            W.current || B();
          }, l);
        };
        x.onMouseEnter = J1(p == null ? void 0 : p.onMouseEnter, S), x.onMouseLeave = J1(p == null ? void 0 : p.onMouseLeave, T);
      }
      return x;
    },
    [B, l, E, v, j, X, i, U, o]
  ), w = n1(
    (p, $) => {
      const x = {
        ...p,
        ref: N1($, Y),
        id: E,
        role: v,
        style: {
          ...a1.popper,
          zIndex: 2001,
          ...h ? { maxWidth: "calc(100vw - 16px)" } : {}
        }
      };
      if (o === "hover") {
        const S = () => {
          W.current = !0;
        }, T = () => {
          W.current = !1, N.current = window.setTimeout(() => {
            W.current || B();
          }, l);
        };
        x.onMouseEnter = J1(p == null ? void 0 : p.onMouseEnter, S), x.onMouseLeave = J1(p == null ? void 0 : p.onMouseLeave, T);
      }
      return x;
    },
    [B, l, E, v, h, a1.popper, o]
  );
  return y1(() => {
    if (!c || !j)
      return;
    const p = ($) => {
      if ($.key !== "Escape")
        return;
      U();
      const x = H != null && H.matches(":is(a,button,input,select,textarea,[tabindex])") ? H : (H == null ? void 0 : H.querySelector("input, button, [tabindex]")) ?? H;
      x == null || x.focus();
    };
    return document.addEventListener("keydown", p), () => {
      document.removeEventListener("keydown", p);
    };
  }, [c, j, U, H]), y1(() => {
    if (!C || !j || !_ || !H)
      return;
    const p = ($) => {
      const x = $.target;
      H != null && H.contains(x) || _.contains(x) || B();
    };
    return document.addEventListener("pointerdown", p), () => {
      document.removeEventListener("pointerdown", p);
    };
  }, [B, C, _, j, H]), y1(() => {
    if (!s || !H) return;
    const p = () => {
      V.current = !0;
    }, $ = () => {
      V.current = !1;
    }, x = () => {
      V.current && B();
    };
    return H.addEventListener("pointerdown", p), H.addEventListener("pointermove", x), H.addEventListener("pointerup", $), () => {
      H.removeEventListener("pointerdown", p), H.removeEventListener("pointermove", x), H.removeEventListener("pointerup", $);
    };
  }, [B, s, j, H]), y1(() => () => {
    A.current && (window.clearTimeout(A.current), A.current = void 0), N.current && (window.clearTimeout(N.current), N.current = void 0);
  }, []), /* @__PURE__ */ t.createElement(B9.Provider, { value: { getTriggerProps: t1, getContentProps: w, contentId: E, isOpen: j } }, O, c5.createPortal(
    /* @__PURE__ */ t.createElement(R4, null, j && D),
    document.body
  ));
}, Rn = t.forwardRef(
  ({
    id: e,
    label: r,
    description: n = "",
    defaultValue: a = null,
    value: o,
    onChange: i,
    defaultIsOpen: l = !1,
    isOpen: c,
    onOpen: C,
    onClose: s,
    onFocus: u,
    onBlur: f,
    helperText: h,
    warningText: d,
    errorText: v,
    isDisabled: m = !1,
    isReadOnly: g = !1,
    valueFormat: L,
    ...E
  }, V) => {
    const O = H1(), D = e || `datepicker-${O}`, H = `${D}-popover`, [F, _] = w1({
      defaultValue: a,
      value: o,
      onChange: i
    }), [Y, W] = t.useState(!1), [A, N] = w1({
      defaultValue: l,
      value: c,
      onChange: (x) => x ? C == null ? void 0 : C() : s == null ? void 0 : s()
    }), j = n1(
      (x) => {
        W(!0), u == null || u(x);
      },
      [u]
    ), J = n1(
      (x) => {
        W(!1), f == null || f(x);
      },
      [f]
    ), X = n1(
      (x) => {
        m || g || (x.key === "Enter" || x.key === " ") && (x.preventDefault(), x.nativeEvent.stopImmediatePropagation(), N(!A));
      },
      [m, A, g, N]
    ), B = n1(
      (x) => {
        x.stopPropagation(), !m && (_(null), N(!1));
      },
      [m, _, N]
    ), U = n1(
      (x, S) => S.toLocaleString(x, { weekday: "short" }).substring(0, 2),
      []
    ), a1 = n1(
      (x, S) => S.toLocaleString(x, { month: "short" }),
      []
    ), t1 = f1(null), w = f1(null);
    y1(() => {
      if (A) {
        let x = 0;
        const S = requestAnimationFrame(() => {
          x = requestAnimationFrame(() => {
            var T;
            (T = w.current) == null || T.focus({ preventScroll: !0 });
          });
        });
        return () => {
          cancelAnimationFrame(S), cancelAnimationFrame(x);
        };
      }
    }, [A]);
    const p = !!v, $ = !!F && !g;
    return /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5, width: "100%" }, /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25 }, /* @__PURE__ */ t.createElement(jn, { htmlFor: D, $isDisabled: m }, r), n && /* @__PURE__ */ t.createElement(l1, { variant: "caption-01-regular", color: m ? "grey40" : "grey80" }, n)), /* @__PURE__ */ t.createElement(
      p3,
      {
        isOpen: A,
        onOpen: () => N(!0),
        onClose: () => N(!1),
        contentRole: "dialog",
        contentId: H
      },
      /* @__PURE__ */ t.createElement(p2, null, /* @__PURE__ */ t.createElement(An, { $isDisabled: m || g }, /* @__PURE__ */ t.createElement(
        In,
        {
          id: D,
          value: F && ((L == null ? void 0 : L(F)) ?? F.toLocaleString("en-sg", {
            day: "2-digit",
            year: "numeric",
            month: "short"
          })) || "",
          readOnly: !0,
          disabled: m,
          $isDisabled: m,
          $isReadOnly: g,
          onFocus: j,
          onBlur: J,
          onKeyDown: X,
          "aria-describedby": v || d || h ? `${D}-info-text` : void 0,
          role: "combobox",
          "aria-haspopup": "dialog",
          "aria-expanded": A,
          "aria-controls": A ? H : void 0,
          "aria-invalid": p,
          $isOpen: A,
          $hasError: p,
          $showClearIcon: $,
          ref: N1(V, t1),
          ...E
        }
      ), /* @__PURE__ */ t.createElement(Nn, null, $ && /* @__PURE__ */ t.createElement(
        Fn,
        {
          type: "button",
          onClick: B,
          "aria-label": `Clear date for ${r}`
        },
        /* @__PURE__ */ t.createElement(
          o1,
          {
            name: "x-outline",
            width: 20,
            height: 20,
            color: m ? "grey30" : A || Y ? "primary60" : "grey70"
          }
        )
      ), /* @__PURE__ */ t.createElement(
        o1,
        {
          name: "calendar-outline",
          width: 20,
          height: 20,
          color: m ? "grey30" : A || Y ? "primary60" : "grey70"
        }
      )))),
      /* @__PURE__ */ t.createElement(g2, { "aria-label": r, ref: w, tabIndex: -1 }, /* @__PURE__ */ t.createElement(Pn, null, /* @__PURE__ */ t.createElement(
        Gn,
        {
          value: F,
          calendarType: "gregory",
          onChange: (x) => {
            x instanceof Date && (_(x), N(!1), requestAnimationFrame(() => {
              var S;
              (S = t1.current) == null || S.focus({ preventScroll: !0 });
            }));
          },
          formatMonth: a1,
          formatWeekday: U,
          formatShortWeekday: U
        }
      )))
    ), (v || d || h) && /* @__PURE__ */ t.createElement(
      Y1,
      {
        id: `${D}-info-text`,
        variant: v ? "error" : d ? "warning" : "helper",
        isDisabled: m
      },
      v || d || h
    ));
  }
);
Rn.displayName = "DatePicker";
const jn = y.label`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  display: block;
  width: 100%;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey40 : r.colors.grey80};
  word-break: break-word;
`, An = y.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  pointer-events: ${({ $isDisabled: e }) => e && "none"};
`, In = y.input`
  ${({ theme: e }) => e.getTextStyles("filled-text-01-semibold")}

  width: 100%;
  padding: 0.6875rem ${({ $showClearIcon: e }) => e ? "4.1875rem" : "2.4375rem"}
    0.6875rem 0.9375rem;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $isOpen: e, theme: r }) => e ? r.colors.primary60 : r.colors.grey50};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
  color: ${({ theme: e }) => e.colors.grey80};
  box-shadow: ${({ $isOpen: e, theme: r }) => e ? `inset 0 0 0 1px ${r.colors.primary60}` : "none"};
  outline: none;
  cursor: pointer;

  &::placeholder {
    ${({ theme: e }) => e.getTextStyles("placeholder-text-01-light")}
    color: ${({ theme: e }) => e.colors.grey60};
  }

  &:hover {
    border-color: ${({ $isOpen: e, theme: r }) => e ? r.colors.primary60 : r.colors.grey80};
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.primary60};
    box-shadow: inset 0 0 0 1px ${({ theme: e }) => e.colors.primary60};
  }

  ${({ $isReadOnly: e, $isDisabled: r, theme: n }) => (e || r) && k`
      border-color: ${n.colors.grey30};
      background-color: ${n.colors.grey10};
      color: ${e ? n.colors.grey80 : n.colors.grey40};
      cursor: default;

      &::placeholder {
        ${n.getTextStyles("placeholder-text-01-light")}
        color: ${n.colors.grey40};
      }
    `}

  ${({ $hasError: e, $isReadOnly: r, $isDisabled: n, theme: a }) => e && k`
      background-color: ${a.colors.errorLight};

      &,
      &:hover:not(:focus) {
        border: 1px solid ${a.colors.error};
        box-shadow: inset 0 0 0 1px ${a.colors.error};
      }

      ${(r || n) && k`
        background-color: ${a.colors.grey10};
      `}
    `}
`, Nn = y.div`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  display: flex;
  gap: 0.5rem;
`, Fn = y.button`
  position: relative;
  display: flex;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    inset: -0.75rem;
  }

  &:focus-visible {
    outline-color: ${({ theme: e }) => e.colors.primary60};
  }
`, Pn = y.div`
  max-width: 100%;
  border: 1px solid ${({ theme: e }) => e.colors.primary60};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
  box-shadow: 0 0 0 1px ${({ theme: e }) => e.colors.primary60};
  outline: none;
`, Gn = y(x9)`
  /* stylelint-disable selector-class-pattern, no-descending-specificity -- Overriding external library css */
  width: 100%;
  min-width: 16rem;
  max-width: 20rem;

  & abbr {
    text-decoration: none;
  }

  & button {
    margin: 0;
    border: 2px solid transparent;
    box-shadow: 0 0 0 2px transparent;

    &:hover {
      cursor: pointer;
    }

    &:focus-visible {
      outline-color: ${({ theme: e }) => e.colors.primary60};
    }
  }

  & .react-calendar__navigation {
    display: flex;
    padding: 0.5rem;
    color: ${({ theme: e }) => e.colors.grey80};
    box-shadow: 0 -1px 0 0 rgb(224 228 232 / 60%) inset;

    span {
      ${({ theme: e }) => e.getTextStyles("filled-text-01-semibold")}
    }

    button {
      min-width: 2.5rem;
      ${({ theme: e }) => e.getTextStyles("label-01-regular")}
      padding: 0.5rem;
      border-radius: 0.5rem;
      background-color: white;

      &:enabled {
        &:hover,
        &:focus {
          background-color: ${({ theme: e }) => e.colors.grey10};
        }
      }

      &:disabled {
        color: ${({ theme: e }) => e.colors.grey40};
      }
    }
  }

  .react-calendar__viewContainer {
    padding: 0.5rem 1.25rem;
  }

  .react-calendar__month-view__weekdays {
    ${({ theme: e }) => e.getTextStyles("filled-text-01-semibold")}
    text-align: center;
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5rem;
  }

  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme: e }) => e.getTextStyles("label-01-regular")}
  }

  .react-calendar__month-view__days__day--weekend {
    color: ${({ theme: e }) => e.colors.grey80};
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: ${({ theme: e }) => e.colors.grey40};
  }

  .react-calendar__year-view,
  .react-calendar__tile {
    position: relative;
    max-width: 100%;
    padding: 0.5rem 0.25rem;
    border-radius: 0.5rem;
    background: none;
    font: inherit;
    text-align: center;

    &:disabled {
      color: ${({ theme: e }) => e.colors.grey40};
    }

    &:enabled {
      &:hover,
      &:focus {
        background-color: ${({ theme: e }) => e.colors.grey10};
      }
    }
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 0.5rem 0.25rem;
  }

  .react-calendar__tile--now {
    ::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      display: inline-block;
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 100%;
      background: ${({ theme: e }) => e.colors.primary60};
      transform: translateX(-50%) translateY(-100%);
    }
  }

  .react-calendar__tile--hasActive,
  .react-calendar__tile--active {
    background: ${({ theme: e }) => e.colors.primary60};
    color: white;

    &:enabled {
      &:hover,
      &:focus {
        background: ${({ theme: e }) => e.colors.primary60};
      }
    }
  }

  & .react-calendar__century-view__decades__decade {
    ${({ theme: e }) => e.getTextStyles("label-02-regular")}
  }

  /* stylelint-enable selector-class-pattern, no-descending-specificity */
`, zn = ({ children: e, action: r }) => {
  const n = f1(null), a = f1(null), [o, i] = c1(null);
  return y1(() => {
    const l = n.current, c = a.current;
    if (!l || !c) return;
    const C = () => {
      const u = l.querySelector('input, [role="combobox"]');
      if (!u) return;
      const f = l.getBoundingClientRect().top, h = u.getBoundingClientRect(), d = h.top + h.height / 2 - f, v = c.offsetHeight;
      i(Math.max(0, d - v / 2));
    };
    C();
    const s = new ResizeObserver(C);
    return s.observe(l), s.observe(c), () => s.disconnect();
  }, []), /* @__PURE__ */ t.createElement(Yn, null, /* @__PURE__ */ t.createElement(Un, { ref: n, "data-testid": "field-with-action__field" }, e), r && /* @__PURE__ */ t.createElement(
    qn,
    {
      ref: a,
      "data-testid": "field-with-action__action",
      style: { marginTop: o !== null ? `${o}px` : void 0 }
    },
    r
  ));
};
zn.displayName = "FieldWithAction";
const Yn = y.div`
  display: flex;
  align-items: flex-start;
  column-gap: 1.5rem;
`, Un = y.div`
  flex: 1;
  min-width: 0;
`, qn = y.div`
  flex-shrink: 0;
`, W9 = y.div`
  border-bottom: 1px solid ${({ theme: e }) => e.colors.grey30};
`, Q = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", e1 = "'cv01' on, 'cv05' on";
function K2(e) {
  switch (e) {
    case "heading-01-bold":
      return k`
        font-weight: 700;
        font-size: 2.5rem;
        font-family: ${Q};
        line-height: 3.25rem;
        letter-spacing: -0.02em;
        font-feature-settings: ${e1};
      `;
    case "heading-02-bold":
      return k`
        font-weight: 700;
        font-size: 2rem;
        font-family: ${Q};
        line-height: 2.75rem;
        letter-spacing: -0.02em;
        font-feature-settings: ${e1};
      `;
    case "heading-03-bold":
      return k`
        font-weight: 700;
        font-size: 1.75rem;
        font-family: ${Q};
        line-height: 2.25rem;
        letter-spacing: -0.02em;
        font-feature-settings: ${e1};
      `;
    case "heading-03-light":
      return k`
        font-weight: 300;
        font-size: 1.75rem;
        font-family: ${Q};
        line-height: 2.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "heading-04-bold":
      return k`
        font-weight: 700;
        font-size: 1.5rem;
        font-family: ${Q};
        line-height: 2rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "heading-04-light":
      return k`
        font-weight: 300;
        font-size: 1.5rem;
        font-family: ${Q};
        line-height: 2rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "heading-05-semibold":
      return k`
        font-weight: 600;
        font-size: 1.25rem;
        font-family: ${Q};
        line-height: 1.75rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "heading-05-light":
      return k`
        font-weight: 300;
        font-size: 1.25rem;
        font-family: ${Q};
        line-height: 1.75rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "heading-06-semibold":
      return k`
        font-weight: 600;
        font-size: 1rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "heading-06-light":
      return k`
        font-weight: 300;
        font-size: 1rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "heading-07-semibold":
      return k`
        font-weight: 600;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "body-01-regular":
      return k`
        font-weight: 400;
        font-size: 1rem;
        font-family: ${Q};
        line-height: 1.5rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "body-01-semibold":
      return k`
        font-weight: 600;
        font-size: 1rem;
        font-family: ${Q};
        line-height: 1.5rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "body-02-regular":
      return k`
        font-weight: 400;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "body-02-semibold":
      return k`
        font-weight: 600;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "caption-01-regular":
      return k`
        font-weight: 400;
        font-size: 0.75rem;
        font-family: ${Q};
        line-height: 1rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "caption-02-semibold":
      return k`
        font-weight: 600;
        font-size: 0.56rem;
        font-family: ${Q};
        line-height: 0.75rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "list-01-regular":
      return k`
        font-weight: 400;
        font-size: 1rem;
        font-family: ${Q};
        line-height: 1.5rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "list-02-regular":
      return k`
        font-weight: 400;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "overline-01-regular":
      return k`
        font-weight: 400;
        font-size: 0.75rem;
        font-family: ${Q};
        line-height: 1rem;
        letter-spacing: 0.1em;
        font-feature-settings: ${e1};
      `;
    case "button-01-semibold":
      return k`
        font-weight: 600;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "button-02-semibold":
      return k`
        font-weight: 600;
        font-size: 0.75rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "label-01-regular":
      return k`
        font-weight: 400;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "label-02-regular":
      return k`
        font-weight: 400;
        font-size: 0.75rem;
        font-family: ${Q};
        line-height: 1rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "label-02-semibold":
      return k`
        font-weight: 600;
        font-size: 0.75rem;
        font-family: ${Q};
        line-height: 1rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "placeholder-text-01-light":
      return k`
        font-weight: 300;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "filled-text-01-semibold":
      return k`
        font-weight: 600;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "textlink-standalone-01-regular":
      return k`
        font-weight: 400;
        font-size: 1rem;
        font-family: ${Q};
        line-height: 1.5rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "textlink-standalone-02-regular":
      return k`
        font-weight: 400;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "textlink-standalone-03-regular":
      return k`
        font-weight: 400;
        font-size: 0.75rem;
        font-family: ${Q};
        line-height: 1rem;
        letter-spacing: 0;
        font-feature-settings: ${e1};
      `;
    case "textlink-inline-01-regular":
      return k`
        font-weight: 400;
        font-size: 1rem;
        font-family: ${Q};
        line-height: 1.5rem;
        letter-spacing: 0;
        text-decoration: underline;
        font-feature-settings: ${e1};
      `;
    case "textlink-inline-02-regular":
      return k`
        font-weight: 400;
        font-size: 0.875rem;
        font-family: ${Q};
        line-height: 1.25rem;
        letter-spacing: 0;
        text-decoration: underline;
        font-feature-settings: ${e1};
      `;
    case "textlink-inline-03-regular":
      return k`
        font-weight: 400;
        font-size: 0.75rem;
        font-family: ${Q};
        line-height: 1rem;
        letter-spacing: 0;
        text-decoration: underline;
        font-feature-settings: ${e1};
      `;
  }
}
const R9 = T4(
  ({
    component: e,
    size: r = "regular",
    variant: n = "standalone",
    isDisabled: a = !1,
    leftIcon: o,
    rightIcon: i,
    children: l,
    onClick: c,
    ...C
  }, s) => {
    const u = e ?? "a", f = n1(
      (v) => {
        if (a) {
          v.preventDefault(), v.stopPropagation();
          return;
        }
        c == null || c(v);
      },
      [a, c]
    ), h = !!o || !!i, d = a ? Object.fromEntries(Object.entries(C).filter(([v]) => v !== "href")) : C;
    return /* @__PURE__ */ t.createElement(
      Xn,
      {
        as: u,
        $size: r,
        $variant: n,
        $isDisabled: a,
        "aria-disabled": a,
        role: a ? void 0 : "link",
        ref: s,
        onClick: f,
        ...d
      },
      h ? /* @__PURE__ */ t.createElement(z, { flexInline: !0, flexRow: !0, columnGap: 0.25, alignItems: "center" }, o && /* @__PURE__ */ t.createElement(o1, { name: o, width: "1.25rem", height: "1.25rem" }), l, i && /* @__PURE__ */ t.createElement(o1, { name: i, width: "1.25rem", height: "1.25rem" })) : l
    );
  }
);
R9.displayName = "Link";
const o3 = R9, Xn = y.a`
  text-decoration: none;
  cursor: ${({ $isDisabled: e }) => e ? "not-allowed" : "pointer"};
  ${({ $size: e, $variant: r }) => Kn(e, r)}
  ${({ $variant: e }) => to(e)}
`, Kn = (e, r) => {
  const n = r === "inline" ? "inline" : "standalone";
  switch (e) {
    case "large":
      return K2(`textlink-${n}-01-regular`);
    case "small":
      return K2(`textlink-${n}-03-regular`);
    case "regular":
    default:
      return K2(`textlink-${n}-02-regular`);
  }
}, Jn = k`
  color: ${({ theme: e }) => e.colors.primary60};

  &:active,
  &:hover {
    color: ${({ theme: e }) => e.colors.primary70};
  }

  :focus-visible {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
  }

  &[aria-disabled='true'] {
    color: ${({ theme: e }) => e.colors.grey30};
  }
`, Qn = k`
  color: ${({ theme: e }) => e.colors.primary60};

  &:active,
  &:hover {
    color: ${({ theme: e }) => e.colors.primary70};
  }

  :focus-visible {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
  }

  &[aria-disabled='true'] {
    color: ${({ theme: e }) => e.colors.grey30};
  }
`, eo = k`
  color: ${({ theme: e }) => e.colors.error};

  &:active,
  &:hover {
    color: ${({ theme: e }) => e.colors.errorDark};
  }

  :focus-visible {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
  }

  &[aria-disabled='true'] {
    color: ${({ theme: e }) => e.colors.grey30};
  }
`, to = (e) => {
  switch (e) {
    case "danger":
      return eo;
    case "inline":
      return Qn;
    case "standalone":
    default:
      return Jn;
  }
}, ro = ({
  filteredCount: e,
  onClearAll: r,
  header: n,
  isClearAllDisabled: a = !1
}) => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5, mb: 1.5 }, /* @__PURE__ */ t.createElement(z, { flex: !0, justifyContent: "space-between", alignItems: "center" }, n && /* @__PURE__ */ t.createElement(l1, { variant: "heading-05-semibold" }, n), /* @__PURE__ */ t.createElement(o3, { onClick: r, isDisabled: a }, "Clear all")), e !== void 0 && /* @__PURE__ */ t.createElement(l1, { variant: "label-01-regular" }, e, " result", e !== 1 && "s", " selected")), /* @__PURE__ */ t.createElement(W9, null));
ro.displayName = "FilterBar";
const no = ({ children: e, title: r, maxHeight: n = "12.5rem" }) => {
  const [a, o] = c1(!0);
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    ao,
    {
      flex: !0,
      justifyContent: "space-between",
      alignItems: "top",
      "data-testid": "expandable-toggle",
      onClick: () => o(!a)
    },
    r,
    /* @__PURE__ */ t.createElement(
      P1.div,
      {
        variants: {
          open: { rotate: 0, width: "24px", height: "24px" },
          close: { rotate: 180, width: "24px", height: "24px" }
        },
        initial: a ? "open" : "close",
        animate: a ? "open" : "close"
      },
      /* @__PURE__ */ t.createElement(o1, { name: "chevron-up-outline" })
    )
  ), /* @__PURE__ */ t.createElement(oo, { $maxHeight: n, "data-testid": "expandable-body" }, a && e));
}, oo = y(z)`
  position: relative;
  overflow-y: auto;
  max-height: ${({ $maxHeight: e }) => e};
`, ao = y(z)`
  cursor: pointer;
`, io = ({ title: e, onClear: r, isClearDisabled: n }) => {
  const a = (o) => {
    o.stopPropagation(), r();
  };
  return /* @__PURE__ */ t.createElement(z, { flex: !0, columnGap: 1, mb: 1.5, alignItems: "baseline" }, /* @__PURE__ */ t.createElement(l1, { variant: "heading-06-semibold" }, e), /* @__PURE__ */ t.createElement(o3, { onClick: a, isDisabled: n }, "Clear"));
}, lo = ({
  title: e,
  onClear: r,
  children: n,
  isClearDisabled: a = !1,
  maxHeight: o
}) => /* @__PURE__ */ t.createElement(z, { mt: 1.5 }, /* @__PURE__ */ t.createElement(
  no,
  {
    title: /* @__PURE__ */ t.createElement(io, { title: e, onClear: r, isClearDisabled: a }),
    maxHeight: o
  },
  n
), /* @__PURE__ */ t.createElement(z, { mt: 1.5 }, /* @__PURE__ */ t.createElement(W9, null)));
lo.displayName = "FilterComponent";
const j9 = a5(
  void 0
);
function A9() {
  const e = i5(j9);
  if (!e)
    throw new Error(
      "'useHorizontalTabContext' returned 'undefined'. Is the component wrapped in a 'HorizontalTabs' component?"
    );
  return e;
}
const y3 = t.forwardRef(
  ({
    children: e,
    variant: r = "default-light",
    icon: n,
    isDisabled: a = !1,
    isReadOnly: o = !1,
    onRemove: i,
    ...l
  }, c) => {
    const C = (s) => {
      s.stopPropagation(), i == null || i();
    };
    return /* @__PURE__ */ t.createElement(co, { ref: c, $variant: r, $isDisabled: a, ...l }, /* @__PURE__ */ t.createElement(
      z,
      {
        flex: !0,
        flexRow: !0,
        columnGap: 0.25,
        px: [0.75, r === "removeable" ? 0.25 : 0.75],
        py: 0.25
      },
      n && /* @__PURE__ */ t.createElement(o1, { name: n, width: 16, height: 16 }),
      /* @__PURE__ */ t.createElement(l1, { variant: "label-02-regular" }, e)
    ), r === "removeable" && /* @__PURE__ */ t.createElement(bo, { onClick: C, disabled: a || o }, /* @__PURE__ */ t.createElement(o1, { name: "x-outline", width: "1rem", height: "1rem" })));
  }
);
y3.displayName = "Tag";
const co = y.div`
  display: inline-flex;
  width: fit-content;
  border-radius: 1rem;

  ${({ $variant: e, $isDisabled: r }) => {
  switch (e) {
    case "removeable":
      return r ? wo : yo;
    case "default-light":
      return S4;
    case "default":
      return Co;
    case "primary-light":
      return so;
    case "primary":
      return uo;
    case "success-light":
      return fo;
    case "success":
      return mo;
    case "warning-light":
      return ho;
    case "warning":
      return vo;
    case "danger-light":
      return go;
    case "danger":
      return po;
    default:
      return S4;
  }
}}
`, S4 = k`
  background-color: ${({ theme: e }) => e.colors.grey20};
  color: ${({ theme: e }) => e.colors.grey80};
`, Co = k`
  background-color: ${({ theme: e }) => e.colors.grey90};
  color: ${({ theme: e }) => e.colors.white};
`, so = k`
  background-color: ${({ theme: e }) => e.colors.primary20};
  color: ${({ theme: e }) => e.colors.primary60};
`, uo = k`
  background-color: ${({ theme: e }) => e.colors.primary60};
  color: ${({ theme: e }) => e.colors.white};
`, fo = k`
  background-color: ${({ theme: e }) => e.colors.successLight};
  color: ${({ theme: e }) => e.colors.success};
`, mo = k`
  background-color: ${({ theme: e }) => e.colors.success};
  color: ${({ theme: e }) => e.colors.white};
`, ho = k`
  background-color: ${({ theme: e }) => e.colors.warningLight};
  color: ${({ theme: e }) => e.colors.warning};
`, vo = k`
  background-color: ${({ theme: e }) => e.colors.warning};
  color: ${({ theme: e }) => e.colors.white};
`, go = k`
  background-color: ${({ theme: e }) => e.colors.errorLight};
  color: ${({ theme: e }) => e.colors.error};
`, po = k`
  background-color: ${({ theme: e }) => e.colors.error};
  color: ${({ theme: e }) => e.colors.white};
`, yo = k`
  background-color: ${({ theme: e }) => e.colors.grey20};
  color: ${({ theme: e }) => e.colors.grey80};
`, wo = k`
  background-color: ${({ theme: e }) => e.colors.grey20};
  color: ${({ theme: e }) => e.colors.grey40};
`, bo = y.button`
  padding: 0.25rem;
  border: none;
  border-radius: 50%;
  background-color: inherit;
  cursor: pointer;
  appearance: none;

  &:hover {
    background-color: ${({ theme: e }) => e.colors.grey30};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    color: ${({ theme: e }) => e.colors.grey30};
    cursor: not-allowed;
  }

  &:disabled:hover {
    background-color: inherit;
  }
`, I9 = t.forwardRef(
  ({ value: e, isDisabled: r = !1, label: n, tagValue: a, onClick: o, ...i }, l) => {
    const { value: c, setValue: C, size: s, minTabWidth: u } = A9(), f = n1(
      (h) => {
        C(e), o == null || o(h);
      },
      [o, C, e]
    );
    return /* @__PURE__ */ t.createElement(
      Eo,
      {
        $size: s,
        $minTabWidth: u,
        $isSelected: e === c,
        disabled: r,
        role: "tab",
        ref: l,
        onClick: f,
        ...i
      },
      /* @__PURE__ */ t.createElement("span", null, n),
      a && /* @__PURE__ */ t.createElement(y3, null, a)
    );
  }
);
I9.displayName = "HorizontalTab";
const Eo = y.button`
  display: inline-flex;
  gap: 0.5rem;
  align-items: center;
  padding: 1rem 0 0.875rem;
  border: none;
  border-bottom: 2px solid
    ${({ $isSelected: e, theme: r }) => e ? r.colors.primary60 : "transparent"};
  background-color: inherit;
  color: ${({ theme: e }) => e.colors.grey80};
  font: inherit;
  cursor: pointer;

  ${({ $minTabWidth: e }) => e && `
    min-width: ${e};
    flex-shrink: 0;
  `}

  ${({ $size: e, theme: r }) => {
  switch (e) {
    case "sm":
      return r.getTextStyles("body-02-semibold");
    case "lg":
      return r.getTextStyles("heading-05-semibold");
    default:
      return r.getTextStyles("heading-06-semibold");
  }
}}

  &:hover {
    border-bottom-color: ${({ $isSelected: e, theme: r }) => e ? r.colors.primary60 : r.colors.grey50};
  }

  &:disabled {
    border-bottom-color: transparent;
    color: ${({ theme: e }) => e.colors.grey30};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
  }
`, N9 = t.forwardRef(
  ({ value: e, children: r, ...n }, a) => {
    const { value: o, isLazy: i } = A9(), l = e === o, c = !i || l;
    return /* @__PURE__ */ t.createElement(z, { ref: a, role: "tabpanel", hidden: !l, ...n }, c && r);
  }
);
N9.displayName = "HorizontalTabPanel";
const ko = t.forwardRef(
  ({
    defaultValue: e = "",
    value: r,
    onChange: n,
    isLazy: a = !1,
    size: o = "md",
    minTabWidth: i,
    children: l,
    ...c
  }, C) => {
    const [s, u] = w1({
      defaultValue: e,
      value: r,
      onChange: n
    }), f = f1(null), h = f1(!0), d = t.Children.toArray(l).filter(
      (g) => t.isValidElement(g) && g.type === I9
    ), v = t.Children.toArray(l).filter(
      (g) => t.isValidElement(g) && g.type === N9
    ), m = d.findIndex(
      (g) => t.isValidElement(g) && g.props.value === s
    );
    return y1(() => {
      var g, L;
      if (h.current) {
        h.current = !1;
        return;
      }
      m < 0 || (L = (g = f.current) == null ? void 0 : g.children.item(m)) == null || L.scrollIntoView({ block: "nearest", inline: "nearest" });
    }, [m]), /* @__PURE__ */ t.createElement(j9.Provider, { value: { value: s, setValue: u, isLazy: a, size: o, minTabWidth: i } }, /* @__PURE__ */ t.createElement("div", { ref: C, ...c }, /* @__PURE__ */ t.createElement(Lo, { role: "tablist", ref: f }, d), v));
  }
);
ko.displayName = "HorizontalTabs";
const Lo = y.div`
  position: relative;
  display: flex;
  flex-direction: row;
  overflow-x: auto;

  /* An inset shadow rather than a border, so the tab underline overlaps the divider without
     overflowing the list - overflow would make it scroll vertically and clip the underline. */
  box-shadow: inset 0 -1px 0 ${({ theme: e }) => e.colors.grey30};
  column-gap: 2.5rem;

  /* Hide the horizontal scrollbar while keeping the list scrollable. */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }
`, xo = t.forwardRef(
  (e, r) => {
    const {
      variant: n,
      title: a,
      description: o,
      showIcon: i = !1,
      actionType: l,
      collapsable: c = !1,
      onDismiss: C,
      ...s
    } = e, u = (() => {
      if (l === "button") {
        const { onClickAction: D, ...H } = s;
        return H;
      }
      return s;
    })(), { titleColor: f, descriptionColor: h, icon: d, iconColor: v, showActionButton: m } = Mo(n), [g, L] = c1(!1), [E, V] = c1(!1), O = f1(null);
    return a3(() => {
      if (!O.current)
        return;
      const D = getComputedStyle(O.current);
      parseFloat(D.height) > 2 * parseFloat(D.lineHeight) && (L(!0), V(!0));
    }, []), /* @__PURE__ */ t.createElement($o, { $variant: n, ref: r, ...u }, /* @__PURE__ */ t.createElement(z, { flex: !0, flexRow: !0, columnGap: 0.75 }, i && /* @__PURE__ */ t.createElement(o1, { name: d, color: v, width: 24, height: 24 }), /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25, mt: 0.125 }, a && /* @__PURE__ */ t.createElement(l1, { variant: "heading-06-semibold", color: f }, a), /* @__PURE__ */ t.createElement(Ho, { ref: O, $isCollapsed: c && E }, typeof o == "string" ? /* @__PURE__ */ t.createElement(l1, { variant: "body-02-regular", color: h }, o) : o({ textColor: h })), l === "link" && /* @__PURE__ */ t.createElement(
      o3,
      {
        href: e.href,
        ...e.openInNewTab && {
          target: "_blank",
          rel: "noopener noreferrer"
        }
      },
      e.actionText || "Action"
    ), c && g && /* @__PURE__ */ t.createElement(
      z,
      {
        flex: !0,
        flexRow: !0,
        alignItems: "center",
        columnGap: 0.25,
        onClick: () => V((D) => !D)
      },
      /* @__PURE__ */ t.createElement(o3, null, E ? "Show more" : "Show less"),
      /* @__PURE__ */ t.createElement(
        P1.div,
        {
          variants: {
            open: { rotate: 180 },
            close: { rotate: 0 }
          },
          initial: E ? "close" : "open",
          animate: E ? "close" : "open"
        },
        /* @__PURE__ */ t.createElement(o1, { name: "chevron-down-outline", width: 20, height: 20, color: "primary60" })
      )
    )), (l === "button" && m || C) && /* @__PURE__ */ t.createElement(z, { flex: !0, flexRow: !0, alignItems: "center", columnGap: 0.5, ml: "auto" }, l === "button" && m && /* @__PURE__ */ t.createElement(I4, { variant: "primary", onClick: e.onClickAction }, e.actionText || "Action"), C && /* @__PURE__ */ t.createElement(Vo, { onClick: C, "aria-label": "dismiss notification" }, /* @__PURE__ */ t.createElement(o1, { name: "x-outline", width: 20, height: 20, color: "grey60" })))));
  }
);
xo.displayName = "InlineNotification";
const Ho = y.div`
  overflow: hidden;
  max-height: ${({ $isCollapsed: e }) => e ? "2.5rem" : "fit-content"};
`, Mo = (e) => {
  switch (e) {
    case "neutral":
      return {
        titleColor: "grey90",
        descriptionColor: "grey70",
        icon: "information-circle-solid",
        iconColor: "grey70",
        showActionButton: !0
      };
    case "informational":
      return {
        titleColor: "white",
        descriptionColor: "white",
        icon: "information-circle-solid",
        iconColor: "white",
        showActionButton: !1
      };
    case "informational-light":
      return {
        titleColor: "primary60",
        descriptionColor: "grey70",
        icon: "information-circle-solid",
        iconColor: "primary60",
        showActionButton: !0
      };
    case "error":
      return {
        titleColor: "white",
        descriptionColor: "white",
        icon: "exclamation-circle-solid",
        iconColor: "white",
        showActionButton: !1
      };
    case "error-light":
      return {
        titleColor: "error",
        descriptionColor: "grey70",
        icon: "exclamation-circle-solid",
        iconColor: "error",
        showActionButton: !0
      };
    case "success":
      return {
        titleColor: "white",
        descriptionColor: "white",
        icon: "check-circle-solid",
        iconColor: "white",
        showActionButton: !1
      };
    case "success-light":
      return {
        titleColor: "success",
        descriptionColor: "grey70",
        icon: "check-circle-solid",
        iconColor: "success",
        showActionButton: !0
      };
    case "warning":
      return {
        titleColor: "white",
        descriptionColor: "white",
        icon: "exclamation-solid",
        iconColor: "white",
        showActionButton: !1
      };
    case "warning-light":
      return {
        titleColor: "warning",
        descriptionColor: "grey70",
        icon: "exclamation-solid",
        iconColor: "warning",
        showActionButton: !0
      };
  }
}, Vo = y.button`
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`, $o = y.div`
  padding-inline: 1rem;
  padding-block: 0.75rem;
  border-radius: 0.5rem;

  ${({ $variant: e }) => Oo(e)}
`, Oo = (e) => {
  switch (e) {
    case "neutral":
      return k`
        background-color: ${({ theme: r }) => r.colors.grey20};
        outline: 1px solid ${({ theme: r }) => r.colors.grey30};
      `;
    case "informational":
      return k`
        background-color: ${({ theme: r }) => r.colors.primary60};

        a {
          color: ${({ theme: r }) => r.colors.white};
          text-decoration: underline;
        }
      `;
    case "informational-light":
      return k`
        background-color: ${({ theme: r }) => r.colors.primary10};
        outline: 1px solid ${({ theme: r }) => r.colors.primary30};
      `;
    case "error":
      return k`
        background-color: ${({ theme: r }) => r.colors.error};

        a {
          color: ${({ theme: r }) => r.colors.white};
          text-decoration: underline;
        }
      `;
    case "error-light":
      return k`
        background-color: ${({ theme: r }) => r.colors.errorLight};
        outline: 1px solid ${({ theme: r }) => r.colors.borderError};
      `;
    case "success":
      return k`
        background-color: ${({ theme: r }) => r.colors.success};

        a {
          color: ${({ theme: r }) => r.colors.white};
          text-decoration: underline;
        }
      `;
    case "success-light":
      return k`
        background-color: ${({ theme: r }) => r.colors.successLight};
        outline: 1px solid ${({ theme: r }) => r.colors.borderSuccess};
      `;
    case "warning":
      return k`
        background-color: ${({ theme: r }) => r.colors.warning};

        a {
          color: ${({ theme: r }) => r.colors.white};
          text-decoration: underline;
        }
      `;
    case "warning-light":
      return k`
        background-color: ${({ theme: r }) => r.colors.warningLight};
        outline: 1px solid ${({ theme: r }) => r.colors.borderWarning};
      `;
  }
}, F9 = a5(void 0);
function w3() {
  const e = i5(F9);
  if (!e)
    throw new Error(
      "'useModalContext' returned 'undefined'. Is the component wrapped within a Provider?"
    );
  return e;
}
const P9 = t.forwardRef(
  ({ children: e, ...r }, n) => {
    const { bodyId: a } = w3();
    return /* @__PURE__ */ t.createElement("div", { id: a, ref: n, ...r }, e);
  }
);
P9.displayName = "ModalBody";
const G9 = t.forwardRef(
  ({ onClick: e, ...r }, n) => {
    const { onClose: a } = w3(), o = n1(
      (i) => {
        a == null || a(), e == null || e(i);
      },
      [e, a]
    );
    return /* @__PURE__ */ t.createElement(So, { "aria-label": "close", onClick: o, ref: n, ...r }, /* @__PURE__ */ t.createElement(o1, { name: "x-outline", width: 20, height: 20, color: "grey70" }));
  }
);
G9.displayName = "ModalCloseButton";
const So = y.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1010;
  width: 1.25rem;
  height: 1.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`, z9 = t.forwardRef(
  ({ children: e, ...r }, n) => {
    const { footerId: a } = w3();
    return /* @__PURE__ */ t.createElement(
      z,
      {
        flex: !0,
        flexRow: !0,
        columnGap: 1,
        justifyContent: "flex-end",
        id: a,
        ref: n,
        ...r
      },
      e
    );
  }
);
z9.displayName = "ModalFooter";
const Y9 = t.forwardRef(
  ({ children: e, ...r }, n) => {
    const { headerId: a } = w3();
    return /* @__PURE__ */ t.createElement("div", { id: a, ref: n, ...r }, e);
  }
);
Y9.displayName = "ModalHeader";
const Z4 = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.24,
      ease: [0, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.24,
      ease: [0.4, 0, 1, 1]
    }
  }
}, Zo = t.forwardRef(
  ({
    isVisible: e,
    onClose: r,
    size: n = "sm",
    id: a,
    closeOnEsc: o = !0,
    closeOnOutsideClick: i = !0,
    children: l,
    ...c
  }, C) => {
    const s = t.Children.toArray(l).filter(
      (E) => t.isValidElement(E) && E.type === G9
    ), u = t.Children.toArray(l).filter(
      (E) => t.isValidElement(E) && E.type === Y9
    ), f = t.Children.toArray(l).filter(
      (E) => t.isValidElement(E) && E.type === P9
    ), h = t.Children.toArray(l).filter(
      (E) => t.isValidElement(E) && E.type === z9
    ), d = f1(null), [v, m, g, L] = q7(
      a,
      "ff-modal",
      "ff-modal--header",
      "ff-modal--body",
      "ff-modal--footer"
    );
    return a3(() => {
      const E = document.body.style.getPropertyValue("overflow");
      return e && document.body.style.setProperty("overflow", "hidden"), () => {
        document.body.style.setProperty("overflow", E);
      };
    }, [e]), y1(() => {
      if (!o || !e)
        return;
      const E = (V) => {
        V.key === "Escape" && (r == null || r());
      };
      return document.addEventListener("keydown", E), () => {
        document.removeEventListener("keydown", E);
      };
    }, [o, e, r]), y1(() => {
      if (!i || !e)
        return;
      const E = (V) => {
        var D;
        const O = V.target;
        (D = d.current) != null && D.contains(O) || r == null || r();
      };
      return document.addEventListener("pointerdown", E), () => {
        document.removeEventListener("pointerdown", E);
      };
    }, [i, e, r]), /* @__PURE__ */ t.createElement(F9.Provider, { value: { id: v, headerId: m, bodyId: g, footerId: L, onClose: r } }, c5.createPortal(
      /* @__PURE__ */ t.createElement(R4, null, e && /* @__PURE__ */ t.createElement("div", { id: v, ref: C, ...c }, /* @__PURE__ */ t.createElement(
        Do,
        {
          variants: Z4,
          initial: "initial",
          animate: "animate",
          exit: "exit"
        }
      ), /* @__PURE__ */ t.createElement(
        _o,
        {
          variants: Z4,
          initial: "initial",
          animate: "animate",
          exit: "exit"
        },
        /* @__PURE__ */ t.createElement(Bo, { $size: n, role: "dialog", ref: d }, s, /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5 }, u, f), h)
      ))),
      document.body
    ));
  }
);
Zo.displayName = "Modal";
const Do = y(P1.div)`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background-color: ${({ theme: e }) => e.colors.grey100}CC;
`, _o = y(P1.div)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2001;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  width: 100vw;
  height: 100vh;
`, Bo = y.div`
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  width: 100%;
  height: fit-content;
  margin-top: 8rem;
  margin-bottom: 8rem;
  padding: 2.5rem 2rem 2rem;
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};

  ${({ $size: e }) => {
  switch (e) {
    case "md":
      return k`
          max-width: 34.5rem;
        `;
    case "lg":
      return k`
          max-width: 46.5rem;
        `;
    default:
      return k`
          max-width: 22.5rem;
        `;
  }
}}
`, To = {
  open: { rotate: 180 },
  close: { rotate: 0 }
}, Wo = 4, Ro = t.forwardRef(
  ({
    label: e,
    description: r,
    options: n,
    defaultValue: a = [],
    value: o,
    onChange: i,
    defaultIsOpen: l = !1,
    isOpen: c,
    onOpen: C,
    onClose: s,
    helperText: u,
    warningText: f,
    errorText: h,
    isDisabled: d = !1,
    isReadOnly: v = !1,
    id: m,
    placeholder: g,
    onFocus: L,
    onBlur: E,
    ...V
  }, O) => {
    const D = H1(), H = m || `multiselectionfield-${D}`, [F, _] = t.useState(!1), [Y, W] = c1(), [A, N] = c1(!1), [j, J] = w1({
      defaultValue: a,
      value: o,
      onChange: i
    }), [X, B] = w1({
      defaultValue: l,
      value: c,
      onChange: (M) => M ? C == null ? void 0 : C() : s == null ? void 0 : s()
    }), U = f1(null), a1 = f1(null);
    y1(() => {
      if (!X || !U.current) return;
      const M = new ResizeObserver((Z) => {
        Z[0] && Z[0].target instanceof HTMLElement && W(Z[0].target.offsetWidth);
      });
      return M.observe(U.current), () => {
        M.disconnect();
      };
    }, [X]);
    const t1 = n1(() => {
      const M = a1.current;
      if (!M || n.length === 0) return !1;
      const Z = M.children[n.length - 1];
      if (!Z) return !1;
      const P = M.getBoundingClientRect();
      return Z.getBoundingClientRect().bottom <= P.bottom;
    }, [n.length]);
    y1(() => {
      if (!X) {
        N(!1);
        return;
      }
      N(t1());
    }, [X, t1]);
    const w = () => {
      N(t1());
    }, p = () => {
      v || (U.current && W(U.current.offsetWidth), B(!0));
    }, $ = () => {
      B(!1);
    }, x = (M) => {
      _(!0), L == null || L(M);
    }, S = (M) => {
      _(!1), E == null || E(M);
    }, T = (M) => {
      J(j.filter((Z) => Z.value !== M.value));
    }, R = (M) => {
      if (j.some((Z) => Z.value === M.value)) {
        J(j.filter((Z) => Z.value !== M.value));
        return;
      }
      J([...j, M]);
    };
    return /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5, width: "100%" }, (e || r) && /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25, width: "100%" }, e && /* @__PURE__ */ t.createElement(jo, { htmlFor: H, $isDisabled: d }, e), r && /* @__PURE__ */ t.createElement(l1, { variant: "caption-01-regular", color: d ? "grey40" : "grey70" }, r)), /* @__PURE__ */ t.createElement(p3, { isOpen: X, onOpen: p, onClose: $ }, /* @__PURE__ */ t.createElement(p2, { ref: N1(O, U) }, /* @__PURE__ */ t.createElement(
      Ao,
      {
        $isOpen: X,
        $isDisabled: d,
        $isReadOnly: v,
        $hasError: !!h,
        $hasSelection: j.length > 0
      },
      j.length > 0 && /* @__PURE__ */ t.createElement(Io, null, j.map((M) => /* @__PURE__ */ t.createElement(
        y3,
        {
          key: M.value,
          variant: v || d || M.isDisabled ? "default-light" : "removeable",
          onRemove: () => T(M)
        },
        M.label
      ))),
      /* @__PURE__ */ t.createElement(
        No,
        {
          id: H,
          readOnly: !0,
          onFocus: x,
          onBlur: S,
          "aria-errormessage": h ? `${H}-error-msg` : void 0,
          "aria-invalid": !!h,
          placeholder: j.length <= 0 ? g : void 0,
          ...V
        }
      ),
      !v && !d && /* @__PURE__ */ t.createElement(Fo, null, /* @__PURE__ */ t.createElement(
        Po,
        {
          initial: X ? "open" : "close",
          animate: X ? "open" : "close",
          variants: To
        },
        /* @__PURE__ */ t.createElement(
          o1,
          {
            name: "chevron-down-outline",
            width: 20,
            height: 20,
            color: d ? "grey30" : X || F ? "primary60" : "grey70"
          }
        )
      ))
    )), /* @__PURE__ */ t.createElement(g2, null, /* @__PURE__ */ t.createElement(Go, { style: { width: Y } }, /* @__PURE__ */ t.createElement(zo, { ref: a1, onScroll: w }, n.map((M) => /* @__PURE__ */ t.createElement(
      Yo,
      {
        key: M.value,
        onClick: M.isDisabled ? void 0 : (Z) => {
          Z.preventDefault(), R(M);
        }
      },
      /* @__PURE__ */ t.createElement(
        C5,
        {
          label: M.label,
          description: M.description,
          isDisabled: M.isDisabled,
          isChecked: j.some((Z) => Z.value === M.value)
        }
      )
    ))), n.length > Wo && !A && /* @__PURE__ */ t.createElement(Uo, null, /* @__PURE__ */ t.createElement(qo, null, "Scroll to view more"))))), (h || f || u) && /* @__PURE__ */ t.createElement(
      Y1,
      {
        id: h ? `${H}-error-msg` : void 0,
        variant: h ? "error" : f ? "warning" : "helper",
        isDisabled: d
      },
      h || f || u
    ));
  }
);
Ro.displayName = "MultiSelectionField";
const jo = y.label`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  display: block;
  width: 100%;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey40 : r.colors.grey80};
  word-break: break-word;
`, Ao = y.div`
  position: relative;
  display: inline-flex;
  width: 100%;
  padding-inline: 0.9375rem 2.4375rem;
  padding-block: ${({ $hasSelection: e }) => e ? "0.5625rem" : "0.6875rem"};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $isOpen: e, theme: r }) => e ? r.colors.primary60 : r.colors.grey50};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
  cursor: pointer;
  pointer-events: ${({ $isDisabled: e, $isReadOnly: r }) => (e || r) && "none"};

  &:hover {
    border-color: ${({ $isOpen: e, theme: r }) => e ? r.colors.primary60 : r.colors.grey80};
  }

  ${({ $isReadOnly: e, theme: r }) => e && k`
      border-color: ${r.colors.grey30};
      background-color: ${r.colors.grey10};
      color: ${r.colors.grey80};
      pointer-events: none;
    `}

  ${({ $isOpen: e, theme: r }) => e && k`
      box-shadow: inset 0 0 0 1px ${r.colors.primary60};
    `}

  ${({ $hasError: e, $isOpen: r, $isReadOnly: n, $isDisabled: a, theme: o }) => e && k`
      background-color: ${o.colors.errorLight};

      &,
      &:hover {
        border: 1px solid ${o.colors.error};
        box-shadow: inset 0 0 0 1px ${o.colors.error};
      }

      ${r && k`
        &,
        &:hover {
          border: 1px solid ${o.colors.primary60};
          box-shadow: inset 0 0 0 1px ${o.colors.primary60};
        }
      `}

      ${(n || a) && k`
        background-color: ${o.colors.grey10};
      `}
    `}
`, Io = y.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`, No = y.input`
  ${({ theme: e }) => e.getTextStyles("filled-text-01-semibold")}

  flex: 1;
  width: 100%;
  padding: 0;
  border: none;
  background-color: transparent;
  color: ${({ theme: e }) => e.colors.grey80};
  outline: none;
  cursor: pointer;
  appearance: none;

  &::placeholder {
    ${({ theme: e }) => e.getTextStyles("placeholder-text-01-light")}
    color: ${({ theme: e }) => e.colors.grey60};
  }
`, Fo = y(P1.div)`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  bottom: 0.75rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
`, Po = y(P1.div)`
  display: flex;
`, Go = y.div`
  position: relative;
  overflow: hidden;
  border: 2px solid ${({ theme: e }) => e.colors.primary60};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
`, zo = y.ul`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 13.5rem;
  margin: 0;
  padding: 0.375rem 0;
  background-color: ${({ theme: e }) => e.colors.white};
  list-style: none;
`, Yo = y.li`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  padding: 0.25rem 1rem;
  color: ${({ theme: e }) => e.colors.grey80};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme: e }) => e.colors.grey10};
  }
`, Uo = y.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 2.5rem;
  padding-bottom: 0.5rem;
  background: linear-gradient(to bottom, transparent, ${({ theme: e }) => e.colors.white});
  pointer-events: none;
`, qo = y.span`
  ${({ theme: e }) => e.getTextStyles("caption-02-semibold")}

  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  background-color: ${({ theme: e }) => e.colors.grey20};
  color: ${({ theme: e }) => e.colors.grey80};
`, U9 = t.forwardRef(
  ({
    id: e,
    label: r,
    description: n,
    helperText: a,
    warningText: o,
    errorText: i,
    isDisabled: l = !1,
    isReadOnly: c = !1,
    ...C
  }, s) => {
    const u = H1(), f = e || `textfield-${u}`, h = !l && !c;
    return /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5, width: "100%" }, (r || n) && /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25 }, r && /* @__PURE__ */ t.createElement(Ko, { htmlFor: f, $isDisabled: l }, r), n && /* @__PURE__ */ t.createElement(l1, { variant: "caption-01-regular", color: l ? "grey40" : "grey70" }, n)), /* @__PURE__ */ t.createElement(Xo, null, /* @__PURE__ */ t.createElement(
      Jo,
      {
        id: f,
        disabled: l,
        readOnly: c,
        ref: s,
        "aria-errormessage": i ? `${f}-error-msg` : void 0,
        "aria-invalid": !!i,
        $hasError: !!i,
        ...C
      }
    ), h && i && /* @__PURE__ */ t.createElement(Qo, null, /* @__PURE__ */ t.createElement(o1, { name: "exclamation-circle-solid", width: 20, height: 20, color: "error" }))), (i || o || a) && /* @__PURE__ */ t.createElement(
      Y1,
      {
        id: i ? `${f}-error-msg` : void 0,
        variant: i ? "error" : o ? "warning" : "helper",
        isDisabled: l
      },
      i || o || a
    ));
  }
);
U9.displayName = "TextField";
const Xo = y.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
`, Ko = y.label`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  display: block;
  width: 100%;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey40 : r.colors.grey80};
  word-break: break-word;
`, Jo = y.input`
  ${({ theme: e }) => e.getTextStyles("filled-text-01-semibold")}

  width: 100%;
  padding-inline: 0.9375rem 0.9375rem;
  padding-block: 0.6875rem;
  border: ${({ theme: e }) => `1px solid ${e.colors.grey50}`};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
  color: ${({ theme: e }) => e.colors.grey80};
  outline: none;
  resize: none;

  &::placeholder {
    ${({ theme: e }) => e.getTextStyles("placeholder-text-01-light")}
    color: ${({ theme: e }) => e.colors.grey60};
  }

  &:hover {
    border-color: ${({ theme: e }) => e.colors.grey80};
  }

  &:read-only {
    border-color: ${({ theme: e }) => e.colors.grey30};
    background-color: ${({ theme: e }) => e.colors.grey10};
    color: ${({ theme: e }) => e.colors.grey80};
    box-shadow: none;
  }

  &:focus {
    border-color: ${({ theme: e }) => e.colors.primary60};
    box-shadow: inset 0 0 0 1px ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey30};
    background-color: ${({ theme: e }) => e.colors.grey10};
    color: ${({ theme: e }) => e.colors.grey40};

    &::placeholder {
      ${({ theme: e }) => e.getTextStyles("placeholder-text-01-light")}
      color: ${({ theme: e }) => e.colors.grey40};
    }
  }

  ${({ $hasError: e, theme: r }) => e && k`
      background-color: ${r.colors.errorLight};

      &,
      &:read-only,
      &:disabled,
      &:hover:not(:focus) {
        padding-inline: 0.9375rem 2.4375rem;
        border: 1px solid ${r.colors.error};
        box-shadow: inset 0 0 0 1px ${r.colors.error};
      }
    `}
`, Qo = y.div`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
`, ea = new RegExp("^-?\\d*\\.?\\d*$");
function ta(e, r) {
  var i, l;
  const n = J2(r), o = (((i = J2(e).match(/,/g)) == null ? void 0 : i.length) ?? 0) - (((l = n.match(/,/g)) == null ? void 0 : l.length) ?? 0);
  return r.length - e.length > 1 ? 0 : o;
}
function ra(e, r, n) {
  return n && r[n] == "," && r.length - e.length == 1 ? [
    e.substring(0, n - 1) + e.substring(n, e.length),
    n - 1
  ] : [e, n];
}
const na = t.forwardRef(
  ({
    id: e,
    defaultValue: r = "",
    value: n,
    onChange: a,
    decimalPlaces: o = 0,
    thousandDelimiter: i = !1,
    ...l
  }, c) => {
    const C = f1(null), s = H1(), u = e || `numericfield-${s}`, [f, h] = w1({
      defaultValue: r,
      value: n,
      onChange: a
    }), [d, v] = c1(null), [m, g] = c1(0), L = n1(
      (E) => {
        let V = E.target.value.replace(/,/g, "");
        if (!ea.test(V))
          return;
        if (i) {
          let H = E.target.selectionStart;
          [V, H] = ra(
            E.target.value,
            J2(f),
            H
          ), V = V.replace(/,/g, ""), v(H), g(ta(V, f));
        }
        const [O, D] = V.split(".");
        if (!o) {
          h(O);
          return;
        }
        if (D) {
          h(`${O}.${D.slice(0, o)}`);
          return;
        }
        h(V);
      },
      [o, h, i, f]
    );
    return a3(() => {
      if (d !== null) {
        const E = C.current;
        if (E) {
          let V = d + m;
          V = V < 0 ? 0 : V, E.setSelectionRange(V, V);
        }
      }
    }, [d, C, m, f]), /* @__PURE__ */ t.createElement(
      U9,
      {
        id: u,
        value: i ? J2(f) : f,
        onChange: L,
        ref: N1(c, C),
        ...l
      }
    );
  }
);
na.displayName = "NumericField";
const q9 = t.createContext(
  void 0
);
function oa() {
  const e = t.useContext(q9);
  if (!e)
    throw new Error(
      "'useRadioGroupContext' returned 'undefined'. Is the component wrapped in a 'RadioGroup' component?"
    );
  return e;
}
const X9 = t.forwardRef(
  ({ label: e, helperText: r, isDisabled: n = !1, value: a, onChange: o, ...i }, l) => {
    const {
      variant: c,
      value: C,
      setValue: s,
      name: u,
      hasError: f,
      isReadOnly: h = !1
    } = oa(), d = n1(
      (L) => {
        s(L.target.value), o == null || o(L);
      },
      [o, s]
    ), v = `radio-${H1()}`, m = C === a, g = n || h;
    return /* @__PURE__ */ t.createElement(ia, { $variant: c, $isDisabled: g, htmlFor: v }, /* @__PURE__ */ t.createElement(
      aa,
      {
        $hasError: f,
        type: "radio",
        id: v,
        name: u,
        checked: m,
        disabled: n,
        readOnly: h,
        value: a,
        onChange: g ? void 0 : d,
        ref: l,
        ...i
      }
    ), /* @__PURE__ */ t.createElement(K9, { $isDisabled: g }, m && /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 20 20", fill: "currentColor" }, /* @__PURE__ */ t.createElement("circle", { cx: "10", cy: "10", r: "6" }))), /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25 }, /* @__PURE__ */ t.createElement(l1, { variant: "label-01-regular" }, e), r && /* @__PURE__ */ t.createElement(l1, { variant: "caption-01-regular" }, r)));
  }
);
X9.displayName = "Radio";
const K9 = y.span`
  position: absolute;
  width: 1.25rem;
  height: 1.25rem;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey70 : r.colors.primary60};
  pointer-events: none;
`, aa = y.input`
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin: 0;
  border: ${({ theme: e }) => `1px solid ${e.colors.grey50}`};
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.colors.white};
  cursor: pointer;
  appearance: none;

  &:hover {
    border-color: ${({ theme: e }) => e.colors.grey80};
    background-color: ${({ theme: e }) => e.colors.grey10};
  }

  &:hover:not(:disabled):not([readonly]) + ${K9} svg circle {
    fill: ${({ theme: e }) => e.colors.primary70};
  }

  &:disabled,
  &[readonly] {
    border-color: ${({ theme: e }) => e.colors.grey30};
    background-color: ${({ theme: e }) => e.colors.grey10};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
  }

  &:hover:checked:not(:disabled, [readonly]) {
    background-color: ${({ theme: e }) => e.colors.white};
  }

  ${({ $hasError: e, theme: r }) => e && k`
      background-color: ${r.colors.errorLight};

      &,
      &:hover,
      &:disabled,
      &[readonly] {
        border: 1px solid ${r.colors.error};
        box-shadow: inset 0 0 0 1px ${r.colors.error};
      }

      &:disabled,
      &[readonly] {
        background-color: ${r.colors.grey10};
      }
    `}
`, ia = y.label`
  position: relative;
  display: flex;
  width: fit-content;
  min-width: ${({ $variant: e }) => e === "horizontal" ? "8rem" : "auto"};
  padding-block: 0.75rem;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey40 : r.colors.grey80};
  cursor: ${({ $isDisabled: e }) => e ? "not-allowed" : "pointer"};
  column-gap: 0.75rem;
`, la = t.forwardRef(
  ({
    label: e,
    description: r,
    variant: n = "vertical",
    name: a,
    helperText: o,
    warningText: i,
    errorText: l,
    isReadOnly: c = !1,
    defaultValue: C = "",
    value: s,
    onChange: u,
    children: f,
    ...h
  }, d) => {
    const v = H1(), m = a || `radio-group-${v}`, [g, L] = w1({
      defaultValue: C,
      value: s,
      onChange: u
    }), E = t.Children.toArray(f).filter(
      (V) => t.isValidElement(V) && V.type === X9
    );
    return /* @__PURE__ */ t.createElement(
      q9.Provider,
      {
        value: { variant: n, value: g, setValue: L, name: m, hasError: !!l, isReadOnly: c }
      },
      /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 1, ref: d, ...h }, /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5 }, e && /* @__PURE__ */ t.createElement(ca, null, e), r && /* @__PURE__ */ t.createElement(l1, { variant: "caption-01-regular", color: "grey70" }, r)), n === "vertical" && /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5 }, E), n === "horizontal" && /* @__PURE__ */ t.createElement(z, { flex: !0, flexRow: !0, columnGap: 1.5 }, E), (l || i || o) && /* @__PURE__ */ t.createElement(Y1, { variant: l ? "error" : i ? "warning" : "helper" }, l || i || o))
    );
  }
);
la.displayName = "RadioGroup";
const ca = y.label`
  display: block;
  color: ${({ theme: e }) => e.colors.grey80};
  word-break: break-word;

  ${({ theme: e }) => e.getTextStyles("label-01-regular")}
`, Ca = t.forwardRef(
  ({
    id: e,
    defaultValue: r,
    value: n,
    hints: a = [],
    placeholder: o = "Search",
    onChange: i,
    onSearch: l,
    isLoading: c = !1,
    isDynamic: C = !1,
    ...s
  }, u) => {
    var F;
    const f = H1(), h = e || `search-${f}`, [d, v] = w1({
      defaultValue: r,
      value: n,
      onChange: (_) => {
        i && i(_), C && l(_);
      }
    }), [m, g] = c1(), [L, E] = c1(!1), V = f1(null), O = f1(null), D = f1([]), H = (_) => {
      if (_.target instanceof HTMLInputElement)
        switch (_.key) {
          case "Enter":
            l(_.target.value), m !== void 0 && v(a[m]);
            break;
          case "Escape":
            v("");
            break;
          case "ArrowUp":
            if (a.length === 0) break;
            m === void 0 ? (g(a.length - 1), D.current[a.length - 1].scrollIntoView({ block: "nearest" })) : m > 0 && (g(m - 1), D.current[m - 1].scrollIntoView({ block: "nearest" })), _.preventDefault();
            break;
          case "ArrowDown":
            if (a.length === 0) break;
            m === void 0 ? (g(0), D.current[0].scrollIntoView({ block: "nearest" })) : m < a.length - 1 && (g(m + 1), D.current[m + 1].scrollIntoView({ block: "nearest" })), _.preventDefault();
            break;
        }
    };
    return /* @__PURE__ */ t.createElement(z, { width: "100%" }, /* @__PURE__ */ t.createElement(
      p3,
      {
        isOpen: L && (a.length > 0 || c),
        onOpen: () => {
          var _;
          E(!0), (_ = O.current) == null || _.focus();
        },
        onClose: () => {
          var _;
          E(!1), (_ = O.current) == null || _.focus();
        }
      },
      /* @__PURE__ */ t.createElement(p2, { ref: V }, /* @__PURE__ */ t.createElement(sa, { flex: !0, flexRow: !0, columnGap: 0.5 }, c ? /* @__PURE__ */ t.createElement(j4, { "data-testid": "spinner", variant: "light", width: 20, height: 20 }) : /* @__PURE__ */ t.createElement(o1, { name: "search-outline", color: "grey60", width: 20, height: 20 }), /* @__PURE__ */ t.createElement(
        ua,
        {
          ref: N1(u, O),
          id: h,
          value: d,
          placeholder: o,
          autoComplete: "off",
          onChange: (_) => v(_.target.value),
          onKeyDown: H,
          ...s
        }
      ), /* @__PURE__ */ t.createElement(
        da,
        {
          "data-testid": "delete-btn",
          name: "x-circle-solid",
          color: "grey60",
          width: 20,
          height: 20,
          onClick: () => v("")
        }
      ))),
      /* @__PURE__ */ t.createElement(g2, null, /* @__PURE__ */ t.createElement(fa, { style: { width: (F = V.current) == null ? void 0 : F.offsetWidth } }, c ? /* @__PURE__ */ t.createElement(D4, null, /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25 }, /* @__PURE__ */ t.createElement(_4, null), /* @__PURE__ */ t.createElement(_4, { style: { width: "70%" } }))) : a.map((_, Y) => /* @__PURE__ */ t.createElement(
        D4,
        {
          ref: (W) => {
            W && (D.current[Y] = W);
          },
          key: Y,
          className: Y === m ? "selected" : "",
          onClick: () => v(_),
          onMouseEnter: () => g(Y),
          onMouseLeave: () => g(void 0)
        },
        _
      ))))
    ));
  }
);
Ca.displayName = "Search";
const sa = y(z)`
  width: 100%;
  min-width: 5.5rem;
  height: 2.75rem;
  padding-inline: 1rem;
  padding-block: 0.75rem;
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};

  &:hover {
    /* stylelint-disable declaration-property-unit-allowed-list */
    padding-inline: calc(1rem - 1px);
    padding-block: calc(0.75rem - 1px);
    border: 1px solid ${({ theme: e }) => e.colors.grey80};
    /* stylelint-enable declaration-property-unit-allowed-list */
  }

  &:has(> input:focus) {
    /* stylelint-disable declaration-property-unit-allowed-list */
    padding-inline: calc(1rem - 2px);
    padding-block: calc(0.75rem - 2px);
    border: 2px solid ${({ theme: e }) => e.colors.primary60};
    /* stylelint-enable declaration-property-unit-allowed-list */
  }
`, ua = y.input`
  ${({ theme: e }) => e.getTextStyles("filled-text-01-semibold")}

  width: 100%;
  border: none;
  color: ${({ theme: e }) => e.colors.grey80};
  outline: none;

  &::placeholder {
    ${({ theme: e }) => e.getTextStyles("placeholder-text-01-light")}
    color: ${({ theme: e }) => e.colors.grey60};
  }

  &:placeholder-shown + svg {
    visibility: hidden;
  }
`, da = y(o1)`
  cursor: pointer;
`, fa = y.ul`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 12rem;
  margin: 0;
  padding: 0.5rem 0;
  border: 2px solid ${({ theme: e }) => e.colors.primary60};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
  list-style: none;
`, D4 = y.li`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  padding: 0.75rem 1rem;
  color: ${({ theme: e }) => e.colors.grey80};
  cursor: pointer;

  &.selected {
    background-color: ${({ theme: e }) => e.colors.grey10};
  }
`, ma = i3`
  from {
    opacity: 0.04;
  }

  to {
    opacity: 0.08;
  }
`, _4 = y.div`
  height: 0.75rem;
  border: none;
  border-radius: 0.25rem;
  background-color: ${({ theme: e }) => e.colors.grey100};
  animation: ${ma} 1.5s infinite linear;
`, ha = {
  open: { rotate: 180 },
  close: { rotate: 0 }
}, va = 4, ga = t.forwardRef(
  ({
    id: e,
    label: r,
    description: n,
    options: a,
    defaultValue: o = null,
    value: i,
    onChange: l,
    defaultIsOpen: c = !1,
    isOpen: C,
    onOpen: s,
    onClose: u,
    helperText: f,
    warningText: h,
    errorText: d,
    isDisabled: v = !1,
    isReadOnly: m = !1,
    showDeleteIcon: g = !0,
    onFocus: L,
    onBlur: E,
    onFilter: V,
    onSortResults: O,
    isLoading: D = !1,
    emptyMessage: H,
    ...F
  }, _) => {
    const Y = H1(), W = e || `selectionfield-${Y}`, A = !v && !m, [N, j] = c1(!1), [J, X] = c1(), [B, U] = c1(-1), [a1, t1] = c1(""), [w, p] = c1(!1), [$, x] = w1({
      defaultValue: o,
      value: i,
      onChange: l
    }), [S, T] = w1({
      defaultValue: c,
      value: C,
      onChange: (I) => I ? s == null ? void 0 : s() : u == null ? void 0 : u()
    }), R = f1(null), M = f1(null), Z = z1(() => {
      if ($ && a1 === $.label)
        return a;
      const I = V ? V(a, a1) : a.filter((r1) => (r1.label + (r1.description ? ` ${r1.description}` : "")).toLowerCase().includes(a1.toLowerCase()));
      return O ? O(I, a1) : I;
    }, [$, a1, a, V, O]);
    y1(() => {
      if (!S || !R.current) return;
      const I = new ResizeObserver((r1) => {
        r1[0] && r1[0].target instanceof HTMLElement && X(r1[0].target.offsetWidth);
      });
      return I.observe(R.current), () => {
        I.disconnect();
      };
    }, [S]);
    const P = n1(() => {
      const I = M.current;
      if (!I || Z.length === 0) return !1;
      const r1 = I.children[Z.length - 1];
      if (!r1) return !1;
      const h1 = I.getBoundingClientRect();
      return r1.getBoundingClientRect().bottom <= h1.bottom;
    }, [Z.length]);
    y1(() => {
      if (!S) {
        p(!1);
        return;
      }
      const I = B < 0 && $ ? Z.findIndex((K1) => K1.value === $.value) : B;
      if (I < 0 || !M.current) return;
      const r1 = M.current, h1 = r1.children[I];
      if (!h1) return;
      const D1 = r1.getBoundingClientRect(), _1 = h1.getBoundingClientRect();
      _1.top < D1.top ? r1.scrollTop -= D1.top - _1.top : _1.bottom > D1.bottom && (r1.scrollTop += _1.bottom - D1.bottom), p(P());
    }, [Z, B, S, $, P]);
    const q = () => {
      p(P());
    }, m1 = () => {
      m || (R.current && X(R.current.offsetWidth), T(!0));
    }, s1 = () => {
      T(!1);
    }, b1 = (I) => {
      t1($ ? $.label : ""), j(!0), L == null || L(I);
    }, u1 = (I) => {
      j(!1), U(-1), E == null || E(I);
    }, A1 = (I) => {
      I.stopPropagation(), x(null);
    }, p1 = (I) => {
      x(I), U(-1), T(!1);
    }, I1 = (I) => {
      t1(I.target.value), U(-1), I.target.value === "" && x(null), S || T(!0);
    }, a2 = (I) => {
      var r1;
      if (I.key === "Tab" && T(!1), I.key === "Enter" && I.preventDefault(), Z.length !== 0) {
        if (I.key === "ArrowDown")
          I.preventDefault(), T(!0), U((h1) => h1 < Z.length - 1 ? h1 + 1 : 0);
        else if (I.key === "ArrowUp")
          I.preventDefault(), T(!0), U((h1) => h1 > 0 ? h1 - 1 : Z.length - 1);
        else if (I.key === "Enter") {
          if (!$ && B < 0) return;
          B >= 0 ? p1(Z[B]) : T(!1);
          const h1 = (r1 = R.current) == null ? void 0 : r1.querySelector("input");
          h1 == null || h1.blur();
        }
      }
    };
    return /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5, width: "100%" }, (r || n) && /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25, width: "100%" }, r && /* @__PURE__ */ t.createElement(wa, { htmlFor: W, $isDisabled: v }, r), n && /* @__PURE__ */ t.createElement(l1, { variant: "caption-01-regular", color: v ? "grey40" : "grey70" }, n)), /* @__PURE__ */ t.createElement(p3, { isOpen: S, onOpen: m1, onClose: s1 }, /* @__PURE__ */ t.createElement(p2, { ref: N1(_, R) }, /* @__PURE__ */ t.createElement(pa, { $isDisabled: v, $isReadOnly: m }, /* @__PURE__ */ t.createElement(
      ba,
      {
        id: W,
        autoComplete: "off",
        disabled: v,
        readOnly: m,
        value: N ? a1 : ($ == null ? void 0 : $.label) ?? "",
        onChange: I1,
        onFocus: b1,
        onBlur: u1,
        onKeyDown: a2,
        "aria-errormessage": d ? `${W}-error-msg` : void 0,
        "aria-invalid": !!d,
        $hasError: !!d,
        $isOpen: S,
        $showDeleteIcon: A && g,
        ...F
      }
    ), /* @__PURE__ */ t.createElement(Ea, null, $ && A && g && /* @__PURE__ */ t.createElement(
      ka,
      {
        name: "x-outline",
        width: 20,
        height: 20,
        color: S || N ? "primary60" : "grey70",
        onClick: A1,
        "aria-label": `Delete icon for ${r}`
      }
    ), /* @__PURE__ */ t.createElement(
      La,
      {
        initial: S ? "open" : "close",
        animate: S ? "open" : "close",
        variants: ha
      },
      /* @__PURE__ */ t.createElement(
        o1,
        {
          name: "chevron-down-outline",
          width: 20,
          height: 20,
          color: v ? "grey30" : S || N ? "primary60" : "grey70"
        }
      )
    )))), /* @__PURE__ */ t.createElement(g2, null, /* @__PURE__ */ t.createElement(ya, { style: { width: J } }, /* @__PURE__ */ t.createElement(xa, { ref: M, onScroll: q }, D ? /* @__PURE__ */ t.createElement(
      z,
      {
        flex: !0,
        flexColumn: !0,
        rowGap: 0.25,
        mx: 0.75,
        my: 0.5,
        onMouseDown: (I) => I.preventDefault(),
        "data-testid": "selection-field-loading"
      },
      /* @__PURE__ */ t.createElement(B4, null),
      /* @__PURE__ */ t.createElement(B4, { $width: "70%" })
    ) : Z.length > 0 ? Z.map((I, r1) => /* @__PURE__ */ t.createElement(
      Ha,
      {
        key: I.value,
        $isSelected: ($ == null ? void 0 : $.value) === I.value,
        $isHighlighted: B === r1,
        onClick: () => p1(I)
      },
      I.label,
      I.description && /* @__PURE__ */ t.createElement(l1, { variant: "label-02-regular", color: "grey60" }, I.description)
    )) : /* @__PURE__ */ t.createElement(Ma, { onMouseDown: (I) => I.preventDefault() }, H ?? "No results found")), Z.length > va && !w && /* @__PURE__ */ t.createElement(Va, null, /* @__PURE__ */ t.createElement($a, null, "Scroll to view more"))))), (d || h || f) && /* @__PURE__ */ t.createElement(
      Y1,
      {
        id: d ? `${W}-error-msg` : void 0,
        variant: d ? "error" : h ? "warning" : "helper",
        isDisabled: v
      },
      d || h || f
    ));
  }
);
ga.displayName = "SelectionField";
const pa = y.div`
  position: relative;
  display: inline-flex;
  pointer-events: ${({ $isDisabled: e, $isReadOnly: r }) => (e || r) && "none"};
`, ya = y.div`
  position: relative;
  overflow: hidden;
  border: 2px solid ${({ theme: e }) => e.colors.primary60};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
`, wa = y.label`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  display: block;
  width: 100%;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey40 : r.colors.grey80};
  word-break: break-word;
`, ba = y.input`
  ${({ theme: e }) => e.getTextStyles("filled-text-01-semibold")}

  width: 100%;
  padding-inline: 0.9375rem
    ${({ $showDeleteIcon: e }) => e ? "4.1875rem" : "2.4375rem"};
  padding-block: 0.6875rem;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $isOpen: e, theme: r }) => e ? r.colors.primary60 : r.colors.grey50};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
  color: ${({ theme: e }) => e.colors.grey80};
  outline: none;
  text-overflow: ellipsis;
  cursor: pointer;

  &::placeholder {
    ${({ theme: e }) => e.getTextStyles("placeholder-text-01-light")}
    color: ${({ theme: e }) => e.colors.grey60};
  }

  &:hover {
    border-color: ${({ $isOpen: e, theme: r }) => e ? r.colors.primary60 : r.colors.grey80};
  }

  &:focus-visible {
    border-color: ${({ theme: e }) => e.colors.primary60};
    box-shadow: inset 0 0 0 1px ${({ theme: e }) => e.colors.primary60};
  }

  &:read-only {
    border-color: ${({ theme: e }) => e.colors.grey30};
    background-color: ${({ theme: e }) => e.colors.grey10};
    color: ${({ theme: e }) => e.colors.grey80};
    pointer-events: none;
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey30};
    background-color: ${({ theme: e }) => e.colors.grey10};
    color: ${({ theme: e }) => e.colors.grey40};

    &::placeholder {
      ${({ theme: e }) => e.getTextStyles("placeholder-text-01-light")}
      color: ${({ theme: e }) => e.colors.grey40};
    }
  }

  ${({ $hasError: e, theme: r }) => e && k`
      background-color: ${r.colors.errorLight};

      &,
      &:read-only,
      &:disabled,
      &:hover:not(:focus) {
        border: 1px solid ${r.colors.error};
        box-shadow: inset 0 0 0 1px ${r.colors.error};
      }
    `}
`, Ea = y(P1.div)`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  bottom: 0.75rem;
  display: flex;
  gap: 0.5rem;
`, ka = y(o1)`
  cursor: pointer;
`, La = y(P1.div)`
  display: flex;
`, xa = y.ul`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 13.5rem;
  margin: 0;
  padding: 0.5rem 0;
  background-color: ${({ theme: e }) => e.colors.white};
  list-style: none;
`, Ha = y.li`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  padding: 0.75rem 1rem;
  background-color: ${({ theme: e, $isSelected: r, $isHighlighted: n }) => n ? e.colors.grey10 : r ? e.colors.primary10 : "transparent"};
  color: ${({ theme: e, $isSelected: r, $isHighlighted: n }) => n ? e.colors.grey80 : r ? e.colors.primary60 : e.colors.grey80};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme: e }) => e.colors.grey10};
  }
`, Ma = y.div`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  padding: 0.75rem 1rem;
`, Va = y.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 2.5rem;
  padding-bottom: 0.5rem;
  background: linear-gradient(to bottom, transparent, ${({ theme: e }) => e.colors.white});
  pointer-events: none;
`, $a = y.span`
  ${({ theme: e }) => e.getTextStyles("caption-02-semibold")}

  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  background-color: ${({ theme: e }) => e.colors.grey20};
  color: ${({ theme: e }) => e.colors.grey80};
`, Oa = i3`
  0%, 40% {
    background-position: 150% 0;
  }
  50% {
    background-position: 0 0;
  }
  60%, 100% {
    background-position: -50% 0;
  }
`, B4 = y.div`
  width: ${({ $width: e }) => e || "100%"};
  height: 1rem;
  border-radius: 0.25rem;
  background: linear-gradient(
    90deg,
    ${({ theme: e }) => e.colors.grey10} 0%,
    ${({ theme: e }) => e.colors.grey10} 25%,
    ${({ theme: e }) => e.colors.grey20} 50%,
    ${({ theme: e }) => e.colors.grey10} 75%,
    ${({ theme: e }) => e.colors.grey10} 100%
  );
  background-size: 200% 100%;
  animation: ${Oa} 5s linear infinite;
`, Sa = t.forwardRef(
  ({
    id: e,
    label: r,
    description: n,
    helperText: a,
    warningText: o,
    errorText: i,
    isDisabled: l = !1,
    isReadOnly: c = !1,
    ...C
  }, s) => {
    const u = H1(), f = e || `textarea-${u}`;
    return /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.5, width: "100%" }, /* @__PURE__ */ t.createElement(z, { flex: !0, flexColumn: !0, rowGap: 0.25 }, /* @__PURE__ */ t.createElement(Za, { htmlFor: f, $isDisabled: l }, r), n && /* @__PURE__ */ t.createElement(l1, { variant: "caption-01-regular", color: l ? "grey40" : "grey70" }, n)), /* @__PURE__ */ t.createElement(
      Da,
      {
        id: f,
        rows: 5,
        disabled: l,
        readOnly: c,
        ref: s,
        "aria-errormessage": i ? `${f}-error-msg` : void 0,
        "aria-invalid": !!i,
        $hasError: !!i,
        ...C
      }
    ), (i || o || a) && /* @__PURE__ */ t.createElement(
      Y1,
      {
        id: i ? `${f}-error-msg` : void 0,
        variant: i ? "error" : o ? "warning" : "helper",
        isDisabled: l
      },
      i || o || a
    ));
  }
);
Sa.displayName = "TextArea";
const Za = y.label`
  ${({ theme: e }) => e.getTextStyles("label-01-regular")}

  display: block;
  width: 100%;
  color: ${({ $isDisabled: e, theme: r }) => e ? r.colors.grey40 : r.colors.grey80};
  word-break: break-word;
`, Da = y.textarea`
  ${({ theme: e }) => e.getTextStyles("filled-text-01-semibold")}

  width: 100%;
  padding: 0.6875rem 0.9375rem;
  border: 1px solid ${({ theme: e }) => e.colors.grey50};
  border-radius: 0.5rem;
  background-color: ${({ theme: e }) => e.colors.white};
  color: ${({ theme: e }) => e.colors.grey80};
  outline: none;
  resize: none;

  &:hover {
    border-color: ${({ theme: e }) => e.colors.grey80};
  }

  &:read-only {
    border-color: ${({ theme: e }) => e.colors.grey30};
    background-color: ${({ theme: e }) => e.colors.grey10};
    color: ${({ theme: e }) => e.colors.grey80};
    box-shadow: none;
  }

  &:focus {
    border-color: ${({ theme: e }) => e.colors.primary60};
    box-shadow: inset 0 0 0 1px ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    border-color: ${({ theme: e }) => e.colors.grey30};
    background-color: ${({ theme: e }) => e.colors.grey10};
    color: ${({ theme: e }) => e.colors.grey40};
  }

  &::placeholder {
    ${({ theme: e }) => e.getTextStyles("placeholder-text-01-light")}
    color: ${({ theme: e }) => e.colors.grey60};
  }

  ${({ $hasError: e, theme: r }) => e && k`
      background-color: ${r.colors.errorLight};

      &,
      &:read-only,
      &:disabled,
      &:hover:not(:focus) {
        border: 1px solid ${r.colors.error};
        box-shadow: inset 0 0 0 1px ${r.colors.error};
      }
    `}
`, _a = t.forwardRef(
  ({
    title: e,
    description: r = "",
    icon: n,
    orientation: a = "horizontal",
    isDisabled: o = !1,
    isBeta: i = !1,
    onClick: l,
    ...c
  }, C) => /* @__PURE__ */ t.createElement(
    Ba,
    {
      disabled: o,
      $orientation: a,
      ...c,
      ref: C,
      onClick: l
    },
    n && /* @__PURE__ */ t.createElement(
      o1,
      {
        name: n,
        width: a === "horizontal" ? 24 : 40,
        height: a === "horizontal" ? 24 : 40,
        color: o ? "grey30" : "primary60"
      }
    ),
    /* @__PURE__ */ t.createElement(
      z,
      {
        ...n && a === "horizontal" ? { mx: 0.75 } : n ? { mt: 1 } : {},
        rowGap: 0.25,
        flex: !0,
        flexColumn: !0,
        alignItems: "flex-start"
      },
      /* @__PURE__ */ t.createElement(z, { flex: !0, alignItems: "center", columnGap: 0.5 }, /* @__PURE__ */ t.createElement(l1, { variant: "heading-07-semibold", color: "grey80" }, e), i && /* @__PURE__ */ t.createElement(y3, { variant: "primary-light" }, "BETA")),
      r && /* @__PURE__ */ t.createElement(l1, { variant: "label-01-regular", color: "grey60" }, r)
    )
  )
);
_a.displayName = "Tile";
const Ba = y.button`
  display: flex;
  flex-direction: ${({ $orientation: e }) => e === "horizontal" ? "row" : "column"};
  align-items: ${({ $orientation: e }) => e === "horizontal" ? "center" : "flex-start"};
  width: 100%;
  height: 100%;
  padding: 1.25rem;
  border: none;
  border-radius: ${({ theme: e }) => e.radii.default};
  background-color: ${({ theme: e }) => e.colors.white};
  box-shadow: ${({ theme: e }) => e.elevations.default};
  text-align: left;
  cursor: pointer;

  &:hover {
    box-shadow: ${({ theme: e }) => e.elevations.onHover};
    outline: 1px solid ${({ theme: e }) => e.colors.grey80};
  }

  &:focus {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
  }

  &:disabled {
    color: ${({ theme: e }) => e.colors.grey40};
    cursor: default;

    & * {
      color: inherit;
    }

    &:hover,
    &:focus {
      background-color: inherit;
      box-shadow: ${({ theme: e }) => e.elevations.default};
      outline: none;
    }
  }
`, $5 = t.forwardRef(
  ({ children: e, ...r }, n) => /* @__PURE__ */ t.createElement(Ta, { ref: n, ...r }, e)
);
$5.displayName = "SideSheetBody";
const Ta = y.div`
  flex: 1;
  overflow-y: auto;
  padding: 4.5rem 3rem 2.5rem;
`, O5 = t.forwardRef(
  ({ children: e, ...r }, n) => /* @__PURE__ */ t.createElement(Wa, { ref: n, ...r }, e)
);
O5.displayName = "SideSheetFooter";
const Wa = y.div`
  height: 5.25rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid rgb(196 197 201 / 60%);
  background-color: ${({ theme: e }) => e.colors.white};
`, J9 = t.forwardRef(
  ({
    isVisible: e,
    onClose: r,
    closeOnEsc: n = !0,
    closeOnOutsideClick: a = !1,
    showOverlay: o = !0,
    zIndex: i = 2e3,
    dataTestId: l = "side-sheet",
    width: c = 32,
    children: C,
    ...s
  }, u) => {
    const f = f1(null), h = N1(u, f), d = t.Children.toArray(C).filter(
      (v) => t.isValidElement(v) && (v.type === $5 || v.type === O5)
    );
    return a3(() => {
      if (!e || !o)
        return;
      const v = document.body.style.overflow;
      return document.body.style.overflow = "hidden", () => {
        document.body.style.overflow = v;
      };
    }, [e, o]), y1(() => {
      if (!n || !e) return;
      const v = (m) => {
        m.key === "Escape" && (r == null || r());
      };
      return document.addEventListener("keydown", v), () => {
        document.removeEventListener("keydown", v);
      };
    }, [n, e, r]), y1(() => {
      if (!a || !e)
        return;
      const v = (m) => {
        var L;
        const g = m.target;
        (L = f.current) != null && L.contains(g) || r();
      };
      return document.addEventListener("pointerdown", v), () => {
        document.removeEventListener("pointerdown", v);
      };
    }, [a, e, r]), e ? c5.createPortal(
      /* @__PURE__ */ t.createElement(t.Fragment, null, o && /* @__PURE__ */ t.createElement(Ra, { "data-testid": "side-sheet-overlay", $zIndex: i }), /* @__PURE__ */ t.createElement(
        ja,
        {
          ref: h,
          "data-testid": l,
          $zIndex: i,
          $width: c,
          ...s
        },
        /* @__PURE__ */ t.createElement(Aa, { type: "button", "aria-label": "close side sheet", onClick: r }, /* @__PURE__ */ t.createElement(o1, { name: "x-outline", width: 24, height: 24, color: "grey70" })),
        d
      )),
      document.body
    ) : null;
  }
);
J9.displayName = "SideSheet";
const ii = Object.assign(J9, {
  Body: $5,
  Footer: O5
}), Ra = y.div`
  position: fixed;
  inset: 0;
  z-index: ${({ $zIndex: e }) => e};
  background-color: ${({ theme: e }) => e.colors.grey100};
  opacity: 0.8;
  pointer-events: auto;
`, ja = y.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ $zIndex: e }) => e};
  display: flex;
  flex-direction: column;
  ${({ $width: e }) => G("width", e)};
  height: 100%;
  background-color: ${({ theme: e }) => e.colors.white};
  box-shadow: ${({ theme: e }) => e.elevations.dropdown};
`, Aa = y.button`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 1;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`, Ia = t.forwardRef(
  ({
    label: e,
    isChecked: r,
    defaultIsChecked: n = !1,
    onChange: a,
    isDisabled: o = !1,
    ...i
  }, l) => {
    const c = H1(), C = l5(), [s, u] = w1({
      defaultValue: n,
      value: r,
      onChange: a
    }), f = (h) => {
      u(h.target.checked);
    };
    return /* @__PURE__ */ t.createElement(Q9, { $isDisabled: o, htmlFor: c }, e && /* @__PURE__ */ t.createElement(l1, { variant: "body-01-regular" }, e), /* @__PURE__ */ t.createElement(
      ee,
      {
        type: "checkbox",
        role: "switch",
        id: c,
        checked: s,
        disabled: o,
        onChange: f,
        ref: l,
        ...i
      }
    ), /* @__PURE__ */ t.createElement(Na, { $isChecked: s, $isDisabled: o }, /* @__PURE__ */ t.createElement(Fa, { $isChecked: s }, s && /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 18 18", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M5.5 9.5L7.5 11.5L12.5 6.5",
        stroke: C.colors.primary60,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )))));
  }
);
Ia.displayName = "Toggle";
const Q9 = y.label`
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: ${({ $isDisabled: e }) => e ? "not-allowed" : "pointer"};
  column-gap: 0.75rem;
`, ee = y.input`
  position: absolute;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  width: 0.0625rem;
  height: 0.0625rem;
  margin: -0.0625rem;
  padding: 0;
  border-width: 0;
  white-space: nowrap;
`, Na = y.span`
  --track-bg: ${({ $isChecked: e, $isDisabled: r, theme: n }) => r ? n.colors.primary20 : e ? n.colors.primary60 : n.colors.grey30};
  --track-hover-bg: ${({ $isChecked: e, $isDisabled: r, theme: n }) => r ? n.colors.primary20 : e ? n.colors.primary70 : n.colors.grey70};

  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  width: 2.625rem;
  height: 1.5rem;
  border-radius: 1rem;
  background-color: var(--track-bg);
  transition: background-color 150ms ease;

  ${Q9}:hover & {
    background-color: var(--track-hover-bg);
  }

  ${ee}:focus-visible + & {
    outline: 2px solid ${({ theme: e }) => e.colors.primary60};
    outline-offset: 2px;
  }
`, Fa = y.span`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.colors.white};
  box-shadow: ${({ theme: e }) => e.elevations.dropdown};
  transition: transform 150ms ease;
  transform: translateX(${({ $isChecked: e }) => e ? "1.3125rem" : "0.1875rem"});
`, Pa = {
  grey10: "#f3f3f4",
  grey20: "#e0e1e3",
  grey30: "#c4c5c9",
  grey40: "#a5a7ad",
  grey50: "#85878f",
  grey60: "#646671",
  grey70: "#4a4c59",
  grey80: "#333644",
  grey90: "#202332",
  grey100: "#111424"
}, Ga = {
  primary10: "#f3f2fe",
  primary20: "#e2defd",
  primary30: "#c7bffc",
  primary40: "#a79bfa",
  primary50: "#8574f8",
  primary60: "#5e47f6",
  primary70: "#3f29d4",
  primary80: "#2e1d9a",
  primary90: "#1f1466",
  primary100: "#130c3e"
}, za = {
  secondary10: "#fdf4cc",
  secondary20: "#fae170",
  secondary30: "#e1c442",
  secondary40: "#bfa638",
  secondary50: "#9a862d",
  secondary60: "#766622",
  secondary70: "#584c1a",
  secondary80: "#3f3612",
  secondary90: "#29240c",
  secondary100: "#181507"
}, Ya = {
  tertiary10: "#e7f5fe",
  tertiary20: "#c5e6fd",
  tertiary30: "#8acefb",
  tertiary40: "#4caff1",
  tertiary50: "#3e8dc3",
  tertiary60: "#2f6c95",
  tertiary70: "#235170",
  tertiary80: "#1a3a50",
  tertiary90: "#112635",
  tertiary100: "#0d171f"
}, Ua = {
  informational: "#5e47f6",
  informationalLight: "#f3f2fe",
  success: "#1e771e",
  successLight: "#e9f6e9",
  warning: "#a94300",
  warningLight: "#ffefe4",
  error: "#cc1616",
  errorLight: "#fdefef",
  errorDark: "#991111"
}, qa = {
  borderError: "#ffb7b7",
  borderSuccess: "#7aff7a",
  borderWarning: "#a94300"
}, Xa = {
  white: "#fff",
  black: "#000",
  ...Pa,
  ...Ga,
  ...za,
  ...Ya,
  ...Ua,
  ...qa
}, Ka = {
  default: "0px 0px 1px rgba(17,20,23,0.24)",
  onHover: "0px 0px 1px rgba(17,20,23,0.24), 0px 2px 8px rgba(17,20,23,0.08)",
  dropdown: "0px 0px 1px rgba(17,20,23,0.24), 0px 8px 16px rgba(17,20,23,0.08), 0px 12px 24px rgba(17,20,23,0.08)",
  header: "0px 2px 4px rgba(17,20,23,0.08), inset 0px -1px 0px rgba(224,228,232,0.64)",
  actionBar: "0px -2px 4px rgba(17,20,23,0.04), inset 0px 1px 0px rgba(224,228,232,0.64)"
}, Ja = {
  default: "8px",
  small: "4px",
  full: "50%"
}, li = {
  colors: Xa,
  fontFamily: Q,
  elevations: Ka,
  radii: Ja,
  getTextStyles: K2
}, ci = de`
  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    background-color: ${({ theme: e }) => e.colors.grey10};
    color: ${({ theme: e }) => e.colors.grey90};

    ${({ theme: e }) => e.getTextStyles("body-01-regular")}
  }

  * {
    font-variant-ligatures: none;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  p {
    margin: 0;
  }

  svg {
    display: block;
  }
`;
export {
  z as Box,
  I4 as Button,
  C5 as Checkbox,
  t0 as CheckboxGroup,
  ai as DataTable,
  Rn as DatePicker,
  zn as FieldWithAction,
  ro as FilterBar,
  lo as FilterComponent,
  ci as GlobalStyle,
  I9 as HorizontalTab,
  N9 as HorizontalTabPanel,
  ko as HorizontalTabs,
  o1 as Icon,
  G3 as IconButton,
  Y1 as InfoText,
  xo as InlineNotification,
  o3 as Link,
  Zo as Modal,
  P9 as ModalBody,
  G9 as ModalCloseButton,
  z9 as ModalFooter,
  Y9 as ModalHeader,
  Ro as MultiSelectionField,
  na as NumericField,
  p3 as Popover,
  g2 as PopoverContent,
  p2 as PopoverTrigger,
  X9 as Radio,
  la as RadioGroup,
  q9 as RadioGroupContext,
  Ca as Search,
  ga as SelectionField,
  ii as SideSheet,
  j4 as Spinner,
  y3 as Tag,
  l1 as Text,
  Sa as TextArea,
  U9 as TextField,
  _a as Tile,
  Ia as Toggle,
  A4 as TruncatedText,
  J2 as applyThousandSeparator,
  J1 as composeEventHandlers,
  ta as getOffsetComma,
  ra as handleDeletingAtComma,
  N1 as mergeRefs,
  oi as noop,
  li as theme,
  G as toCSSProperty,
  w1 as useControllableValue,
  q7 as useIds,
  T9 as usePopoverContext
};
